/* eslint-disable */
export const libraryData = {
    ['Acintya-bhedābheda-tattva']: [
        {
            'subTopicName': 'Acintya-bhedābheda-tattva in Catuḥ-ślokī Bhāgavatam. (22 min)',
            'youtubeLink': 'https://www.youtube.com/live/HLs1k6FVRTk?si=N0B2ud5UFo9hGW4O&t=1316',
        },
        {
            'subTopicName': 'How Acintya-bhedābheda is the culmination of all the philosophies? (7 min)',
            'youtubeLink': 'https://youtu.be/d8hiSn1MoDo?si=tPopAef16Jtmyhwl&t=2008',
        },
        {
            'subTopicName': 'How śakti and śaktimān are non-different? (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/0yNfiUCQnVg?si=GdowYCMDqqlsi8gm&t=1120',
        },
        {
            'subTopicName': 'How change less and change simultaneously exist in the Lord (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2D3b3u4tiQ0&t=4585s',
        },
    ],
    ['Anarthas/Anartha-nivṛtti']: [
        {
            'subTopicName': 'Importance of engaging in likeable devotional activities in order to escape sense gratification. (16 min)',
            'youtubeLink': 'https://youtu.be/pFkS4zyyVe8?si=E-9-k15GzpgLZXFP&t=1666',
        },
        {
            'subTopicName': 'How to deal with our anarthas while not bewildering our subordinates due to that anartha? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/RTepF-Dr4NI?si=-JKJPBB7-e__FlDK&t=4754',
        },
        {
            'subTopicName': 'Guṇas are the direct cause of our anarthas, even though some external factors might sometimes be ascribed to be the cause of our anarthas. (6 min)',
            'youtubeLink': 'https://youtu.be/a3DqrSqPnp0?si=sEsu2rvBQ1LXsPcE&t=4803',
        },
        {
            'subTopicName': 'Does anartha-nivṛtti happen only through difficult situations or sufferings in a devotee’s life? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/jb_TeDKfY1c?si=xkrl62FtkfNDO8kJ&t=3726',
        },
        {
            'subTopicName': 'One must learn to subdue his svabhāva by the strength of his śraddhā. (8 min)',
            'youtubeLink': 'https://youtu.be/_7jxSZ7LflE?si=aCNPN6k3VBo1ak5V&t=2861',
        },
        {
            'subTopicName': 'Understanding the nature of śraddhā and svabhāva for a vaidī sādhaka. (4 min)',
            'youtubeLink': 'https://youtu.be/_7jxSZ7LflE?si=aJOFhWrnyd6l8J0E&t=3328',
        },
        {
            'subTopicName': 'A devotee overcomes his conditionings by the strength of his devotional service. (10 min)',
            'youtubeLink': 'https://youtu.be/JaBwvcMkjtY?si=oKJyZ-xmlNpV3OAW&t=4187',
        },
        {
            'subTopicName': 'A sādhaka undergoes tug-of-war between his śraddhā (faith) and svabhāva (conditionings) to finally attain spiritual bliss. (7 min)',
            'youtubeLink': 'https://youtu.be/vRFiLPh7CDI?si=QZkQKwI831scPxTg&t=2819',
        },
        {
            'subTopicName': 'Five stages of nullification of the four types of anarthas. (7 min)',
            'youtubeLink': 'https://youtu.be/vRFiLPh7CDI?si=8gACDG5rjUHlVTlR&t=3554',
        },
        {
            'subTopicName': 'Śraddhā determines the eligibility to perform bhakti and not the svabhāva. (10 min)',
            'youtubeLink': 'https://youtu.be/vRFiLPh7CDI?si=r-ocw8cjDPrQPD_G&t=3950',
        },
        {
            'subTopicName': 'Bhakti and unwholesome activities. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/OzAAIvrhzgs?si=zJwy86Y85o6RMGSf&t=3052',
        },
        {
            'subTopicName': 'A sādhaka is not dependent on varṇāśrama to purify his heart. Bhakti alone purifies his heart. (4 min)',
            'youtubeLink': 'https://youtu.be/WpdSAdGLTEA?si=dkdCwoxrT_nhSLQe&t=4567',
        },
        {
            'subTopicName': 'The conditioned senses naturally gravitate towards sense objects due to the influence of material impressions of past enjoyment (vāsanās). (2 min)',
            'youtubeLink': 'https://youtu.be/gepFnz2QEtw?si=5xHoXkOIh4U9Cq5T&t=3308',
        },
        {
            'subTopicName': 'Connection between sadhu‑saṅga and anartha‑nivṛtti. (36 min)',
            'youtubeLink': 'https://www.youtube.com/live/uZ62gEcCbhg?si=OJbJ1j5l8IAruDO-&t=645',
        },
        {
            'subTopicName': 'Is it possible for one to truly have only one of the two qualities of \'amāninā\' AND \'māna‑dena\'? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XSAGwNMoF08&t=629s',
        },
        {
            'subTopicName': 'Actions of a Sādhaka are not reliable indicators of one\'s nature of Faith. (25 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ps8gaL79Lqw&t=5400s',
        },
        {
            'subTopicName': 'Can we dovetail all our Anarthas in Kṛṣṇa\'s service? In other words, can we engage in \'Anartha Niyukti\' rather than \'Anartha Nivṛtti\'? (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RAGls-9gZVU&t=460s',
        },
        {
            'subTopicName': 'How to maintain enthusiasm as a sādhaka in performing devotional service despite the deep rooted anarthas pulling us down? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=TNeLuClc1oI&t=3309s',
        },
        {
            'subTopicName': 'Indicators of complete anartha nivṛtti (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6p3PKPOXAFc&t=1377s',
        },
        {
            'subTopicName': 'Anarthas do not disqualify one from practising pure devotional service. (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GhMA8-sKdI0&t=1670s',
        },
        {
            'subTopicName': 'Lust compromises the ability to realise knowledge. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=x96ilsBtFsI&t=1762s',
        },
        {
            'subTopicName': 'How to control lust? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=x96ilsBtFsI&t=2861s',
        },
        {
            'subTopicName': 'Force of vāsanās is very powerful. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1T1tquP4yzU&t=2103s',
        },
        {
            'subTopicName': 'Bhāgavatam’s recommendation on ways to conquer anarthas. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pHtStax8QBU&t=3600s',
        },
        {
            'subTopicName': 'Purification of Intelligence vs Purification of Mind. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=d36Obvd-_68&t=3295s',
        },
        {
            'subTopicName': 'How the Supereme Lord, who is Bhāva‑grāhī, deals with a Sādhaka troubled by desires for Sense Gratification? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=4258s',
        },
        {
            'subTopicName': 'How uncontrolled senses steal away the mind and intelligence? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=2049s',
        },
        {
            'subTopicName': 'If one chanting of the Holy Name destroys all Karmas, then why does Anartha‑nivṛtti take even lifetimes sometimes? (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=3158s',
        },
        {
            'subTopicName': 'Is there any way to know whether my impressions of pre Kṛṣṇa conscious life are decreasing or increasing? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=4161s',
        },
        {
            'subTopicName': 'Understanding Pre‑Meditated and Non Pre‑Meditated Sense Gratification. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jDi9z66krt0&t=3236s',
        },
        {
            'subTopicName': 'Where are the impressions of sense objects stored? In the mind or in the intelligence? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jDi9z66krt0&t=3786s',
        },
        {
            'subTopicName': 'Why there is so much mention about conditioning in discussions on Vaiṣṇava relationships if anartha‑nivṛtti happens automatically by practice of Bhakti? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glVWOuUj9OA&t=3165s',
        },
        {
            'subTopicName': 'Sādhanā-bhakti stage is characterized by simultaneous presence of Sense gratification and regret. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=3345s',
        },
        {
            'subTopicName': 'Other anarthas on the path of Bhakti. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Xoe0HwWTnBk&t=6400s',
        },
        {
            'subTopicName': 'Only sattva‑guṇa can be dovetailed in Kṛṣṇa\'s service, rajo‑guṇa and tamo‑guṇa must be given up. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LtduJkS8hZU&t=815s',
        },
    ],
    ['Association of Devotees']: [
        {
            'subTopicName': 'Attraction to a specific form develops only by association. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/-k-KLLTzxrg?si=Pq5zt3Uw5rrydsAf&t=3688',
        },
        {
            'subTopicName': 'How did Śaunakādi ṛṣis transform from Sakāma devotees to pure devotees ? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/kqfiviAf3HA?si=Fa48xdonZBIB0dox&t=384',
        },
        {
            'subTopicName': 'Faith is shaped through association. (22 min)',
            'youtubeLink': 'https://youtu.be/6SMLpWmC6rg?si=_UayKLohfHGNe2YJ&t=1092',
        },
        {
            'subTopicName': 'Importance of Vaiṣṇava-sevā. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/Fj7DzcIWN64?si=8Q8bJTqYb1g_lU-i&t=1112',
        },
        {
            'subTopicName': 'Association of devotees is not the means to attain success, it itself is success. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/NMWhuFTL4Yc?si=e8U3ZjyiNHoxip_T&t=2540',
        },
        {
            'subTopicName': 'If devotees have to fly their own plane, then what is the need for association? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/NMWhuFTL4Yc?si=QfRgbqq0TxlmtpRj&t=3475',
        },
        {
            'subTopicName': 'Strength for doing Bhakti is borrowed in devotees\' association. (4 min)',
            'youtubeLink': 'https://youtu.be/6RuUs5AEXrQ?si=pjJ3HNfX8xK9HxyB&t=1432',
        },
        {
            'subTopicName': 'What is "asat-saṅga" and "sādhu-saṅga"? (43 min)',
            'youtubeLink': 'https://youtu.be/IsCTZ4JSXlk?si=JlznZqv3hLJPifhe&t=1436',
        },
        {
            'subTopicName': 'Glories of Vaiṣṇava association. (30 min)',
            'youtubeLink': 'https://youtu.be/IsCTZ4JSXlk?si=iIXPqWuDyjlaehH6&t=2197',
        },
        {
            'subTopicName': 'When we have faith in guru and mantra, what is the importance of association? (8 min)',
            'youtubeLink': 'https://youtu.be/mtmJpauKcE8?si=Kdf5tLASy6FCPLxt&t=3331',
        },
        {
            'subTopicName': 'How devotee relationships become deeper and deeper? (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/lOgHcm3azvQ?si=KI5NZLAcLPgRqmAh&t=1075',
        },
        {
            'subTopicName': 'Interdependence is the key to beneficial association. (11 min)',
            'youtubeLink': 'https://youtu.be/11vLgWMEHfQ?si=a-r0iFxw-uo12_nB&t=2581',
        },
        {
            'subTopicName': 'Bhakti is bestowed by the mercy of the pure devotees. (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/mqAq-YWAxr4?si=FQLMIF7XZGg3PjEd&t=2573',
        },
        {
            'subTopicName': 'The glories of "association of devotees". (70 min)',
            'youtubeLink': 'https://youtu.be/111oUuqScao?si=vajapmggnQQMc9Qa&t=765',
        },
        {
            'subTopicName': 'The easiest way to develop loving relationship with the devotees is through Kṛṣṇa-kathā. (6 min)',
            'youtubeLink': 'https://youtu.be/111oUuqScao?si=FRCRlyyDwvM7S5-A&t=4084',
        },
        {
            'subTopicName': 'Association of devotees is more glorious than association of the Supreme Lord. (8 min)',
            'youtubeLink': 'https://youtu.be/111oUuqScao?si=NzTL5PSK63jROM2y&t=4431',
        },
        {
            'subTopicName': 'Importance of like-minded association. (5 min)',
            'youtubeLink': 'https://youtu.be/NA7UEU7qFyM?si=zzMsRPTyoabFfouU&t=4002',
        },
        {
            'subTopicName': 'ajñāta-sādhu-saṅga and jñāta-sādhu-saṅga. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/7sBphkords4?si=Wbpvrv9-q5bL9Txx&t=2218',
        },
        {
            'subTopicName': 'Meeting a sādhu to enter the realm of bhakti does not depend on karma but solely on fortune. Bhakti is not the right of the jīva but the mercy of devotees. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/7sBphkords4?si=3HZkHMYBxsWixrZn&t=2406',
        },
        {
            'subTopicName': 'Importance of association with devotees. (5 min)',
            'youtubeLink': 'https://youtu.be/6RuUs5AEXrQ?si=ViFK_qDc_WNSf8Hf&t=1433',
        },
        {
            'subTopicName': 'The greatest benediction in Bhakti is the association of devotees. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Gbg2F-YEDS8&t=3538s',
        },
        {
            'subTopicName': 'A devotee gratefully values his dependence on the association of devotees. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Gbg2F-YEDS8&t=4913s',
        },
        {
            'subTopicName': 'Importance of seeking advice of senior Vaiṣṇavas. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RwaILVgzrF8&t=682s',
        },
        {
            'subTopicName': 'Duties give their full effect when approved by all the Vaiṣṇavas. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RwaILVgzrF8&t=2388s',
        },
        {
            'subTopicName': 'In the absence of a qualified guru, one must take association of advanced Vaiṣṇavas and serve them. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7FEVl_0dUvs&t=3800s',
        },
        {
            'subTopicName': 'Examples of personalities from scriptures who have achieved control of the Lord through association of devotees. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7FEVl_0dUvs&t=5631s',
        },
        {
            'subTopicName': 'Association of devotees is the key to receiving the mercy of the Lord (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7FEVl_0dUvs&t=6457s',
        },
        {
            'subTopicName': 'Perfection of sacrifices and charitable acts through performance under association and guidance of devotees. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7FEVl_0dUvs&t=4527s',
        },
        {
            'subTopicName': 'Association of devotees is the key to success (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EBAqOcl0Gts&t=3990s',
        },
        {
            'subTopicName': 'Even unknowing association of devotees is valuable. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EBAqOcl0Gts&t=4568s',
        },
        {
            'subTopicName': 'Śāstras criticize one who considers a guru to be an ordinary person. The same śāstras glorify association with an exalted devotee without knowledge of his greatness. How to resolve this contradiction? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EBAqOcl0Gts&t=4645s',
        },
        {
            'subTopicName': 'Even unknowing association of devotees is valuable ‑ Part‑2 (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EBAqOcl0Gts&t=5304s',
        },
        {
            'subTopicName': 'Result of associating with Vaiṣṇavas is the giving up of false identification on the platform of false ego. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=1920s',
        },
        {
            'subTopicName': 'Glories and benefits of associating and serving great devotees. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OSP02lDJzkw&t=3920s',
        },
        {
            'subTopicName': 'Why there is so much mention about conditioning in discussions on Vaiṣṇava relationships if anartha‑nivṛtti happens automatically by practice of Bhakti? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glVWOuUj9OA&t=3165s',
        },
        {
            'subTopicName': 'Loving association of devotees is non‑negotiable at any stage of our Kṛṣṇa Consciousness. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=545s',
        },
        {
            'subTopicName': 'What makes or breaks the lifeline of devotees\' association? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nwHllIMh068&t=4062s',
        },
        {
            'subTopicName': 'No hope for reaching prema without association of devotees. (43 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=a9vYWReNDwA&t=2730s',
        },
    ],
    ['Avatāras']: [
        {
            'subTopicName': 'Guṇa-Avatāras. (36 min)',
            'youtubeLink': 'https://youtu.be/RpK9YjaF51g?si=hbjx7GrIDGtSd5ze&t=1580',
        },
        {
            'subTopicName': 'Brahma. (46 min)',
            'youtubeLink': 'https://youtu.be/CEGKGJuFHLM?si=c_5tqnxFgbW1mzp2&t=782',
        },
        {
            'subTopicName': 'Śiva Tattva in detail. (40 min)',
            'youtubeLink': 'https://youtu.be/CNnWmvveZg0?si=3V3K2oTuluCufvfN&t=1322',
        },
        {
            'subTopicName': 'List of Manvantara-avatāras - Part-1. (30 min)',
            'youtubeLink': 'https://youtu.be/qz4I8TdUNJc?si=VfVODiyB4EEBbUh0&t=1677',
        },
        {
            'subTopicName': 'List of Manvantara-avatāras - Part-2. (32 min)',
            'youtubeLink': 'https://youtu.be/pePldmPiSDY?si=gn29GpntDKt_xYLm&t=2080',
        },
        {
            'subTopicName': 'Yugāvatāras. (48 min)',
            'youtubeLink': 'https://youtu.be/jWjGP55MG6k?si=ObvSqudcsZRhSj6I&t=541',
        },
        {
            'subTopicName': '4 types of avatāras. (22 min)',
            'youtubeLink': 'https://youtu.be/NJJI7_6fraA?si=1_7AKsMI3NcS-x0N&t=2598',
        },
        {
            'subTopicName': 'Lord Rāma as a Parāvastha avatāra - Part-1. (40 min)',
            'youtubeLink': 'https://youtu.be/e2LcGvvJoR0?si=XqQh9s6D9-FftD82&t=1017',
        },
        {
            'subTopicName': 'Lord Rāma as a Parāvastha avatāra - Part-2. (40 min)',
            'youtubeLink': 'https://youtu.be/zO-rM3m99-E?si=jFzP2liUZdY_nMTL&t=1000',
        },
        {
            'subTopicName': 'Lord Kṛṣṇa as a Parāvastha avatāra. (52 min)',
            'youtubeLink': 'https://youtu.be/RIB7ABI3AO8?si=XKJlmwOgEelLhcXy&t=685',
        },
        {
            'subTopicName': 'How many Catur-Vyūhas are there? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=jyeEZpm2_lPrjPhm&t=6497',
        },
        {
            'subTopicName': 'The five forms of the Lord according to the Śrī Vaiṣṇavas. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/ZwW__cOftwg?si=FjHCXWGKAX46moo9&t=2779',
        },
        {
            'subTopicName': 'Who are the yuga-avatāras? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/ZwW__cOftwg?si=aahg2L-VR56-Cm8y&t=3898',
        },
        {
            'subTopicName': 'Are Lord Śiva and Brahmā partial expansions of the Lord? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/8lTMU4Nr_to?si=jh9PQl71mOxLwMy4&t=1496',
        },
        {
            'subTopicName': 'Kṛṣṇa and His expansions at a glance. (6 min)',
            'youtubeLink': 'https://youtu.be/RpK9YjaF51g?si=PBAwYvvsxET6og9Y&t=767',
        },
        {
            'subTopicName': 'Understanding the tattva of guṇa-avatāras. (9 min)',
            'youtubeLink': 'https://youtu.be/RpK9YjaF51g?si=gdZQPy245kyBNBHL&t=1586',
        },
        {
            'subTopicName': 'Relationship of guṇa-avatāras with the guṇas. (8 min)',
            'youtubeLink': 'https://youtu.be/RpK9YjaF51g?si=lJ1MlldFYDBLy6E5&t=2148',
        },
        {
            'subTopicName': 'Garbodakaśāyī Viṣṇu manifesting guṇa-avatāras through agency of māyā. (5 min)',
            'youtubeLink': 'https://youtu.be/RpK9YjaF51g?si=gxcUHUAGFwBMu04k&t=2574',
        },
        {
            'subTopicName': 'Among the guṇa-avatāras only Viṣṇu can give liberation. (5 min)',
            'youtubeLink': 'https://youtu.be/RpK9YjaF51g?si=LST-188bovRRVbK6&t=3368',
        },
        {
            'subTopicName': 'Two forms of Brahmā. (8 min)',
            'youtubeLink': 'https://youtu.be/CEGKGJuFHLM?si=oBssNMRRYrSj--v8&t=786',
        },
        {
            'subTopicName': 'Vairāja Brahmā. (4 min)',
            'youtubeLink': 'https://youtu.be/CEGKGJuFHLM?si=so7u_B80KOfgVurt&t=1269',
        },
        {
            'subTopicName': 'Garbodakaśāyī Viṣṇu and jīva taking the role of Brahmā. (16 min)',
            'youtubeLink': 'https://youtu.be/CEGKGJuFHLM?si=uS_U33Ze8w9klNYn&t=1461',
        },
        {
            'subTopicName': 'Why is Brahmā called an avatāra? (16 min)',
            'youtubeLink': 'https://youtu.be/CEGKGJuFHLM?si=Mh4v_sPvQfx4FrHh&t=2446',
        },
        {
            'subTopicName': 'Viṣṇu as a guṇa-avatāra. (9 min)',
            'youtubeLink': 'https://youtu.be/Nr9FKFhTneM?si=KGBbowqCUVwnzzB0&t=112',
        },
        {
            'subTopicName': 'Kumāras. (10 min)',
            'youtubeLink': 'https://youtu.be/34Wp2kQiqxU?si=QkER6j7Pz17MUsbT&t=3064',
        },
        {
            'subTopicName': 'Nārada. (30 min)',
            'youtubeLink': 'https://youtu.be/pIOGGavW5Co?si=q1lvzFwx-2GZwvZx&t=879',
        },
        {
            'subTopicName': 'Appearance of Nārada. (14 min)',
            'youtubeLink': 'https://youtu.be/pIOGGavW5Co?si=A_9hvbqzTyRcR-9d&t=2637',
        },
        {
            'subTopicName': 'Appearance of Varāhadeva. (11 min)',
            'youtubeLink': 'https://youtu.be/on4xF87W-Tk?si=UyjD55A0p7M4Rw7x&t=2362',
        },
        {
            'subTopicName': 'Proof that second Varāha appeared during Cākṣuṣa Manu. (19 min)',
            'youtubeLink': 'https://youtu.be/3ztcrGVEAoM?si=qBY5PBk2sYodGn7j&t=2475',
        },
        {
            'subTopicName': 'Two Varāhas explained. (37 min)',
            'youtubeLink': 'https://youtu.be/t2GJVxotDis?si=g8UnFJrKMG5zN8r3&t=1378',
        },
        {
            'subTopicName': 'Yajña – manvantara-avatāra. (6 min)',
            'youtubeLink': 'https://youtu.be/hS7oF9O0oCg?si=pIAC0Ux8Wjbnkwx0&t=1864',
        },
        {
            'subTopicName': 'Nara-Nārāyaṇa ṛṣi. (6 min)',
            'youtubeLink': 'https://youtu.be/hS7oF9O0oCg?si=9ThZDmw23hJH11Me&t=2251',
        },
        {
            'subTopicName': 'Kapila. (15 min)',
            'youtubeLink': 'https://youtu.be/hS7oF9O0oCg?si=UCnp9uWCtE7CqjIo&t=2572',
        },
        {
            'subTopicName': 'Is Kapila an avatāra? (11 min)',
            'youtubeLink': 'https://youtu.be/UtolvDukp8w?si=W8O7aSyYyNKWLAEb&t=816',
        },
        {
            'subTopicName': 'Dattātreya avatāra. (8 min)',
            'youtubeLink': 'https://youtu.be/UtolvDukp8w?si=CflXbiN32vmXtq72&t=2545',
        },
        {
            'subTopicName': 'Hayagrīva. (2 min)',
            'youtubeLink': 'https://youtu.be/UtolvDukp8w?si=hETv7ahpTe2ErDam&t=3048',
        },
        {
            'subTopicName': 'Haṁsāvatāra. (5 min)',
            'youtubeLink': 'https://youtu.be/ewaOEpK9zlE?si=UKFH8OPn2QGVN8l_&t=2313',
        },
        {
            'subTopicName': 'Pṛśnigarbha. (15 min)',
            'youtubeLink': 'https://youtu.be/ewaOEpK9zlE?si=2TTJGbxWmpIiqoZK&t=2574',
        },
        {
            'subTopicName': 'It was Pṛśnigarbha who gave benediction to Dhruva Mahārāja. (23 min)',
            'youtubeLink': 'https://youtu.be/svl8VegVTAY?si=jS_8jkekrw74ID7K&t=502',
        },
        {
            'subTopicName': 'Ṛṣabhadeva. (6 min)',
            'youtubeLink': 'https://youtu.be/svl8VegVTAY?si=HM1xTaxNcxSIXFNL&t=1857',
        },
        {
            'subTopicName': 'Pṛthu. (6 min)',
            'youtubeLink': 'https://youtu.be/svl8VegVTAY?si=cnOdKqCqpmy79VmH&t=2241',
        },
        {
            'subTopicName': 'Nṛsiṁha. (6 min)',
            'youtubeLink': 'https://youtu.be/svl8VegVTAY?si=kfMNoDXBH1nMIzt8&t=2627',
        },
        {
            'subTopicName': 'Kūrma. (6 min)',
            'youtubeLink': 'https://youtu.be/svl8VegVTAY?si=2m7lXPhnBY1er6Ne&t=3024',
        },
        {
            'subTopicName': 'Dhanvantari, Mohinī. (4 min)',
            'youtubeLink': 'https://youtu.be/PTY2aNHt0to?si=nnx78wmWbalhNr2W&t=1591',
        },
        {
            'subTopicName': 'Mohinī. (3 min)',
            'youtubeLink': 'https://youtu.be/-Rlv-uheoto?si=aOHQh4fAD2msCoy7&t=3251',
        },
        {
            'subTopicName': 'Vāmana. (23 min)',
            'youtubeLink': 'https://youtu.be/c5Lvt-y12Mg?si=GnyADHgEgT3-NZr-&t=1631',
        },
        {
            'subTopicName': 'Rāma avatāra. (8 min)',
            'youtubeLink': 'https://youtu.be/c5Lvt-y12Mg?si=y7OgL4gZQPchPnFR&t=3127',
        },
        {
            'subTopicName': 'Vyāsadeva. (16 min)',
            'youtubeLink': 'https://youtu.be/lzxwzzDGFo8?si=L_XiVma5KLmmZr4x&t=1592',
        },
        {
            'subTopicName': 'Balarāma and Kṛṣṇa. (15 min)',
            'youtubeLink': 'https://youtu.be/lzxwzzDGFo8?si=Bifk8LN-qmKeB8WX&t=2521',
        },
        {
            'subTopicName': 'Buddha. (13 min)',
            'youtubeLink': 'https://youtu.be/rD9nfDYJcmY?si=hyhEF-V7ufM6L70R&t=1858',
        },
        {
            'subTopicName': 'Kalki. (7 min)',
            'youtubeLink': 'https://youtu.be/rD9nfDYJcmY?si=5AgAIb9q9iLhjvjd&t=2673',
        },
        {
            'subTopicName': 'Role of manvantara-avatāras. (10 min)',
            'youtubeLink': 'https://youtu.be/qz4I8TdUNJc?si=CrzmSCWNxFapbYtE&t=978',
        },
        {
            'subTopicName': 'Āveśa forms. (6 min)',
            'youtubeLink': 'https://youtu.be/HmalZt6xdvA?si=yKAp0QqFRovg4_vm&t=1326',
        },
        {
            'subTopicName': 'Prabhāva-āveśa forms. (11 min)',
            'youtubeLink': 'https://youtu.be/HmalZt6xdvA?si=qK7aX-Abjv00BV1i&t=1686',
        },
        {
            'subTopicName': 'Vaibhava-āveśa forms. (13 min)',
            'youtubeLink': 'https://youtu.be/HmalZt6xdvA?si=qzxFHbt_wTodVzpZ&t=2400',
        },
        {
            'subTopicName': 'How Nara-Nārāyaṇa became Arjuna and Kṛṣṇa. (20 min)',
            'youtubeLink': 'https://youtu.be/XEVoigWeogA?si=516kku04RLRhHc2D&t=2314',
        },
        {
            'subTopicName': 'Nṛsiṁha as paravastha. (10 min)',
            'youtubeLink': 'https://youtu.be/ICXPGRidIZM?si=kuH9m5I7lp0oouxm&t=2804',
        },
        {
            'subTopicName': 'Tāratamya among the forms of Viṣṇu. (12 min)',
            'youtubeLink': 'https://youtu.be/Sw5xO5BaoI8?si=M3zvckXicfgt_muC&t=2966',
        },
        {
            'subTopicName': 'Why are parāvasthā forms considered to be special? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/AfxpAnkX-t4?si=A3tux-tdGH_Wjant&t=1052',
        },
        {
            'subTopicName': 'If Kṛṣṇa is the aṁśī and not aṁśa, then why is He mentioned in the list of avatāras? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/Lj0h6N7IZL4?si=FduZiGayISEKeJNS&t=1595',
        },
        {
            'subTopicName': 'Understanding the Caturvyūha forms of the Lord. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/nOfNItlQ3Y4?si=3M9SnJCF7Si33eyg&t=2568',
        },
        {
            'subTopicName': '3 forms of Kṛṣṇa. (8 min)',
            'youtubeLink': 'https://youtu.be/5XncZKbSKHA?si=8b8BsMhrsM9cWEy4&t=738',
        },
        {
            'subTopicName': 'tad-ekātma rūpa forms of the Lord. (3 min)',
            'youtubeLink': 'https://youtu.be/2h4aegotCuE?si=1W9evrzvtfWriAFP&t=1024',
        },
        {
            'subTopicName': 'vilāsa forms of the Lord. (3 Min)',
            'youtubeLink': 'https://youtu.be/2h4aegotCuE?si=xjBbzfunDilWJvdD&t=1194',
        },
        {
            'subTopicName': 'vilāsa forms of Kṛṣṇa and Nārāyaṇa. (10 min)',
            'youtubeLink': 'https://youtu.be/2h4aegotCuE?si=A4NxEGAAWWTStf2u&t=1430',
        },
        {
            'subTopicName': 'svāmśa forms of the Lord. (3 min)',
            'youtubeLink': 'https://youtu.be/2h4aegotCuE?si=S1fX2447NcC2nrYy&t=2042',
        },
        {
            'subTopicName': 'āveśa forms of the Lord. (4 min)',
            'youtubeLink': 'https://youtu.be/2h4aegotCuE?si=e3mzxkxtZ70EGMCh&t=2265',
        },
        {
            'subTopicName': 'prakāśa forms of the Lord. (16 min)',
            'youtubeLink': 'https://youtu.be/2h4aegotCuE?si=pd1zE-TtN4lS4-t1&t=2539',
        },
        {
            'subTopicName': 'Understanding the Svayaṁ-rūpa. (40 min)',
            'youtubeLink': 'https://youtu.be/5XncZKbSKHA?si=Lsd1kDl5K0l68KKp&t=1200',
        },
        {
            'subTopicName': 'General overview of avatāras. (23 min)',
            'youtubeLink': 'https://youtu.be/McwCiLPCeL4?si=rlCSTkykx-8k3FD9&t=1799',
        },
        {
            'subTopicName': 'Puruṣāvatāras - Part-1. (30 min)',
            'youtubeLink': 'https://youtu.be/EVjx4j0IyTY?si=mY6O8lCVFTrEp-Wz&t=1014',
        },
        {
            'subTopicName': 'Puruṣāvatāras - Part-2. (40 min)',
            'youtubeLink': 'https://youtu.be/gNDstW1rSLE?si=V7hlFxb1GFrepxsb&t=901',
        },
        {
            'subTopicName': 'Manvantarāvatāras - Part-1. (30 min)',
            'youtubeLink': 'https://youtu.be/qz4I8TdUNJc?si=OUi4hNe23efwVL2d&t=1725',
        },
        {
            'subTopicName': 'Manvantarāvatāras - Part-2. (30 min)',
            'youtubeLink': 'https://youtu.be/pePldmPiSDY?si=z0WDviPNI3Lgrddg&t=1982',
        },
        {
            'subTopicName': 'Yugāvatāras. (45 min)',
            'youtubeLink': 'https://youtu.be/jWjGP55MG6k?si=4qvrQYQZbnW64X5F&t=539',
        },
        {
            'subTopicName': 'The 4 types of avatāras. (20 min)',
            'youtubeLink': 'https://youtu.be/NJJI7_6fraA?si=na3s6k_CXU0hvFTE&t=2602',
        },
        {
            'subTopicName': 'Importance of hearing Puruṣāvatāra-kathā before we approach the Līlāvatāra-kathā. (8 min)',
            'youtubeLink': 'https://youtu.be/1G09tBj3x1M?si=7BNoj1plY7rAkL3t&t=1512',
        },
        {
            'subTopicName': 'Why Līlāvatāra-kathā is more difficult to understand than Puruṣāvatāra-kathā even though our experience seems to be contradictory? (35 min)',
            'youtubeLink': 'https://youtu.be/1G09tBj3x1M?si=1TsfHJ4QtEHTe--g&t=1955',
        },
        {
            'subTopicName': 'Three forms of the Lord in the spiritual world. (33 min)',
            'youtubeLink': 'https://www.youtube.com/live/YryHwqGZOt4?si=RM5kkYejq6a0s94K&t=1201',
        },
        {
            'subTopicName': 'Understanding of prabhāva and vaibhāva prakāśa forms. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/G9YQFheuJUo?si=56tNCZUb9Erpm59w&t=441',
        },
        {
            'subTopicName': 'Is Brahmā always a pure devotee? (31 min)',
            'youtubeLink': 'https://youtu.be/qC3eOMmOvb4?si=JJs7U1avmH3D-7hr&t=1472',
        },
        {
            'subTopicName': 'Is Śrī Advaita Ācārya a mixed incarnation of Mahā‑Viṣṇu and Sadā‑Śiva? (13 min)',
            'youtubeLink': 'https://youtu.be/UF_453TI91k?si=7dvtYULmqvYbciPx&t=1270',
        },
        {
            'subTopicName': 'Kṛṣṇa expands into various svāḿśa and vibhinnāṁśa forms for performing līlās. (26 min)',
            'youtubeLink': 'https://youtu.be/_sCeZ37rIi0?si=EO3rrIGm0Fxx5heb&t=5283',
        },
        {
            'subTopicName': 'What is the difference between Incarnation and Expansion of the Supreme Lord? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-v9S56pnTuI&t=6180s',
        },
        {
            'subTopicName': 'Who is the Yuga Avatāra of Dvāpara Yuga? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-v9S56pnTuI&t=6085s',
        },
        {
            'subTopicName': 'Understanding how the Yuga Avatāras are recognized or named after their colour. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-v9S56pnTuI&t=6240s',
        },
        {
            'subTopicName': 'Summary of Verse 10.8.13 to understand the Yuga Avatāras with different colours and what it actually implies. (23 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XNhjSoPI9_Q&t=405s',
        },
        {
            'subTopicName': 'Qualification for Brahmā\'s post. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Mul8EsJXjR8&t=2152s',
        },
        {
            'subTopicName': 'Dāsa‑abhimāna of the Avatāras towards the Avatārī. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=La-E5bGUD4w&t=1606s',
        },
    ],
    ['Behavior of Perfected devotees']: [
        {
            'subTopicName': 'Why a pure devotee Śrīla Sanātana Gosvāmī tried to give up his body? Is it bodily consciousness? (4 min)',
            'youtubeLink': 'https://youtu.be/a3DqrSqPnp0?si=-RwvvbHzEIRvrAGD&t=968',
        },
        {
            'subTopicName': 'Arjuna\'s bewilderment is because of Kṛṣṇa\'s Yogamāya. (2 min)',
            'youtubeLink': 'https://youtu.be/KycrMfpSxYY?si=elZiP2DPNDC919pR&t=724',
        },
        {
            'subTopicName': 'Did Prabhupāda, as a nitya-siddha, know about what would happen in the future? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/NMWhuFTL4Yc?si=MnZnbHXKLAlzsEbJ&t=4014',
        },
        {
            'subTopicName': 'Words spoken by a perfected devotee out of prema need not always be according to the siddhānta. (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/NMWhuFTL4Yc?si=e_tcaUn2131Zv7BF&t=392',
        },
        {
            'subTopicName': 'How prema and yoga-māyā differently influence the actions of perfect devotees? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/cssRhhe4_YE?si=37Rtv0v1d57XqIDp&t=7136',
        },
        {
            'subTopicName': 'How to understand the lamentation of great devotees? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/zJQzbf_XGtc?si=NrxZQbdN9Jclkbzg&t=3799',
        },
        {
            'subTopicName': 'Arjuna\'s bewilderment is due to the influence of Yogamāyā. (4 min)',
            'youtubeLink': 'https://youtu.be/a3DqrSqPnp0?si=UqO_G_3vwMkvUkx-&t=1232',
        },
        {
            'subTopicName': 'Spiritual envy of Uddhava. (5 min)',
            'youtubeLink': 'https://youtu.be/1G09tBj3x1M?si=iMUTiRdL1iOCOjoe&t=2634',
        },
        {
            'subTopicName': 'How to understand the bewilderment of the close associates of the Lord? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JYld7aQ6KF8&t=2404s',
        },
        {
            'subTopicName': 'Arjuna’s bewilderment is only due to the influence of yoga-māyā. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=b6wJQpJQurw&t=1570s',
        },
        {
            'subTopicName': 'Universal controllers are not affected by apparent transgression of morality. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5DPnaY774qg&t=982s',
        },
        {
            'subTopicName': 'When to and when not to apply the principle of following a great personality’s actions? (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5DPnaY774qg&t=1384s',
        },
        {
            'subTopicName': 'The body of a perfected devotee is also an object of worship. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/Nbu7MFESQ84?si=UkLtFZQd4HF3Srb2&t=3119',
        },
        {
            'subTopicName': 'Arjuna deciphers the heart of Kṛṣṇa. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/Qw0uvqBg1K8?si=Fv2CXoKMrFih6ybF&t=714',
        },
        {
            'subTopicName': 'Kṛṣṇa is the life and soul for devotees. (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/FFwkcvT7muc?si=SY7_yXmsmMwTPegC&t=2100',
        },
        {
            'subTopicName': 'How can even the exalted devotees be bewildered by Kṛṣṇa’s real nature? (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/dDFWGaCRpFk?si=m2iTSFr4ZXCnMWj2&t=1510',
        },
        {
            'subTopicName': 'Even devotees get bewildered by Kṛṣṇa’s pastimes. (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/dDFWGaCRpFk?si=WLttHQbSmjUCL3Gr&t=1288',
        },
        {
            'subTopicName': 'The mood of Kuntī Māhārāṇī: Kṛṣṇa-darśana-jīvanam. (48 min)',
            'youtubeLink': 'https://www.youtube.com/live/ar-PURH43Kc?si=syjQzfdmAD1a-8qs&t=134',
        },
        {
            'subTopicName': 'Perfected devotees can see Kṛṣṇa’s hands in their life experiences, but they cannot understand Kṛṣṇa’s plans. (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/LSVkGYWfWYY?si=CjsLVWD_e9JK1xfB&t=606',
        },
        {
            'subTopicName': 'Why do pure devotees even on the level of prema act in worldly ways sometimes? (29 min)',
            'youtubeLink': 'https://www.youtube.com/live/_fA3R3fKZlU?si=9OizDcfitMtCg-86&t=815',
        },
        {
            'subTopicName': 'Svabhāva of a nitya-siddha vs. svabhāva of a sādhana-siddha — is there any difference? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/kUSzNWc62Lw?si=pzzUbcSsh0in93nl&t=4150',
        },
        {
            'subTopicName': 'How is it that associates like Brahmā perform actions unfavorable to the Lord? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/CO9MBb75S_0?si=u4Ynkt7lykAn6qkF&t=4360',
        },
        {
            'subTopicName': 'Do rasika-bhaktas lose interest in aiśvarya-jñāna of Kṛṣṇa? ()',
            'youtubeLink': 'https://www.youtube.com/live/AODeK6z60ME?si=9zK1bABtBKYgA88G&t=1339',
        },
        {
            'subTopicName': 'Can Spiritual emotions co‑exist with knowledge of Aiśvarya in perfected devotees? What is the role of Yogamāyā in this? (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/AODeK6z60ME?si=y63U16WUIdoWNlJq&t=4205',
        },
        {
            'subTopicName': 'Understanding Prema through Devakī’s apparent lamentation and fear which appeared to have arisen from ignorance. (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/pOqEe9h4uBM?si=FIjpyXUL0s6I6fGq&t=5256',
        },
        {
            'subTopicName': 'Mother Rohinī glorifying the love of the Brajavāsīs while expressing her anger on Kṛṣṇa for neglecting the Brajavāsīs. (7 min)',
            'youtubeLink': 'https://youtu.be/JrMQzTlp4iE?si=0ZbZX4sShBc9Smbt&t=1466',
        },
        {
            'subTopicName': 'Balarāma accusing Kṛṣṇa for neglecting the Brajavāsīs. (6 min)',
            'youtubeLink': 'https://youtu.be/JrMQzTlp4iE?si=Z-JgP7NTz0KYec3x&t=2091',
        },
        {
            'subTopicName': 'Uddhava accusing Kṛṣṇa of neglecting the Brajavāsīs. (3 min)',
            'youtubeLink': 'https://youtu.be/JrMQzTlp4iE?si=7zR33zyYddmHGYNy&t=3012',
        },
        {
            'subTopicName': 'Nanda‑Mahārāja pacifying the Brajavāsīs in the absence of Kṛṣṇa. (3 min)',
            'youtubeLink': 'https://youtu.be/JrMQzTlp4iE?si=ey_Ns4RaCf_79R-S&t=2849',
        },
        {
            'subTopicName': 'Brajavāsīs’ eternal mood is of separation from Kṛṣṇa. (8 min)',
            'youtubeLink': 'https://youtu.be/JrMQzTlp4iE?si=3njJ2Gqyvy7pUN4O&t=3304',
        },
        {
            'subTopicName': 'Were the instructions of Gītā meant for Arjuna? (17 min)',
            'youtubeLink': 'https://youtu.be/Y5WG8UdumvY?si=gJeKmXNCSHm93-Tk&t=3327',
        },
        {
            'subTopicName': 'Understanding Yudhiṣṭhira’s grief for Bhīṣma. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/6F_EFTcHFYs?si=lJ2fAWVI6d6lkyvk&t=3103',
        },
        {
            'subTopicName': 'How ideal rulers like Ambarīṣa Mahārāja inspire? (3 min)',
            'youtubeLink': 'https://youtu.be/gaqtgYl08Mc?si=dQwYMIHds5OBXGXa&t=584',
        },
        {
            'subTopicName': 'Vidura’s position was the same as Bhīṣma and Droṇācārya. All three were dependent on the king. But still, only Vidura gave bold advice. Why? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/5THj2496iq4?si=JXDVy7WNSfYcmgnU&t=3485',
        },
        {
            'subTopicName': 'Why is Vidura addressing his relatives while indicating their material relationship, but not their relationship with Kṛṣṇa? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/da3Mhwh6Kec?si=c_9mkc_ZTyHH0_K7&t=4461',
        },
        {
            'subTopicName': 'Does every exalted devotee show the kind of attachment to Kṛṣṇa like Uddhava right from a very young age? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/TNeLuClc1oI?si=6eh_uM7jt9ZRKvao&t=1656',
        },
        {
            'subTopicName': 'Why do pure devotees like Pṛthu Mahārāja express a sense of competition with Nitya Siddha devotees like Mother Lakṣmī in their exalted prayers to the Supreme Lord? (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GTd6KcvXc84&t=2523s',
        },
        {
            'subTopicName': 'With what vision do we see Prema Bhaktas and highly advanced Sādhakas acting in apparently non‑comprehendible ways? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dXwsyg80F5c&t=4218s',
        },
        {
            'subTopicName': 'Why does a Paṇḍita / learned person never lament? (36 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=qNg82CwyIdE&t=1934s',
        },
        {
            'subTopicName': 'Why is Vidura not telling the truth not considered cheating? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=fCnjnG9Ioz0&t=3822s',
        },
        {
            'subTopicName': 'How is Śrīpāda Śaṅkarācārya a perfect Vaiṣṇava? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=E1Huq3O0vsg&t=4940s',
        },
        {
            'subTopicName': 'Why did the Vraja Gopīs worship Kātyāyanī Devī? (37 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2xR9wTPsUG8&t=45s',
        },
        {
            'subTopicName': 'What is the symptom of a Bonafide Ācārya? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=5104s',
        },
        {
            'subTopicName': 'Vaiṣṇava Humility Vs Jāti‑buddhi. (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=4255s',
        },
        {
            'subTopicName': 'Why was Pṛthu Mahārāj justifying his actions to the 4 Kumāras? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3qnSB9TmSAQ&t=3825s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize the Creator. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=2081s',
        },
        {
            'subTopicName': 'Why is gopīs’ criticism of Akrūra not a vaiṣṇava‑aparādha? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=6070s',
        },
        {
            'subTopicName': 'How is gopīs’ criticism of the Lord different from Gāndhārī’s criticism of Kṛṣṇa? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=2810s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize Providence for cruelly taking their eyesight away. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=3370s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize Kṛṣṇa for being indifferent towards them and deciding to leave to Mathurā. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=3876s',
        },
        {
            'subTopicName': 'Why did Pṛthu Mahārāj patiently hear Jñāna‑miśra‑bhakti from the Kumāras? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5zk7IbCiQJY&t=1664s',
        },
        {
            'subTopicName': 'Do great Kings like Pṛthu Mahārāja glorify Sādhus like the 4 Kumāras in order to evade giving them charity? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=490s',
        },
        {
            'subTopicName': 'Why did pure devotees like Pṛthu Mahārāja engage in their Varṇāśrama duties perfectly? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=2942s',
        },
        {
            'subTopicName': 'Why did Pṛthu Mahārāja have to indulge in such severe austerities in the Vānaprastha‑āśrama at the end of his life? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=2607s',
        },
        {
            'subTopicName': '​Is it possible to be a politician and still put into practice the principles of pure devotional service? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=3614s',
        },
        {
            'subTopicName': 'Why did pure devotees like Pṛthu Mahārāja have to engage in Jñāna‑yoga processes at the end of their lives? (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glVWOuUj9OA&t=2268s',
        },
        {
            'subTopicName': 'one should overlook the faults of a Bhāva‑bhakta. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=4290s',
        },
        {
            'subTopicName': 'Gopīs’ attachment to Kṛṣṇa in not letting him go to Mathurā is not due to material possessiveness. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=4390s',
        },
        {
            'subTopicName': 'Offering prayers to the Presiding / Worshipable Deities of the Senses ‑ is this bonafide / non‑bonafide? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mVProlZbvaY&t=1530s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs decide to abandon all dharma and directly try to stop Kṛṣṇa from leaving Vṛndāvana. (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ix-cxhDpdCg&t=4170s',
        },
        {
            'subTopicName': 'Are the gopīs really envious on the women of mathura that they will now get to relish Kṛṣṇa? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ix-cxhDpdCg&t=2663s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize Akrūra as a krūra or cruel man (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=6070s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs express envy towards women of Mathurā (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=4950s',
        },
        {
            'subTopicName': 'It is difficult to understand a person in Prema‑bhakti. (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=SH0ionOFw-o&t=3560s',
        },
        {
            'subTopicName': 'Actions of a person at the stage of Bhāva. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=VFnjKiJO_rc&t=2320s',
        },
        {
            'subTopicName': 'Reliable symptoms of Bhāva‑bhakti. (64 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glw_mxNyMJQ&t=3355s',
        },
    ],
    ['Bhāva and Prema Bhakti']: [
        {
            'subTopicName': 'Definition of Bhāva and Prema. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/1wFC-Z4xXpU?si=kvwNXfU50T2wF7Vt&t=2396',
        },
        {
            'subTopicName': 'Are there Anarthās at the stage of Bhāva? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/1wFC-Z4xXpU?si=2suNsUQcvzxOqkWU&t=3183',
        },
        {
            'subTopicName': 'Can a jīva serve both in Goloka and Vaikuṇṭha? (8 min)',
            'youtubeLink': 'https://youtu.be/R2VmZix87yA?si=GwjlKhbQ4nlA7QCh&t=4096',
        },
        {
            'subTopicName': 'Potent methods to attain Kṛṣṇa-prema very fast. (6 min)',
            'youtubeLink': 'https://youtu.be/PLZXh50mtWE?si=OkVSNVc2hfJLkZV0&t=1379',
        },
        {
            'subTopicName': 'Why prema is the highest puruṣārtha? (5 min)',
            'youtubeLink': 'https://youtu.be/PLZXh50mtWE?si=1vBSAsNw-BSFkA80&t=1680',
        },
        {
            'subTopicName': 'Can one reach the stage of prema in this lifetime? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/Nbu7MFESQ84?si=t05LRLVl8dvxUY5s&t=3756',
        },
        {
            'subTopicName': 'How jīva develops bhāva, which is inherent to the soul? (3 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=8dXilJZX5OmrwXOJ&t=3359',
        },
        {
            'subTopicName': 'Appreciating the exalted nature of vīraha‑bhāva. (50 min)',
            'youtubeLink': 'https://youtu.be/JrMQzTlp4iE?si=JPXejLz-4sC0e8vG&t=627',
        },
        {
            'subTopicName': 'Two divisions of gopī’s prema. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/ez76v_qh4zA?si=58o4HTXw__89b7Wc&t=604',
        },
        {
            'subTopicName': 'How to understand that Kṛṣṇa‑prema is eternal and inherent to the jīva? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/jouVi4pU3Xk?si=QHudRPTHAMkHHcIf&t=2415',
        },
        {
            'subTopicName': 'Uddhava is the greatest recipient of Kṛṣṇa’s mercy outside of Vṛndāvana. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/TNeLuClc1oI?si=dy8Q16_TH43bWtiX&t=774',
        },
        {
            'subTopicName': 'Proof that Kṛṣṇa is dependent and controlled by Prema, Prema is not dependent on him! (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=yO8UV6Mn2mM&t=837s',
        },
        {
            'subTopicName': 'Reliable symptoms of bhāva. (28 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=kyf1ewR2vDg&t=5405s',
        },
        {
            'subTopicName': 'Does Prema have the capacity to reverse the pain that one has gone through in his life? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GfCGcN9jJdg&t=2159s',
        },
        {
            'subTopicName': 'How to develop bhāva/prema through association? (44 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=kyf1ewR2vDg&t=2748s',
        },
        {
            'subTopicName': 'Characteristics of prema. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=zWJCSbQubLQ&t=760s',
        },
        {
            'subTopicName': 'What is the difference a spiritual body and a spiritualised material body? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=4870s',
        },
        {
            'subTopicName': 'Why is gopīs’ criticism of Akrūra not a vaiṣṇava‑aparādha? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=6070s',
        },
        {
            'subTopicName': 'How is gopīs’ criticism of the Lord different from Gāndhārī’s criticism of Kṛṣṇa? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=2810s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize Providence for cruelly taking their eyesight away. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=3370s',
        },
        {
            'subTopicName': 'Why did Pṛthu Mahārāja have to indulge in such severe austerities in the Vānaprastha‑āśrama at the end of his life? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=2607s',
        },
        {
            'subTopicName': 'Ways in which prema‑bhakti appears ‑ Part‑1 (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NsGLIgITQZE&t=6305s',
        },
        {
            'subTopicName': 'Ways in which prema‑bhakti appears ‑ Part‑2 (68 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=v0DB5CwXU1Y&t=541s',
        },
        {
            'subTopicName': 'Definition of prema‑bhakti (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NsGLIgITQZE&t=3935s',
        },
        {
            'subTopicName': '5 Primary Ratis. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=5040s',
        },
        {
            'subTopicName': 'Bhāva is tastier than millions of moons. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=4860s',
        },
        {
            'subTopicName': 'one should overlook the faults of a Bhāva‑bhakta. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=4290s',
        },
        {
            'subTopicName': 'Most amazing type of Bhāva. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=4050s',
        },
        {
            'subTopicName': 'Sudden appearance of Bhāva without sādhanā/mercy. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=3675s',
        },
        {
            'subTopicName': 'Kubjā\'s love is Kāma‑prāya. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mPV5ksADt7o&t=3810s',
        },
        {
            'subTopicName': 'Kāma‑rūpā rāgātmikā-bhakti of gopīs. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mPV5ksADt7o&t=1945s',
        },
        {
            'subTopicName': 'Kāma‑rūpā rāgātmikā-bhakti. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=6180s',
        },
        {
            'subTopicName': 'Understanding Pūrvarāga and Utkaṇṭhitā. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=2100s',
        },
        {
            'subTopicName': 'Kāma‑rūpā and Sambandha‑rūpā Rāgātmikā-bhakti. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=1110s',
        },
        {
            'subTopicName': 'Understanding Rāgātmikā-bhakti. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=650s',
        },
        {
            'subTopicName': '2 types of Rāgātmikā-bhakti. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cOjeSXHw1N0&t=6800s',
        },
        {
            'subTopicName': 'Understanding Rāgātmikā-bhakti. (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cOjeSXHw1N0&t=2985s',
        },
        {
            'subTopicName': 'Should the Gopīs’ criticisms in viraha‑gītā be taken at face value? (27 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=l9JSxaKiTi8&t=1230s',
        },
        {
            'subTopicName': 'Gopīs’ attachment to Kṛṣṇa in not letting him go to Mathurā is not due to material possessiveness. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=4390s',
        },
        {
            'subTopicName': 'Lamentation of gopīs for Kṛṣṇa\'s departure from Vṛndāvana and Lord’s messages of reassurance (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BNepBkhv7aA&t=3465s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs decide to abandon all dharma and directly try to stop Kṛṣṇa from leaving Vṛndāvana. (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ix-cxhDpdCg&t=4170s',
        },
        {
            'subTopicName': 'Are the gopīs really envious on the women of mathura that they will now get to relish Kṛṣṇa? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ix-cxhDpdCg&t=2663s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize Akrūra as a krūra or cruel man (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=6070s',
        },
        {
            'subTopicName': 'Attaining Vastu‑siddhi through Rāgānugā sādhanā. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NGb3avTZOLw&t=5540s',
        },
        {
            'subTopicName': 'Chanting the name while aspiring to attain prema ‑ Part‑1. (81 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=S_jL9Vulh-8&t=1620s',
        },
        {
            'subTopicName': 'Chanting the name with aspiration to attain prema ‑ Part‑2. (55 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n6q79aHYYKw&t=30s',
        },
        {
            'subTopicName': 'No hope for reaching prema without association of devotees. (43 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=a9vYWReNDwA&t=2730s',
        },
        {
            'subTopicName': 'Stages leading to prema ‑ Part‑2. (36 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=SH0ionOFw-o&t=4860s',
        },
        {
            'subTopicName': 'Stages leading to prema ‑ Part‑1. (56 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=SH0ionOFw-o&t=215s',
        },
        {
            'subTopicName': 'Raty‑ābhāsa ‑ Part‑1. (65 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=VFnjKiJO_rc&t=3246s',
        },
        {
            'subTopicName': 'Raty‑ābhāsa ‑ Part‑2 (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=768s',
        },
        {
            'subTopicName': 'It is difficult to understand a person in Prema‑bhakti. (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=SH0ionOFw-o&t=3560s',
        },
        {
            'subTopicName': 'Actions of a person at the stage of Bhāva. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=VFnjKiJO_rc&t=2320s',
        },
        {
            'subTopicName': 'Reliable symptoms of Bhāva‑bhakti. (64 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glw_mxNyMJQ&t=3355s',
        },
        {
            'subTopicName': 'Ways in which Bhāva‑bhakti appears ‑ Part‑1 (36 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sdG9Ak72tDk&t=4920s',
        },
        {
            'subTopicName': 'Ways in which Bhāva‑bhakti appears ‑ Part‑2. (44 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glw_mxNyMJQ&t=720s',
        },
        {
            'subTopicName': 'Two types of Bhāva‑bhakti. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sdG9Ak72tDk&t=3894s',
        },
        {
            'subTopicName': 'Role of Saṁvit and Hlādinī‑śakti in maifesting Bhāva. (31 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sdG9Ak72tDk&t=2040s',
        },
        {
            'subTopicName': 'Understanding Bhāva‑bhakti. (36 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=4830s',
        },
        {
            'subTopicName': 'Proof for definition of Bhāva‑bhakti. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sdG9Ak72tDk&t=1305s',
        },
        {
            'subTopicName': 'The Jīva Fall Discussion. (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=2160s',
        },
        {
            'subTopicName': 'Is Bhāva‑bhakti eternal in the Jīva? (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=2160s',
        },
    ],
    ['Chastity to the Paramparā']: [
        {
            'subTopicName': 'Adapting to the mood of Śrīmad-Bhāgavatam. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/mjq6ixAvJTM?si=AG2NTB1vkBtwyPYZ&t=1587',
        },
        {
            'subTopicName': 'How to confirm if a commentary is bonafide? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/uSxVKrr7Ab8?si=nNXze4XIJwlZ7By0&t=629',
        },
        {
            'subTopicName': 'Bonafide commentaries are written following the footsteps of the previous ācāryas. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/uSxVKrr7Ab8?si=UoMnTY7emQhfWSnP&t=3060',
        },
        {
            'subTopicName': 'Challenges in sticking to the presentation of the ācāryas and the benefits of sticking. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/cFgOw0dHG0Q?si=GiV4uGdJqy66GJel&t=838',
        },
        {
            'subTopicName': 'Different sampradāyas nourish different moods of worship. (10 min)',
            'youtubeLink': 'https://youtu.be/yIDZBJMd_QE?si=V_WF6JrNH43SZ4bm&t=3697',
        },
        {
            'subTopicName': 'Writing in line with the past Ācāryas. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=_8X2eJO69hdAfNRy&t=371',
        },
        {
            'subTopicName': 'How can we know if a Commentary is bonafide? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/oBSNCs_mTDw?si=oY0BQf5-xFgT6zNA&t=3330',
        },
        {
            'subTopicName': 'Why should a devotee be faithful to chanting and hearing in the paramparā? (11 min)',
            'youtubeLink': 'https://youtu.be/RXTbDKTzTtk?si=anXsnPlmbyD7pBxU&t=1049',
        },
        {
            'subTopicName': 'Should ISKCON devotees learn culture from the other sampradāyas? (6 min)',
            'youtubeLink': 'https://youtu.be/RXTbDKTzTtk?si=j5UZv7zC8_XEYm_6&t=2264',
        },
        {
            'subTopicName': 'Dangers of hearing and reciting compositions glorifying Kṛṣṇa outside the sampradāya. (14 min)',
            'youtubeLink': 'https://youtu.be/Wi68_XAAlcY?si=qg1uQ4BchggsxQKO&t=3100',
        },
        {
            'subTopicName': 'Should we cross-validate the teachings of our sampradāya from the other sampradāyas? (60 min)',
            'youtubeLink': 'https://youtu.be/5hC01vRCDj8?si=dtpMMbjBFPnVRnS7&t=300',
        },
        {
            'subTopicName': 'Hazards of reading stories from scriptures other than those commented on by our ācāryas. (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/EHznydtUlts?si=cwPSBAd2VZ_cVb0e&t=6005',
        },
        {
            'subTopicName': 'How to develop unflinching faith in the words of our Ācāryas? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/pOqEe9h4uBM?si=SMTLc_3CVGvsnk4X&t=3095',
        },
        {
            'subTopicName': 'Will a bona‑fide guru not be bothered if the disciple changes sampradāya? (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/qLMa8Wg7y2s?si=O8puQl7z0aHpTOsM&t=2270',
        },
        {
            'subTopicName': 'Repercussions of hearing outside the sampradāya. (66 min)',
            'youtubeLink': 'https://www.youtube.com/live/M9Ep5BpOoBk?si=OjEpXZ-9TgKxDrU_&t=2139',
        },
        {
            'subTopicName': 'What is required of a Sādhaka to gain entry into Goloka Vṛndāvana. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=irXwcVTNbbQ&t=4170s',
        },
        {
            'subTopicName': 'Is the blind following of our family traditions innocuous or scary? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ft5OYPZnBho&t=1218s',
        },
        {
            'subTopicName': 'Is Nārāyaṇīyam a Bonafide Scripture? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=2875s',
        },
        {
            'subTopicName': 'If Śrī Caitanya Mahāprabhu Himself borrowed 2 principles each from every Vaiṣṇava Sampradāya, why should we NOT not borrow? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gjIKMojudEU&t=1355s',
        },
        {
            'subTopicName': 'Similarities in conclusions and differences in details amongst the various Vaiṣṇava Sampradāyas. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gjIKMojudEU&t=382s',
        },
        {
            'subTopicName': 'Should we ask Kṛṣṇa‑prema from Kṛṣṇa and material facilities from the devatās? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mVProlZbvaY&t=1589s',
        },
        {
            'subTopicName': 'Offering prayers to the Presiding / Worshipable Deities of the Senses ‑ is this bonafide / non‑bonafide? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mVProlZbvaY&t=1530s',
        },
    ],
    ['Clarifications on Bhakti Siddhānta']: [
        {
            'subTopicName': 'Difference between Vaidhi Sādhanā Bhakti and Mixed Bhakti. (5 min)',
            'youtubeLink': 'https://youtu.be/fQRmE-27pOM?si=KtwKg7hzIf36TxgM&t=1970',
        },
        {
            'subTopicName': 'Understanding the śraddhā svabhāva tug of war from Jaiva Dharma. (11 min)',
            'youtubeLink': 'https://youtu.be/C06X4_ODAZ8?si=HuZAzfN3kuy4n9ed&t=1145',
        },
        {
            'subTopicName': 'Understanding various definitions of Purity. (4 min)',
            'youtubeLink': 'https://youtu.be/C06X4_ODAZ8?si=WfF_GRCVXKo5T-e-&t=1879',
        },
        {
            'subTopicName': 'Types or stages of bhakti. (9 min)',
            'youtubeLink': 'https://youtu.be/_Jrl6bhAHMw?si=ck7iNDFNdQpzZ-41&t=1514',
        },
        {
            'subTopicName': 'Is it proper to cry when Vaiṣṇavas leave their bodies? (4 min)',
            'youtubeLink': 'https://youtu.be/a3DqrSqPnp0?si=IR0rNTvFwiu-KLL7&t=1233',
        },
        {
            'subTopicName': 'Price to purchase a ticket to go back home. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/HLs1k6FVRTk?si=ozkLqiurcC5zvLcF&t=3187',
        },
        {
            'subTopicName': 'How to understand the guidance of the Lord from within? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/HLs1k6FVRTk?si=aLhGXEqz70Znu9KK&t=4542',
        },
        {
            'subTopicName': 'Is Bhakti inherent in the Jīva? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/uSxVKrr7Ab8?si=dEYHmkSb_s-KdAOJ&t=2456',
        },
        {
            'subTopicName': 'Is Prema inherent or received? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/uSxVKrr7Ab8?si=xbaTVn4d5zCB5fmX&t=3454',
        },
        {
            'subTopicName': 'Why there are material benedictions in Śrīmad-Bhāgavatam? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/uSxVKrr7Ab8?si=chZEPRVK4QZ4ajkC&t=4156',
        },
        {
            'subTopicName': 'How can material analogies used to describe Spiritual reality when spirit and matter are opposites? (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/r2uDAt3-ESc?si=L6OQdVkq9BalLRo7&t=603',
        },
        {
            'subTopicName': 'How can material analogies be used to describe Spiritual reality when spirit and matter are opposites? - Part-2. (7 min)',
            'youtubeLink': 'https://youtu.be/tkl9_a5uPFs?si=XmOFGuTJRBwNvysT&t=3351',
        },
        {
            'subTopicName': 'Suffering of devotees is not due to Karma. (16 min)',
            'youtubeLink': 'https://youtu.be/_hEdInbzrv8?si=jdQrz4teicKdOssR&t=2750',
        },
        {
            'subTopicName': 'Difference between Vaidhi Sādhanā Bhakti and Mixed Bhakti. (1 min)',
            'youtubeLink': 'https://youtu.be/fQRmE-27pOM?si=JyK-3Q43F-qLpVAw&t=648',
        },
        {
            'subTopicName': 'Six qualities of Uttamā Bhakti. (54 min)',
            'youtubeLink': 'https://youtu.be/C06X4_ODAZ8?si=vo9-QwGP8shjOy5n&t=2821',
        },
        {
            'subTopicName': 'Desires for Bhukti and Mukti obstruct Bhakti. (20 min)',
            'youtubeLink': 'https://youtu.be/SfFVMSoXu0I?si=2-gSnCPu_I7w8h2s&t=1565',
        },
        {
            'subTopicName': 'Devotee\'s suffering is not due to Karma. (44 min)',
            'youtubeLink': 'https://www.youtube.com/live/9Tu_d3wiP94?si=oC9Hst2ZvAUXWk0K&t=4990',
        },
        {
            'subTopicName': 'Understanding the 5 layers of ignorance. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/JqBTQylRg10?si=wicurzpVTlSrO8nB&t=2154',
        },
        {
            'subTopicName': 'Detachment of a devotee and a Jñāna Yogi. (20 min)',
            'youtubeLink': 'https://youtu.be/gepFnz2QEtw?si=Z7PFYJxuyskEDkqu&t=1983',
        },
        {
            'subTopicName': 'Destiny. (Karma) vs Endeavor. (8 min)',
            'youtubeLink': 'https://youtu.be/d8hiSn1MoDo?si=ll8Q5Yc7kkkHfh__&t=1047',
        },
        {
            'subTopicName': 'At what stage of Bhakti does true humility develops? (4 min)',
            'youtubeLink': 'https://youtu.be/KycrMfpSxYY?si=8QozBka5tSDVHaFa&t=2684',
        },
        {
            'subTopicName': 'Is trascending False Ego a gradual process? (15 min)',
            'youtubeLink': 'https://youtu.be/NSbLUll9y1c?si=_pD3eEJh4N6T9V6H&t=3865',
        },
        {
            'subTopicName': 'Understanding the obstacles to bhakti in the form of śraddhā and svabhāva. (10 min)',
            'youtubeLink': 'https://youtu.be/eHagME5qLM8?si=h5fUbRXIaVS_CIyM&t=732',
        },
        {
            'subTopicName': 'Learning to see our experiences through the eyes of the Śāstra. (25 min)',
            'youtubeLink': 'https://youtu.be/PLZXh50mtWE?si=csq-u5GJjOcC89RI&t=3402',
        },
        {
            'subTopicName': 'ones life experience is the strongest pramāṇa. (4 min)',
            'youtubeLink': 'https://youtu.be/MOvv7IAKUHo?si=fKchyXBy2_IBhz1F&t=939',
        },
        {
            'subTopicName': 'Should we teach Children Dharma-śāstras before Bhakti-śāstras? (6 min)',
            'youtubeLink': 'https://youtu.be/2c0puoy0NMw?si=6vSYUoeYe3jGGADb&t=649',
        },
        {
            'subTopicName': 'What will I do in ISKCON if my eternal form happens to be a worshipper of Lord Rāma? (8 min)',
            'youtubeLink': 'https://youtu.be/Wi68_XAAlcY?si=yoKFLTY4HSLfnJnP&t=4727',
        },
        {
            'subTopicName': 'Qualification for Bhakti Śāstra. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=_46vDixSkoiBCG4i&t=1510',
        },
        {
            'subTopicName': 'Between Between śravaṇaṁ and kīrtanaṁ which is better? (6 min)',
            'youtubeLink': 'https://youtu.be/jH5d1AsH4tM?si=O5cm4FM3fFzxQoUk&t=4462',
        },
        {
            'subTopicName': 'Understanding the concept of mixed faith. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/LQZJYlTGtls?si=oKLGuhjRENoc-Cn7&t=3487',
        },
        {
            'subTopicName': 'Common understanding of Bhakti Vs the Śāstric understanding. (2 min)',
            'youtubeLink': 'https://youtu.be/KxlGUpdv0sM?si=AnbZXPNe0YmEBKyp&t=1396',
        },
        {
            'subTopicName': 'There is no material disqualification for practice of Bhakti? (15 min)',
            'youtubeLink': 'https://youtu.be/SfFVMSoXu0I?si=2dXkEzepE2t2Od7e&t=4101',
        },
        {
            'subTopicName': 'Does having a material desire make me into a mixed devotee? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/mjq6ixAvJTM?si=Uoiz4U8cqP9nacmg&t=1907',
        },
        {
            'subTopicName': 'Can someone without faith in Bhakti directly reach the stage of Bhāva? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/mjq6ixAvJTM?si=TizcI3pzuaCNrnTq&t=2647',
        },
        {
            'subTopicName': 'Which is more potent in purifying the goal of one\'s life- Śrīmad-Bhāgavatam or the Holy Name? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/8YeJ_YbqCd4?si=bra6-RN6u7YLaMzp&t=2526',
        },
        {
            'subTopicName': 'How to understand the happiness and distress experienced by the devotees? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/8YeJ_YbqCd4?si=xjOGR4_cIv_pqcA8&t=3300',
        },
        {
            'subTopicName': 'Understanding the value systems of various types of practitioners. (10 min)',
            'youtubeLink': 'https://youtu.be/W3bCamTcsKM?si=2Bhee7VQYPebo9ad&t=3415',
        },
        {
            'subTopicName': 'Understanding the causeless nature of Bhakti. (23 min)',
            'youtubeLink': 'https://www.youtube.com/live/f_BpAryXLdQ?si=MCZs_WfKFq7qdEiS&t=2538',
        },
        {
            'subTopicName': 'Understanding the 5 Aspects of Ignorance. (7 min)',
            'youtubeLink': 'https://youtu.be/jH5d1AsH4tM?si=YhKdWUmDFeXoO3Kz&t=6058',
        },
        {
            'subTopicName': 'Vṛtti, Vāsanās and Saṁskāras. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/JqBTQylRg10?si=9UiU6M9JNTl-582n&t=1220',
        },
        {
            'subTopicName': 'If someone\'s spiritual svarūpa is in Vaikuṇṭha , can he achieve a different form if desired? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/R-p0hvYXJ94?si=gip1lDogKBNK9oZU&t=5262',
        },
        {
            'subTopicName': 'Why doesn\'t Kṛṣṇa influence the other yogīs to develop pure devotion? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/R-p0hvYXJ94?si=L-ppbRngAhtMSDvL&t=5585',
        },
        {
            'subTopicName': 'Is Dhruva\'s change of faith attributed to offense less chanting or mercy of the devotee? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/1wFC-Z4xXpU?si=3wSuSg8gxbo3GgNS&t=1531',
        },
        {
            'subTopicName': 'Is the desire to go back to the Spiritual world a pure devotional desire? (6 min)',
            'youtubeLink': 'https://youtu.be/pVYq4qnCMDA?si=KqjP44yBvrQ8EcPd&t=2215',
        },
        {
            'subTopicName': 'How do sādhaka avoid mukti-vādī tendencies? (4 min)',
            'youtubeLink': 'https://youtu.be/pVYq4qnCMDA?si=1GmJxqMX_yz17o8u&t=2472',
        },
        {
            'subTopicName': 'Can Mixed Bhakti give ajñāta-sukṛti? (6 min)',
            'youtubeLink': 'https://youtu.be/pVYq4qnCMDA?si=qvrhd98bvjIrzkAB&t=3443',
        },
        {
            'subTopicName': 'If a devotee already has a fixed form in the spiritual world, then what is the relevance of Mahāprabhu distributing Mādhurya-rasa? (3 min)',
            'youtubeLink': 'https://youtu.be/R2VmZix87yA?si=8ru-Fln2CIJE4INJ&t=1712',
        },
        {
            'subTopicName': 'Is the reception of mercy of the devotees an event or a process? (14 min)',
            'youtubeLink': 'https://youtu.be/UCD1itvjZIA?si=uce7vJOQp42M9WE7&t=3640',
        },
        {
            'subTopicName': 'Is seeing Kṛṣṇa necessarily a measure of advancement? (5 min)',
            'youtubeLink': 'https://youtu.be/61ng23W-Xyo?si=oC3GSCcKo_OQ6ZZP&t=1626',
        },
        {
            'subTopicName': 'Role of yoga-māyā and mahā-māyā. (15 min)',
            'youtubeLink': 'https://youtu.be/Wi68_XAAlcY?si=X1XAch0xdpQgFW_q&t=1702',
        },
        {
            'subTopicName': 'If one can achieve the results of karma, jñāna, etc. just by practice of bhakti, then what is the need for the other processes? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/Kb3arqif_sg?si=W1iIXGIvHzN9W-To&t=515',
        },
        {
            'subTopicName': 'Can only humans assimilate the qualification to perform bhakti? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/PPy-CHynXvs?si=5IeaaKfbj7Ph8zAf&t=382',
        },
        {
            'subTopicName': 'If bhakti produces all good qualities, then why do I sometimes see non-devotees possessing better qualities than the devotees? (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/qFWjzQepoLI?si=nBRCQflTjKt1b6ZV&t=2140',
        },
        {
            'subTopicName': 'Pure devotional value system in a conditioned person is more appreciable than mixed devotional value system in a person with all good qualities. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/qFWjzQepoLI?si=yHdweUvRrm6t_TEC&t=5686',
        },
        {
            'subTopicName': 'Under what circumstances does Kṛṣṇa help those who stray away from the practice of pure devotional practice? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/NqB3cD-nCHc?si=gz6GZ9e3spRkeJyW&t=3493',
        },
        {
            'subTopicName': 'It is only by good fortune that one comes in touch with a proper devotee. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/NqB3cD-nCHc?si=5Vl-ewGXs0lZj0Jj&t=5880',
        },
        {
            'subTopicName': 'Does a mixed devotee automatically become a pure devotional sādhaka by continuing to worship the Lord? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/EGFy5wmARC8?si=6sKnf2-H2lv0Ik_c&t=2740',
        },
        {
            'subTopicName': 'How does one get sukṛti through prasāda? (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/rpTraKYLpxk?si=L8UwP0X37mrwD9vO&t=2685',
        },
        {
            'subTopicName': 'Can devatās independently put obstacles in a devotee\'s path? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/w4RvZLrr3zg?si=lXOTzbWskCMVpnJ6&t=4651',
        },
        {
            'subTopicName': 'Did Nṛsiṁhadeva really promise liberation to 21 generations of family members of the devotees? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/VkF9SrWmHZs?si=hDlyYTJj1brGJ1Pg&t=563',
        },
        {
            'subTopicName': 'Both prārabdha and aprārabdha-karma are immediately destroyed once one takes up to bhakti. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=lOvdR4PrZqF2hG6p&t=81',
        },
        {
            'subTopicName': 'How to understand materialists showing more good qualities than devotees when bhakti is supposed to generate all good qualities? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=KH0JCJ5dnmE6cbXQ&t=4096',
        },
        {
            'subTopicName': 'For devotees, the cause of happiness is bhakti only and not their karma. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=CarL8ePsBOaWDsxU&t=4645',
        },
        {
            'subTopicName': 'Discussion on anyābhilāṣitā. (32 min)',
            'youtubeLink': 'https://youtu.be/PTY2aNHt0to?si=wi8TeTZiPIyRBHi0&t=1853',
        },
        {
            'subTopicName': 'Did the 21 generations connected to Prahlāda Mahārāja get liberated? (14 min)',
            'youtubeLink': 'https://youtu.be/FceBs7eqSrc?si=ybYfaoYECZypYV34&t=832',
        },
        {
            'subTopicName': 'As a sādhaka, do I really have attraction for Kṛṣṇa? (17 min)',
            'youtubeLink': 'https://youtu.be/o88wd4wqTrY?si=wCWQ5p2bYStRf7gj&t=1653',
        },
        {
            'subTopicName': 'Understanding Dhruva Mahārāja\'s rejection of Nārada Muni\'s advice. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=4Pj2y47MpQe6SZok&t=576',
        },
        {
            'subTopicName': 'When Dhruva performed such severe austerities, why is it mentioned that he is a kṛpā-siddha? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=DqvEAA1PgpjYJoPA&t=3515',
        },
        {
            'subTopicName': 'Why did Nārada instruct aṣṭāṅga-yoga along with Bhakti to Dhruva Mahārāja? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=yp5MMKwT7n8shBLd&t=3743',
        },
        {
            'subTopicName': 'If Bhakti is simple, why don\'t we see everyone accepting it? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=fWJVoAcOXkdQQuwW&t=4545',
        },
        {
            'subTopicName': 'If Bhakti itself is received through kṛpā, then why are we not called as kṛpā-siddhas? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=45cS2EF7RmFtVZ4u&t=4795',
        },
        {
            'subTopicName': 'What is the destination of devotees chanting Hare Kṛṣṇa but are attached to Lord Nārāyaṇa? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/T8_KihNeqEk?si=NH6ccSP6rEQ30ZsH&t=4490',
        },
        {
            'subTopicName': 'Understanding Dhruva Mahārāja\'s rejection of Nārada Muni\'s advice - Part 2. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/Yat6Iasojzw?si=GW_9QKmWO2kOgA9K&t=275',
        },
        {
            'subTopicName': 'How Bhakti helps overcome sufferings. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/NMWhuFTL4Yc?si=yr3gsyuIuaOPzoTK&t=2289',
        },
        {
            'subTopicName': 'Why do devotees suffer even after Bhakti promises kleśaghnī? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/NMWhuFTL4Yc?si=qMXj4v_yaiX380UJ&t=2805',
        },
        {
            'subTopicName': 'Suffering of great devotees sometimes brings others also closer to Kṛṣṇa\'s lotus feet. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/NMWhuFTL4Yc?si=0eGtfoNL41oTehHX&t=4246',
        },
        {
            'subTopicName': 'Kṛṣṇa-prema is not inherent in the jīva, but the potential to express it is inherent. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/PujeNZwY2U8?si=eC78oeCzlsCY-Q_m&t=1018',
        },
        {
            'subTopicName': 'The śāstras say that one name of Kṛṣṇa is equivalent to three names of Lord Rāma. Should this statement be taken literally? (23 min)',
            'youtubeLink': 'https://www.youtube.com/live/T8_KihNeqEk?si=__VDr1xa3Pp7zYgx&t=1885',
        },
        {
            'subTopicName': 'Who can see the Lord in truth? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/oBSNCs_mTDw?si=DUtDcjIZ2j_yKjUu&t=1403',
        },
        {
            'subTopicName': 'Is Bhakti a result of piety? (7 min)',
            'youtubeLink': 'https://youtu.be/kAdiSI4Qh5g?si=NZkApdIm2u86zVUD&t=1270',
        },
        {
            'subTopicName': 'Does one receive Bhakti by causeless luck? (8 min)',
            'youtubeLink': 'https://youtu.be/kAdiSI4Qh5g?si=CRaNjb9wnBOtrvwD&t=2008',
        },
        {
            'subTopicName': 'Does one receive Bhakti by Kṛṣṇa\'s independent will? (6 min)',
            'youtubeLink': 'https://youtu.be/kAdiSI4Qh5g?si=N89wVnCgSYC7NYlZ&t=2586',
        },
        {
            'subTopicName': 'Bhakti causes Bhakti. (10min)',
            'youtubeLink': 'https://youtu.be/kAdiSI4Qh5g?si=TszTEJiIX-HmQlyL&t=3034',
        },
        {
            'subTopicName': 'Bhakti causes Bhakti - Part 2. (4 min)',
            'youtubeLink': 'https://youtu.be/6kRGDoaOX58?si=lWnG7cgJ6rvxkn-k&t=1356',
        },
        {
            'subTopicName': 'Kṛṣṇa grants the power to the devotee to bestow His mercy to other jīvas. (2 min)',
            'youtubeLink': 'https://youtu.be/6kRGDoaOX58?si=7YuM1LiAgrioQJsE&t=1606',
        },
        {
            'subTopicName': 'Understanding ajñāta-sukṛti. (24 min)',
            'youtubeLink': 'https://youtu.be/6kRGDoaOX58?si=go3ylNRzGcjR47C-&t=1810',
        },
        {
            'subTopicName': 'Understanding the science of Bhakti\'s descent in a jīva\'s heart. (53 min)',
            'youtubeLink': 'https://youtu.be/kAdiSI4Qh5g?si=usj0M4V82O4FWs0u&t=488',
        },
        {
            'subTopicName': 'Is offering fruits of one\'s actions to Kṛṣṇa Bhakti? (20 min)',
            'youtubeLink': 'https://youtu.be/vKIx7B4JIyk?si=Q62wWGlRKjsqbWcd&t=350',
        },
        {
            'subTopicName': 'Why doesn’t Kṛṣṇa reciprocate immediately with devotees? (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/pwByE7bADGc?si=KCgrf06pQau-R95_&t=1744',
        },
        {
            'subTopicName': 'Bhakti is not transformation of karma? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/9_LM_EezNGc?si=_xkoP5ywagX16cBP&t=2301',
        },
        {
            'subTopicName': 'How jñāna and vairāgya are by-products of bhakti? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/tKtflACfyY0?si=Widedxw5-qVPsZ2d&t=1623',
        },
        {
            'subTopicName': 'How attraction for the topics of the Lord arises? (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/VuzxMXez__I?si=kzpLtu4tA1V1kfnU&t=2346',
        },
        {
            'subTopicName': 'How to differentiate weak pure faith from strong mixed faith? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/VuzxMXez__I?si=6am81fq2wkVn9-hk&t=3447',
        },
        {
            'subTopicName': 'How can we identify if we are not practicing mixed bhakti? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/VuzxMXez__I?si=OKjgN-h37f4mer4U&t=4162',
        },
        {
            'subTopicName': 'Why did Parīkṣit Mahārāja, despite having so less time, choose to hear all nine cantos instead of direct Kṛṣṇa-līlā? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/51buEFEn9Vo?si=3ijNk50PBxVcJcue&t=816',
        },
        {
            'subTopicName': 'Is there distinction between a sādhana-siddha and a nitya-siddha in the spiritual world? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/cssRhhe4_YE?si=UeopowBhD0_Crfh3&t=1928',
        },
        {
            'subTopicName': 'What is the difference between the levels of consciousness experienced by the sādhakas and perfected devotees? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/cssRhhe4_YE?si=JTHBuEi6Zth5W-IS&t=6499',
        },
        {
            'subTopicName': 'What is the role of bhakti-devī and mahā-māyā in the life of sādhakas? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/kHDK6F33peg?si=PL0fq6q4_ybaAutr&t=3087',
        },
        {
            'subTopicName': 'Why does Kṛṣṇa put devotees under difficulties? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/kHDK6F33peg?si=qrFSSNaz_-uQYkXg&t=5334',
        },
        {
            'subTopicName': 'The 3 categories of people who get purified by Kṛṣṇa-kathā. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/opMuBbLyHRI?si=_H0XoVfgbQManzl7&t=2545',
        },
        {
            'subTopicName': 'How can Śrīmad-Bhāgavatam help unintelligent people? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/opMuBbLyHRI?si=Q2A8TgNCn_yaklJX&t=4104',
        },
        {
            'subTopicName': 'The conjunction of material and spiritual in Kṛṣṇa\'s pastimes illustrates the nature of bhakti. (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/qOHUGmgjlyc?si=u_a1nowmfnmRKdvS&t=5521',
        },
        {
            'subTopicName': 'Why Kṛṣṇa allows things like black magic? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/LBVwqJ_X7Eo?si=qW-O8a4rw5yyEe1B&t=4069',
        },
        {
            'subTopicName': 'Can proficiency in Sanskrit help one understand Bhāgavatam better? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/gD-lySniPH0?si=VArjDGqHwn4_srIz&t=2758',
        },
        {
            'subTopicName': 'How will one develop the qualification for bhakti? (33 min)',
            'youtubeLink': 'https://www.youtube.com/live/VuzxMXez__I?si=HznOzrEnHkOitYx7&t=1390',
        },
        {
            'subTopicName': 'Why bhakti is to be directed only to Viṣṇu? (65 min)',
            'youtubeLink': 'https://www.youtube.com/live/2PRIb9fu5iM?si=McwLgGJTfI0iW_KO&t=304',
        },
        {
            'subTopicName': 'Extreme attachment to a particular limb of bhakti need not necessarily be a sign of progress. (16 min)',
            'youtubeLink': 'https://youtu.be/JeybpTYH6Y4?si=QivuHKnNiD9HZCMa&t=3895',
        },
        {
            'subTopicName': 'Is the final goal predestined for all the sādhakas as it was for Gopa Kumāra? (4 min)',
            'youtubeLink': 'https://youtu.be/mtmJpauKcE8?si=NH01hp91nkxILj6P&t=1846',
        },
        {
            'subTopicName': 'How does one take up to the process of bhakti? (25 min)',
            'youtubeLink': 'https://www.youtube.com/live/Qv8myvTruxY?si=Rzj04ZPtll8DnIno&t=3775',
        },
        {
            'subTopicName': 'Is Vraja-bhakti for everyone? What if my eternal form is in Vaikuṇṭha? (28 min)',
            'youtubeLink': 'https://youtu.be/ekEVgxupvng?si=wADNpVYHII0TXLpn&t=3624',
        },
        {
            'subTopicName': 'Which is the most potent limb of bhakti? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/T8_KihNeqEk?si=gQErvlyrgbXbLf5-&t=2824',
        },
        {
            'subTopicName': 'Why did Śrīla Prabhupāda install deities of Lord Rāmacandra in some of the ISKCON temples? Can\'t it distract the devotees in pursuing Vraja-prema? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/wA-GpgZ-J4c?si=whjdldzrgS3GjO6Q&t=1491',
        },
        {
            'subTopicName': 'How to understand non-devotees exhibiting more good qualities than the devotees? Isn\'t Bhakti supposed to bestow all good qualities? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/q21rUjORUJI?si=t0aakaAUehtnj6RW&t=232',
        },
        {
            'subTopicName': 'How bhakti is Nirguṇa if the senses and mind performing that bhakti are within the three modes? - Part-1. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/q21rUjORUJI?si=yPn9iSykC0S9xoU1&t=3112',
        },
        {
            'subTopicName': 'Is Bhakti intrinsic to the Jīva? What does "Guru Kṛṣṇa prasāde pāye bhakti-latā bīja" actually mean? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/q21rUjORUJI?si=2nqfMbCzj6ps11H2&t=3414',
        },
        {
            'subTopicName': 'How bhakti is Nirguṇa if the senses and mind performing that bhakti are within the three modes? - Part-2. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/q21rUjORUJI?si=XbN3u9-phjLCarSq&t=5252',
        },
        {
            'subTopicName': 'Two reasons why the activities in bhakti are transcendental (Nirguṇa). (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/yGOBaKMgyn0?si=RZ1Ztm3c1CvRArtm&t=3815',
        },
        {
            'subTopicName': 'Is Kṛṣṇa Prema inherent or inspired? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/8MTQOdwb7Fg?si=DPfe0ktctJDMkDMW&t=1570',
        },
        {
            'subTopicName': 'Relationship between Yogamāyā and Prema. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/kHDK6F33peg?si=4kz4Qhkmzya8dy7h&t=2588',
        },
        {
            'subTopicName': 'Are sādhakas under the influence of Yogamāyā or Mahāmāyā? (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/kHDK6F33peg?si=RN0metEEz0ChSL2m&t=2825',
        },
        {
            'subTopicName': 'Is Bhakti inherent or inherited? (47 min)',
            'youtubeLink': 'https://www.youtube.com/live/8MTQOdwb7Fg?si=zW7ldafZJNwZTe0l&t=784',
        },
        {
            'subTopicName': 'Faith in Bhakti will not develop without sukṛti. (13 min)',
            'youtubeLink': 'https://youtu.be/HBLbm1PVlNQ?si=AbEfg-g8sp3kpj3M&t=2111',
        },
        {
            'subTopicName': 'Does one have to be an initiated devotee for Kṛṣṇa to personally intervene? (6 min)',
            'youtubeLink': 'https://youtu.be/5Qfhq45x0_I?si=5U8xmdTgstr4RIkX&t=4680',
        },
        {
            'subTopicName': 'Devotees and good qualities. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/DJnW58BcFek?si=xceaj_bfmxv5ZHCR&t=3521',
        },
        {
            'subTopicName': 'Kṛṣṇa personally maintains devotees. (28 min)',
            'youtubeLink': 'https://youtu.be/sPqA9dvDNNM?si=kHqBNozyTvoFPy1b&t=737',
        },
        {
            'subTopicName': 'Experiences of devotees—how they came to bhakti. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sYFkbDvA9vg&t=1740s',
        },
        {
            'subTopicName': 'Does the free will of the receiving jīva play any role in the receiving of bhakti? – Part-1. (28 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sYFkbDvA9vg&t=2480s',
        },
        {
            'subTopicName': 'Does the free will of the receiving jīva play any role in the receiving of bhakti? – Part-2. (37 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=yfuzWHHVRoU&t=120s',
        },
        {
            'subTopicName': 'Śāstric evidences for the concept of śraddhā-svabhāva tug of war. (23 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=yfuzWHHVRoU&t=300s',
        },
        {
            'subTopicName': 'If bhakti is self-causative, then why is it said that only by mercy of Guru and Kṛṣṇa we receive the seed of devotion? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=yfuzWHHVRoU&t=2340s',
        },
        {
            'subTopicName': 'From what stage of a sādhaka’s bhakti does Kṛṣṇa take his responsibility? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=yfuzWHHVRoU&t=2771s',
        },
        {
            'subTopicName': 'Why do we say that prayojana is Kṛṣṇa-prema and not Kṛṣṇa Himself? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rnLOb76ko0A&t=3379s',
        },
        {
            'subTopicName': 'Bhakti supports karma-yoga. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=byeLP0tX4Nc&t=2740s',
        },
        {
            'subTopicName': 'Do karma-yogīs, jñāna-yogīs and aṣṭāṅga-yogīs ever feel the necessity or importance of bhakti? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=byeLP0tX4Nc&t=3564s',
        },
        {
            'subTopicName': 'What qualifies as pure śraddhā? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=miIZ5wHAJs8&t=2964s',
        },
        {
            'subTopicName': 'What weakens faith? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=miIZ5wHAJs8&t=3480s',
        },
        {
            'subTopicName': 'Examples of purity of faith and strength of faith. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=miIZ5wHAJs8&t=3705s',
        },
        {
            'subTopicName': 'Bhakti doesn’t depend on purity. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-9dp2mzOlKM&t=2120s',
        },
        {
            'subTopicName': 'Bhakti doesn’t depend on faith. (52 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ojNX7c_Kk30&t=150s',
        },
        {
            'subTopicName': 'Kṛṣṇa guarantees to take care and purify the devotee who sincerely practices devotional service. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ojNX7c_Kk30&t=1382s',
        },
        {
            'subTopicName': 'Meaning of yajña for the devotees. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=K5BB56w1M38&t=2741s',
        },
        {
            'subTopicName': 'Realm of karma for devotees and non-devotees. (65 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=X5x74WCbg3g&t=1260s',
        },
        {
            'subTopicName': 'Scriptural proofs about the role of karma in a devotee’s life. (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=X5x74WCbg3g&t=2710s',
        },
        {
            'subTopicName': 'Kṛṣṇa personally takes care of His devotee’s life. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5jTppLPr2Nw&t=1495s',
        },
        {
            'subTopicName': 'Kṛṣṇa’s devotee is not governed by the law of karma. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5jTppLPr2Nw&t=1700s',
        },
        {
            'subTopicName': 'Our free will is our only possession and must be utilised to love Kṛṣṇa. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5jTppLPr2Nw&t=4098s',
        },
        {
            'subTopicName': 'For a devotee next birth is not dependent on the remembrance at the time of death. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EkGPE4oRvgo&t=684s',
        },
        {
            'subTopicName': 'Understanding the full scope of devotional service. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EkGPE4oRvgo&t=5263s',
        },
        {
            'subTopicName': 'Qualifications for bhakti. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ewylq64UBGs&t=2944s',
        },
        {
            'subTopicName': 'Saguṇa-bhakti. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ewylq64UBGs&t=3618s',
        },
        {
            'subTopicName': 'Abhilāṣas and anarthas. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vqtB83kCAKk&t=2239s',
        },
        {
            'subTopicName': 'Difference between vaidhi-sādhana-bhakti and mixed devotional service. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vqtB83kCAKk&t=2859s',
        },
        {
            'subTopicName': 'Can our bhakti seed change from pure devotional seed to mixed devotional seed? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QAV4P_DseEg&t=3200s',
        },
        {
            'subTopicName': 'Since our sampradāya is rāsa-ātmikā, can one directly start in rāgānugā-bhakti? (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/WvuXneSOLmU?si=m_6q3goVazQJcfG8&t=2115',
        },
        {
            'subTopicName': 'How can one favourably practicing bhakti give it up completely? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/-4fWZa3IqS8?si=aBk37foB1OdBH8jj&t=3703',
        },
        {
            'subTopicName': 'There is no material qualification or disqualification to practice bhakti. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/h0AL964D8mU?si=eLGdCA5mZXxRs1vs&t=1450',
        },
        {
            'subTopicName': 'Is there misfortune or falldown for a devotee? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/h0AL964D8mU?si=poD54b5io0VHk8oc&t=2701',
        },
        {
            'subTopicName': 'Understanding the principles of bhakti according to one’s adhikāra. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/FcWTqdy5Kgk?si=d0q0TL3QwrGHucnb&t=1201',
        },
        {
            'subTopicName': 'Does devotee\'s giving up of varṇāśrama mean irresponsible behavior? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/FcWTqdy5Kgk?si=4-aJam-xxMQ4ffo4&t=3851',
        },
        {
            'subTopicName': 'Karma does not act on devotees. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/9VzQoyr1xZQ?si=YXbomMCipEAHmbdA&t=3104',
        },
        {
            'subTopicName': 'How to understand that an offender of a Vaiṣṇava becomes a devotee? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/uvqUcmzKVhQ?si=NwqlLa7ysEpbtV7k&t=3909',
        },
        {
            'subTopicName': 'Three factors which influence the speed of progress in bhakti. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/KWzzpMq-mNI?si=oyY7pEC0gDw0Fkj_&t=846',
        },
        {
            'subTopicName': 'When does destruction of prārabdha-karma happen in a sādhaka? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/Nbu7MFESQ84?si=q9ErxDWeKsJxfIhG&t=2932',
        },
        {
            'subTopicName': 'If karma is destroyed by bhakti, then why does one take more lifetimes for perfection? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/5enwGJglbhg?si=aE-MMhKiULOezTKD&t=3557',
        },
        {
            'subTopicName': 'When Kṛṣṇa comes, all becomes secondary. How to apply this in practical life? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/pWdeQCFPTRo?si=9Ckn2eFun-aadEWE&t=3412',
        },
        {
            'subTopicName': 'If there is no qualification needed for bhakti, then why do we speak about bhakti-adhikāra? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/RniTCjHns4Y?si=4EEC7BRO6LT0WP23&t=3760',
        },
        {
            'subTopicName': 'The Brahmajyoti misconception and the mercy of the Ācāryas. (34 min)',
            'youtubeLink': 'https://www.youtube.com/live/sx87Y2vK3vQ?si=DvGBpm1F0SdV1Bu7&t=1211',
        },
        {
            'subTopicName': 'In order to enhance our bhakti we need to realize Kṛṣṇa, and in order to realize Kṛṣṇa we have to enhance our bhakti. How to understand this circular logic? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/FhQaHCtXw4s?si=cNX-Z5roNciSogBP&t=1668',
        },
        {
            'subTopicName': 'Jñāna and vairāgya are not limbs of bhakti. (18 min)',
            'youtubeLink': 'https://youtu.be/kVLqAUzRayw?si=1yj_adERISFHzXuN&t=2306',
        },
        {
            'subTopicName': 'Understanding yukta and phalgu-vairāgya. (35 min)',
            'youtubeLink': 'https://youtu.be/HgXOw8lJZ14?si=P5iYye773qFUhp12&t=720',
        },
        {
            'subTopicName': 'Do pious practices constitute limbs of bhakti? (7 min)',
            'youtubeLink': 'https://youtu.be/HgXOw8lJZ14?si=H-psv8V6MVG_2411&t=2783',
        },
        {
            'subTopicName': 'If bhakti destroys prārabdha-karma, then why does a devotee suffer? (25 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=fprGtZGTI__63bEz&t=252',
        },
        {
            'subTopicName': 'If a person is still affected by desires of pūjā, lābha and pratiṣṭhā, can his bhakti be considered to be pure devotional sādhana? (4 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=IxXV5L3FcUsp0hjb&t=3468',
        },
        {
            'subTopicName': 'Why Draupadī asking help from Kṛṣṇa is accepted as pure devotional service? (4 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=DMnKUzv879t-z75s&t=3691',
        },
        {
            'subTopicName': 'How does one get purified, if he is not performing uttamā-bhakti? (2 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=vEtpo1l1UK1qNyVY&t=3971',
        },
        {
            'subTopicName': 'How Kṛṣṇa bestows pure bhakti to Dhruva Mahārāja? (2 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=1svSAIpHC_A_Oz7C&t=4020',
        },
        {
            'subTopicName': 'What is the difference between bhakti and uttamā-bhakti? (2 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=nBicm-y1EYiCPRS4&t=4134',
        },
        {
            'subTopicName': 'Is it possible for a sādhaka to experience bhāva sometimes? (2 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=iMobemXNP5gWbPg6&t=5021',
        },
        {
            'subTopicName': 'Devotees’ suffering is not due to their prārabdha-karma. (28 min)',
            'youtubeLink': 'https://www.youtube.com/live/YFxqYGzfQIk?si=LWUrZ12Sb8Q2Zxte&t=1437',
        },
        {
            'subTopicName': 'How can the Lord, so affectionate to His devotees, make them suffer? (24 min)',
            'youtubeLink': 'https://www.youtube.com/live/YFxqYGzfQIk?si=wNVS7jO7LBqCwItE&t=2085',
        },
        {
            'subTopicName': 'When Kṛṣṇa takes everything from a devotee, then won’t the devotee leave bhakti? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/YFxqYGzfQIk?si=KLy9q2V3C9n_B7he&t=3472',
        },
        {
            'subTopicName': 'If the devotee’s suffering is not due to karma, then why are they recommended to see their sufferings as karma? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/YFxqYGzfQIk?si=ys77YzoD_UPS0m7p&t=3674',
        },
        {
            'subTopicName': 'Can a devotee’s future be predicted through their horoscope? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/YFxqYGzfQIk?si=RuaSOiqWk0GLe49L&t=4029',
        },
        {
            'subTopicName': 'What are the reasons for not getting immediate results from practice of bhakti? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/YFxqYGzfQIk?si=KUu0jGGKT375Wopi&t=4146',
        },
        {
            'subTopicName': 'Good qualities in non-devotees vs. good qualities in devotees — is the Lord equally pleased by both? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=kUSzNWc62Lw&list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&index=57&t=2411s',
        },
        {
            'subTopicName': 'The connection between devotional credits and aparādha. (6 min)',
            'youtubeLink': 'https://youtu.be/aMYvNoX0CUI?si=LdZnLRYldp0mEJ6_&t=2168',
        },
        {
            'subTopicName': 'Understanding the interplay of free will and conditioning in getting the qualification for bhakti. (60 min)',
            'youtubeLink': 'https://www.youtube.com/live/2c4jNSS9kpE?si=SSgWk9uURw-i4XAd&t=1198',
        },
        {
            'subTopicName': 'Relevance of Gopa Kumāra’s journey for a practicing sādhaka. (4 min)',
            'youtubeLink': 'https://youtu.be/nQ0mLXBs-qQ?si=dDUzCtmdflkLB4II&t=3376',
        },
        {
            'subTopicName': 'Does the Lord reciprocate personally with pure devotees only? (2 min)',
            'youtubeLink': 'https://youtu.be/kHMp4s8KMBM?si=o_gUYNWYb3gU_FG7&t=4476',
        },
        {
            'subTopicName': 'What is eka-niṣṭhā? (8 min)',
            'youtubeLink': 'https://youtu.be/kHMp4s8KMBM?si=qgiLVKJqCIvx7Nyf&t=4648',
        },
        {
            'subTopicName': 'Understanding the intricacies of causeless love for the Lord. (16 min)',
            'youtubeLink': 'https://www.youtube.com/live/6cUjH7NqSw8?si=dN2qslK5Vor9g1SU&t=3178',
        },
        {
            'subTopicName': 'Role of surrender in pure love. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/6cUjH7NqSw8?si=ZCL9nmYuaqQafbEv&t=5062',
        },
        {
            'subTopicName': 'There is no other external factor to receiving bhakti other than the mercy of devotees. (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/7sBphkords4?si=UbMDQ7Sb1jLx0mS1&t=1270',
        },
        {
            'subTopicName': 'Understanding how karma is not a limb of bhakti. (33 min)',
            'youtubeLink': 'https://www.youtube.com/live/svGuxsB2ryE?si=-F4wo5cV5CpZGrYV&t=1381',
        },
        {
            'subTopicName': 'It is not wrong to say that Kali-yuga dharma is Vaiṣṇava‑sevā. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/Fj7DzcIWN64?si=EkBW9syxZw436Cfp&t=3652',
        },
        {
            'subTopicName': 'Reasons for people taking up devotional service. (31 min)',
            'youtubeLink': 'https://youtu.be/EYaZ2XSLwts?si=pItHV_CknLTARRNx&t=4540',
        },
        {
            'subTopicName': 'What if one is attracted to sayujya even after hearing the glories of Goloka? (13 min)',
            'youtubeLink': 'https://youtu.be/pVYq4qnCMDA?si=J8_OvRsXAcK4YBZD&t=1194',
        },
        {
            'subTopicName': 'Is the desire to return back to the spiritual world a desire opposed to the pure devotional principles? (5 min)',
            'youtubeLink': 'https://youtu.be/pVYq4qnCMDA?si=IfM1xTfsr0jm3w0T&t=2220',
        },
        {
            'subTopicName': 'Those who chant the holy names even once will escape hell. (1 min)',
            'youtubeLink': 'https://youtu.be/pVYq4qnCMDA?si=D5BAOQWWxKwjpbqu&t=2706',
        },
        {
            'subTopicName': 'Does demigod worship bestow material results faster than worshipping Kṛṣṇa? (14 min)',
            'youtubeLink': 'https://youtu.be/FwZywLwu6Wk?si=lLSAx4T1Mft4mtD0&t=4399',
        },
        {
            'subTopicName': 'Comparing the ego in karma‑yoga and bhakti‑yoga. (4 min)',
            'youtubeLink': 'https://youtu.be/_hEdInbzrv8?si=pAnLZ_vEC-rSW5vn&t=4369',
        },
        {
            'subTopicName': 'The ten types of saṁskāras as described in dharma‑śāstras are not mandatory for the devotees. (2 min)',
            'youtubeLink': 'https://youtu.be/_hEdInbzrv8?si=mkEIOH_SMMuqcDCS&t=4580',
        },
        {
            'subTopicName': 'Devotees and varṇāśrama. (12 min)',
            'youtubeLink': 'https://youtu.be/WpdSAdGLTEA?si=Y-te_3U_1jubgaXY&t=1336',
        },
        {
            'subTopicName': 'Different terminologies used by ācāryas for classification of types of bhakti. (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/6OI7sdLI8Vo?si=C5pluDpRIiZ2ZcKl&t=2310',
        },
        {
            'subTopicName': 'How bhakti acts similar to digestive fire in destroying anarthas while preserving spiritual impressions? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/jouVi4pU3Xk?si=v1ivqEHsJSWrvZ2C&t=2562',
        },
        {
            'subTopicName': 'What role does the mentality and faith with which an activity is performed play in defining the type of bhakti? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/YoPVAdlIo-w?si=NQI48b104RjGyov0&t=3194',
        },
        {
            'subTopicName': 'Is it possible/not possible to go back to Godhead in one lifetime? (4 min)',
            'youtubeLink': 'https://youtu.be/YacS18Q0dDI?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=5725',
        },
        {
            'subTopicName': 'Do devotees take other people’s sins? (5 min)',
            'youtubeLink': 'https://youtu.be/zmbxeCag-RI?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=4033',
        },
        {
            'subTopicName': 'Does an aṣṭāṅga‑yogī, because of his pure heart, progress very fast if he takes up bhakti? (11 min)',
            'youtubeLink': 'https://youtu.be/s-MQjjU6XMc?si=QowpxGRQNK5IeMUV&t=1669',
        },
        {
            'subTopicName': 'If a person with a very clean heart takes up bhakti, would he attain niṣṭhā very fast? (5 min)',
            'youtubeLink': 'https://youtu.be/s-MQjjU6XMc?si=CMiOCYM-SLp9OSQe&t=2361',
        },
        {
            'subTopicName': 'How to understand if a devotee’s faith is compromised with jñāna or yoga? (5 min)',
            'youtubeLink': 'https://youtu.be/YMCwAkYXODM?si=To8BZjCxdCdmv1EU&t=2339',
        },
        {
            'subTopicName': 'Devotee’s suffering is not due to prārabdha‑karma. (15 min)',
            'youtubeLink': 'https://youtu.be/lApvtNPj6to?si=QtQzLEHEXtNU780b&t=2798',
        },
        {
            'subTopicName': 'Understanding continuity (anu) in the definition of pure devotional service. (46 min)',
            'youtubeLink': 'https://youtu.be/z9bGcrczhi0?si=BkGTLt2vjwXzHP-7&t=935',
        },
        {
            'subTopicName': 'Why does a devotee undergo suffering if bhakti is said to be su‑sukhaṁ? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/454cpAnNtMU?si=4OijL8PuCHc9_ScQ&t=2762',
        },
        {
            'subTopicName': 'Was Pradyumna Cupid in his previous birth? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/T7MOMdCA690?si=jnWFTa48RxhxvS5z&t=2730',
        },
        {
            'subTopicName': 'Why do the nitya‑siddhas have to perform austerities to attain Kṛṣṇa? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/da3Mhwh6Kec?si=Ii-7wgl3NkRa4Z66&t=1202',
        },
        {
            'subTopicName': 'There is no guarantee that a devotee will take birth in a devotee family. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/TNeLuClc1oI?si=jbRasWhkg910klFW&t=1379',
        },
        {
            'subTopicName': 'Does garbha‑dhāna saṁskāra guarantee a devotee child? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/TNeLuClc1oI?si=yBxDWZPhx5t7-pib&t=1871',
        },
        {
            'subTopicName': 'Ideologies vs religious practices. (53 min)',
            'youtubeLink': 'https://youtu.be/s7gxOBZxXTY?si=-2HQa1F1TBxQzJKZ&t=2881',
        },
        {
            'subTopicName': 'Resolving doubts strengthens sambandha‑jñāna. (7 min)',
            'youtubeLink': 'https://youtu.be/R7j9POpY4bU?si=3K6FS2jT5rk2AZ9o&t=4543',
        },
        {
            'subTopicName': 'Primary/secondary rules of bhakti vs primary and secondary dharma. (88 min)',
            'youtubeLink': 'https://youtu.be/FdtvkYbDPWE?si=Gj91tq_3r4IcB6Ch&t=1551',
        },
        {
            'subTopicName': 'Daśa‑mūla‑tattva is absolutely necessary for vaidhī sādhakas but not for raga‑bhaktas. (34 min)',
            'youtubeLink': 'https://youtu.be/E-F-FbtvVaQ?si=9H_fxKWsNE9H4Hr5&t=1626',
        },
        {
            'subTopicName': 'Kṛṣṇa uses māyā and devotees to guide the conditioned souls back to the spiritual world. (7 min)',
            'youtubeLink': 'https://youtu.be/3e3jFtvIWMU?si=SloKfnk1WbZp4Lpp&t=2711',
        },
        {
            'subTopicName': 'Śuddha‑bhakti. The only sādhana. (21 min)',
            'youtubeLink': 'https://youtu.be/pIVrffAk210?si=2zuvfV0TTQ_F8Exf&t=5751',
        },
        {
            'subTopicName': 'Will animals be assured of a human birth in their next lives if we feed them prasādam in this life? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ngCFwTEm7Zo&t=4189s',
        },
        {
            'subTopicName': 'How should we look at Exalted Devotee\'s physical sufferings? (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=AgK1wHrMdLQ&t=4355s',
        },
        {
            'subTopicName': 'Does Bhakti depend on Sukṛti for one to develop faith in Bhakti? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jOAW3XNnk5M&t=2961s',
        },
        {
            'subTopicName': 'What is the difference between abhilāṣa and abhilāṣitā? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ngo3AF4gytQ&t=4214s',
        },
        {
            'subTopicName': 'Is inattentive hearing by the Vaiṣṇavas without translating it into service Jñāna Prayās? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nC3nN3mEQc8&t=3130s',
        },
        {
            'subTopicName': 'What\'s the difference between pure devotees like Pṛthu Mahārāja thinking that their present state is because of their Karma AND ordinary Sādhakas like us thinking the same? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XSAGwNMoF08&t=2048s',
        },
        {
            'subTopicName': 'What\'s the difference between pure devotees like Pṛthu Mahārāja thinking that their present state is because of their Karma AND ordinary Sādhakas like us thinking the same? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XSAGwNMoF08&t=2048s',
        },
        {
            'subTopicName': 'Pure devotional service or mixed devotional service is decided by one\'s faith and not his conditioning. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GhMA8-sKdI0&t=2527s',
        },
        {
            'subTopicName': 'How does a living entity receive the seed of Devotion? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=irXwcVTNbbQ&t=6050s',
        },
        {
            'subTopicName': 'How do we understand devotees\' children being strong at one point in time and completely giving up devotional service later? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ngCFwTEm7Zo&t=4534s',
        },
        {
            'subTopicName': 'How do we understand the falldown of Sannyāsīs within ISKCON? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9EvcG3HS9ZQ&t=2225s',
        },
        {
            'subTopicName': 'Is it Lord\'s arrangement to connect Jīvas to different Ācāryas of different Sampradāyas to develop a particular mood? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hqKudy8CZuQ&t=4440s',
        },
        {
            'subTopicName': 'Why do pure devotees like Pṛthu Mahārāja address the Lord as kaivalya‑pati sometimes, if they themselves are NOT interested in liberation? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h18rDjUNHRM&t=4154s',
        },
        {
            'subTopicName': 'Virakti and realisation increases as one progresses in Bhakti. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6FPH1bGupDk&t=1380s',
        },
        {
            'subTopicName': 'If one receives a particular seed (flavour) of Bhakti, does it remain the same throughout? (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oh6fTI7lz18&t=3917s',
        },
        {
            'subTopicName': 'What emotions can we dovetail in Kṛṣṇa\'s service? (61 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RAGls-9gZVU&t=3254s',
        },
        {
            'subTopicName': 'How can desires in the Mode of Goodness be dovetailed in Kṛṣṇa\'s service, WHILE desires in the lower modes NOT dovetailed? (66 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RAGls-9gZVU&t=3760s',
        },
        {
            'subTopicName': 'Is it not disturbing to see one incarnation of the Lord (Pṛthu) fighting another (Indra)? How should we see this? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=76tSxvBUtZE&t=3330s',
        },
        {
            'subTopicName': 'Is protection of cows an act of Varṇāśrama OR Bhakti? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vc95tzVZ3Qw&t=2898s',
        },
        {
            'subTopicName': 'Do devotees only at the stage of Prema have love for Kṛṣṇa? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2aJZVXd88aA&t=4380s',
        },
        {
            'subTopicName': 'What is the difference between Bābājīs and sannyāsīs? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rGDhBdnJWgc&t=3211s',
        },
        {
            'subTopicName': 'Does indiscriminate charity by devotees lead to karma? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=X6mgE1oQFto&t=3300s',
        },
        {
            'subTopicName': 'What is the difference between nitya karma and nitya dharma? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vt-nAaamMZM&t=5901s',
        },
        {
            'subTopicName': 'Definitions of Pradhānī bhūta, Guṇī bhūta and Śuddha Bhakti (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9EvcG3HS9ZQ&t=4848s',
        },
        {
            'subTopicName': 'Right or Wrong? " Seeing Kṛṣṇa’s will behind every apparent injustice " (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=fCnjnG9Ioz0&t=2647s',
        },
        {
            'subTopicName': 'What is the difference between a Niṣkāma Bhakta and Vaidhī Sādhaka? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=R2VmZix87yA&t=1618s',
        },
        {
            'subTopicName': 'Characteristics of the process of Bhakti. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GhMA8-sKdI0&t=631s',
        },
        {
            'subTopicName': 'Vijñāna - realisation of the knowledge of Kṛṣṇa occurs in proportion to the intensity of our worship. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=xqsdZWrV2FM&t=2232s',
        },
        {
            'subTopicName': 'Definitions of Pradhānī bhūta Bhakti and Śuddha Bhakti and their destinations and results. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=xqsdZWrV2FM&t=716s',
        },
        {
            'subTopicName': 'A devotee\'s suffering is not due to his prārabdha karma. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=X5x74WCbg3g&t=2738s',
        },
        {
            'subTopicName': 'Is a Sādhaka on the platform of False Ego or True Ego? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OrEbBFsqADg&t=2015s',
        },
        {
            'subTopicName': 'Characteristics of the process of bhakti. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GhMA8-sKdI0&t=631s',
        },
        {
            'subTopicName': 'Unless one has sufficient sukṛti, he cannot appreciate the glories of Bhakti and Kṛṣṇa Prema. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=q0FTkYQBz1E&t=3798s',
        },
        {
            'subTopicName': 'Is bhakti inherent in the jīva? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=E1Huq3O0vsg&t=2230s',
        },
        {
            'subTopicName': 'What is the dharma of a jīva before receiving the seed of bhakti? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=zh48Lok_D8c&t=1720s',
        },
        {
            'subTopicName': 'How could mlecchas and yavanas from other countries realize the Jaiva dharma without knowing the form, name and qualities of the Lord? (22 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=zh48Lok_D8c&t=2370s',
        },
        {
            'subTopicName': 'Why is there so much difficulty to follow one’s eternal dharma? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vt0EOh18BwQ&t=6865s',
        },
        {
            'subTopicName': 'Effect of the three modes on Bhakti and Conditioning. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Aia0KJjqInw&t=3026s',
        },
        {
            'subTopicName': 'What really changes at the dawn of devotion? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9EvcG3HS9ZQ&t=4412s',
        },
        {
            'subTopicName': 'Devotees are not bound by karma, Kṛṣṇa takes over right from the Śraddhā stage. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=X5x74WCbg3g&t=1313s',
        },
        {
            'subTopicName': 'Do devotees get sin if they eat unoffered food? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=K5BB56w1M38&t=2997s',
        },
        {
            'subTopicName': 'How to redirect our love and affection towards Kṛṣṇa instead of material relationships? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=kghkt4_jLzE&t=5740s',
        },
        {
            'subTopicName': 'Are Gauḍīya Vaiṣṇavas disrespectful about those pursuing Brahman and Paramātmā? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=w3TyHuJD0cw&t=3717s',
        },
        {
            'subTopicName': 'Who can understand the dualities of the Lord? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2D3b3u4tiQ0&t=2502s',
        },
        {
            'subTopicName': 'Can one have devotion for Paramātmā and Bhagavān feature? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2D3b3u4tiQ0&t=4847s',
        },
        {
            'subTopicName': 'Can one take up to pure devotion by reading scriptures on their own, without coming in contact with devotees? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=zh48Lok_D8c&t=4860s',
        },
        {
            'subTopicName': 'Fate of a devotee who does not attain perfection in this life. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=w3TyHuJD0cw&t=3391s',
        },
        {
            'subTopicName': 'Should one try to cultivate the 6 limbs of surrender or will it develop automatically with growth in Bhakti? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pHtStax8QBU&t=3180s',
        },
        {
            'subTopicName': 'Does anxiety for results indicate that we don’t have complete surrender? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pHtStax8QBU&t=5350s',
        },
        {
            'subTopicName': 'What should a disciple do if his guru is discouraging him from respecting Vaiṣṇavas? (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pHtStax8QBU&t=5647s',
        },
        {
            'subTopicName': 'Various types of Bhakti and their characteristics. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2JHFguvmCfE&t=4286s',
        },
        {
            'subTopicName': 'Why the Śāstras repeatedly call persons striving for Liberation as less intelligent? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=YUQ_hACNqp8&t=2720s',
        },
        {
            'subTopicName': 'Why the Bhakti Śāstras seem to encourage Liberation? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=MFd3A2euW3o&t=4285s',
        },
        {
            'subTopicName': 'Is Brahmā, who has not achieved spiritual perfection, guaranteed a birth in a devotee family? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5gBZRGZdwRI&t=2005s',
        },
        {
            'subTopicName': 'Different levels of Self Realisation. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=YUQ_hACNqp8&t=3330s',
        },
        {
            'subTopicName': 'Role of intelligence in a Sādhaka\'s life and a Self Realized person\'s life. (53 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=uXosOLmwCTg&t=525s',
        },
        {
            'subTopicName': 'How does one know if he is qualified for bhakti? (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=b6wJQpJQurw&t=2754s',
        },
        {
            'subTopicName': 'Is there a clear demarcation as to when one crosses from Vaidhī to Rāgānugā? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=CV6J5WDhduQ&t=4619s',
        },
        {
            'subTopicName': 'Is it possible to understand spiritual subject matters through conditioned defective senses? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=uXosOLmwCTg&t=3710s',
        },
        {
            'subTopicName': 'What is the use of hearing Kṛṣṇa‑kathā if our senses are anyways defective? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=uXosOLmwCTg&t=3710s',
        },
        {
            'subTopicName': 'Paradox of Spiritual Life : those who don\'t have it don\'t feel the need for it, and those who have it feel they can\'t live without it. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ft5OYPZnBho&t=563s',
        },
        {
            'subTopicName': 'Next birth of a Sādhaka in this material world is not due to his Karma. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ft5OYPZnBho&t=2780s',
        },
        {
            'subTopicName': 'Why does Śrīmad‑Bhāgavatam contain glorification of Brāhmaṇas if it rejects Varṇāśrama? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=y7FRfYpPTxo&t=3416s',
        },
        {
            'subTopicName': 'Why are the Brāhmaṇas glorified sometimes in the Śrīmad‑Bhāgavatam to be more exalted than even the Supreme Lord? (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tXLaiH5XLzA&t=1041s',
        },
        {
            'subTopicName': 'Though spoken by exalted devotees, the words of Śrīmad‑Bhāgavatam need NOT be always philosophically correct. (26 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tXLaiH5XLzA&t=1862s',
        },
        {
            'subTopicName': 'It is important to understand the words of an Ācārya in reference to the context, his own greater teachings, and the teachings of the greater Paramparā. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tXLaiH5XLzA&t=2554s',
        },
        {
            'subTopicName': 'How should we see devotees sometimes introduced as belonging to Brāhmaṇa families? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tXLaiH5XLzA&t=3405s',
        },
        {
            'subTopicName': 'Is it true that the airplanes come only to go to Vaikuṇṭha, but for going to Goloka one has to only change his consciousness? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0IPPwGpKaKc&t=1391s',
        },
        {
            'subTopicName': 'There is no material disqualification to gain qualification for Bhakti. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-dkJ3oTj9Kc&t=3260s',
        },
        {
            'subTopicName': 'In the absence of a qualified guru, one must take association of advanced Vaiṣṇavas and serve them. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7FEVl_0dUvs&t=3800s',
        },
        {
            'subTopicName': 'Scriptures glorifying one of the limbs of Bhakti should not be taken as a suggestion to neglect the performance of other limbs. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7FEVl_0dUvs&t=4976s',
        },
        {
            'subTopicName': 'Perfection of sacrifices and charitable acts through performance under association and guidance of devotees. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7FEVl_0dUvs&t=4527s',
        },
        {
            'subTopicName': 'How the Supereme Lord, who is Bhāva‑grāhī, deals with a Sādhaka troubled by desires for Sense Gratification? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=4258s',
        },
        {
            'subTopicName': 'Even unknowing association of devotees is valuable. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EBAqOcl0Gts&t=4568s',
        },
        {
            'subTopicName': 'Śāstras criticize one who considers a guru to be an ordinary person. The same śāstras glorify association with an exalted devotee without knowledge of his greatness. How to resolve this contradiction? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EBAqOcl0Gts&t=4645s',
        },
        {
            'subTopicName': 'Even unknowing association of devotees is valuable ‑ Part‑2 (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EBAqOcl0Gts&t=5304s',
        },
        {
            'subTopicName': 'Genuine love is indicated by the expression of love for the tadīya. (28 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EBAqOcl0Gts&t=5425s',
        },
        {
            'subTopicName': 'On what basis should a Sādhaka prioritize one limb of Bhakti over the other? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7YQcN7hlx9w&t=5640s',
        },
        {
            'subTopicName': 'The true ego of a Vaiṣṇava? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=1380s',
        },
        {
            'subTopicName': 'Varṇa designations are not appropriate for a Vaiṣṇava. (49 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=2500s',
        },
        {
            'subTopicName': 'Gotra in Gauḍīya Vaiṣṇava tradition. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=2624s',
        },
        {
            'subTopicName': 'Vaiṣṇava Humility Vs Jāti‑buddhi. (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=4255s',
        },
        {
            'subTopicName': 'Mixed Devotional Service and Varṇāśrama designations. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=5455s',
        },
        {
            'subTopicName': 'Taste for hearing Kṛṣṇa‑kathā is the basic qualification for Bhakti. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3qnSB9TmSAQ&t=3480s',
        },
        {
            'subTopicName': 'Balancing practicality with proper etiquettes. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3qnSB9TmSAQ&t=3825s',
        },
        {
            'subTopicName': 'If one chanting of the Holy Name destroys all Karmas, then why does Anartha‑nivṛtti take even lifetimes sometimes? (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=3158s',
        },
        {
            'subTopicName': 'How is Jñāna an obstacle to Bhakti if it destroys the subtle body too? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=3552s',
        },
        {
            'subTopicName': 'Is there any way to know whether my impressions of pre Kṛṣṇa conscious life are decreasing or increasing? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=4161s',
        },
        {
            'subTopicName': 'What is the difference a spiritual body and a spiritualised material body? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=4870s',
        },
        {
            'subTopicName': 'How do we understand the 4 Kumāras to be mixed devotees when they actually lead the Kumāra‑sampradāya? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0qKHOs7NFqM&t=4676s',
        },
        {
            'subTopicName': 'Can Viṣṇu Worshippers become Demigod Worshippers and vice versa? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=3580s',
        },
        {
            'subTopicName': 'Considering a devotee to belong to a caste is an offense. But a non‑devotee can get benefitted by unknowingly getting attached to a devotee belonging to his caste. How to reconcile? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OSP02lDJzkw&t=960s',
        },
        {
            'subTopicName': 'What does \'taking shelter at the lotus feet of the Lord\' mean? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0utgOK2TwGU&t=3268s',
        },
        {
            'subTopicName': 'Difference between gratitude and a sense of obligation. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=1728s',
        },
        {
            'subTopicName': 'Is Bhakti easy / tedious? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=4149s',
        },
        {
            'subTopicName': 'Is Vānaprastha‑āśrama mandatory for all Gṛhastha devotees? (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=650s',
        },
        {
            'subTopicName': 'Were Śrīla Prabhupāda and Jesus Śaktyāveśa‑avatāras? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=3769s',
        },
        {
            'subTopicName': 'Is the process of merging one element into another while devotees leave their bodies as described in Śrīmad‑Bhāgavatam figurative OR real? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=5079s',
        },
        {
            'subTopicName': 'Can one repay one\'s Guru OR the great Vaiṣṇavas? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=1504s',
        },
        {
            'subTopicName': 'Should we act on the platform of Mahābhārata or Śrīmad‑Bhāgavatam? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=4759s',
        },
        {
            'subTopicName': 'Why there is so much mention about conditioning in discussions on Vaiṣṇava relationships if anartha‑nivṛtti happens automatically by practice of Bhakti? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glVWOuUj9OA&t=3165s',
        },
        {
            'subTopicName': 'How did Jñāna‑miśra‑bhaktas like the 4 Kumāras glorify Śuddha‑bhakti? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5zk7IbCiQJY&t=261s',
        },
        {
            'subTopicName': 'Discouraging children to carry on with their material studies will only increase their irresponsibilty later in bhakti also. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=1710s',
        },
        {
            'subTopicName': 'Why did pure devotees like Pṛthu Mahārāja engage in their Varṇāśrama duties perfectly? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=2942s',
        },
        {
            'subTopicName': 'Why did Pṛthu Mahārāja have to indulge in such severe austerities in the Vānaprastha‑āśrama at the end of his life? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=2607s',
        },
        {
            'subTopicName': 'Any endeavour always brings results proportional to it. How then does Bhakti act contrary to this principle? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=4044s',
        },
        {
            'subTopicName': 'Is my faith in Bhakti compromised when I think "I have no other choice but to practice Bhakti since I am not qualified for Karma / Jñāna?" (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=3775s',
        },
        {
            'subTopicName': 'How to avoid introducing Karma‑kāṇḍīya mentality in Bhakti? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=2736s',
        },
        {
            'subTopicName': 'Will a Gauḍīya Vaiṣṇava devotee go to Vaikuṇṭha if a particular section of the Bhāgavatam that he reads has a Phala‑śruti associated with Vaikuṇṭha? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=2440s',
        },
        {
            'subTopicName': 'What are the Common recommendations, the Highest recommendations, and allowances prescribed in the Mahābhārata, Bhagavad‑gītā, Bhāgavatam and Caitanya‑caritāmṛta? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=5298s',
        },
        {
            'subTopicName': 'Why did pure devotees like Pṛthu Mahārāja have to engage in Jñāna‑yoga processes at the end of their lives? (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glVWOuUj9OA&t=2268s',
        },
        {
            'subTopicName': 'Ways in which prema‑bhakti appears ‑ Part‑1 (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NsGLIgITQZE&t=6305s',
        },
        {
            'subTopicName': 'Ways in which prema‑bhakti appears ‑ Part‑2 (68 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=v0DB5CwXU1Y&t=541s',
        },
        {
            'subTopicName': 'Sudden appearance of Bhāva without sādhanā/mercy. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=3675s',
        },
        {
            'subTopicName': 'Kubjā\'s love is Kāma‑prāya. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mPV5ksADt7o&t=3810s',
        },
        {
            'subTopicName': 'Sowing the seed of devotion is a process and not an event. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=3940s',
        },
        {
            'subTopicName': 'Sādhanā-bhakti stage is characterized by simultaneous presence of Sense gratification and regret. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=3345s',
        },
        {
            'subTopicName': 'Symptoms of true ego in a sādhaka. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=2700s',
        },
        {
            'subTopicName': 'How can the Gopīs and the Vṛṣṇis attain the same destination attained by Kaṁsa and Śiśupāla? (26 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=4560s',
        },
        {
            'subTopicName': 'Is the term Rāgānugā applicable to Vaikuṇṭha Bhakti? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=1725s',
        },
        {
            'subTopicName': 'Anuśīlanam ìn the life of a sādhaka. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=1380s',
        },
        {
            'subTopicName': 'Rāgānugā-sādhaka\'s relationship with guru. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=bTOcBnPLlGM&t=3460s',
        },
        {
            'subTopicName': 'How does greed for Rāgānugā-bhakti develop? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cdYT3svsbSM&t=4060s',
        },
        {
            'subTopicName': 'What is the purpose of our ācāryas elaborately describing to the sādhaka devotees these elevated topics about gopīs’s feelings of separation? How should one assess one’s qualification to hear these topics? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=6820s',
        },
        {
            'subTopicName': 'Should the Gopīs’ criticisms in viraha‑gītā be taken at face value? (27 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=l9JSxaKiTi8&t=1230s',
        },
        {
            'subTopicName': 'When śāstras say that Only a killer of animals will not hear the glories of the Lord, does it mean that animal killers cannot take up to devotion? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nVfSEaO-qWc&t=3883s',
        },
        {
            'subTopicName': 'Does the BG 8.6 verse yaṁ yaṁ vāpi smaran bhāvaṁ suggest smaraṇam as the most important limb compared to śravaṇam and kīrtanam? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nVfSEaO-qWc&t=2730s',
        },
        {
            'subTopicName': 'What destinations do Karma‑miśra‑bhakti, Jñāna‑miśra‑bhakti, and Śuddha‑bhakti fetch? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=o7YgN8pXjBs&t=1647s',
        },
        {
            'subTopicName': 'Is the Lord beautified by His ornaments OR are His ornaments beautified by Him? Or are both true? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gjIKMojudEU&t=3325s',
        },
        {
            'subTopicName': 'Does Śrīla Rūpa Gosvāmī recommend worship of Gaṇeśa in the Bhakti‑rasāmṛta‑sindhu? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gjIKMojudEU&t=1465s',
        },
        {
            'subTopicName': 'If Śrī Caitanya Mahāprabhu Himself borrowed 2 principles each from every Vaiṣṇava Sampradāya, why should we NOT not borrow? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gjIKMojudEU&t=1355s',
        },
        {
            'subTopicName': 'Should we ask Kṛṣṇa‑prema from Kṛṣṇa and material facilities from the devatās? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mVProlZbvaY&t=1589s',
        },
        {
            'subTopicName': 'Offering prayers to the Presiding / Worshipable Deities of the Senses ‑ is this bonafide / non‑bonafide? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mVProlZbvaY&t=1530s',
        },
        {
            'subTopicName': 'Why / how are prayers powerful? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mVProlZbvaY&t=934s',
        },
        {
            'subTopicName': 'What\'s the difference between the destinations of Pradhānībhūta‑bhakti and Śuddha‑bhakti? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=o7YgN8pXjBs&t=5598s',
        },
        {
            'subTopicName': 'Discussion on the terminology \'pure devotee\'. (29 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=phYwzJ8IFGc&t=3885s',
        },
        {
            'subTopicName': 'Impact of hearing from great devotees even on simpler topics that one may not find intellectually stimulating. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=phYwzJ8IFGc&t=1828s',
        },
        {
            'subTopicName': 'Conclusion on āropa‑siddha‑bhakti from discussions with H H Bhakti Vijñāna Mahārāja. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=phYwzJ8IFGc&t=1040s',
        },
        {
            'subTopicName': 'How can we take \'Bhagavad‑gītā As It Is\' book as ‘as it is’, if only Bhakti aspect is prioritized? Is it not biased? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=2811s',
        },
        {
            'subTopicName': 'Is it acceptable to skip puruṣāvatāra‑kathā and get into līlāvatāra‑kathā? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=4370s',
        },
        {
            'subTopicName': 'How to understand the words of Prabhupāda stating that one should perform their prescribed duties? Does Prabhupāda refer to Varṇāśrama prescribed duties as being non negotiable for sādhakas? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=1908s',
        },
        {
            'subTopicName': 'Are people conditioned to violent material sense enjoyment disqualified from taking up to Bhakti? (21 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=480s',
        },
        {
            'subTopicName': 'Selfishness is not such a bad thing as long as one has the right understanding of the Self. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=6650s',
        },
        {
            'subTopicName': 'Development of attraction to Vṛndāvana is Gradual. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=5020s',
        },
        {
            'subTopicName': 'Genuine Rāgānugā-bhakti cannot be imitated. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=6100s',
        },
        {
            'subTopicName': 'How Vaidhī sādhanā transforms into Rāgānugā sādhanā? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=lC3mZpoQvH4&t=3997s',
        },
        {
            'subTopicName': 'Realising name, form, qualities and pastimes of Kṛṣṇa. (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NGb3avTZOLw&t=4680s',
        },
        {
            'subTopicName': 'Śuddha‑nāma is revealed by mercy of pure devotee. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NGb3avTZOLw&t=2245s',
        },
        {
            'subTopicName': 'Progressing in chanting from śraddhā to prema (76 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sCv630ZH52E&t=2745s',
        },
        {
            'subTopicName': 'Meaning of the Mahāmantra. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pD0QG8prkIw&t=5690s',
        },
        {
            'subTopicName': 'Material Vision VS Impersonal Vision VS Vision of the Lord. (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n6q79aHYYKw&t=3300s',
        },
        {
            'subTopicName': 'Progressing from śraddhā to prema. (23 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=S_jL9Vulh-8&t=230s',
        },
        {
            'subTopicName': 'If Kṛṣṇa has put us in a particular situation, does he want us to accept it as it is? (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=a9vYWReNDwA&t=5160s',
        },
        {
            'subTopicName': 'Purpose behind manifestation of the material world. (25 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=a9vYWReNDwA&t=1270s',
        },
        {
            'subTopicName': 'Raty‑ābhāsa ‑ Part‑1. (65 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=VFnjKiJO_rc&t=3246s',
        },
        {
            'subTopicName': 'Raty‑ābhāsa ‑ Part‑2 (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=768s',
        },
        {
            'subTopicName': 'It is difficult to understand a person in Prema‑bhakti. (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=SH0ionOFw-o&t=3560s',
        },
        {
            'subTopicName': 'Actions of a person at the stage of Bhāva. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=VFnjKiJO_rc&t=2320s',
        },
        {
            'subTopicName': 'Role of Saṁvit and Hlādinī‑śakti in maifesting Bhāva. (31 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sdG9Ak72tDk&t=2040s',
        },
        {
            'subTopicName': 'Is Bhāva‑bhakti eternal in the Jīva? (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=2160s',
        },
        {
            'subTopicName': 'The Jīva Fall Discussion. (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=2160s',
        },
        {
            'subTopicName': 'Role of Śrī Caitanya Mahāprabhu in the development of Rāgānugā-bhakti. (30 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=lC3mZpoQvH4&t=5082s',
        },
        {
            'subTopicName': 'Is Vraja‑bhakti for everyone? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=948s',
        },
        {
            'subTopicName': 'Why is it mentioned that the queens are reflections of Śrīmatī Rādhārāṇī and not the Gopīs? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=5207s',
        },
        {
            'subTopicName': 'Understanding the role of the Hlādinī potency of the Lord. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=2888s',
        },
        {
            'subTopicName': 'Direct Knowledge, Indirect Knowledge and Perverted Knowledge from the Saṁvit Potency. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=2615s',
        },
        {
            'subTopicName': 'What does it mean when Śrīla Prabhupāda says: Kṛṣṇa consciousness begins on the platform of pure goodness( viśuddha‑sattva). (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=1805s',
        },
        {
            'subTopicName': 'Understanding Saṁvit potency of the Lord. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=2477s',
        },
        {
            'subTopicName': 'Understanding the Sandhinī‑śakti. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=1745s',
        },
        {
            'subTopicName': 'If the Hlādinī‑śakti comes in touch with the Jīva only at the stage of Bhāva‑bhakti, then how does the Sādhaka receive nourishment? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mFOWu4YRy_g&t=4861s',
        },
        {
            'subTopicName': 'How do we say that the devotees are beyond the three modes when they are still seen to be affected by it? (57 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vqtB83kCAKk&t=979s',
        },
        {
            'subTopicName': 'What are the various ways in which the 3 modes affect a Sādhaka? (57 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vqtB83kCAKk&t=979s',
        },
        {
            'subTopicName': 'What if a devotee remembers a dog at the time of death? Will he get a dog birth? (21 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EkGPE4oRvgo&t=160s',
        },
        {
            'subTopicName': 'Importance of worshipping the \'Tādīya\' of the Lord. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4Kj9WE3zldA&t=3714s',
        },
        {
            'subTopicName': 'Meaning of "bhajanty ananya‑manaso" and "satataṁ kīrtayanto mām". (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QwKi7-MyaTg&t=3284s',
        },
        {
            'subTopicName': 'Who is qualified to worship Kṛṣṇa? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QwKi7-MyaTg&t=931s',
        },
        {
            'subTopicName': 'Kṛṣṇa the aṁśī can claim to have performed an action actually performed by one of His aṁśas. (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oFANPMdLS2k&t=1520s',
        },
        {
            'subTopicName': '7 Characteristics of Śuddha‑bhakti. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oFANPMdLS2k&t=171s',
        },
        {
            'subTopicName': 'If Kṛṣṇa is ātmārāma, then why does He get attracted to bhakti? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h-QxzjE5SLc&t=1401s',
        },
        {
            'subTopicName': 'Only sattva‑guṇa can be dovetailed in Kṛṣṇa\'s service, rajo‑guṇa and tamo‑guṇa must be given up. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LtduJkS8hZU&t=815s',
        },
        {
            'subTopicName': 'Why is Bhakti "susukhaṁ kartum"? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pfQR18UAJ8c&t=3895s',
        },
        {
            'subTopicName': 'Seven aspects of Śuddha‑bhakti or Pure devotional service. (21 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pfQR18UAJ8c&t=2618s',
        },
    ],
    ['Classification of Devotees']: [
        {
            'subTopicName': 'Three types of Accomplished devotees. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/4RqUBBRVXOU?si=XT5VI2L0w4fzefgo&t=151',
        },
        {
            'subTopicName': 'How can Śukadeva Gosvāmī, an impersonalizt turned devotee, be addressed as ādi-kavi in Śrīmad-Bhāgavatam? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/JYld7aQ6KF8?si=IPIZF-sWU9RrPWiD&t=2715',
        },
        {
            'subTopicName': 'Are the 4 types of people who surrender to Kṛṣṇa Kaniṣṭha-adhikārīs or Madhyama-adhikārīs ? (8 min)',
            'youtubeLink': 'https://youtu.be/SfFVMSoXu0I?si=62y1SHf91AVl2aqu&t=1105',
        },
        {
            'subTopicName': 'Gradation of Devotees. (6 min)',
            'youtubeLink': 'https://youtu.be/MlObwlmgFLw?si=uDb7zb4pSlI3NwWT&t=2882',
        },
        {
            'subTopicName': 'Need to discriminate between the Vaiṣṇavas. (23 min)',
            'youtubeLink': 'https://youtu.be/P3ZnLJs5ICc?si=6MsrfEoBdsNpf6qw&t=3931',
        },
        {
            'subTopicName': 'Behaviour of madhyama-adhikārī. (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/4RqUBBRVXOU?si=ciwrik3tzbbsT79u&t=2089',
        },
        {
            'subTopicName': 'Behaviour of kaniṣṭha-adhikārī. (25 min)',
            'youtubeLink': 'https://www.youtube.com/live/4RqUBBRVXOU?si=kI3XxBkzsL5z3WN3&t=2963',
        },
        {
            'subTopicName': 'Are madhyama-adhikārīs always more respectful than the kaniṣṭha-adhikārīs? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/4RqUBBRVXOU?si=drg233Ch31yEylKi&t=3151',
        },
        {
            'subTopicName': 'Uttama-adhikārī n terms of arcana. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/fGuNMVhAuDc?si=5HXPlczaJu0h5h_q&t=2891',
        },
        {
            'subTopicName': 'Classification of devotees according to arcana. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/RTepF-Dr4NI?si=_tza7eGsjz-9y2uF&t=5474',
        },
        {
            'subTopicName': 'Shades of Madhyama-adhikārīs. (28 min)',
            'youtubeLink': 'https://www.youtube.com/live/9wpou6exh9Q?si=MAF1Y1RKSxj9EIkc&t=1936',
        },
        {
            'subTopicName': 'Classification of devotees according to differences in sādhanas. (46 min)',
            'youtubeLink': 'https://www.youtube.com/live/RTepF-Dr4NI?si=FKTm0xTi0MILdH3M&t=1164',
        },
        {
            'subTopicName': 'Is Dhruva Mahārāja a kaniṣṭha or a madhyama or an uttama-adhikārī? (3 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=U0OL4QAuCdos5u_B&t=3897',
        },
        {
            'subTopicName': 'Yādavas, Uddhava, Gopīs and Rādhārāṇī are successively better and better devotees. (74 min)',
            'youtubeLink': 'https://www.youtube.com/live/LQFDuSutdsI?si=OXpTjfy58yBfPolu&t=991',
        },
        {
            'subTopicName': 'Hierarchy of the Lord\'s perfected devotees. (22 min)',
            'youtubeLink': 'https://youtu.be/MlObwlmgFLw?si=OPII1mF1WFlcYPEO&t=2866',
        },
        {
            'subTopicName': 'Nirguṇa Svarūpa Siddhā Bhakti (21 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9IZAlA8UENA&t=1281s',
        },
        {
            'subTopicName': '3 Kinds of Visions of a devotee in perceiving Transcendental objects ‑Jaḍamaya, Manomaya and Cinmaya. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9gMR2e8eaZ4&t=4515s',
        },
        {
            'subTopicName': '3 levels of devotees based on faith. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0JhMipOSX34&t=2160s',
        },
        {
            'subTopicName': 'Can we say that majority of the ISKCON devotees today are Karma‑miśra‑bhaktas? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=d36Obvd-_68&t=3108s',
        },
        {
            'subTopicName': '8 symptoms of a person with devotion (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=4000s',
        },
        {
            'subTopicName': 'Discussion on the terminology \'pure devotee\'. (29 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=phYwzJ8IFGc&t=3885s',
        },
    ],
    ['Creation/Dissolution of the Material World']: [
        {
            'subTopicName': 'Creation and dissolution/liberation happen in the opposite chronological order. (8 min)',
            'youtubeLink': 'https://youtu.be/sVUOpD4LyQk?si=rLOk7ataJMwPFGlc&t=3741',
        },
        {
            'subTopicName': 'Purpose of creating the material world by the Lord for the Nitya Baddha Jīvas. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wiiBuDgtFJM&t=2845s',
        },
        {
            'subTopicName': 'Sequence of formation of Pradhān and its products. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=xqsdZWrV2FM&t=4367s',
        },
        {
            'subTopicName': 'Products of Pradhāna‑2. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=xqsdZWrV2FM&t=4350s',
        },
        {
            'subTopicName': 'Products of Pradhāna‑1. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=xqsdZWrV2FM&t=3564s',
        },
        {
            'subTopicName': 'Is the process of merging one element into another while devotees leave their bodies as described in Śrīmad‑Bhāgavatam figurative OR real? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=5079s',
        },
        {
            'subTopicName': 'Purpose behind manifestation of the material world. (25 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=a9vYWReNDwA&t=1270s',
        },
        {
            'subTopicName': 'Kṛṣṇa is both the material cause and the efficient cause of this universe. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oFANPMdLS2k&t=2925s',
        },
        {
            'subTopicName': 'Śakti‑pariṇāmavāda ‑ creation of the material universe happens by transformation of Kṛṣṇa\'s external energy. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h-QxzjE5SLc&t=4974s',
        },
    ],
    ['Dealings with Devotees']: [
        {
            'subTopicName': 'How one should look at devotees who do not have service attitude? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/4RqUBBRVXOU?si=gXRHY0prv7UiFmej&t=2979',
        },
        {
            'subTopicName': 'How to deal with devotees who have severe conditionings? (19 min)',
            'youtubeLink': 'https://www.youtube.com/live/EubUG6Tau60?si=-zRZgdIfv3ZhNY8x&t=3947',
        },
        {
            'subTopicName': 'How can one know if their senior’s instructions are in line with śāstras? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5DPnaY774qg&t=2640s',
        },
        {
            'subTopicName': 'Vapu-sevā vs vāṇī-sevā. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/uvqUcmzKVhQ?si=mUDAzUJwEL8TnBMu&t=4018',
        },
        {
            'subTopicName': 'Communication through words vs voice vs gestures. (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/w233O_wl1jA?si=k_mEM8tUsCCtBEtg&t=540',
        },
        {
            'subTopicName': 'Unsolicited advice is a relationship killer. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/w233O_wl1jA?si=J48eZIWfL0RKx-Lz&t=3449',
        },
        {
            'subTopicName': 'Those who expect respect are naturally disrespectful towards others. (2 min)',
            'youtubeLink': 'https://youtu.be/RgPqaepshpY?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=4229',
        },
        {
            'subTopicName': 'How can one respect a person whom he deems unqualified? (6 min)',
            'youtubeLink': 'https://youtu.be/RgPqaepshpY?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=4356',
        },
        {
            'subTopicName': 'Expectation is a kind of force which strains relationships. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/gDZqD_Yz5Ns?si=WlqVm3-EL5qBlhD_&t=1129',
        },
        {
            'subTopicName': 'A person who cannot trust others, does not trust himself. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/gDZqD_Yz5Ns?si=MtUaS3IodDq99CcC&t=1366',
        },
        {
            'subTopicName': 'How to rekindle relationship with our authority? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/gDZqD_Yz5Ns?si=t7cVAkADgKL_eD9g&t=3573',
        },
        {
            'subTopicName': 'How to maintain a cordial relationship with co‑devotees amidst difference of opinion? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=irXwcVTNbbQ&t=4975s',
        },
        {
            'subTopicName': 'How should we see devotees sometimes introduced as belonging to Brāhmaṇa families? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tXLaiH5XLzA&t=3405s',
        },
        {
            'subTopicName': 'Vaiṣṇava Humility Vs Jāti‑buddhi. (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=4255s',
        },
        {
            'subTopicName': 'How should we deal with situations where one has to hear something that\'s NOT according to the Paramparā, but still can\'t avoid it on account of a variety of reasons? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=2408s',
        },
        {
            'subTopicName': 'Why did Pṛthu Mahārāj patiently hear Jñāna‑miśra‑bhakti from the Kumāras? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5zk7IbCiQJY&t=1664s',
        },
        {
            'subTopicName': 'Do great Kings like Pṛthu Mahārāja glorify Sādhus like the 4 Kumāras in order to evade giving them charity? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=490s',
        },
        {
            'subTopicName': 'Can one repay one\'s Guru OR the great Vaiṣṇavas? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=1504s',
        },
        {
            'subTopicName': 'Why there is so much mention about conditioning in discussions on Vaiṣṇava relationships if anartha‑nivṛtti happens automatically by practice of Bhakti? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glVWOuUj9OA&t=3165s',
        },
        {
            'subTopicName': 'What makes or breaks the lifeline of devotees\' association? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nwHllIMh068&t=4062s',
        },
    ],
    ['Demigod Worship']: [
        {
            'subTopicName': 'Do Śiva worshippers become Vaiṣṇavas automatically? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/_8VL4jiBTvI?si=EjTqv7Y0L9vqAytv&t=4448',
        },
        {
            'subTopicName': 'Understanding demigods as secondary controllers. (7 min)',
            'youtubeLink': 'https://youtu.be/EGzBFBDSmsA?si=ljCjosn1YoWfKJlt&t=669',
        },
        {
            'subTopicName': 'If demigod worship is given in the Vedas, then why is Kṛṣṇa criticizing it in the Bhagavad-gītā? (19 min)',
            'youtubeLink': 'https://youtu.be/K634Vxup5dM?si=lyOMKi0CPwKxxq5y&t=1733',
        },
        {
            'subTopicName': 'Is there any evidence that Kṛṣṇa fulfills material desires faster than demigods? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/bLGy3Huo9ok?si=LjKZFlJ2K4n-u5NM&t=4004',
        },
        {
            'subTopicName': 'What kind of bhakti do demigod worshippers render? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/jv3_D9sAtgQ?si=E_QMqpT_JNk-uA1M&t=3685',
        },
        {
            'subTopicName': 'Can other gods also give liberation? (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/EHznydtUlts?si=sw_Iv_amS9qeYOIL&t=4621',
        },
        {
            'subTopicName': 'Understanding Indra as a post. (6 min)',
            'youtubeLink': 'https://youtu.be/vZW3zGm1PIs?si=qiPkho8_e7QTFA7B&t=2938',
        },
        {
            'subTopicName': 'Are the sense-devatās the same as the demigods of this material world? (2 min)',
            'youtubeLink': 'https://youtu.be/sVUOpD4LyQk?si=rBgpAY2_WjNMR34G&t=4261',
        },
        {
            'subTopicName': 'Peripheral Śāstras and Demigod Worship. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1ooqlgc2DZo&t=1605s',
        },
        {
            'subTopicName': 'Do the Śāstras recommend Demigod worship? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0jaeK5dlL8E&t=2527s',
        },
        {
            'subTopicName': 'The 2 kinds of mercy that the Demigods bestow upon their worshippers. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0jaeK5dlL8E&t=3247s',
        },
        {
            'subTopicName': 'Results of improper and indirect Demigod Worship. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0jaeK5dlL8E&t=4890s',
        },
        {
            'subTopicName': 'I oppose the demigod worship of my family members. Would the demigods create obstacles in my Bhakti? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=y7FRfYpPTxo&t=2771s',
        },
        {
            'subTopicName': 'Are demigods disrespected in ISKCON? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tXLaiH5XLzA&t=3925s',
        },
        {
            'subTopicName': 'Conditions under which one performs Demigod Worship. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=R91CJZltUcs&t=5211s',
        },
        {
            'subTopicName': 'Understanding Svabhāva‑jaṁ Śraddhā (Faith born out of one\'s conditioned nature). (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=R91CJZltUcs&t=5211s',
        },
        {
            'subTopicName': 'Understanding the difference between Scriptural and Sentimental Faith. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=770s',
        },
        {
            'subTopicName': 'Does Śrīla Rūpa Gosvāmī recommend worship of Gaṇeśa in the Bhakti‑rasāmṛta‑sindhu? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gjIKMojudEU&t=1465s',
        },
        {
            'subTopicName': 'Should we ask Kṛṣṇa‑prema from Kṛṣṇa and material facilities from the devatās? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mVProlZbvaY&t=1589s',
        },
        {
            'subTopicName': 'Offering prayers to the Presiding / Worshipable Deities of the Senses ‑ is this bonafide / non‑bonafide? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mVProlZbvaY&t=1530s',
        },
        {
            'subTopicName': 'Who are the Presiding Deities and Worshippable Deities of the different aspects of Antaḥkaraṇa viz. citta, manaḥ, buddhi, and ahaṅkāra? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=o7YgN8pXjBs&t=2625s',
        },
    ],
    ['Deviation and degradation of a Paramparā']: [
        {
            'subTopicName': 'Causes of vanishing of some critical meanings of scriptures. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/cFgOw0dHG0Q?si=0BOZlLpVc1ASDNA6&t=705',
        },
        {
            'subTopicName': 'How religion gets lost? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/cFgOw0dHG0Q?si=70hNDbZiIVmJ9DLn&t=1995',
        },
        {
            'subTopicName': 'How do we understand whether one is getting deviated from the teachings of Pūrva‑Ācāryas? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XUgB4PWa1jA&t=4724s',
        },
        {
            'subTopicName': 'Is the blind following of our family traditions innocuous or scary? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ft5OYPZnBho&t=1218s',
        },
        {
            'subTopicName': 'How do we ensure that, in the name of contextualizing Śrīla Prabhupāda\'s words, we do not stray away from the core teachings of Śrī Caitanya Mahāprabhu? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1fMRJBYYcuE&t=3433s',
        },
        {
            'subTopicName': 'How to avoid introducing Karma‑kāṇḍīya mentality in Bhakti? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=2736s',
        },
        {
            'subTopicName': 'If Śrī Caitanya Mahāprabhu Himself borrowed 2 principles each from every Vaiṣṇava Sampradāya, why should we NOT not borrow? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gjIKMojudEU&t=1355s',
        },
    ],
    ['Devotee Relationships']: [
        {
            'subTopicName': 'How to avoid other\'s conditionings and still protect oneself from being affected by it? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/96Gj-cfvCf8?si=5MkcLZPRPTFJQ_P5&t=5067',
        },
        {
            'subTopicName': 'When the relationship is deep, even unspoken messages can be understood. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/fo3n8WGDyrk?si=yu-2qfOSAjah-VE8&t=2972',
        },
        {
            'subTopicName': 'Closer the relation, the more one is equipped to understand the heart. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/88KkQmu9k90?si=KelH9FMXpzijY4g-&t=117',
        },
        {
            'subTopicName': 'To understand the unspoken one has to have the relationship. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/pjgffDmoxhk?si=5Ky7wyprWW0cDywS&t=3461',
        },
        {
            'subTopicName': 'Motivated affection is false affection. (2 min)',
            'youtubeLink': 'https://youtu.be/6RuUs5AEXrQ?si=j9-wdiO8RIJeMNg3&t=530',
        },
        {
            'subTopicName': 'Importance investing in devotee relationships. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Gbg2F-YEDS8&t=4440s',
        },
    ],
    ['Dhāms/Dhām vāsīs']: [
        {
            'subTopicName': 'Who are dhām vāsīs/ Vrajvāsīs? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/jO33AgEPYmI?si=gW5Rh988ppzRHyY8&t=1578',
        },
        {
            'subTopicName': 'Is Bhauma Vṛndāvana more glorious than Goloka? (15 min)',
            'youtubeLink': 'https://youtu.be/R2VmZix87yA?si=-nrxKNVJWRo5nGud&t=3067',
        },
        {
            'subTopicName': 'Glories of Mathurā. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/qwr6qQ50sZc?si=-YbwePbYvhrzW-JC&t=2320',
        },
        {
            'subTopicName': 'How to perceive dhāma in its true splendor? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/1wFC-Z4xXpU?si=12O1BrJkYHB144xT&t=4993',
        },
        {
            'subTopicName': 'How to make the best use of being in a dhāma? (5 min)',
            'youtubeLink': 'https://youtu.be/0XI0basB3aI?si=4Lo5UAegLSK8K3mF&t=3011',
        },
        {
            'subTopicName': 'What happens to the Bhauma-Vṛndāvana during the devastation? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/TtWtstSXjLc?si=Fyhg3gek_opEBbHH&t=1148',
        },
        {
            'subTopicName': 'Abodes of Kṛṣṇa. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/8WMus7iacFE?si=tRsnMSIoz9v_Vcs3&t=3829',
        },
        {
            'subTopicName': 'Description of Goloka. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/NdOZJ-9pzYc?si=JXRWnjL_9Mgo5Ugw&t=961',
        },
        {
            'subTopicName': 'Gokula is greater than Goloka. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/NdOZJ-9pzYc?si=hULMiQXwOPFUT3Dc&t=3760',
        },
        {
            'subTopicName': 'Mathurā is eternal and unlimited. (25 min)',
            'youtubeLink': 'https://www.youtube.com/live/NdOZJ-9pzYc?si=Csg5Y0nx11-Zrp3M&t=5049',
        },
        {
            'subTopicName': 'How/why one is not able to see the real Vṛndāvana/Mathurā even after going to such Holy places? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=R2VmZix87yA&t=4620s',
        },
        {
            'subTopicName': 'Descriptions of Spiritual Māyāpur beyond the curtain of māyā. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=zh48Lok_D8c&t=5558s',
        },
        {
            'subTopicName': 'Two types of staying in the Dhām. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=uXosOLmwCTg&t=360s',
        },
        {
            'subTopicName': 'Need for Descriptions of Vṛndāvana in Śrīmad‑Bhāgavatam ‑ Mental Vrajavāsa. (23 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=N90t516qYew&t=320s',
        },
        {
            'subTopicName': 'Rainy Season in Vṛndāvana‑Part 1 (95 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ciwV7SjB0uc&t=560s',
        },
        {
            'subTopicName': 'Rainy Season in Vṛndāvana‑Part 2 (38 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HJoDej88k54&t=1290s',
        },
        {
            'subTopicName': 'Śarad‑ṛtu (Autumn Season in Vṛndāvana) ‑ Part 1 (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HJoDej88k54&t=3560s',
        },
        {
            'subTopicName': 'Śarad‑ṛtu (Autumn Season) in Vṛndāvana ‑ Part 2 (84 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LUKUYdlh2nE&t=145s',
        },
        {
            'subTopicName': 'Preparing one\'s consciousness to enter the Dhāma. (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7YQcN7hlx9w&t=2570s',
        },
        {
            'subTopicName': 'Development of attraction to Vṛndāvana is Gradual. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=5020s',
        },
    ],
    ['Gaura lila']: [
        {
            'subTopicName': 'Glories of Śrī Advaita Ācārya. (60 min)',
            'youtubeLink': 'https://youtu.be/UF_453TI91k?si=IiXdZ-W4hhx5Oql7&t=744',
        },
        {
            'subTopicName': 'Understanding the concept of ‘daśa‑abhimāna’ from the life of Śrī Advaita Ācārya. (32 min)',
            'youtubeLink': 'https://youtu.be/UF_453TI91k?si=0P49YNN_J38-Rugi&t=3144',
        },
        {
            'subTopicName': 'Even after Lord Caitanya accepted Sannyāsa, why did he keep his brahmacārī name? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rGDhBdnJWgc&t=2460s',
        },
        {
            'subTopicName': 'Dāsa‑abhimāna of Advaita Ācārya. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=La-E5bGUD4w&t=1606s',
        },
    ],
    ['Gaura-Tattva']: [
        {
            'subTopicName': 'Overview of Ādi-līlā 1.1 to 1.14. (60 min)',
            'youtubeLink': 'https://www.youtube.com/live/0aZPPuOqwE0?si=bZ27eF2jEyxaOpWK&t=1377',
        },
        {
            'subTopicName': 'Isn\'t Mahāprabhu a yuga-avatāra? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/ZwW__cOftwg?si=vM7mdutv7IEChhHc&t=4189',
        },
        {
            'subTopicName': 'Worship of Caitanya Mahāprabhu. (6 min)',
            'youtubeLink': 'https://youtu.be/9K7Q-MqeV4c?si=t21vO58V8oHtx134&t=741',
        },
        {
            'subTopicName': 'Caitanya Mahāprabhu is Yuga-avatāra. (5 min)',
            'youtubeLink': 'https://youtu.be/9K7Q-MqeV4c?si=WLKMZ6dxNIFGFle-&t=1039',
        },
        {
            'subTopicName': 'Lord as Triyugi. (4 min)',
            'youtubeLink': 'https://youtu.be/9K7Q-MqeV4c?si=oYk9aZoyK_iVTszA&t=1473',
        },
        {
            'subTopicName': 'Prediction of Śrī Caitanya Mahāprabhu\'s descent. (4 min)',
            'youtubeLink': 'https://youtu.be/9K7Q-MqeV4c?si=FWxxElxV0RJTEHEK&t=1667',
        },
        {
            'subTopicName': 'Caitanya Mahāprabhu is also the avatārī and not an avatāra. (5 min)',
            'youtubeLink': 'https://youtu.be/2cggtuiu7Jk?si=U5QypSwQL0HaY5rN&t=3045',
        },
        {
            'subTopicName': 'What does ‘hidden incarnation’ or channa‑avatāras mean? (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/QS1HpvX2VN4?si=SJ8zAb2pIpwrMzcy&t=839',
        },
        {
            'subTopicName': 'How Caitanya Mahāprabhu is non‑different from that Svayam‑Bhagavān Kṛṣṇa? (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/G9YQFheuJUo?si=GxDT9yi3THDDfyMM&t=1437',
        },
        {
            'subTopicName': 'Understanding the three meanings of Varṇam in the "Kṛṣṇa Varṇam" verse. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=24zlLfq0_BE&t=2291s',
        },
        {
            'subTopicName': 'Understanding meaning of aṅga, upāṅga and astra in the "Kṛṣṇa Varṇam" verse. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=24zlLfq0_BE&t=3196s',
        },
        {
            'subTopicName': 'Explanation of "Kṛṣṇa varṇam" verse. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GN2Gd1kjAxM&t=2453s',
        },
        {
            'subTopicName': 'Understanding the meaning of verse 10.8.13 in detail which predicts the appearance of Caitanya Mahāprabhu. (80 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-v9S56pnTuI&t=1410s',
        },
        {
            'subTopicName': 'Why did Lord Caitanya take Sannyāsa in the Śaṅkara sampradāya and the purpose of his taking sannyāsa? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rGDhBdnJWgc&t=1543s',
        },
        {
            'subTopicName': 'Lord Caitanya\'s bodily symptoms which distinguished Him as the Supreme Personality of Godhead. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rGDhBdnJWgc&t=4289s',
        },
        {
            'subTopicName': 'One can get the essence of the scriptures only by mercy of Śrī Caitanya Mahāprabhu. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Pwp-nD5Wtlc&t=856s',
        },
        {
            'subTopicName': 'What did Śrī Caitanya Mahāprabhu truly come to give? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Pwp-nD5Wtlc&t=1316s',
        },
        {
            'subTopicName': 'What is the reason why Advaita Ācārya did not distribute Vraja‑prema? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=La-E5bGUD4w&t=635s',
        },
        {
            'subTopicName': 'Role of Śrī Caitanya Mahāprabhu in the development of Rāgānugā-bhakti. (30 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=lC3mZpoQvH4&t=5082s',
        },
    ],
    ['Glories of Bhakti']: [
        {
            'subTopicName': 'Bhakti yoga\'s supremacy over the other Paths. (48 min)',
            'youtubeLink': 'https://www.youtube.com/live/rnLOb76ko0A?si=DmugZxZ3tSVQdhMt&t=1185',
        },
        {
            'subTopicName': '4 Aspects of Auspiciousness created by Bhakti. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/R-p0hvYXJ94?si=1pMJtmNKN2e25HTK&t=2952',
        },
        {
            'subTopicName': 'Four aspects of auspiciousness bestowed by bhakti. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=GGyoYiQxNxSrPUaI&t=2665',
        },
        {
            'subTopicName': 'One who pleases Kṛṣṇa pleases everyone. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=se32QRTcbo6gJyGj&t=2832',
        },
        {
            'subTopicName': 'Śrīmad Bhāgavatam\'s consistency in insisting only Bhakti-yoga for achieving all goals. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=9D7oSzIM_q3uYYmu&t=1652',
        },
        {
            'subTopicName': 'How is Bhakti simpler than the other processes? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=U62Iu3gPst5cDozB&t=5373',
        },
        {
            'subTopicName': 'Karma and jñāna are dependent on bhakti but bhakti is independent. (26 min)',
            'youtubeLink': 'https://www.youtube.com/live/tKtflACfyY0?si=DY04DB02SWch3X0y&t=2160',
        },
        {
            'subTopicName': 'Three kinds of pleasures attained by Bhakti. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/yGOBaKMgyn0?si=yiwx-oq4axAv8sXj&t=4095',
        },
        {
            'subTopicName': 'All other processes such as karma-yoga, jñāna-yoga, aṣṭāṅga-yoga etc depend on bhakti, whereas bhakti is independent – Part-1. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rnLOb76ko0A&t=1860s',
        },
        {
            'subTopicName': 'All other processes such as karma-yoga, jñāna-yoga, aṣṭāṅga-yoga etc depend on bhakti, whereas bhakti is independent – Part-2. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rnLOb76ko0A&t=3847s',
        },
        {
            'subTopicName': 'Bhakti is not caused by any other process. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=byeLP0tX4Nc&t=840s',
        },
        {
            'subTopicName': 'Yogīs attain perfection only by the support of devotional service. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=byeLP0tX4Nc&t=3162s',
        },
        {
            'subTopicName': 'Supreme excellence of bhakti over jñāna. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ojNX7c_Kk30&t=3300s',
        },
        {
            'subTopicName': 'Pure devotional service is beyond the three modes of nature. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5jTppLPr2Nw&t=2334s',
        },
        {
            'subTopicName': 'Only in bhakti can there be true one-pointed intelligence. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EkGPE4oRvgo&t=1752s',
        },
        {
            'subTopicName': 'Sādhana-sādhya, abhidheya-prayojana meaning. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EkGPE4oRvgo&t=3727s',
        },
        {
            'subTopicName': 'Bhakti alone acts as an atonement for the devotees. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/FcWTqdy5Kgk?si=uyq9fdi4sNXPIK0s&t=898',
        },
        {
            'subTopicName': 'The fastest means of achieving any goal is śuddha-bhakti. (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/bLGy3Huo9ok?si=_d56-fC52L008072&t=2590',
        },
        {
            'subTopicName': 'Without bhakti, other yogas bear no result. (21 min)',
            'youtubeLink': 'https://www.youtube.com/live/jv3_D9sAtgQ?si=8LYk_bMJ7aFxt2_f&t=1976',
        },
        {
            'subTopicName': 'Devotees do not fall down like the other yogīs. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/sx87Y2vK3vQ?si=MD8HvrA0ey4lVoY8&t=4136',
        },
        {
            'subTopicName': 'The goal of other processes is achieved by bhakti alone. (18 min)',
            'youtubeLink': 'https://youtu.be/kVLqAUzRayw?si=0QLnj5qa78U0CyZC&t=3195',
        },
        {
            'subTopicName': 'Taste for bhakti destroys all material attachments. (6 min)',
            'youtubeLink': 'https://youtu.be/kVLqAUzRayw?si=kiuYSO-RqyF86j1d&t=3666',
        },
        {
            'subTopicName': 'Whatever can be attained by karma, jñāna, and yoga can be achieved by bhakti alone. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/5bsdPwXzISg?si=4m9HTpjYdtPdLspx&t=3152',
        },
        {
            'subTopicName': 'By worship of Lord Kṛṣṇa alone everything is accomplished. (3 min)',
            'youtubeLink': 'https://youtu.be/_hEdInbzrv8?si=gD26yxOeoHr2Jvsf&t=2171',
        },
        {
            'subTopicName': 'Bhakti is independent of karma, jñāna, yoga. (2 min)',
            'youtubeLink': 'https://youtu.be/pFkS4zyyVe8?si=HZBV0jVPwppJyrX4&t=1664',
        },
        {
            'subTopicName': 'Only one who surrenders to Kṛṣṇa can overcome raga‑dveṣa and attain a peaceful mind. (2 min)',
            'youtubeLink': 'https://youtu.be/pFkS4zyyVe8?si=MS6fvItLKCoAc07J&t=3434',
        },
        {
            'subTopicName': 'Only those with devotional faith can understand the true destination of a perfected devotee. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/6F_EFTcHFYs?si=ejLMyJoBSg3PTnwA&t=2345',
        },
        {
            'subTopicName': 'How is devotional service superior to impersonal liberation? (5 min)',
            'youtubeLink': 'https://youtu.be/mMx_JB0izg0?si=VgLlB8f-GEOo-Wvx&t=3268',
        },
        {
            'subTopicName': 'Even a devotee having material desires is better than impersonalists. (12 min)',
            'youtubeLink': 'https://youtu.be/rnA74aDvpRE?si=K2mD9wcsqXPXToMA&t=774',
        },
        {
            'subTopicName': 'Animals can acquire qualification for Bhakti. But, can they acquire qualification for Karma and Jñāna too? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ngCFwTEm7Zo&t=2566s',
        },
        {
            'subTopicName': 'Futility of Jñāna without the limb of Bhakti. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OeawW2Xt8Y0&t=610s',
        },
        {
            'subTopicName': 'Glories of Unadulterated Bhakti. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GhMA8-sKdI0&t=1730s',
        },
        {
            'subTopicName': 'Supreme Lord has no friends or enemies, but He lovingly reciprocates with His dear devotees. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2ffu8hErtBs&t=4579s',
        },
        {
            'subTopicName': 'What is the difference between the bliss of merging in impersonal Brahman and bliss of Kṛṣṇa Prema? (29 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=E1Huq3O0vsg&t=4945s',
        },
        {
            'subTopicName': 'Manifestation of Vairāgya in a Jñāna Yogī and a Bhakti Yogī is different. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OwTewOcAxQ4&t=4326s',
        },
        {
            'subTopicName': 'What Varṇāśrama duties do for a Karma Yogī, Bhakti can do the same thing and more for a Bhakti Yogī. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4HjKSGFbgAY&t=1550s',
        },
        {
            'subTopicName': '7 Characteristics of Śuddha‑bhakti. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oFANPMdLS2k&t=171s',
        },
        {
            'subTopicName': 'Seven aspects of Śuddha‑bhakti or Pure devotional service. (21 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pfQR18UAJ8c&t=2618s',
        },
    ],
    ['Glories/Qualities of Devotees']: [
        {
            'subTopicName': 'What is common between the Sharks and the devotees? (5 min)',
            'youtubeLink': 'https://youtu.be/KxlGUpdv0sM?si=CiuhT-1ggQVPY_Sc&t=2943',
        },
        {
            'subTopicName': 'Qualification of Sūta Goswami. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/kqfiviAf3HA?si=MuluLGb3LMePvn_D&t=596',
        },
        {
            'subTopicName': 'Understanding the special position of Vaiṣṇavas. (5 min)',
            'youtubeLink': 'https://youtu.be/UCD1itvjZIA?si=B43w_Tq1BMHEJq3Q&t=3275',
        },
        {
            'subTopicName': 'What are the symptoms of a soft-hearted devotee? (14 min)',
            'youtubeLink': 'https://youtu.be/EiMIeLVmY3g?si=c-8YLSvMhJ9CyK8S&t=3137',
        },
        {
            'subTopicName': 'The ahaitukī nature of Vaiṣṇava-kṛpā. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/mqAq-YWAxr4?si=GqouYJjnZXWwBLm5&t=3381',
        },
        {
            'subTopicName': 'Is mercy of pure devotees upon a jīva dependent on karma? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/mqAq-YWAxr4?si=uoSlNt19QlxDTFKv&t=3804',
        },
        {
            'subTopicName': 'Surrendered devotees vs Self-centered non-devotees. (33 min)',
            'youtubeLink': 'https://www.youtube.com/live/Ee1jhekYWOQ?si=dZAiWmlSvCli8NZq&t=5085',
        },
        {
            'subTopicName': 'All good qualities take shelter of a devotee. (14 min)',
            'youtubeLink': 'https://youtu.be/HgXOw8lJZ14?si=m0OzKymSq5-WRsas&t=3157',
        },
        {
            'subTopicName': 'Worship of devotees is even better than worship of the Lord. (98 min)',
            'youtubeLink': 'https://www.youtube.com/live/wlmdAgkBJNA?si=397j_bHDUZ1bdw-1&t=186',
        },
        {
            'subTopicName': 'Why does Nārada Muni have to glorify his own disciple Dhruva in a public assembly? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=FD68k2rO4QM&list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&index=65',
        },
        {
            'subTopicName': 'Only the devotees of Lord Kṛṣṇa are free from the shackles of material attachments. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=e-OVjHGgkdQ&t=5490s',
        },
        {
            'subTopicName': 'The desire of the devotees always prevails over the desire of the Lord. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ndFrek_I6jU&t=1080s',
        },
        {
            'subTopicName': 'Nityasiddha devotees have imperishable (spiritual) bodies. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Y5WG8UdumvY&t=1674s',
        },
        {
            'subTopicName': '8 symptoms of a person with devotion (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=4000s',
        },
        {
            'subTopicName': 'Vaiṣṇava Humility Vs Jāti‑buddhi. (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=4255s',
        },
        {
            'subTopicName': 'Śuddha‑nāma is revealed by mercy of pure devotee. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NGb3avTZOLw&t=2245s',
        },
    ],
    ['Good/Bad Leadership']: [
        {
            'subTopicName': 'Leaders expecting unconditional surrender from their followers. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=WDsb54zH1qk&t=3298s',
        },
        {
            'subTopicName': 'Leadership and the sense of Responsibility. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hRVaoeIJ8BQ&t=1251s',
        },
        {
            'subTopicName': 'Reasons for Devotees to leave ISKCON. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hRVaoeIJ8BQ&t=2390s',
        },
        {
            'subTopicName': 'Authoritative VS Authoritarian Leadership. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hRVaoeIJ8BQ&t=555s',
        },
        {
            'subTopicName': 'A Fish rots from its head and an Institution from its Leader. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hRVaoeIJ8BQ&t=3653s',
        },
    ],
    ['Guru-Tattva']: [
        {
            'subTopicName': 'Importance of approaching a Spiritual Master from Catuḥ-ślokī Bhāgavatam. (25 min)',
            'youtubeLink': 'https://www.youtube.com/live/HLs1k6FVRTk?si=MkjOgBucjd4AQ3M8&t=2632',
        },
        {
            'subTopicName': 'Trust and surrender to Guru. (5 min)',
            'youtubeLink': 'https://youtu.be/gEB779mzLW0?si=8ELGryoaRmksDtRg&t=1306',
        },
        {
            'subTopicName': 'Will the Spiritual master suffer for taking the karma of his disciple? (3 min)',
            'youtubeLink': 'https://youtu.be/V4PsCuKR8nE?si=hq1no6k3w8-JE2WM&t=3033',
        },
        {
            'subTopicName': 'Are we responsible for the degree of faith that we have in our guru? (6 min)',
            'youtubeLink': 'https://youtu.be/4F6z9cJm02w?si=5pc7-iXH8OGcsuVv&t=3256',
        },
        {
            'subTopicName': 'When does a guru take full responsibility of a disciple? (4 min)',
            'youtubeLink': 'https://youtu.be/K634Vxup5dM?si=U3L_Ri-p1o0aN_tV&t=4651',
        },
        {
            'subTopicName': 'Why are the words of the spiritual master so impactful? (2 min)',
            'youtubeLink': 'https://youtu.be/PLuBQKhg2G0?si=v1BQYIG-Gzh2mTVS&t=2767',
        },
        {
            'subTopicName': 'Will the guru take the sinful reactions of the disciple and suffer for it? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1T1tquP4yzU&t=5116s',
        },
        {
            'subTopicName': 'Accepting a guru (śravaṇa-guru). (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2Y7OJqc-9Eo&t=4343s',
        },
        {
            'subTopicName': 'Balanced approach to evaluate the qualification of a guru. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2Y7OJqc-9Eo&t=5047s',
        },
        {
            'subTopicName': 'Is it true that traditional Vedic gurus always provided personal guidance/instruction to their disciples? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2Y7OJqc-9Eo&t=5321s',
        },
        {
            'subTopicName': 'Is the initiating guru the one planting the seed of bhakti in the heart of a devotee? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QAV4P_DseEg&t=2933s',
        },
        {
            'subTopicName': 'Good and bad śravaṇa-guru qualifications. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QAV4P_DseEg&t=5285s',
        },
        {
            'subTopicName': 'Power of guru-niṣṭhā on the path of bhakti. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/KWzzpMq-mNI?si=Zlbob5zIXd8JmTYT&t=1435',
        },
        {
            'subTopicName': 'How to understand the heart of guru? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/88KkQmu9k90?si=kvV48FOy0iFB1afV&t=3666',
        },
        {
            'subTopicName': 'What does it mean to serve a guru? (3 min)',
            'youtubeLink': 'https://youtu.be/aMYvNoX0CUI?si=Le4e1DOQ3KeSCcXE&t=4562',
        },
        {
            'subTopicName': 'Mantra‑guru or dīkṣā‑guru is only one. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/vKkRCUEP0WQ?si=3bCqcaHPU7HTu8KS&t=1000',
        },
        {
            'subTopicName': 'Rejecting a guru. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/vKkRCUEP0WQ?si=NsbSL3ExRtAXwKCG&t=1416',
        },
        {
            'subTopicName': 'Should one reject a guru because he is not a mahā‑bhāgavata? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/vKkRCUEP0WQ?si=S19HaP-qifQiAVZd&t=1581',
        },
        {
            'subTopicName': 'Why in ISKCON śikṣā is emphasized more than dīkṣā? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/vKkRCUEP0WQ?si=JATTVc_gvgnX3v1G&t=1875',
        },
        {
            'subTopicName': 'Why is it not an acceptable reason to reject a guru because of a fall down from inability to control senses? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/vKkRCUEP0WQ?si=2EhMr3_9pBviHaeG&t=2479',
        },
        {
            'subTopicName': 'Scriptural proofs for when and when not to reject a guru. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/vKkRCUEP0WQ?si=o31NYDCYLD6hgZ33&t=4516',
        },
        {
            'subTopicName': 'Does the guru suffer the sinful reactions of his disciple? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/vKkRCUEP0WQ?si=YxSoq3mj82-WD6v3&t=5236',
        },
        {
            'subTopicName': 'Functions of śravaṇa‑guru. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/M_xhQVZancA?si=v3pjXf0y0Tys9m4u&t=3061',
        },
        {
            'subTopicName': 'Need for śikṣā‑guru. (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/M_xhQVZancA?si=eE0PBaMFwdSNfP1h&t=3450',
        },
        {
            'subTopicName': 'How to deal with differences in teachings from multiple śravaṇa‑gurus? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/M_xhQVZancA?si=NAsjAI73gJw9CfX-&t=4481',
        },
        {
            'subTopicName': 'Need for a mantra‑guru. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/M_xhQVZancA?si=1D87cknPf3aDP7BM&t=5036',
        },
        {
            'subTopicName': 'Seeing the guru as the Lord. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/M_xhQVZancA?si=8ISg8Y2lrmNddgpI&t=5902',
        },
        {
            'subTopicName': 'Initially we might choose the guru without much knowledge of the śāstras. Later, if we come to know that our choice was wrong, what should we do? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/qLMa8Wg7y2s?si=qob3_MNhXLE7Pgle&t=980',
        },
        {
            'subTopicName': '“The Guru accepts all the sinful reactions of his disciples at the time of initiation” – how do we understand this principle? (5 min)',
            'youtubeLink': 'https://youtu.be/zmbxeCag-RI?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=4730',
        },
        {
            'subTopicName': 'Who determines the ceiling of our devotional service? Our Śikṣā Guru or our Dīkṣā Guru? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dXwsyg80F5c&t=5653s',
        },
        {
            'subTopicName': 'What does it mean when our ācāryas say that without Caitanya Mahāprabhu\'s mercy we cannot understand Rādhā and Kṛṣṇa? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=G9YQFheuJUo&t=5174s',
        },
        {
            'subTopicName': 'Who determines the cap of our devotional service? Our Śikṣā Guru or our Dīkṣā Guru? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dXwsyg80F5c&t=5653s',
        },
        {
            'subTopicName': 'Are all the Gurus in ISKCON on the platform of Bhāva / Prema? If no, how do we see Gurus NOT on those stages? (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dXwsyg80F5c&t=4645s',
        },
        {
            'subTopicName': 'Method of acquiring transcendental knowledge - Surrendering to a Spiritual Master. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=FkJpzAur308&t=1557s',
        },
        {
            'subTopicName': 'What should a disciple do if he has doubts to ask, but can\'t ask his Guru since the Guru has already left the world? What does Kṛṣṇa instruct Uddhava in this regard? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pLtOvwHMfmQ&t=1266s',
        },
        {
            'subTopicName': 'How to choose an appropriate guru? (48 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2UlP8whEbdI&t=2040s',
        },
        {
            'subTopicName': 'If one initiated devotee leaves his body before attaining perfection, would the same guru come in the next life to accept him as his disciple? - Part‑2 (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Rcws510LWh8&t=911s',
        },
        {
            'subTopicName': 'Why is Bhāva/Prema not a pre‑requisite for the guruship in ISKCON? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Rcws510LWh8&t=1537s',
        },
        {
            'subTopicName': 'If one initiated devotee leaves his body before attaining perfection, would the same guru come in the next life to accept him as his disciple? - Part‑1 (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Rcws510LWh8&t=913s',
        },
        {
            'subTopicName': 'Why were demons like Pralambāsura and Dhenukāsura killed particularly by Balarām only? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h9u-x5Gx4XA&t=3790s',
        },
        {
            'subTopicName': 'Why does even a senior Vaiṣṇava serving as a Guru for decades still fall victim to māyā? How should a disciple deal with this? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pHtStax8QBU&t=2500s',
        },
        {
            'subTopicName': 'Service to guru. (31 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pHtStax8QBU&t=3360s',
        },
        {
            'subTopicName': 'What should a disciple do if his guru is discouraging him from respecting Vaiṣṇavas? (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pHtStax8QBU&t=5647s',
        },
        {
            'subTopicName': 'Way of receiving Vedic Knowledge. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Mul8EsJXjR8&t=3812s',
        },
        {
            'subTopicName': 'What if the Dīkṣā‑guru deviates? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ft5OYPZnBho&t=1677s',
        },
        {
            'subTopicName': 'What\'s the solution that Śrīla Bhaktisiddhānta Sarasvatī Ṭhākura and Śrīla Prabhupāda instituted for Gurus\' falldown / Gurus NOT being an Uttama‑adhikārī? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ft5OYPZnBho&t=3398s',
        },
        {
            'subTopicName': 'Development in Bhakti depends solely on the attachment to our guru (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7FEVl_0dUvs&t=2090s',
        },
        {
            'subTopicName': 'In the absence of a qualified guru, one must take association of advanced Vaiṣṇavas and serve them. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7FEVl_0dUvs&t=3800s',
        },
        {
            'subTopicName': 'What is the symptom of a Bonafide Ācārya? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=5104s',
        },
        {
            'subTopicName': 'Śāstras criticize one who considers a guru to be an ordinary person. The same śāstras glorify association with an exalted devotee without knowledge of his greatness. How to resolve this contradiction? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EBAqOcl0Gts&t=4645s',
        },
        {
            'subTopicName': 'Can one repay one\'s Guru OR the great Vaiṣṇavas? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=1504s',
        },
        {
            'subTopicName': 'Rāgānugā-sādhaka\'s relationship with guru. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=bTOcBnPLlGM&t=3460s',
        },
    ],
    ['Jīva-tattva']: [
        {
            'subTopicName': 'Differences between the jīva and the Supreme Lord. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/opMuBbLyHRI?si=husygUXlcc4cmNCF&t=830',
        },
        {
            'subTopicName': 'Jīva-śakti. (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/1wFC-Z4xXpU?si=63BEfP8JgL3-hjj2&t=5351',
        },
        {
            'subTopicName': 'What is jīva\'s position in the spiritual world? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/hCBc7QObMig?si=puJoaTEbF--IKuT9&t=5228',
        },
        {
            'subTopicName': 'Is jīva qualitatively equal to the Supreme Lord? (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/hCBc7QObMig?si=7Evfse_RN134Gzzu&t=1633',
        },
        {
            'subTopicName': 'Six factors that determine the deliverance of jīva. (3 min)',
            'youtubeLink': 'https://youtu.be/4F6z9cJm02w?si=Wtl7zriWxidvtV_i&t=2573',
        },
        {
            'subTopicName': 'Did Kṛṣṇa create the souls? (7 min)',
            'youtubeLink': 'https://youtu.be/ekEVgxupvng?si=m-YbpUDdcKj3QCL2&t=1354',
        },
        {
            'subTopicName': 'Refuting the Vaiśeṣika argument about the size of the soul. (3 min)',
            'youtubeLink': 'https://youtu.be/a3DqrSqPnp0?si=en-RELRw-FCAKis6&t=1605',
        },
        {
            'subTopicName': 'Soul\'s influence spreads throughout the body. (2 min)',
            'youtubeLink': 'https://youtu.be/a3DqrSqPnp0?si=TxDoHdOnUfJ7Dgha&t=1794',
        },
        {
            'subTopicName': 'Gradations of conscious entities. (5 min)',
            'youtubeLink': 'https://youtu.be/a3DqrSqPnp0?si=L2iuDDwASTTMMkQh&t=3711',
        },
        {
            'subTopicName': 'Difference between nitya-siddhas and nitya-pārṣadas. (2 min)',
            'youtubeLink': 'https://youtu.be/a3DqrSqPnp0?si=A9Cb4DPi5nd_e8l1&t=4085',
        },
        {
            'subTopicName': 'How to understand that jīva has nothing to do with matter? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/b9-RAq6Fhug?si=jIv51SVb_BQOwolq&t=3868',
        },
        {
            'subTopicName': 'In perfected state can the jīvas also have multiple forms like the Lord’s prākāśa and vilāsa forms? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/CO9MBb75S_0?si=_obtbaO3-vPg2giX&t=2476',
        },
        {
            'subTopicName': 'When Kṛṣṇa descends, all His expansions also descend. Similarly, when His nitya-siddha associates descend from Goloka, their expansions also descend with them. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/TtWtstSXjLc?si=YFTeRM35a8v0zKAE&t=2095',
        },
        {
            'subTopicName': 'Is activity inherent to the soul? So can someone get bored in Brahma-jyoti and decide to come back from there? (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/sx87Y2vK3vQ?si=TB6pbpCbKeBf-Clm&t=1220',
        },
        {
            'subTopicName': 'Bhakti being inherent in the jīva should be understood in the functional sense and not constitutional sense. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/K_sLYVaKqnQ?si=Oihls9TX8pGR7nFJ&t=2703',
        },
        {
            'subTopicName': 'If jīva is superior to māyā, how is it possible that the inferior energy can bewilder the superior energy? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/K_sLYVaKqnQ?si=D-TYAkKg_9aPcezL&t=3437',
        },
        {
            'subTopicName': 'Are Pṛśni and Sutapa, sādhana‑siddhas or nitya‑siddha devotees as aṃśas of Devakī and Vasudeva? (38 min)',
            'youtubeLink': 'https://www.youtube.com/live/0-goGC5mZ58?si=5XItqMhSdPz_sS16&t=854',
        },
        {
            'subTopicName': 'The Million‑Dollar Question on jīva fall down – when, how, why? (70 min)',
            'youtubeLink': 'https://youtu.be/5lvpXO7cvCU?si=PCN4S6upiB4EGzuV&t=979',
        },
        {
            'subTopicName': 'Elaborations on the jīva‑tattva. (14 min)',
            'youtubeLink': 'https://youtu.be/PWmLgLCTuzY?si=BtA2dQ1uu6sbEFsx&t=6210',
        },
        {
            'subTopicName': 'Nitya‑baddhas and Nitya‑muktas. (14 min)',
            'youtubeLink': 'https://youtu.be/3e3jFtvIWMU?si=SLQbmKsPTwGw_s1p&t=3420',
        },
        {
            'subTopicName': 'Tatastha‑śakti‑jīvas. (12 min)',
            'youtubeLink': 'https://youtu.be/nHwFO5iU1Gk?si=4A6tMa5tzzp9WIqa&t=1859',
        },
        {
            'subTopicName': 'Kāya‑vyūha expansions, nitya‑parasādās and nitya‑muktās. (10 min)',
            'youtubeLink': 'https://youtu.be/0c1QhktmW5k?si=btigolcopJOGhvKa&t=1674',
        },
        {
            'subTopicName': 'Nitya‑baddha, sādhanā‑siddha and nitya‑mukta. (7 min)',
            'youtubeLink': 'https://youtu.be/0c1QhktmW5k?si=-wLX3zHCAjR_A1s6&t=2263',
        },
        {
            'subTopicName': 'Jīva’s free will. (8 min)',
            'youtubeLink': 'https://youtu.be/0c1QhktmW5k?si=A8jDH8BjnShso-J6&t=2640',
        },
        {
            'subTopicName': 'Versatility of jīvās: nitya‑parṣadas and nitya‑muktas. (33 min)',
            'youtubeLink': 'https://youtu.be/_sCeZ37rIi0?si=qD4MXuSyXZ7Kr20h&t=902',
        },
        {
            'subTopicName': 'Free will and rectification of jīvas. (19 min)',
            'youtubeLink': 'https://youtu.be/_sCeZ37rIi0?si=WIHHbdtC3BMxeHtr&t=2829',
        },
        {
            'subTopicName': 'In what aspects are the Jīva and the Lord similar AND in what aspects are they different? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h18rDjUNHRM&t=3544s',
        },
        {
            'subTopicName': 'Can a Nitya Siddha Jīva expand innumerably as different Aṁśas in different Lokas? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=teWMWm_L9Fs&t=4920s',
        },
        {
            'subTopicName': 'While not participating in the Bhauma Līlā, what do the Aṁśas like Droṇa and Dharā engage in? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=teWMWm_L9Fs&t=4575s',
        },
        {
            'subTopicName': 'Is One Jīva capable of serving the Lord in different Rasas in the same body or the same Jīva acquires different bodies to serve the purpose? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=PGmncAg6Trs&t=2730s',
        },
        {
            'subTopicName': 'The doership mentality of the jīva is due to his svabhāva. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Aiwh5_InFhM&t=1349s',
        },
        {
            'subTopicName': 'If the soul is pure and cannot be contaminated, then what does contaminated consciousness mean? Isn\'t consciousness the symptom of soul? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OrEbBFsqADg&t=1690s',
        },
        {
            'subTopicName': 'If the soul has nothing to do with sense objects, then why people are so attached to sense objects? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EledLeVo5J4&t=3814s',
        },
        {
            'subTopicName': 'How can the Dharma of the infinitesimally small Jīva be absolute and Pure? Is the Jīva eternal or created? (41 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dhxXSOxcaME&t=3360s',
        },
        {
            'subTopicName': 'How can the dharma of jīva be eternal, if it was created with the jīva? (29 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jouVi4pU3Xk&t=4488s',
        },
        {
            'subTopicName': 'Since when are jīvas bewildered by māyā? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ZnQH4cbm3zc&t=4900s',
        },
        {
            'subTopicName': 'How Māyā assists Kṛṣṇa in facilitating the Jīva\'s existence in this world? (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Iea5UCJbc6o&t=2298s',
        },
        {
            'subTopicName': 'Māyādevī, Vaiṣṇavas, Śāstras and Kṛṣṇa have a common mission of sending the jīva back to the spiritual world. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=R91CJZltUcs&t=890s',
        },
        {
            'subTopicName': 'When did the bewilderment of the Jīva by Māyā begin? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-dkJ3oTj9Kc&t=2820s',
        },
        {
            'subTopicName': 'Does the Lordships give Faith to Jīva? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pRT_2QL6fMc&t=3082s',
        },
        {
            'subTopicName': 'Purpose behind manifestation of the material world. (25 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=a9vYWReNDwA&t=1270s',
        },
        {
            'subTopicName': 'Is Bhāva‑bhakti eternal in the Jīva? (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=2160s',
        },
        {
            'subTopicName': 'The Jīva Fall Discussion. (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=2160s',
        },
        {
            'subTopicName': 'If the Hlādinī‑śakti comes in touch with the Jīva only at the stage of Bhāva‑bhakti, then how does the Sādhaka receive nourishment? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mFOWu4YRy_g&t=4861s',
        },
    ],
    ['Karma Yoga']: [
        {
            'subTopicName': 'Understanding the difference between Vaidhi Sādhakas and Sakāma Bhaktas. (1 min)',
            'youtubeLink': 'https://youtu.be/rnA74aDvpRE?si=VdH2rD6xT_eGZ939&t=557',
        },
        {
            'subTopicName': 'Are niṣkāma-karma-yogīs still under karma? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/9_LM_EezNGc?si=nAvzbX8S_9tt-zGT&t=3470',
        },
        {
            'subTopicName': 'Understanding karma-yoga – Part-1. (48 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0fAPjgx62_8&t=0s',
        },
        {
            'subTopicName': 'Understanding karma-yoga – Part-2. (91 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=K5BB56w1M38&t=0s',
        },
        {
            'subTopicName': 'Why Śrīla Prabhupāda describes karma-yoga and jñāna-yoga as bhakti-yoga? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=K5BB56w1M38&t=60s',
        },
        {
            'subTopicName': 'Niṣkāma-karma-yoga summarized. (83 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EledLeVo5J4&t=0s',
        },
        {
            'subTopicName': 'Understanding karma, akarma, and vikarma. (16 min)',
            'youtubeLink': 'https://youtu.be/bVJyBgjD79E?si=DmPYupKQWtYmVO0r&t=1805',
        },
        {
            'subTopicName': 'Understanding inaction in action and action in inaction. (12 min)',
            'youtubeLink': 'https://youtu.be/bVJyBgjD79E?si=uuDLH-4KgSnXlRa0&t=2770',
        },
        {
            'subTopicName': 'Different types of sacrifices. (40 min)',
            'youtubeLink': 'https://youtu.be/TXN0_Y_XlsQ?si=wnjVNXGnIFXPri5-&t=2808',
        },
        {
            'subTopicName': 'What is the purpose of Karma‑kāṇḍa? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XSAGwNMoF08&t=3552s',
        },
        {
            'subTopicName': 'Is Niṣkāma Karma Yoga a safer option to Karma Sannyāsa? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=YLy7RJjP32o&t=4345s',
        },
        {
            'subTopicName': 'What impels action for a person who is practicing Karma on the platform of Jñāna. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6p3PKPOXAFc&t=2485s',
        },
        {
            'subTopicName': 'Varṇa Adhikāra and Varṇa Karma. (39 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=uvtPbeUA1zY&t=1072s',
        },
        {
            'subTopicName': 'Sacrifice of Knowledge is better than Sacrifice of Materials. (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=FkJpzAur308&t=1188s',
        },
        {
            'subTopicName': 'Differences between Niṣkāma karmayogī type 1 (unpurified gṛhastha) and Niṣkāma karmayogī type 2 (gṛhastha sannyāsī) (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nMHX1U_Yey4&t=1698s',
        },
        {
            'subTopicName': 'Increasing the population - puṇya karma. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KHLS-42if4c&t=1920s',
        },
        {
            'subTopicName': 'Puṇya Karmas. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1ooqlgc2DZo&t=3380s',
        },
        {
            'subTopicName': 'Puṇya Karmas - Assistance to needy. (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1ooqlgc2DZo&t=3830s',
        },
        {
            'subTopicName': 'Puṇya Karmas - Service to elders. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1ooqlgc2DZo&t=6195s',
        },
        {
            'subTopicName': 'Puṇya Karmas - Charity. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=eStIcO0BikI&t=1740s',
        },
        {
            'subTopicName': 'Puṇya Karmas - Serving guests. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=eStIcO0BikI&t=2330s',
        },
        {
            'subTopicName': 'Complexities of Karma, Akarma and Vikarma. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1ooqlgc2DZo&t=2730s',
        },
        {
            'subTopicName': 'Puṇya Karmas - Cleanliness. (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=eStIcO0BikI&t=2900s',
        },
        {
            'subTopicName': 'Puṇya Karmas - Vratas. (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=eStIcO0BikI&t=5613s',
        },
        {
            'subTopicName': 'Puṇya Karmas - Increasing the population. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KHLS-42if4c&t=1920s',
        },
        {
            'subTopicName': 'Puṇya Karmas - Conduct. (77 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KHLS-42if4c&t=2605s',
        },
        {
            'subTopicName': 'Conduct as Puṇya Karma. (77 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KHLS-42if4c&t=2605s',
        },
        {
            'subTopicName': 'A person performing Karma on the platform of Jñāna does not get reactions because he performs his duties on the platform of true ego. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9EvcG3HS9ZQ&t=3633s',
        },
        {
            'subTopicName': 'A qualified gṛhastha engaged in varṇāśrama duties is better than an unqualified sanyāsī. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=K5BB56w1M38&t=1821s',
        },
        {
            'subTopicName': 'Are the Devatās dependent on our sacrifices? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0fAPjgx62_8&t=2306s',
        },
        {
            'subTopicName': 'Varṇas are created from Kṛṣṇa\'s material energy with the purpose of purifying the heart of the gradual Practitioners. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ctk6M9Y0Cj4&t=2600s',
        },
        {
            'subTopicName': 'One qualified for Karma should strictly perform his occupation according to his varṇāśrama. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=x96ilsBtFsI&t=645s',
        },
        {
            'subTopicName': 'Five aspects of Niṣkāma karma yoga (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EledLeVo5J4&t=4690s',
        },
        {
            'subTopicName': 'One\'s varṇa is according to his guṇas and his occupation should be according to his varṇa. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=K5BB56w1M38&t=375s',
        },
        {
            'subTopicName': 'Niṣkāma Karma Yoga is the means to purify the heart of the practitioner of the gradual process. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=K5BB56w1M38&t=1178s',
        },
        {
            'subTopicName': 'Vānaprastha stage is the litmus test to assess one\'s readiness for sannyāsa āśram. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OwTewOcAxQ4&t=4148s',
        },
        {
            'subTopicName': 'What is the meaning of "detachment from the fruits of one\'s work"? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=WpdSAdGLTEA&t=3792s',
        },
    ],
    ['Kṛṣṇa Tattva']: [
        {
            'subTopicName': 'Kṛṣṇa - Akhila rasāmṛta mūrti. (60 min)',
            'youtubeLink': 'https://youtu.be/tkl9_a5uPFs?si=MqdKMDKp_vhImNBq&t=443',
        },
        {
            'subTopicName': 'Kṛṣṇa is controlled by Sweetness of relationships. (7 min)',
            'youtubeLink': 'https://youtu.be/yIDZBJMd_QE?si=3PtpzbcVVHU-C1yF&t=2740',
        },
        {
            'subTopicName': 'Dāsa Abhimāna in the Avatāras towards Kṛṣṇa. (3 min)',
            'youtubeLink': 'https://youtu.be/yIDZBJMd_QE?si=rjiWPYkAhRRTIfxL&t=3219',
        },
        {
            'subTopicName': 'Understanding Aṁśī and Aṁśa. (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/bfdbewI_XgE?si=vmHpCx4ulgiC4ZKF&t=3724',
        },
        {
            'subTopicName': 'Glories of Kṛṣṇa\'s lotus feet. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=bIjSD6QLiZSaFdNE&t=4873',
        },
        {
            'subTopicName': 'Why Kṛṣṇa is addressed as "Satyam" ? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/oBSNCs_mTDw?si=vzbNXDxh9kc0i41S&t=453',
        },
        {
            'subTopicName': 'Kṛṣṇa, the reservoir of all Rasa. (6 min)',
            'youtubeLink': 'https://youtu.be/KxlGUpdv0sM?si=IqHqIT7byahKU8eZ&t=2256',
        },
        {
            'subTopicName': 'Understanding how Kṛṣṇa is the root of all the names of all His expansions. (11 min)',
            'youtubeLink': 'https://youtu.be/o88wd4wqTrY?si=p4V13jbJXIFaoyW2&t=2945',
        },
        {
            'subTopicName': 'Kṛṣṇa is more remarkable as object of worship. (12 min)',
            'youtubeLink': 'https://youtu.be/o88wd4wqTrY?si=Hs3fDilK5eW7hjw3&t=910',
        },
        {
            'subTopicName': 'How did Kṛṣṇa get the name Adhokṣaja? (5 min)',
            'youtubeLink': 'https://youtu.be/Sw5xO5BaoI8?si=EMTy_QD67WcKBBnv&t=1230',
        },
        {
            'subTopicName': 'Only Kṛṣṇa can give liberation to demons. (4 min)',
            'youtubeLink': 'https://youtu.be/Sw5xO5BaoI8?si=XRE8VYkQjuiHlKNo&t=1959',
        },
        {
            'subTopicName': 'The real superiority of Kṛṣṇa over Nārāyaṇa is due to the exhibition of rasa. (5 min)',
            'youtubeLink': 'https://youtu.be/alxaqeyYwrY?si=qFQLlr_kGfb4C9Lq&t=1997',
        },
        {
            'subTopicName': 'Kṛṣṇa kills only those who are demons by curse. (11 min)',
            'youtubeLink': 'https://youtu.be/alxaqeyYwrY?si=ktBu8SYt3ce8vO9C&t=2292',
        },
        {
            'subTopicName': 'Kṛṣṇa does not liberate those who are demons by nature. (9 min)',
            'youtubeLink': 'https://youtu.be/alxaqeyYwrY?si=7_NRg4Thc5oB7chN&t=3118',
        },
        {
            'subTopicName': 'Sweetness of Kṛṣṇa\'s relation with His devotees. (8 min)',
            'youtubeLink': 'https://youtu.be/yIDZBJMd_QE?si=Ht_Y61Pjdgd83YAy&t=2708',
        },
        {
            'subTopicName': 'Why is Kṛṣṇa addressed as Satya? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/oBSNCs_mTDw?si=_dFT1tQkkDiXxmW2&t=504',
        },
        {
            'subTopicName': 'Kṛṣṇa is addressed as Satya or Absolute Truth. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/qwr6qQ50sZc?si=fCFxA0DgpCFIit3p&t=1927',
        },
        {
            'subTopicName': 'Ability of Kṛṣṇa\'s form to destroy ignorance. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/qwr6qQ50sZc?si=YLDVUyjs8FZq_y7I&t=2487',
        },
        {
            'subTopicName': 'Lord\'s form is not material, but spiritual. The universal form is not made of Kṛṣṇa\'s svarūpa-śakti. (23 min)',
            'youtubeLink': 'https://www.youtube.com/live/opMuBbLyHRI?si=WW8xtA0AQixj49UZ&t=82',
        },
        {
            'subTopicName': 'Who can understand Kṛṣṇa? (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/opMuBbLyHRI?si=fSaGgPDZqiq0HaLJ&t=1602',
        },
        {
            'subTopicName': 'Kṛṣṇa\'s form is powerful, but because it is covered by sweetness, its power becomes invisible. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/T8_KihNeqEk?si=VxNQXVcaxh7LnjC4&t=1156',
        },
        {
            'subTopicName': 'Why did Śrīla Rūpa Gosvāmī take so much endeavour to establish the supremacy of Śrī Kṛṣṇa? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/T8_KihNeqEk?si=y4SmgBo0gcFi5Mfd&t=4981',
        },
        {
            'subTopicName': 'Śāstric proofs for the form of Kṛṣṇa to be eternal. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/nOfNItlQ3Y4?si=h9kaT0bqCKW2P3_Q&t=4195',
        },
        {
            'subTopicName': 'Bhāgavatam says Kṛṣṇa is eternal. But how to understand when the same Bhāgavatam says Kṛṣṇa accepted and gave up a form? (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/27pSPzF12rQ?si=fzQBo5TBEnzZgj_l&t=2218',
        },
        {
            'subTopicName': 'Due to His inconceivable potencies, Kṛṣṇa can be simultaneously amśī and also amśa. (10 min)',
            'youtubeLink': 'https://youtu.be/LICigxfK3fs?si=no6xDeUPe29qbgk0&t=974',
        },
        {
            'subTopicName': 'Contradictory qualities can coexist in Kṛṣṇa. (12 min)',
            'youtubeLink': 'https://youtu.be/2cggtuiu7Jk?si=QZ3G49HRuosQO2P-&t=982',
        },
        {
            'subTopicName': 'How can Kṛṣṇa be called as ātmārāma if He is pleased with Bhakti? (5 min)',
            'youtubeLink': 'https://youtu.be/2cggtuiu7Jk?si=_kQxo0FsaJ9l3iGm&t=2082',
        },
        {
            'subTopicName': 'Powers of Kṛṣṇa are inconceivable. (9 min)',
            'youtubeLink': 'https://youtu.be/tH-6gKdbtpM?si=37M2NpWDlYlpwYNp&t=1595',
        },
        {
            'subTopicName': 'Human form of Kṛṣṇa is most astounding. (5 min)',
            'youtubeLink': 'https://youtu.be/IhuVM6RY_tE?si=lH_X2tpCrvkp-eJQ&t=1142',
        },
        {
            'subTopicName': 'Kṛṣṇa and His body are non-different. (7 min)',
            'youtubeLink': 'https://youtu.be/IhuVM6RY_tE?si=luXibGMOH6MSA0Lw&t=1446',
        },
        {
            'subTopicName': 'Kṛṣṇa is not directly involved in creation, maintenance, or destruction of this material world. (30 min)',
            'youtubeLink': 'https://youtu.be/R40e2EnGLi8?si=-oqtBGvHUXslfriD&t=1904',
        },
        {
            'subTopicName': 'Realisation of Kṛṣṇa is due to absorption. (35 min)',
            'youtubeLink': 'https://youtu.be/GFb96AucE7A?si=lnDhhfnOCzG64HCN&t=1594',
        },
        {
            'subTopicName': 'Contradictory qualities coexist in Kṛṣṇa. (32 min)',
            'youtubeLink': 'https://youtu.be/LICigxfK3fs?si=3EFOdviu72Nwm8dR&t=1576',
        },
        {
            'subTopicName': 'Kṛṣṇa has contradictory qualities. (33 min)',
            'youtubeLink': 'https://youtu.be/Vwgk1kgtr8I?si=R4pLLY5BqrWufiNq&t=1270',
        },
        {
            'subTopicName': 'How Kṛṣṇa\'s activities are inconceivable and uncommon. (38 min)',
            'youtubeLink': 'https://youtu.be/d1gylkfrxus?si=0QvgLYEIV-dQTZyt&t=1136',
        },
        {
            'subTopicName': 'Kṛṣṇa\'s qualities are unlimited. (36 min)',
            'youtubeLink': 'https://youtu.be/8lSR6ZomGH4?si=otUWaFg0WXrZNxZN&t=1459',
        },
        {
            'subTopicName': 'Kṛṣṇa is the basis of Brahman - Part-1. (36 min)',
            'youtubeLink': 'https://youtu.be/yKpo9EIc010?si=TkAaHntZQVY83hva&t=1188',
        },
        {
            'subTopicName': 'Kṛṣṇa is the basis of Brahman - Part-2. (17 min)',
            'youtubeLink': 'https://youtu.be/WNSqLf81BOI?si=xIYcnagdYo70ZICn&t=2467',
        },
        {
            'subTopicName': 'Kṛṣṇa is the basis of Brahman - Part-3. (40 min)',
            'youtubeLink': 'https://youtu.be/3bQ42YlEwwo?si=yYoAlp_yGWM6e-Oz&t=1222',
        },
        {
            'subTopicName': 'Human form of Kṛṣṇa is the most suitable for variegated human pastimes. (40 min)',
            'youtubeLink': 'https://youtu.be/h6jm2yjZFo8?si=AEh-QpkavWCtGA-9&t=2095',
        },
        {
            'subTopicName': 'Description of our Sambandha Vigraha. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/WgQ0Dd29wJ4?si=xjpdJi4JRKHoaSLz&t=1556',
        },
        {
            'subTopicName': 'Description of our Abhidheya Vigraha. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/WgQ0Dd29wJ4?si=7LfhlYaLFYyBE-9v&t=2013',
        },
        {
            'subTopicName': 'Description of our Prayojana Vigraha. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/WgQ0Dd29wJ4?si=WRTCjThbbdyJpOrc&t=2168',
        },
        {
            'subTopicName': 'Concept of aṁśa and aṁśī. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jJ3bJ5ZV4dQ&t=3597s',
        },
        {
            'subTopicName': 'Understanding Kṛṣṇa’s birth – Part-1. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jJ3bJ5ZV4dQ&t=4145s',
        },
        {
            'subTopicName': 'Understanding Kṛṣṇa’s birth – Part-2. (55 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=m0qz3WcNWYA&t=2112s',
        },
        {
            'subTopicName': 'Why does Kṛṣṇa test His devotees? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/Qw0uvqBg1K8?si=yZ17ReE5nGNAhepE&t=3851',
        },
        {
            'subTopicName': 'Does Kṛṣṇa know how we will respond to a particular situation? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/Qw0uvqBg1K8?si=2D4n34yLCHsJ2VeI&t=4144',
        },
        {
            'subTopicName': 'Kṛṣṇa can glorify His devotees without any material accomplishments. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/qSEYXVoQvp0?si=6Q8ktcwYgZaYChIV&t=2395',
        },
        {
            'subTopicName': 'Why is Kṛṣṇa called tri-satyam? (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/VIuxqpsV5v4?si=2BEoI4Nqwm10QA8M&t=3120',
        },
        {
            'subTopicName': 'Glories of Kṛṣṇa’s lotus feet. (45 min)',
            'youtubeLink': 'https://www.youtube.com/live/Ee1jhekYWOQ?si=AcoLlQMSUlX94S9G&t=3586',
        },
        {
            'subTopicName': 'Kṛṣṇa protects the consciousness of a devotee. (11 min)',
            'youtubeLink': 'https://youtu.be/8iEp8gQh2-k?si=_aMQoY1C2N1BbIxS&t=2923',
        },
        {
            'subTopicName': 'How can the Lord’s birth and activities be both real and unreal? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/WGDxS2Zh950?si=e38H4jsyT_MvONdL&t=2916',
        },
        {
            'subTopicName': 'How to understand the inconceivable aspect of the Lord. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/WGDxS2Zh950?si=hFMJPnfd0nxLP8Ql&t=3692',
        },
        {
            'subTopicName': 'Lord’s special attachment to the akiñcana-bhaktas. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/WGDxS2Zh950?si=e-F1_WwTgX7tg6k6&t=1228',
        },
        {
            'subTopicName': 'How can the Lord be simultaneously equal to all and partial to devotees? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/WGDxS2Zh950?si=9du4lTddNxDYn0K0&t=2067',
        },
        {
            'subTopicName': 'Kṛṣṇa is feared by fear personified? (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/dDFWGaCRpFk?si=wUq8piwR6uXDCo_v&t=1263',
        },
        {
            'subTopicName': 'What is the real reason for Kṛṣṇa’s appearance in this material world? (16 min)',
            'youtubeLink': 'https://www.youtube.com/live/dDFWGaCRpFk?si=vZceV8WljP7ZcDs2&t=2437',
        },
        {
            'subTopicName': 'Kṛṣṇa’s mercy is not always beautiful, but it’s always wonderful. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/8ZbccLoQKNk?si=t-JAWzT0X3Vp8P0u&t=1140',
        },
        {
            'subTopicName': 'Do the demons who try to kill Kṛṣṇa go to hell or get liberated? (7 min)',
            'youtubeLink': 'https://youtu.be/aMYvNoX0CUI?si=WC3d9-y17VGZgLvW&t=1006',
        },
        {
            'subTopicName': 'There is a difference in the personal feature of Kṛṣṇa being unlimited and His impersonal feature being unlimited. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/TtWtstSXjLc?si=QmJqePhodSLcY_gR&t=1822',
        },
        {
            'subTopicName': 'Three appearances of Śrī Kṛṣṇa to three different parents at different times. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/sQYDVRF1VMU?si=Bvs3rU_XU_TPJOnx&t=5197',
        },
        {
            'subTopicName': 'Kṛṣṇa appears with His expansions to protect His devotees. (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/dl1CQ8h9UIg?si=jlGs6UwWoVbJSaUQ&t=1026',
        },
        {
            'subTopicName': 'Mahāt and Aṃśas are present in Kṛṣṇa in Vṛndāvana. (22 min)',
            'youtubeLink': 'https://www.youtube.com/live/hyr1xVwVw0U?si=Kebi2KMxHqDtGLj5&t=2231',
        },
        {
            'subTopicName': 'Kṛṣṇa’s appearance is astonishing. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/gxqeAeFS97U?si=ZpOoDuS4O1R5s5aa&t=1145',
        },
        {
            'subTopicName': 'Cause of Kṛṣṇa’s appearance. (35 min)',
            'youtubeLink': 'https://www.youtube.com/live/gxqeAeFS97U?si=R1TsEXKG6gFI4P40&t=1500',
        },
        {
            'subTopicName': 'Scriptural proofs that Kṛṣṇa’s form is eternal. (33 min)',
            'youtubeLink': 'https://www.youtube.com/live/n7ZQng3c1CQ?si=Q8KFOLNZbmZiQc06&t=969',
        },
        {
            'subTopicName': 'Kṛṣṇa is not formless and has no material form – Part 1. (39 min)',
            'youtubeLink': 'https://www.youtube.com/live/cPkZY8iKuy0?si=bwW_UHSEuYxXfyoz&t=1233',
        },
        {
            'subTopicName': 'Kṛṣṇa is not formless and has no material form – Part 2. (19 min)',
            'youtubeLink': 'https://www.youtube.com/live/ObZmIN0lzr4?si=LIwsw05gcyn8PE91&t=2068',
        },
        {
            'subTopicName': 'Further proof that Kṛṣṇa has a spiritual form. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/79JkwguF_nc?si=MGKHeL2oR4N3N1VT&t=1927',
        },
        {
            'subTopicName': 'Kṛṣṇa’s form is all‑pervasive and at the same time limited. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/rn2LrwEXniA?si=iK8i46BZ_SxZuxw4&t=2064',
        },
        {
            'subTopicName': 'Kṛṣṇa’s pastimes are eternal – Part 1. (25 min)',
            'youtubeLink': 'https://www.youtube.com/live/RD5nXQr9Sec?si=W-85qjePnrZxEtHt&t=2141',
        },
        {
            'subTopicName': 'Kṛṣṇa’s pastimes are eternal – Part 2. (45 min)',
            'youtubeLink': 'https://www.youtube.com/live/4fjoKUIiFeM?si=A_4AjE2wRlaQLv2t&t=1092',
        },
        {
            'subTopicName': 'Kṛṣṇa’s sweetness is greatest in Gokula. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/NdOZJ-9pzYc?si=FS5T5mEjeF0KVfI9&t=6547',
        },
        {
            'subTopicName': 'Kṛṣṇa’s prakāṭa līlā. (25 min)',
            'youtubeLink': 'https://www.youtube.com/live/Q3QXIzKEHsg?si=8EMcWgYXQYC7EGF0&t=1512',
        },
        {
            'subTopicName': 'Four types of sweetness of Kṛṣṇa. (26 min)',
            'youtubeLink': 'https://www.youtube.com/live/pWf_z2HVMik?si=VlH_Ujgmk5VAQBZs&t=3132',
        },
        {
            'subTopicName': 'Tattva of Kṛṣṇa’s birth and activities. (5 min)',
            'youtubeLink': 'https://youtu.be/1phTLCyR2ms?si=73tlzvIPLgg0JR1N&t=2512',
        },
        {
            'subTopicName': 'Symptoms of a person who has understood the “tattva” of Kṛṣṇa’s birth and activities. (12 min)',
            'youtubeLink': 'https://youtu.be/1phTLCyR2ms?si=V0tBmdphbp9LM7L_&t=4377',
        },
        {
            'subTopicName': 'Purpose of the Lord’s descent and the superiority of Kṛṣṇa’s form. (15 min)',
            'youtubeLink': 'https://youtu.be/1phTLCyR2ms?si=HfLuE2BWAVKN4YWf&t=1565',
        },
        {
            'subTopicName': 'Why does Kṛṣṇa perform karma? (11 min)',
            'youtubeLink': 'https://youtu.be/Y5WG8UdumvY?si=25grOYmO36Yj9oQC&t=2352',
        },
        {
            'subTopicName': 'The timeless shelter of Kṛṣṇa’s lotus‑feet. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/ArTC9o-3vJg?si=K6odWNNPaB70TbCP&t=1937',
        },
        {
            'subTopicName': 'The name Govinda and its significance. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/G61l_G9Zuuk?si=h_wqvNssNF1yTPfK&t=247',
        },
        {
            'subTopicName': 'Kṛṣṇa’s transcendental love towards the queens of Dvārakā bewilders even Cupid. (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/G61l_G9Zuuk?si=AuUGabdB8Mu0Gd9Y&t=2610',
        },
        {
            'subTopicName': 'Sweetness of the Lord in Gokula is higher than in other places. (28 min)',
            'youtubeLink': 'https://www.youtube.com/live/JN7U30zp_60?si=qADmkHWdeap56b6h&t=2979',
        },
        {
            'subTopicName': 'Description of the extraordinary qualities which are the causes for Kṛṣṇa’s superiority in Vraja. (22 min)',
            'youtubeLink': 'https://www.youtube.com/live/JN7U30zp_60?si=RxMt33ZwFrtNpuBC&t=3354',
        },
        {
            'subTopicName': 'The same līlā‑puruṣottam Kṛṣṇa is present in Dvārakā, Mathurā, and Vraja, but He exhibits additional qualities in Vraja, not in Dvārakā and Mathurā. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/JN7U30zp_60?si=3GNA9muO2qGBtGWm&t=5341',
        },
        {
            'subTopicName': 'Discussion on Śrī Kṛṣṇa’s svarūpa and His three śaktīs. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/K_sLYVaKqnQ?si=navc0548SE237dHi&t=2219',
        },
        {
            'subTopicName': 'Reconciling the statements of Hari‑vaṁśa‑Purāṇa and Śrīmad‑Bhāgavatam about Lord Kṛṣṇa’s birth. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/M9Ep5BpOoBk?si=7iXqt6kpE3csz6SI&t=944',
        },
        {
            'subTopicName': 'Is Kṛṣṇa’s umbilical cord being attached to Mother Yaśodā a proof that He was her real son? (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/zZWqKGRgMGw?si=0i7nwEe_kRQqZPl2&t=113',
        },
        {
            'subTopicName': 'Does Puṭanā attaining Vaikuṇṭha show Kṛṣṇa’s lack of discrimination towards Mother Yaśodā and the other elderly gopīs? (23 min)',
            'youtubeLink': 'https://www.youtube.com/live/CHgBjEYlklI?si=-mVxkR1fXGXpunUS&t=3482',
        },
        {
            'subTopicName': 'Though ātmārāma, the Lord is hankering for bhakti. (11 min)',
            'youtubeLink': 'https://youtu.be/R7j9POpY4bU?si=dHn0_CWo4LJrzoXt&t=5549',
        },
        {
            'subTopicName': 'Sweetness of Kṛṣṇa is greatest in Gokula. (10 min)',
            'youtubeLink': 'https://youtu.be/R7j9POpY4bU?si=sA7bnXCrgmMSWP9v&t=6548',
        },
        {
            'subTopicName': 'Kṛṣṇa is the Absolute Truth – 2nd daśa‑mūla‑tattva. (22 min)',
            'youtubeLink': 'https://youtu.be/E-F-FbtvVaQ?si=B7aNTMhLR52PpHBt&t=5699',
        },
        {
            'subTopicName': 'Though ātmārāma, Kṛṣṇa is anxious that every jīva in this material world gets out of the struggles of saṁsāra. (20 min)',
            'youtubeLink': 'https://youtu.be/3e3jFtvIWMU?si=HDw3eiVuazxdSClN&t=1551',
        },
        {
            'subTopicName': 'Do all forms of Kṛṣṇa have different potencies, or do they only display different potencies? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=24zlLfq0_BE&t=2889s',
        },
        {
            'subTopicName': 'Lord Brahmā wonders if Kṛṣṇa is indiscriminate in His actions. (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=e-OVjHGgkdQ&t=4560s',
        },
        {
            'subTopicName': 'The whole universe is under Kṛṣṇa\'s control, yet he comes under the control of his devotee\'s love as shown in Dāmodar Līlā. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Kbi_NC_cDbU&t=2535s',
        },
        {
            'subTopicName': 'If Kṛṣṇa is the Absolute Truth, then why does Kṛṣṇa lie in his pastime of eating dirt? (25 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hqKudy8CZuQ&t=5750s',
        },
        {
            'subTopicName': 'The Lord\'s quality of Bhakta Vātsalya is greater than any of his other spiritual qualities such as Purity, Mercy or Truthfulness. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=UrPgbp3G1IU&t=780s',
        },
        {
            'subTopicName': 'Kṛṣṇa is ātmarāma, but still hankers for the love of his devotees. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2D3b3u4tiQ0&t=2295s',
        },
        {
            'subTopicName': 'Acintya nature of Kṛṣṇa. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ar1okrtZNZQ&t=1120s',
        },
        {
            'subTopicName': 'When Kṛṣṇa kills a demon they get liberation, when Kṛṣṇa\'s incarnations kill a demon, they get a better material destination. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1phTLCyR2ms&t=2053s',
        },
        {
            'subTopicName': 'Proofs from Bhagavad Gītā about Kṛṣṇa being the aṁśī. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Q1tmJZhIgIc&t=932s',
        },
        {
            'subTopicName': 'Understanding the contradiction of Supreme Lord being Unborn and takes Birth. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2D3b3u4tiQ0&t=2065s',
        },
        {
            'subTopicName': 'Why is Kṛṣṇa not always visible to perfected devotees even in His own abodes? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ZnQH4cbm3zc&t=3361s',
        },
        {
            'subTopicName': 'Why did Kṛṣṇa fulfill the material sexual desire of Kubjā? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=M4uzc8AOsHw&t=2250s',
        },
        {
            'subTopicName': 'What is the reason why Advaita Ācārya did not distribute Vraja‑prema? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=La-E5bGUD4w&t=635s',
        },
        {
            'subTopicName': 'Perfection of all rasas is in Kṛṣṇa. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=5190s',
        },
        {
            'subTopicName': 'Liberation of demons is due to the glorious position of Kṛṣṇa. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mPV5ksADt7o&t=4130s',
        },
        {
            'subTopicName': 'Is the Lord beautified by His ornaments OR are His ornaments beautified by Him? Or are both true? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gjIKMojudEU&t=3325s',
        },
        {
            'subTopicName': 'How Lord Kṛṣṇa\'s consorts help him taste rasa and help him in his pastime? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=4265s',
        },
        {
            'subTopicName': 'Kṛṣṇa is Bhāva‑grāhī. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2ffu8hErtBs&t=3748s',
        },
        {
            'subTopicName': 'Comparison of Kṛṣṇa and the desire tree. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2ffu8hErtBs&t=4714s',
        },
        {
            'subTopicName': 'Kṛṣṇa the aṁśī can claim to have performed an action actually performed by one of His aṁśas. (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oFANPMdLS2k&t=1520s',
        },
    ],
    ['Law of Karma']: [
        {
            'subTopicName': 'Detailed explanation of Aprārabdha Karma. (60 min)',
            'youtubeLink': 'https://www.youtube.com/live/9Tu_d3wiP94?si=jDuB9DI1O0-2irdK&t=99',
        },
        {
            'subTopicName': 'Who falls within the law of karma? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-9dp2mzOlKM&t=1835s',
        },
        {
            'subTopicName': 'Intricacies of action and reaction in the material world. (60 min)',
            'youtubeLink': 'https://youtu.be/bVJyBgjD79E?si=V-I8AUa-TR9SsGRM&t=2165',
        },
        {
            'subTopicName': 'Intricacies of law of karma. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/GLNyoijb_2w?si=ZOxEbTGXMtd3Y4LA&t=5685',
        },
        {
            'subTopicName': 'How karma works and how important is our perspective to deal with sufferings. (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/7jtK9a0Ru3A?si=3jdeP8KOQ7bpQl_7&t=619',
        },
        {
            'subTopicName': 'How to understand the apparent injustice in the law of karma. (10 min)',
            'youtubeLink': 'https://youtu.be/kTrXcDsUOyU?si=Z-Ipw2agPougNCSN&t=5431',
        },
        {
            'subTopicName': 'Understanding law of karma with reference to SB 10.4.46. (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/454cpAnNtMU?si=FMFLbQn_fRjM3Lck&t=1147',
        },
        {
            'subTopicName': 'Is the law of karma exactly reciprocal? Does one become the same species whom he had killed in his previous birth? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/454cpAnNtMU?si=J-WKK4G0Hn1LMHqW&t=3134',
        },
        {
            'subTopicName': 'If Karma applies only to the human residents of Bhārata Varṣa, how so many species are manifesting in the other parts of the universe? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gOW6r-Kb0vU&t=3967s',
        },
        {
            'subTopicName': 'Qualities of Karmic Suffering. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=X5x74WCbg3g&t=3305s',
        },
    ],
    ['Limbs of Bhakti']: [
        {
            'subTopicName': 'Smaranam is the result of sufficient śravaṇam and kīrtanam. (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5jTppLPr2Nw&t=5342s',
        },
        {
            'subTopicName': '3 types of prayers to the Lord. (37 min)',
            'youtubeLink': 'https://youtu.be/BTLSRM-69Oo?si=qpc_tMzIBUMxy3tF&t=2508',
        },
        {
            'subTopicName': 'The power of glorifying the name, qualities and pastimes of the Lord. (32 min)',
            'youtubeLink': 'https://youtu.be/BTLSRM-69Oo?si=eWJstQvWEQDdXZwh&t=1061',
        },
        {
            'subTopicName': 'Glory of honoring "prasādam". (20 min)',
            'youtubeLink': 'https://youtu.be/8iEp8gQh2-k?si=a9yM5tSx9j0YIwzh&t=426',
        },
        {
            'subTopicName': 'Expecting the Lord\'s mercy: An important limb of bhakti. (31 min)',
            'youtubeLink': 'https://youtu.be/hUnxciAKoVc?si=_WKvXwwk5-q0M-KV&t=176',
        },
        {
            'subTopicName': 'Contemplation with absorption on Kṛṣṇa. (33 min)',
            'youtubeLink': 'https://youtu.be/hUnxciAKoVc?si=aijWNLRbXGVMZ5H2&t=1996',
        },
        {
            'subTopicName': 'The glorification of service to Vaiṣṇavas. (16 min)',
            'youtubeLink': 'https://youtu.be/85Xyo1ZsMCo?si=wbYDHNbTVShIvaK6&t=338',
        },
        {
            'subTopicName': 'How to develop attachment to Deity worship? (38 min)',
            'youtubeLink': 'https://youtu.be/85Xyo1ZsMCo?si=XXm19qw2HEGdTBhM&t=3604',
        },
        {
            'subTopicName': 'Neglect of Deity worship leads to collapse of a spiritual community. (8 min)',
            'youtubeLink': 'https://youtu.be/85Xyo1ZsMCo?si=3pInc-c4Tq8iDmEP&t=5435',
        },
        {
            'subTopicName': 'Relishing Bhāgavatam. (56 min)',
            'youtubeLink': 'https://youtu.be/UFvqDmP0D44?si=5nKbSej42mnQEvTu&t=1110',
        },
        {
            'subTopicName': 'Significance of hearing the pastimes of Kṛṣṇa killing demons. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NfsDcuEqmpw&t=2151s',
        },
        {
            'subTopicName': 'Kṛṣṇana smaraṇam is possible only after significant anartha nivṛtti (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-y_GswkNDVA&t=2133s',
        },
        {
            'subTopicName': 'The sādhaka\'s contaminated svabhāva is a serious obstacle to Smaraṇam. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Iea5UCJbc6o&t=1886s',
        },
        {
            'subTopicName': 'Service to guru. (31 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pHtStax8QBU&t=3360s',
        },
        {
            'subTopicName': 'Words devoid of Lord\'s Glories are ornaments of a dead body. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4Kj9WE3zldA&t=2317s',
        },
        {
            'subTopicName': 'Detailed descriptions of Vṛndāvana in Śrīmad‑Bhāgavatam nourishes Kṛṣṇa‑smaraṇam. (23 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=N90t516qYew&t=320s',
        },
        {
            'subTopicName': 'Scriptures glorifying one of the limbs of Bhakti should not be taken as a suggestion to neglect the performance of other limbs. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7FEVl_0dUvs&t=4976s',
        },
        {
            'subTopicName': 'Taste for hearing Kṛṣṇa‑kathā is the basic qualification for Bhakti. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3qnSB9TmSAQ&t=3480s',
        },
        {
            'subTopicName': 'Nāma‑śravaṇam. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nVfSEaO-qWc&t=225s',
        },
        {
            'subTopicName': 'Rūpa‑śravaṇam. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nVfSEaO-qWc&t=580s',
        },
        {
            'subTopicName': 'Guṇa‑śravaṇam. (29 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nVfSEaO-qWc&t=985s',
        },
        {
            'subTopicName': 'Guṇa‑śravaṇam. (21 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nVfSEaO-qWc&t=3601s',
        },
        {
            'subTopicName': 'Guṇa‑śravaṇam attracts even those desiring liberation. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nVfSEaO-qWc&t=3320s',
        },
        {
            'subTopicName': 'Śravaṇam, which is the most foundational limb, empowers all other limbs of bhakti. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nVfSEaO-qWc&t=1219s',
        },
        {
            'subTopicName': 'What does \'taking shelter at the lotus feet of the Lord\' mean? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0utgOK2TwGU&t=3268s',
        },
        {
            'subTopicName': 'Does the BG 8.6 verse yaṁ yaṁ vāpi smaran bhāvaṁ suggest smaraṇam as the most important limb compared to śravaṇam and kīrtanam? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nVfSEaO-qWc&t=2730s',
        },
        {
            'subTopicName': 'Why / how are prayers powerful? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mVProlZbvaY&t=934s',
        },
        {
            'subTopicName': 'Anuccheda 260/261/262 ‑ In the process of hearing, hearing Bhāgavatam is the best. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=phYwzJ8IFGc&t=6570s',
        },
        {
            'subTopicName': 'Anuccheda 258/259 ‑ Hearing from great devotees is powerful and blissful. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=phYwzJ8IFGc&t=1800s',
        },
        {
            'subTopicName': 'Impact of hearing from great devotees even on simpler topics that one may not find intellectually stimulating. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=phYwzJ8IFGc&t=1828s',
        },
        {
            'subTopicName': 'Anuccheda 257 ‑ Two types of hearing from great devotees. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=phYwzJ8IFGc&t=1310s',
        },
        {
            'subTopicName': 'Anuccheda 256 ‑ Hearing about Lord’s associates. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=5832s',
        },
        {
            'subTopicName': 'Anuccheda 255 ‑ Līlā‑śravaṇam. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=5328s',
        },
        {
            'subTopicName': 'Is it acceptable to skip puruṣāvatāra‑kathā and get into līlāvatāra‑kathā? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=4370s',
        },
        {
            'subTopicName': 'Anuccheda 253/254 ‑ Līlā‑śravaṇam. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=3635s',
        },
        {
            'subTopicName': 'Pre‑requisite for remembering Kṛṣṇa and the Vrajavāsīs. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=4470s',
        },
    ],
    ['Līlā-Tattva']: [
        {
            'subTopicName': 'How the Supreme Lord interacts with the manifestations of Yogamaya and Mahamaya? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/HLs1k6FVRTk?si=u4XeQKC8f_4_AA39&t=1490',
        },
        {
            'subTopicName': 'Display of Kṛṣṇa\'s aiśwarya in Vṛndāvana, only enhances the devotees\'s love for Him. (5 min)',
            'youtubeLink': 'https://youtu.be/Wi68_XAAlcY?si=0hqo4_4l3JqZh10Q&t=2190',
        },
        {
            'subTopicName': 'Understanding the eternal nature of Kṛṣṇa\'s Pastimes. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=JjbAa0n1B0PAjl6G&t=5387',
        },
        {
            'subTopicName': 'Love between Kṛṣṇa and the gopīs is not material. (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/zikcWKy_ugw?si=J8mD64LuEU16LZp0&t=1194',
        },
        {
            'subTopicName': 'Variegated reciprocation of Kṛṣṇa with different categories of Gopīs. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/oBSNCs_mTDw?si=vVrYE4puGUBA9n71&t=2236',
        },
        {
            'subTopicName': 'Why did Kṛṣṇa go to Vṛndāvana from Mathurā after birth? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/oBSNCs_mTDw?si=wnDK1UVMkkiIm1Nw&t=1569',
        },
        {
            'subTopicName': 'Are bhauma-līlā pastimes eternal? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=TBQIeB_nL1bZ3RLE&t=5376',
        },
        {
            'subTopicName': 'The main reason of Kṛṣṇa\'s appearance. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/nOfNItlQ3Y4?si=MYcMJweii-rzk3aM&t=3889',
        },
        {
            'subTopicName': 'It is more difficult to understand the pastimes of the Līlāvatāras in comparison to the pastimes of the Puruṣāvatāras. (14 min)',
            'youtubeLink': 'https://youtu.be/1G09tBj3x1M?si=5PtCdElICYtjt-mN&t=1743',
        },
        {
            'subTopicName': 'Kṛṣṇa’s conjugal līlā with the gopīs is not material. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ix1qTqpWbx4&t=3626s',
        },
        {
            'subTopicName': 'Why did Parīkṣit Mahārāja himself question Kṛṣṇa’s moral values after hearing rāsa-līlā? (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ix1qTqpWbx4&t=5195s',
        },
        {
            'subTopicName': 'Did Kṛṣṇa break any moral principles by performing rāsa-līlā with the gopīs? (57 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5DPnaY774qg&t=155s',
        },
        {
            'subTopicName': 'How is Kṛṣṇa’s relation with the gopīs transcendental? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5DPnaY774qg&t=3840s',
        },
        {
            'subTopicName': 'How Kṛṣṇa can be fearful of Yaśodā? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/mYMbiY6FWfY?si=5Tmcd1cbe0f-vOJi&t=3928',
        },
        {
            'subTopicName': 'Parīkṣit Mahārāja’s doubts about Rāsa-līlā. (88 min)',
            'youtubeLink': 'https://www.youtube.com/live/5DPnaY774qg?si=8IB_p3kKJWm72og_&t=137',
        },
        {
            'subTopicName': 'Is Rāsa-līlā immoral? (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/5DPnaY774qg?si=36KCu8D4E-Pb1nvi&t=3823',
        },
        {
            'subTopicName': 'Understanding the eternal nature of Kṛṣṇa’s prakaṭa and aprakaṭa līlā. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/CO9MBb75S_0?si=rCOzqRInQ3NlVG-j&t=4095',
        },
        {
            'subTopicName': 'Understanding the appearance of Lord Kṛṣṇa through both Mother Yaśodā and Devakī. (35 min)',
            'youtubeLink': 'https://www.youtube.com/live/TtWtstSXjLc?si=JmIyZvayeYBp53Ga&t=2578',
        },
        {
            'subTopicName': 'Why are the śāstras very secretive about Kṛṣṇa’s appearance to Mother Yaśodā? (24 min)',
            'youtubeLink': 'https://www.youtube.com/live/g_MA-tQ48M0?si=fFET0xCgi_A8uqHB&t=1443',
        },
        {
            'subTopicName': 'Understanding Kṛṣṇa’s prakāṭa līlā. (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/owq77cZ5P5Q?si=DCalWuMFs-sUVQ7g&t=650',
        },
        {
            'subTopicName': 'Understanding the intricacies of Kṛṣṇa’s appearance – Part 1. (32 min)',
            'youtubeLink': 'https://www.youtube.com/live/owq77cZ5P5Q?si=lEziJK9HFajRYXxL&t=1652',
        },
        {
            'subTopicName': 'Understanding the intricacies of Kṛṣṇa’s appearance – Part 2. (16 min)',
            'youtubeLink': 'https://www.youtube.com/live/QheyHX2EznU?si=H-Tfrb_6HsJvo4lM&t=1415',
        },
        {
            'subTopicName': 'Proof that Kṛṣṇa is son of Nanda‑Mahārāja. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/5NVCnO1XO1U?si=NcwYcAGO01jSQuB5&t=1256',
        },
        {
            'subTopicName': 'Did Kṛṣṇa leave Vṛndāvana? (36 min)',
            'youtubeLink': 'https://www.youtube.com/live/5NVCnO1XO1U?si=FTtzh0bDH1txqZ5Y&t=1448',
        },
        {
            'subTopicName': 'Kṛṣṇa’s return to Vraja. (22 min)',
            'youtubeLink': 'https://www.youtube.com/live/U7dHSLDt29s?si=6xrJkiBDzgg0UQ8s&t=2407',
        },
        {
            'subTopicName': 'Understanding the eternal nature of Kṛṣṇa’s pastimes. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/8WMus7iacFE?si=eRHgI1-4CkRYhqLh&t=3228',
        },
        {
            'subTopicName': 'Prakāṭa and aprakāṭa līlās in the material world. (91 min)',
            'youtubeLink': 'https://www.youtube.com/live/_iVmyWy0Lvo?si=j0W686FVE9s9JW_F&t=243',
        },
        {
            'subTopicName': 'Kṛṣṇa is in Dvārakā, but His heart is in Vraja. (5 min)',
            'youtubeLink': 'https://youtu.be/JrMQzTlp4iE?si=37b_ERDKiQ3pIu_R&t=1856',
        },
        {
            'subTopicName': 'Dimensions of Kṛṣṇa’s eternal pastimes. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/gm-LWZ6qybc?si=Z8S76wZJBypkron3&t=2027',
        },
        {
            'subTopicName': 'Does līlā‑puruṣottam Kṛṣṇa ever leave Vṛndāvana? (26 min)',
            'youtubeLink': 'https://www.youtube.com/live/v6pulzCsUDQ?si=fqawf0jtYxrz6Dll&t=3791',
        },
        {
            'subTopicName': 'Is Śrīla Rūpa Gosvāmī rejecting the statements of the śāstras or is he rejecting the explanations by some other ācāryas by mentioning that Kṛṣṇa does leave Vṛndāvana? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/UHNyuwoANWk?si=6thUtZgmydq-Ft5T&t=1473',
        },
        {
            'subTopicName': 'How to understand the yamala verse which says: Kṛṣṇa never leaves Vṛndāvana. (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/UHNyuwoANWk?si=Tt2PCsma1YIuq5BK&t=1682',
        },
        {
            'subTopicName': 'Agamana (Kṛṣṇa’s physical return to Vraja) described. (22 min)',
            'youtubeLink': 'https://www.youtube.com/live/UHNyuwoANWk?si=enss_b8qN_nZgbOu&t=3307',
        },
        {
            'subTopicName': 'Understanding viṣphurti (bliss experienced due to the pain of separation by the Vrajavāsīs, during the first three months). (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/P8Lh5gkC0qo?si=lEwi7X33HGr-Fmyx&t=2749',
        },
        {
            'subTopicName': 'What is the difference between agati and avirbhāva, as both represent Kṛṣṇa’s presence? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/P8Lh5gkC0qo?si=MfgaegDhnN0xAmN2&t=3463',
        },
        {
            'subTopicName': 'How can you say that Droṇa and others merged into Nanda during the earthly pastimes and later emerged from them and went into Vaikuṇṭha? Is there proof for such a happening? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/P8Lh5gkC0qo?si=dS4HHtGy80QZzp4Y&t=82',
        },
        {
            'subTopicName': 'Understanding the evidence presented by Śrīla Rūpa Gosvāmī for Kṛṣṇa never leaving Vṛndāvana. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/M5LIRVZVMVA?si=HPB6opgbIcuyK_Cg&t=2328',
        },
        {
            'subTopicName': 'What happens to those who get attracted to the Dāmodar līlā if in the spiritual world that form does not exist? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/YryHwqGZOt4?si=AjZKXO0p0XaSjFtg&t=5201',
        },
        {
            'subTopicName': 'Deep understanding of the feelings of separation of the Pāṇḍavas from Kṛṣṇa after the war. (36 min)',
            'youtubeLink': 'https://youtu.be/hiA1oSf812A?si=mi5r5PvT1nt8U3Tg&t=2444',
        },
        {
            'subTopicName': 'Kṛṣṇa’s eternal associates and their expansions – Part‑I (37 min)',
            'youtubeLink': 'https://www.youtube.com/live/0-goGC5mZ58?si=uCX4XLrtp1Er9wwo&t=1683',
        },
        {
            'subTopicName': 'Kṛṣṇa’s eternal associates and their expansions – Part‑II (120 min)',
            'youtubeLink': 'https://www.youtube.com/live/eCopD7nLox8?si=LZDqVTzcI4cAj5Nl&t=62',
        },
        {
            'subTopicName': 'Kṛṣṇa’s eternal associates and their expansions – Part‑III (73 min)',
            'youtubeLink': 'https://www.youtube.com/live/n-C8P_PlfS8?si=oW6MqfPlEsV8Fvgt&t=61',
        },
        {
            'subTopicName': 'Importance of understanding the siddhānta to appreciate Kṛṣṇa‑kathā. (46 min)',
            'youtubeLink': 'https://youtu.be/R0yONCoi2Ps?si=F5z7dEuaE_CFPcDZ&t=2020',
        },
        {
            'subTopicName': 'Kṛṣṇa’s eternal associates and their expansions – Part IV. (70 min)',
            'youtubeLink': 'https://www.youtube.com/live/Yu1tfiXwArE?si=knVYB_HZYeqpEspS&t=143',
        },
        {
            'subTopicName': 'Kṛṣṇa’s eternal associates and their expansions – Part V. (73 min)',
            'youtubeLink': 'https://www.youtube.com/live/jMH3BK-tlk8?si=dVyAZvx_1IdKsiGX&t=69',
        },
        {
            'subTopicName': 'Kṛṣṇa’s eternal associates and their expansions – Part VI. (120 min)',
            'youtubeLink': 'https://www.youtube.com/live/2bqYMedjzf0?si=gIxx3x9ZpCTv_cgO&t=244',
        },
        {
            'subTopicName': 'Why does yogamāyā cover the memory of nitya‑siddhas in their bhauma‑līlā? (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/lxUigu7wOeQ?si=eT2D6M7ermEqydh3&t=3580',
        },
        {
            'subTopicName': 'Why yogamāyā sometimes hides and sometimes reveals certain things — in order to assist in the līlās. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/7kc-3dFnkxo?si=86Fbd0pQCRKx5SH5&t=2261',
        },
        {
            'subTopicName': 'Interplay of Kṛṣṇa\'s various Potencies in Vraja. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KI1oFi_kLfg&t=3630s',
        },
        {
            'subTopicName': 'Yogamāyā can mimick exactly like Mahāmāyā for the Lord\'s pastime purpose. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dShVtpY4wzY&t=4211s',
        },
        {
            'subTopicName': 'Why the Eternal Lord\'s Eternal Knowledge and Bliss gets covered in Vraja to perform his sweet and loving pastimes? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=iDFPpXmiXkA&t=3080s',
        },
        {
            'subTopicName': 'When Kṛṣṇa\'s own Satya Saṅkalpa Śakti failed? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ndFrek_I6jU&t=1355s',
        },
        {
            'subTopicName': 'Correct perspective to understand the eternality of Lord’s pastimes. (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NfsDcuEqmpw&t=4173s',
        },
        {
            'subTopicName': 'How to look at Aghāsura\'s Liberation - Injustice or Mercy? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gVdLB-yEzwk&t=740s',
        },
        {
            'subTopicName': 'Is it a fault for the Lord to have repetition of His pastimes in various yugas/kalpas? Does the unlimited Lord have less variety in pastimes? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NfsDcuEqmpw&t=3450s',
        },
        {
            'subTopicName': 'Understanding the role of Yogamāyā and his other energies though the Mṛd‑Bhakṣaṇa‑Līlā. (28 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=UrPgbp3G1IU&t=1730s',
        },
        {
            'subTopicName': 'Lord Brahmā gives the reason for Kṛṣṇa\'s descent by imitating material life. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=e-OVjHGgkdQ&t=6480s',
        },
        {
            'subTopicName': 'How do devotees in other rasas perceive Kṛṣṇa’s mādhuryā‑līlās? (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HJcD57yDGE8&t=4205s',
        },
        {
            'subTopicName': 'A perfected devotee\'s vision of Kṛṣṇa is also occasionally covered by yogamāyā. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ZnQH4cbm3zc&t=3361s',
        },
        {
            'subTopicName': 'Why did Kṛṣṇa fulfill the material sexual desire of Kubjā? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=M4uzc8AOsHw&t=2250s',
        },
        {
            'subTopicName': 'How Lord Kṛṣṇa\'s consorts help him taste rasa and help him in his pastime? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=4265s',
        },
        {
            'subTopicName': 'Understanding the role of the Hlādinī potency of the Lord. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=2888s',
        },
    ],
    ['Mixed Devotional Service']: [
        {
            'subTopicName': 'Bhakti in the Mode of Goodness. (4 min)',
            'youtubeLink': 'https://youtu.be/fQRmE-27pOM?si=PRpNEydto2x-NEyN&t=1073',
        },
        {
            'subTopicName': 'Are there gradations in desire for Mukti? (5 min)',
            'youtubeLink': 'https://youtu.be/SfFVMSoXu0I?si=qDuskCUyE8C8V4Zs&t=2606',
        },
        {
            'subTopicName': 'Difference between jñāna and jñāna-miśra-bhakti. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rnLOb76ko0A&t=3507s',
        },
        {
            'subTopicName': 'Why are sarva-kāmīs and mokṣa-kāmīs called very intelligent in the “akāmaḥ sarva-kāmo vā” verse? (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rnLOb76ko0A&t=3624s',
        },
        {
            'subTopicName': 'If bhakti is beyond the guṇas, then what is the meaning of sāttvika-bhakti, rājasika-bhakti and tāmasika-bhakti? (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LQZJYlTGtls&t=1755s',
        },
        {
            'subTopicName': 'After purification through niṣkāma-karma-yoga, how can one become a jīvan-mukta? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/-4fWZa3IqS8?si=9H2Q6SGWqkqLtR6E&t=3554',
        },
        {
            'subTopicName': 'A jñāna-yogī should not confuse the mind of a karma-yogī and discourage him from abruptly stopping karma. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/FcWTqdy5Kgk?si=lYzrEr51z9wQxuZX&t=2041',
        },
        {
            'subTopicName': 'How mixed devotion can lead to sālokya-mukti? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/kkNawrmCVaQ?si=JlbgEfLlmCwWSv6K&t=4224',
        },
        {
            'subTopicName': 'Are the Navayogendras and four Kumāras miśra or śuddha-bhaktas? (8 min)',
            'youtubeLink': 'https://youtu.be/QT5ZlC5rURY?si=0Dvc4XqyWJu6RiwU&t=3662',
        },
        {
            'subTopicName': 'Two kinds of mixed devotees: those attached to alternate goals, and those attached to both alternate goals and alternate means. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/svGuxsB2ryE?si=1fWIy5EcBmEzu9v-&t=6006',
        },
        {
            'subTopicName': 'The planets that the krama‑muktās pass before reaching the Brahma‑jyoti. (23 min)',
            'youtubeLink': 'https://youtu.be/sVUOpD4LyQk?si=RmRqQkqRRS27rZ9A&t=2059',
        },
        {
            'subTopicName': 'The two types of mixed devotees. (14 min)',
            'youtubeLink': 'https://youtu.be/pVYq4qnCMDA?si=0btVuwHnz5AayO4Z&t=4439',
        },
        {
            'subTopicName': 'Different fruits for different routes of worship. (17 min )',
            'youtubeLink': 'https://youtu.be/FwZywLwu6Wk?si=KtSLZi9N9phW__7K&t=3342',
        },
        {
            'subTopicName': 'Definition of Mixed devotional service. (5 min)',
            'youtubeLink': 'https://youtu.be/_7jxSZ7LflE?si=zsRFqNGR3dHzLgKN&t=675',
        },
        {
            'subTopicName': 'Three types of bhakti – āropa‑siddhā, saṅga‑siddhā, and svarūpa‑siddhā. (28 min)',
            'youtubeLink': 'https://www.youtube.com/live/6OI7sdLI8Vo?si=HDuRELqzPipG35Z4&t=3060',
        },
        {
            'subTopicName': 'Śrīla Jīva Gosvāmī’s terminologies for classification of bhakti (āropa, saṅga, and svarūpa‑siddhā bhakti) consider only the sādhana and not the goal. (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/6OI7sdLI8Vo?si=snpSFrVUPwYwcFtb&t=3585',
        },
        {
            'subTopicName': 'Can someone practice saṅga‑siddhā‑bhakti and yet have prema as their goal? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/6OI7sdLI8Vo?si=8XzFqyEUeXv-6GiU&t=5240',
        },
        {
            'subTopicName': 'Does doing yoga exercises to maintain the body make one a performer of saṅga‑siddhā‑bhakti? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/6OI7sdLI8Vo?si=WCd0uxunDVdLwXri&t=5380',
        },
        {
            'subTopicName': 'Āropa‑siddhā‑bhakti: offering of karmas. (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/6OI7sdLI8Vo?si=W7G6osqqRvFqydXU&t=5855',
        },
        {
            'subTopicName': 'Excellence of results received from offering scripturally prescribed acts. (27 min)',
            'youtubeLink': 'https://www.youtube.com/live/OzAAIvrhzgs?si=9xm2HqZSFv5BHgqb&t=4140',
        },
        {
            'subTopicName': 'Bharata Mahārāja’s apparent execution of āropa‑siddhā‑bhakti. (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/OzAAIvrhzgs?si=zxa16cLwTRkPtdE1&t=5970',
        },
        {
            'subTopicName': 'Why does Śrīla Jīva Gosvāmī quote SB 11.2.35 yan āsthāya naro rājan verse in āropa‑siddhā‑bhakti section, which was explained as śuddha‑bhakti verse by Śrīla Prabhupāda and SVCT? (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/GN6pTdaY48Y?si=GVjMsBmlOMB211G4&t=2611',
        },
        {
            'subTopicName': 'Is the karma actions performed by a svarūpa‑siddha‑bhakta for loka‑saṅgraha considered as āropa‑siddhā? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/GN6pTdaY48Y?si=RX5B3YrpFfHlI1GH&t=3600',
        },
        {
            'subTopicName': 'How can Bharata Mahārāja, who is a pure devotee, perform āropa‑siddhā‑bhakti activities? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/GN6pTdaY48Y?si=g9y7641DUhuhKa5-&t=3992',
        },
        {
            'subTopicName': 'Āropa‑siddhā‑bhakti performed by Bharata Mahārāja? (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/GN6pTdaY48Y?si=hJnNDJC8-NQM9c2v&t=5105',
        },
        {
            'subTopicName': 'Are all bona‑fide varṇāśrama activities considered āropa‑siddhā‑bhakti? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/YoPVAdlIo-w?si=AZxwdNa1F7C6JO0p&t=2240',
        },
        {
            'subTopicName': 'Why does a pure devotee king perform āropa‑siddhā‑bhakti to inspire the citizen to properly perform karma? Can’t he directly perform svarūpa‑siddhā‑bhakti and inspire them to take up pure devotional service? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/YoPVAdlIo-w?si=7OcaCTpEQQvb7mWB&t=2700',
        },
        {
            'subTopicName': 'Three types of offerings of karma to the Lord in āropa‑siddhā‑bhakti. (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/YoPVAdlIo-w?si=28RHRvWqv1egooi8&t=3497',
        },
        {
            'subTopicName': 'Why is offering of karma to the Lord for His pleasure still considered āropa‑siddhā‑bhakti? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/YoPVAdlIo-w?si=Wyjxmp2ehbqGPYYR&t=4294',
        },
        {
            'subTopicName': 'Saṅga‑siddhā‑bhakti – karma‑jñāna‑miśra‑bhakti. (21 min)',
            'youtubeLink': 'https://www.youtube.com/live/YoPVAdlIo-w?si=T3G_GTTxoJrBX6mp&t=4387',
        },
        {
            'subTopicName': 'Saṅga‑siddhā‑bhakti – jñāna‑miśra‑bhakti. (19 min)',
            'youtubeLink': 'https://www.youtube.com/live/YoPVAdlIo-w?si=CWzBr7wGDuaXTd6r&t=5659',
        },
        {
            'subTopicName': 'Is a mixed devotee in a better position than a niṣkāma‑karma‑yogī? (1 min)',
            'youtubeLink': 'https://youtu.be/0W5mBmDmT2w?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=2794',
        },
        {
            'subTopicName': 'Path of a ṣaṇīṣṭha-bhakta. (11 min)',
            'youtubeLink': 'https://youtu.be/2uDMb-wElLE?si=OQcnImd0x9xtWCJ3&t=3785',
        },
        {
            'subTopicName': 'The Grand Yoga Chart. (20 min )',
            'youtubeLink': 'https://youtu.be/2uDMb-wElLE?si=GzzdkR6HsI8lygci&t=4601',
        },
        {
            'subTopicName': 'Svarūpa Siddhā Bhakti in 3 modes (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9IZAlA8UENA&t=222s',
        },
        {
            'subTopicName': 'Definition of Guṇī bhūta Bhakti. (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=xqsdZWrV2FM&t=686s',
        },
        {
            'subTopicName': 'Gradual progress from one yoga to another with and without association of the devotees. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JbcMdCyV4do&t=2976s',
        },
        {
            'subTopicName': 'Various types of Bhakti and their characteristics. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2JHFguvmCfE&t=4286s',
        },
        {
            'subTopicName': 'Understanding Pradhānī‑bhūta, Guṇī‑bhūta and Śuddha‑bhakti Practitioners. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hsOWsv1PRdo&t=1631s',
        },
        {
            'subTopicName': 'Summary of types of Bhakti and results of various yogic practices. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=R91CJZltUcs&t=2075s',
        },
        {
            'subTopicName': 'Why the Lord becomes obliged to respond to mixed devotees who have material desires? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EBAqOcl0Gts&t=3490s',
        },
        {
            'subTopicName': 'Mixed Devotional Service and Varṇāśrama designations. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=5455s',
        },
        {
            'subTopicName': 'How is Jñāna an obstacle to Bhakti if it destroys the subtle body too? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=3552s',
        },
        {
            'subTopicName': 'How did Jñāna‑miśra‑bhaktas like the 4 Kumāras glorify Śuddha‑bhakti? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5zk7IbCiQJY&t=261s',
        },
        {
            'subTopicName': 'What destinations do Karma‑miśra‑bhakti, Jñāna‑miśra‑bhakti, and Śuddha‑bhakti fetch? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=o7YgN8pXjBs&t=1647s',
        },
        {
            'subTopicName': 'What\'s the difference between the destinations of Pradhānībhūta‑bhakti and Śuddha‑bhakti? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=o7YgN8pXjBs&t=5598s',
        },
        {
            'subTopicName': 'Conclusion on āropa‑siddha‑bhakti from discussions with H H Bhakti Vijñāna Mahārāja. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=phYwzJ8IFGc&t=1040s',
        },
        {
            'subTopicName': 'Raty‑ābhāsa ‑ Part‑1. (65 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=VFnjKiJO_rc&t=3246s',
        },
        {
            'subTopicName': 'Raty‑ābhāsa ‑ Part‑2 (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=768s',
        },
    ],
    ['Mukti']: [
        {
            'subTopicName': 'Krama Mukti. (1 min)',
            'youtubeLink': 'https://youtu.be/sVUOpD4LyQk?si=KJQ2Dax7wuqxMKlq&t=1262',
        },
        {
            'subTopicName': 'How to protect from Sayujya desire? (6 min)',
            'youtubeLink': 'https://youtu.be/iJx6h4gLfBw?si=U5ouovlapVYhDOLg&t=4085',
        },
        {
            'subTopicName': 'Is there fear of fall-down in krama-mukti? (6 min)',
            'youtubeLink': 'https://youtu.be/ubOIdKVoXew?si=_C09qErBhYAuxbOT&t=2286',
        },
        {
            'subTopicName': 'Does a person who attains Brahma‑jyoti return to this world or not? (30 min)',
            'youtubeLink': 'https://youtu.be/iJx6h4gLfBw?si=e5YIyLsUX1Z7tdUg&t=1431',
        },
        {
            'subTopicName': 'Since jñāna‑ and aṣṭāṅga‑yogas have bhakti as a minor portion, how is it that the perfected jñāna‑ and aṣṭāṅga‑yogīs in the Brahma‑jyoti remain free from spiritual experience? (12 min)',
            'youtubeLink': 'https://youtu.be/pVYq4qnCMDA?si=4gMtTyZ4_3YFei8s&t=2771',
        },
        {
            'subTopicName': 'Who can attain Brahma‑jyoti? (9 min)',
            'youtubeLink': 'https://youtu.be/F_OCV4HdUY0?si=3FySKXGsyeVUwZey&t=1436',
        },
        {
            'subTopicName': 'A comprehensive description of impersonal liberation from Bṛhad‑Bhāgavatāmṛta and its comparison with the glories of prema. (63 min)',
            'youtubeLink': 'https://youtu.be/mMx_JB0izg0?si=DU3eeyPvo0NQe9-b&t=915',
        },
        {
            'subTopicName': 'Transmigration and liberation of the jīvas. (81 min)',
            'youtubeLink': 'https://youtu.be/drRVkdupvck?si=pKc_HlmTSWfRjNLT&t=2279',
        },
        {
            'subTopicName': 'Abhidheya, bondage and liberation of jīvas. (10 min)',
            'youtubeLink': 'https://youtu.be/pIVrffAk210?si=Am2p99CRNO3Xfk3n&t=1887',
        },
        {
            'subTopicName': 'How can devotees with selfish desires reach Vaikuṇṭha? (33 min)',
            'youtubeLink': 'https://youtu.be/rnA74aDvpRE?si=7ebqJCThUwUSd1h8&t=2609',
        },
        {
            'subTopicName': 'Bondage and Liberation are both an illusion. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=AgK1wHrMdLQ&t=2725s',
        },
        {
            'subTopicName': 'If one generally doesn\'t fall down from Brahmajyoti, how do you explain the verse \'ye\'nye\'ravindākṣa vimukta‑māninaḥ....\' of Śrīmad Bhāgavatam quoted often by Śrīla Prabhupāda? (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jOAW3XNnk5M&t=3087s',
        },
        {
            'subTopicName': 'Is the goal of liberation to escape sufferings of the material world OR to experience the bliss of Brahmajyoti? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jOAW3XNnk5M&t=2070s',
        },
        {
            'subTopicName': 'What form of Liberation did Aghāsura get being killed by Kṛṣṇa directly? (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ndFrek_I6jU&t=4580s',
        },
        {
            'subTopicName': 'Is there a gradation in the 4 types of personal liberations? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0zJytSMFObI&t=3647s',
        },
        {
            'subTopicName': 'Liberation is dependent on internal sannyāsa (karma phala tyāga) and not external sannyāsa. (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9EvcG3HS9ZQ&t=1413s',
        },
        {
            'subTopicName': 'Three ways to attain liberation. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Aiwh5_InFhM&t=4627s',
        },
        {
            'subTopicName': 'Basic Meaning of Liberation. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GhMA8-sKdI0&t=3510s',
        },
        {
            'subTopicName': 'Are bondage and liberation real? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OrEbBFsqADg&t=464s',
        },
        {
            'subTopicName': 'The Gradual path to attain liberation. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=__YuiNf5o1g&t=863s',
        },
        {
            'subTopicName': 'Does a jīva get bored in Brahma jyoti? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=zh48Lok_D8c&t=3705s',
        },
        {
            'subTopicName': 'How Bhakti Śāstras embrace those who seek liberation. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=MFd3A2euW3o&t=3034s',
        },
        {
            'subTopicName': 'Do all jīvas in Vaikuṇṭha have Sālokya, Sārṣṭi, Sāmīpya and Sārūpya? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=xqsdZWrV2FM&t=1772s',
        },
        {
            'subTopicName': 'The three definitions of Mokṣa according to various philosophies. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=MFd3A2euW3o&t=4870s',
        },
        {
            'subTopicName': 'Why the Śāstras repeatedly call persons striving for Liberation as less intelligent? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=YUQ_hACNqp8&t=2720s',
        },
        {
            'subTopicName': 'Why the Bhakti Śāstras seem to encourage Liberation? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=MFd3A2euW3o&t=4285s',
        },
        {
            'subTopicName': 'The six types of devotees who cross over Māyā according to the Bhagavad‑gītā. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hsOWsv1PRdo&t=2500s',
        },
        {
            'subTopicName': 'Does Paramātmā accompany the jīva to the Spiritual world/Brahmajyoti? (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0IPPwGpKaKc&t=2805s',
        },
        {
            'subTopicName': 'What\'s the difference between Jñāna destroying the subtle body and Bhakti destroying the subtle body? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=3282s',
        },
        {
            'subTopicName': 'What does it mean when the subtle body gets destroyed? Is it figurative? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=4480s',
        },
        {
            'subTopicName': 'What is the difference between a Jīvan‑mukta maintaining his body and an ordinary conditioned soul maintaining his? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0qKHOs7NFqM&t=3935s',
        },
        {
            'subTopicName': 'Different categories of Sārūpya‑mukti. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mPV5ksADt7o&t=1130s',
        },
        {
            'subTopicName': 'What\'s the difference between the destinations of Pradhānībhūta‑bhakti and Śuddha‑bhakti? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=o7YgN8pXjBs&t=5598s',
        },
    ],
    ['Nāma-tattva']: [
        {
            'subTopicName': 'Holy name is aṅgī and not just an aṅga of Bhakti. (3 min)',
            'youtubeLink': 'https://youtu.be/jH5d1AsH4tM?si=9GXotQvA2COy5A5T&t=296',
        },
        {
            'subTopicName': 'Stages of chanting. (7 min)',
            'youtubeLink': 'https://youtu.be/dIYJqhp518I?si=ul9_PZb6_xVoEpZm&t=2656',
        },
        {
            'subTopicName': 'Glories of Chanting the Holyname. (42 min)',
            'youtubeLink': 'https://youtu.be/jH5d1AsH4tM?si=5g29OGT4-OP122yp&t=9',
        },
        {
            'subTopicName': 'understanding ceto-darpaṇa-mārjanam. (30 min)',
            'youtubeLink': 'https://youtu.be/jH5d1AsH4tM?si=zpYVnjpiZA3pgMqF&t=4928',
        },
        {
            'subTopicName': 'Chanting is the best way to establish a relationship with Kṛṣṇa. (5 min)',
            'youtubeLink': 'https://youtu.be/jH5d1AsH4tM?si=TE_DDl_iCqmLdy3_&t=3596',
        },
        {
            'subTopicName': 'Is 2 rounds of attentive chanting better than 16 rounds of inattentive chanting? (5 min)',
            'youtubeLink': 'https://youtu.be/jH5d1AsH4tM?si=obNgqBWWt9-HtMH1&t=4007',
        },
        {
            'subTopicName': 'Can Kīrtan replace Japa? (2 min)',
            'youtubeLink': 'https://youtu.be/jH5d1AsH4tM?si=S0PxIt09JYQPO_sr&t=4346',
        },
        {
            'subTopicName': 'Why chanting is victorious? (5 min)',
            'youtubeLink': 'https://youtu.be/jH5d1AsH4tM?si=Sv7eEqqW0uvIZv5A&t=4970',
        },
        {
            'subTopicName': 'Does holy name fulfills or Purifies all our material desires? (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/JqBTQylRg10?si=nLIi3MdL-TVm6Crz&t=4831',
        },
        {
            'subTopicName': 'Can Chanting fulfil material desires? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/R-p0hvYXJ94?si=eKH9YHU60tlNFhlt&t=4527',
        },
        {
            'subTopicName': 'Does regularity in chanting activate the power of Holy name. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/R-p0hvYXJ94?si=sm0BHNu4_FwoZAHT&t=4796',
        },
        {
            'subTopicName': 'Did Śrīla Prabhupāda talk about reading Harināma Cintāmaṇi? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/R-p0hvYXJ94?si=vpyiohx3J9bMC5Ue&t=4980',
        },
        {
            'subTopicName': '5th and 6th benefit of chanting the Holy name. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/1wFC-Z4xXpU?si=lCgx5GWKSIXpJxMH&t=2197',
        },
        {
            'subTopicName': 'Offenseless Nāma-saṅkīrtana is the way to develop spontaneous attraction for Kṛṣṇa. (9 min)',
            'youtubeLink': 'https://youtu.be/SYVykIjOH_g?si=8toh7UOvdXGZ4jg4&t=3710',
        },
        {
            'subTopicName': 'Are we doing japa or kīrtana? (4 min)',
            'youtubeLink': 'https://youtu.be/PLZXh50mtWE?si=fPwPVt2gpk7OTRmN&t=1969',
        },
        {
            'subTopicName': 'Can accidental chanting be effective? (4 min)',
            'youtubeLink': 'https://youtu.be/dIYJqhp518I?si=qG8mkPfT40Q8Yoee&t=1828',
        },
        {
            'subTopicName': 'How to develop taste for chanting the holy name? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/hCBc7QObMig?si=JjxiXBMZnKHkH7Zw&t=5005',
        },
        {
            'subTopicName': 'How would understanding technical details of the holy name help one chant better? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/hCBc7QObMig?si=DWuUqBM1SJwKTdmB&t=2193',
        },
        {
            'subTopicName': 'Is the holy name energy or energetic? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/hCBc7QObMig?si=L26Xb4JjA-_jWrdf&t=3059',
        },
        {
            'subTopicName': 'Glories of the holy name. (50 min)',
            'youtubeLink': 'https://www.youtube.com/live/1wFC-Z4xXpU?si=HLvSG9gpPnxgWZEq&t=3453',
        },
        {
            'subTopicName': 'Accepting the holy name. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/hCBc7QObMig?si=kO_JRJBdM0tY-Row&t=5470',
        },
        {
            'subTopicName': 'Importance of taking saṅkalpa before chanting. (5 min)',
            'youtubeLink': 'https://youtu.be/tLeqlQn1YkA?si=_1_3KE1ITmQanc6B&t=2415',
        },
        {
            'subTopicName': 'Does chanting mantra sincerely protect a sādhaka? (4 min)',
            'youtubeLink': 'https://youtu.be/mtmJpauKcE8?si=GpiF4dAGSbLdY6Mg&t=2957',
        },
        {
            'subTopicName': 'Why are such statements like "3000 names of Viṣṇu is equivalent to 1 name of Kṛṣṇa" given in the śāstras? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/T8_KihNeqEk?si=ZwNbfgwACUWoEdwV&t=3675',
        },
        {
            'subTopicName': 'Why do we chant Hare Kṛṣṇa Hare Rāma and why not only Hare Kṛṣṇa although Kṛṣṇa\'s name is 3 times more powerful than the name of Lord Rāma? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/T8_KihNeqEk?si=k6GDtTuO1qUitHmk&t=4016',
        },
        {
            'subTopicName': 'Glories of the Hare Kṛṣṇa Mahāmantra. (4 min)',
            'youtubeLink': 'https://youtu.be/9K7Q-MqeV4c?si=rJlA0ywALOe-Vh5_&t=2268',
        },
        {
            'subTopicName': 'There are no hard and fast rules for chanting the holy names. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-9dp2mzOlKM&t=2725s',
        },
        {
            'subTopicName': 'If inattentive chanting is an offense to the holy name, then why is it said that by unknowingly or unconsciously chanting the holy name one gets benefitted? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ojNX7c_Kk30&t=2530s',
        },
        {
            'subTopicName': 'How to protect ourselves from distracting thoughts while chanting? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ojNX7c_Kk30&t=3925s',
        },
        {
            'subTopicName': 'Glories of the "holy name". (30 min)',
            'youtubeLink': 'https://youtu.be/hqidhZBsJOY?si=xdGF69uAdueUL_0-&t=3174',
        },
        {
            'subTopicName': 'How the holy name is non-different from Kṛṣṇa’s qualities. (3 min)',
            'youtubeLink': 'https://youtu.be/aMYvNoX0CUI?si=RdQqAPceMdHB0WfZ&t=1989',
        },
        {
            'subTopicName': 'What is vyavadhāna or separation with respect to chanting the holy name? (8 min)',
            'youtubeLink': 'https://youtu.be/aMYvNoX0CUI?si=_u--bfihXgpQDeNI&t=3741',
        },
        {
            'subTopicName': 'Understanding the real nature of the holy name. (3 min)',
            'youtubeLink': 'https://youtu.be/aMYvNoX0CUI?si=0ti0JXEo8yZhAVto&t=4261',
        },
        {
            'subTopicName': 'Overcoming nāmābhāsa. (2 min)',
            'youtubeLink': 'https://youtu.be/aMYvNoX0CUI?si=Vj5uQGZtocOhLJlq&t=4445',
        },
        {
            'subTopicName': 'Can someone fall from śuddha-nāma to nāmābhāsa? (7 min)',
            'youtubeLink': 'https://youtu.be/aMYvNoX0CUI?si=wVpJUwYYp0TEDK7E&t=4820',
        },
        {
            'subTopicName': 'Kṛṣṇa’s primary and secondary names. (12 min)',
            'youtubeLink': 'https://youtu.be/aMYvNoX0CUI?si=H-DeLaalVdzHt6p8&t=2638',
        },
        {
            'subTopicName': 'How to correctly understand the power and potency of the holy name while being afflicted with ghosts and spirits. (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/lxUigu7wOeQ?si=eT2D6M7ermEqydh3&t=3580',
        },
        {
            'subTopicName': 'Why we don\'t feel the effect of the Holy name that the Śāstras claim? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=MFd3A2euW3o&t=3645s',
        },
        {
            'subTopicName': 'If one chanting of the Holy Name destroys all Karmas, then why does Anartha‑nivṛtti take even lifetimes sometimes? (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=3158s',
        },
        {
            'subTopicName': 'Realising name, form, qualities and pastimes of Kṛṣṇa. (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NGb3avTZOLw&t=4680s',
        },
        {
            'subTopicName': 'Meditation on the meaning of the Mantra (Mantrārtha‑cintanam). (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NGb3avTZOLw&t=3600s',
        },
        {
            'subTopicName': 'Śuddha‑nāma is revealed by mercy of pure devotee. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NGb3avTZOLw&t=2245s',
        },
        {
            'subTopicName': 'Progressing in chanting from śraddhā to prema (76 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sCv630ZH52E&t=2745s',
        },
        {
            'subTopicName': 'Meaning of the Mahāmantra. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pD0QG8prkIw&t=5690s',
        },
        {
            'subTopicName': 'System for cultivating the name. (45 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pD0QG8prkIw&t=3570s',
        },
        {
            'subTopicName': 'Procedure for intensive chanting. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-PziVSpmu9c&t=5160s',
        },
        {
            'subTopicName': 'Śikṣāṣṭakam and Progressive steps in Chanting. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-PziVSpmu9c&t=4390s',
        },
        {
            'subTopicName': 'Glories of harināma. (36 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-PziVSpmu9c&t=1920s',
        },
        {
            'subTopicName': 'Chanting the name with aspiration to attain prema ‑ Part‑2. (55 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n6q79aHYYKw&t=30s',
        },
        {
            'subTopicName': 'Chanting the name while aspiring to attain prema ‑ Part‑1. (81 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=S_jL9Vulh-8&t=1620s',
        },
    ],
    ['Obstacles to Bhakti']: [
        {
            'subTopicName': 'How desires for Bhuki and Mukti obstruct Bhakti? (18 min)',
            'youtubeLink': 'https://youtu.be/SfFVMSoXu0I?si=hILjX8KX4pHo9Xok&t=1565',
        },
        {
            'subTopicName': 'What binds us to the material world? (19 min)',
            'youtubeLink': 'https://youtu.be/jH5d1AsH4tM?si=nFwIhpxyR-zZacsj&t=5305',
        },
        {
            'subTopicName': 'What creates anya abhilāṣas? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/R-p0hvYXJ94?si=B8_3P1ADR9EwnSN6&t=5111',
        },
        {
            'subTopicName': 'Does doing yoga before chanting hinder one\'s progress in Bhakti? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/LCAVigSxhGg?si=SsKOIVJAtw6Sh2Sy&t=4309',
        },
        {
            'subTopicName': 'Why our chanting of the mantra is not so powerful? (7 min)',
            'youtubeLink': 'https://youtu.be/7SUiAo7po9Q?si=ikVc9i_y_7K05wV9&t=2629',
        },
        {
            'subTopicName': 'How obstacles come in the path of bhakti due to past practices, both pious and impious. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/oS0p9mqBkos?si=UKnKbe96Dl5-V7Rh&t=2533',
        },
        {
            'subTopicName': 'Why do devotees lose taste for Kṛṣṇa-kathā? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=_duU9loYrWEn5H9N&t=2425',
        },
        {
            'subTopicName': 'How to understand the role of astrology and vāstu in devotees\' lives? (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/J16RhR-e_CA?si=UE45fG9KdnYJ0MjN&t=138',
        },
        {
            'subTopicName': 'How to deal with obsession with a particular limb of bhakti during sādhana-bhakti? (5 min)',
            'youtubeLink': 'https://youtu.be/mtmJpauKcE8?si=YRhHkj0cwIaC0CvH&t=4260',
        },
        {
            'subTopicName': 'Jealousy is a relationship killer. (7 min)',
            'youtubeLink': 'https://youtu.be/sJhDmHinfOI?si=J6SQHEYpU75jcihb&t=2134',
        },
        {
            'subTopicName': '6 faults while performing Bhakti: (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/CVxfCTV6O2g?si=hKIOdEZgdSY12afd&t=2777',
        },
        {
            'subTopicName': 'Bad habits acquired in the past—will it affect the svabhāva or śraddhā? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=miIZ5wHAJs8&t=4012s',
        },
        {
            'subTopicName': 'Understanding lust – Part-1. (28 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=__YuiNf5o1g&t=3869s',
        },
        {
            'subTopicName': 'Understanding lust – Part-2. (98 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=x96ilsBtFsI&t=0s',
        },
        {
            'subTopicName': 'Why lust cannot be dovetailed? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=x96ilsBtFsI&t=1732s',
        },
        {
            'subTopicName': 'Effect of disrespect on bhakti. (9 min)',
            'youtubeLink': 'https://youtu.be/kuFpSksNlVA?si=sPzmgy1FAZEEqRat&t=2413',
        },
        {
            'subTopicName': 'How Kapila-deva’s sāṅkhya obstructs pure bhakti? (3 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=423axwgYqYmmQjVh&t=4659',
        },
        {
            'subTopicName': 'Fear, guilt and pressure are obstacles to bhakti. (32 min)',
            'youtubeLink': 'https://www.youtube.com/live/6cUjH7NqSw8?si=HmXDvJLIqblNg-bA&t=670',
        },
        {
            'subTopicName': 'Switching from other yogas to bhakti is not automatic. (8 min)',
            'youtubeLink': 'https://youtu.be/TXN0_Y_XlsQ?si=q-Bp4eIwhW0Oru66&t=3439',
        },
        {
            'subTopicName': 'Principle of sense control in bhakti. (9 min)',
            'youtubeLink': 'https://youtu.be/TXN0_Y_XlsQ?si=yhW4meRP_6K4fypX&t=3943',
        },
        {
            'subTopicName': 'Perception of injustice agitates the mind. (16 min)',
            'youtubeLink': 'https://youtu.be/sbdWireHqZU?si=6YevuJbsCKa0NE-n&t=5195',
        },
        {
            'subTopicName': 'Is giving up Janma, Aiśvarya and Śrī the only solution to subdue Pride? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=B859Nrb_aeE&t=1645s',
        },
        {
            'subTopicName': 'Why is the desire for liberation a greater selfish desire than the desire to enjoy this world? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h18rDjUNHRM&t=2485s',
        },
        {
            'subTopicName': 'Jñāna and Karma are a hindrance to bhakti. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6FPH1bGupDk&t=2415s',
        },
        {
            'subTopicName': 'People in responsible positions can cause great damage if misled. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=76tSxvBUtZE&t=1994s',
        },
        {
            'subTopicName': 'What necessitates the \'Institutionalisation\' of a Spiritual Movement? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XUgB4PWa1jA&t=4664s',
        },
        {
            'subTopicName': 'Mental illusion caused by sinful activity. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6oXbce27QPY&t=2270s',
        },
        {
            'subTopicName': 'Unnecessary endeavor. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KKboXsS-Q40&t=5855s',
        },
        {
            'subTopicName': 'Studying too many scriptures. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KKboXsS-Q40&t=6075s',
        },
        {
            'subTopicName': 'Lust. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6oXbce27QPY&t=3490s',
        },
        {
            'subTopicName': '10 forbidden activities. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KKboXsS-Q40&t=910s',
        },
        {
            'subTopicName': 'Miserliness. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KKboXsS-Q40&t=6428s',
        },
        {
            'subTopicName': 'Lamentation. (29 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LW6HP1FOCts&t=3040s',
        },
        {
            'subTopicName': 'Persons with faith problems struggle to aquire knowledge. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=aa446809Zgo&t=2388s',
        },
        {
            'subTopicName': 'The problem of Blind Following. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hRVaoeIJ8BQ&t=238s',
        },
        {
            'subTopicName': 'Why we don\'t feel the effect of the Holy name that the Śāstras claim? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=MFd3A2euW3o&t=3645s',
        },
        {
            'subTopicName': 'How uncontrolled senses steal away the mind and intelligence? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=2049s',
        },
        {
            'subTopicName': 'How is Jñāna an obstacle to Bhakti if it destroys the subtle body too? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=3552s',
        },
        {
            'subTopicName': 'Is Nārāyaṇīyam a Bonafide Scripture? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=2875s',
        },
        {
            'subTopicName': 'Can Viṣṇu Worshippers become Demigod Worshippers and vice versa? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=3580s',
        },
        {
            'subTopicName': 'Considering a devotee to belong to a caste is an offense. But a non‑devotee can get benefitted by unknowingly getting attached to a devotee belonging to his caste. How to reconcile? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OSP02lDJzkw&t=960s',
        },
        {
            'subTopicName': 'In other prominent vaiṣṇava sampradāyas, the current generation considers consumption of onion/garlic acceptable. Could this happen to ISKCON as well? How to maintain our standards? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OSP02lDJzkw&t=3460s',
        },
        {
            'subTopicName': 'Discouraging children to carry on with their material studies will only increase their irresponsibilty later in bhakti also. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=1710s',
        },
        {
            'subTopicName': 'Is my faith in Bhakti compromised when I think "I have no other choice but to practice Bhakti since I am not qualified for Karma / Jñāna?" (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=3775s',
        },
        {
            'subTopicName': 'How to avoid introducing Karma‑kāṇḍīya mentality in Bhakti? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=2736s',
        },
        {
            'subTopicName': 'Attachment to Kṛṣṇa‑kathā doesn\'t come necessarily by demeaning material education. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=1430s',
        },
        {
            'subTopicName': 'What makes or breaks the lifeline of devotees\' association? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nwHllIMh068&t=4062s',
        },
        {
            'subTopicName': 'Historical misuse of the external path of Rāgānugā-bhakti ‑ Part‑1. (92 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5TMgZekcaL0&t=1630s',
        },
        {
            'subTopicName': 'Historical misuse of the external path of Rāgānugā-bhakti ‑ Part‑2 (23 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cOjeSXHw1N0&t=500s',
        },
        {
            'subTopicName': 'Genuine Rāgānugā-bhakti cannot be imitated. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=6100s',
        },
        {
            'subTopicName': 'Other anarthas on the path of Bhakti. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Xoe0HwWTnBk&t=6400s',
        },
        {
            'subTopicName': 'Only sattva‑guṇa can be dovetailed in Kṛṣṇa\'s service, rajo‑guṇa and tamo‑guṇa must be given up. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LtduJkS8hZU&t=815s',
        },
    ],
    ['Offenses']: [
        {
            'subTopicName': 'Losing faith in Bhakti due offenses. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=ZMqi_1wA5BewxMvR&t=2430',
        },
        {
            'subTopicName': 'Do Anarthas push us to commit Aparādhas? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/mjq6ixAvJTM?si=b-nVYJR5XzqF1Li-&t=3337',
        },
        {
            'subTopicName': 'How can faithless chanting be offenseless? (4 min)',
            'youtubeLink': 'https://youtu.be/V4PsCuKR8nE?si=McvGVcodCojDm0m7&t=1312',
        },
        {
            'subTopicName': 'Why are we not getting taste when we are consciously not committing offenses ? (9 min)',
            'youtubeLink': 'https://youtu.be/V4PsCuKR8nE?si=Q8A5juS9A4tlLaBH&t=1550',
        },
        {
            'subTopicName': 'What is sin and an Offense with respect to a devotee? (2 min)',
            'youtubeLink': 'https://youtu.be/V4PsCuKR8nE?si=qKjMn5r5f-mGTLi9&t=2862',
        },
        {
            'subTopicName': 'What happens when we dishonor prasādam? (8 min)',
            'youtubeLink': 'https://youtu.be/7SUiAo7po9Q?si=aaU4gt8QhSn8QbEa&t=4694',
        },
        {
            'subTopicName': 'Avoid criticism of the Lord and His devotees. (7 min)',
            'youtubeLink': 'https://youtu.be/kuFpSksNlVA?si=_AG0RVnpRy86dltd&t=3693',
        },
        {
            'subTopicName': 'Does the ninth offense apply to the jñānīs and yogīs? (5 min)',
            'youtubeLink': 'https://youtu.be/F_OCV4HdUY0?si=353aNQZeXp3odyWo&t=2075',
        },
        {
            'subTopicName': 'Nāmāparādha. (89 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dFBqInlTpDE&t=1624s',
        },
        {
            'subTopicName': 'Sevāparādha. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dFBqInlTpDE&t=900s',
        },
        {
            'subTopicName': 'Devotional credits get covered by our anarthas but are completely removed when we commit offences. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=eiRsN915n6A&t=1918s',
        },
        {
            'subTopicName': 'Understanding the influence of Sinful activities and Aparādha in the life of a devotee. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6oXbce27QPY&t=840s',
        },
        {
            'subTopicName': 'Why we don\'t feel the effect of the Holy name that the Śāstras claim? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=MFd3A2euW3o&t=3645s',
        },
        {
            'subTopicName': 'Why is gopīs’ criticism of Akrūra not a vaiṣṇava‑aparādha? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=6070s',
        },
        {
            'subTopicName': 'How is gopīs’ criticism of the Lord different from Gāndhārī’s criticism of Kṛṣṇa? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=2810s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize Providence for cruelly taking their eyesight away. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=3370s',
        },
        {
            'subTopicName': 'one should overlook the faults of a Bhāva‑bhakta. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=4290s',
        },
        {
            'subTopicName': 'Vaiṣṇava‑aparādha destroys Bhakti. (61 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Xoe0HwWTnBk&t=2700s',
        },
    ],
    ['Other Yogas']: [
        {
            'subTopicName': 'Symptoms of a person situated in samādhi. (25 min)',
            'youtubeLink': 'https://youtu.be/sbdWireHqZU?si=OH603pgXiTBwiEPS&t=3430',
        },
        {
            'subTopicName': 'Symptoms of a person situated in samādhi. (30 min)',
            'youtubeLink': 'https://youtu.be/sbdWireHqZU?si=K5ScCLcEuL5YaBr1&t=3395',
        },
        {
            'subTopicName': 'Results of Niṣkāma-Karma-Yoga. (40 min)',
            'youtubeLink': 'https://youtu.be/sbdWireHqZU?si=6LsCFS5ladxOVRfK&t=1032',
        },
        {
            'subTopicName': 'Does practice of Jñāna yoga lead to hard heartedness? (10 min)',
            'youtubeLink': 'https://youtu.be/gepFnz2QEtw?si=bkTEXHDVe1f3j2p6&t=1706',
        },
        {
            'subTopicName': 'Detachment from higher taste. (12 min)',
            'youtubeLink': 'https://youtu.be/gepFnz2QEtw?si=z5YmDPRnN9rIRngZ&t=3459',
        },
        {
            'subTopicName': 'Understanding the Yoga ladder. (25 min)',
            'youtubeLink': 'https://youtu.be/NSbLUll9y1c?si=al1NqjN4r-3AEZ8J&t=1540',
        },
        {
            'subTopicName': 'Śrīla Baladeva Vidyābhūṣaṇa\'s concept of Yoga ladder. (10 min)',
            'youtubeLink': 'https://youtu.be/eHagME5qLM8?si=_zqdSvhz4WJ7B6qL&t=1776',
        },
        {
            'subTopicName': 'Various types of yoga practitioners. (6 min)',
            'youtubeLink': 'https://youtu.be/eHagME5qLM8?si=Jb_E17uhi6GR7XeR&t=3607',
        },
        {
            'subTopicName': 'How different yogīs perceive Kṛṣṇa. (2 min)',
            'youtubeLink': 'https://youtu.be/jH5d1AsH4tM?si=UGDsRz8hkiNfaCCr&t=3450',
        },
        {
            'subTopicName': 'Difference between Niṣkāma karma yoga and Bhakti yoga. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/1wFC-Z4xXpU?si=PUw6sZ8zYNAD_NiL&t=1246',
        },
        {
            'subTopicName': 'What is the destination of the Karmīs and the Yogīs? (11 min)',
            'youtubeLink': 'https://youtu.be/sVUOpD4LyQk?si=9JHqqyjmcdumu0wT&t=586',
        },
        {
            'subTopicName': 'Understanding the yoga ladder. (16 min)',
            'youtubeLink': 'https://youtu.be/eHagME5qLM8?si=c_Rv4q8gAgKxufvC&t=1367',
        },
        {
            'subTopicName': 'Jñāna-yoga or karma-yoga is not a matter of choice. (10 min)',
            'youtubeLink': 'https://youtu.be/vKIx7B4JIyk?si=_46yS72UmOtazIyE&t=4942',
        },
        {
            'subTopicName': 'Basics of karma-yoga and jñāna-yoga. (92 min)',
            'youtubeLink': 'https://youtu.be/vKIx7B4JIyk?si=ZX9qLXuDfG_2pL4p',
        },
        {
            'subTopicName': 'Yoga ladder explained. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/9_LM_EezNGc?si=-ZZYFqMWum_wDchR&t=3284',
        },
        {
            'subTopicName': 'Should the jñāna-yogīs and aṣṭāṅga-yogīs also accept the Bhagavān feature in order to perfect their own sādhana? (19 min)',
            'youtubeLink': 'https://www.youtube.com/live/tKtflACfyY0?si=y4q3mBrAM2khXjXD&t=956',
        },
        {
            'subTopicName': 'How do we understand that jñāna-yogīs also perform bhakti to attain liberation? (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=byeLP0tX4Nc&t=1680s',
        },
        {
            'subTopicName': 'What is the difference between 3 jñānīs mentioned in BG 4.34, 7.16 and 7.19? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LQZJYlTGtls&t=2595s',
        },
        {
            'subTopicName': 'The two types of buddhi-yoga. (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5jTppLPr2Nw&t=2255s',
        },
        {
            'subTopicName': 'If Paramātmā is only an observer, how do yogīs meditate? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/pWdeQCFPTRo?si=k2CvS1CFmIGKAfkV&t=3564',
        },
        {
            'subTopicName': 'The fall of Jñāna-yogīs who reject Kṛṣṇa\'s lotus feet. (44 min)',
            'youtubeLink': 'https://www.youtube.com/live/EHznydtUlts?si=TU4jnA2TPzFNt8Eg&t=1463',
        },
        {
            'subTopicName': 'Methods to approach the Lord with jñāna‑sādhana. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/qLMa8Wg7y2s?si=syJR_8HSwq-9pFKe&t=3715',
        },
        {
            'subTopicName': 'Does a jñāna‑yogī need to perform aṣṭāṅga or bhakti‑yoga? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/qLMa8Wg7y2s?si=9eJpFLM0a5rurzwp&t=4440',
        },
        {
            'subTopicName': 'Methods to approach the Lord with self‑worship or ahaṅgrāhopāsanā. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/qLMa8Wg7y2s?si=V-O2YGQGk9dmpcah&t=4645',
        },
        {
            'subTopicName': 'Why is ahaṅgrāhopāsanā criticized if it was mentioned that Prahlāda Mahārāja himself performed this practice? Is it not favorable for practicing sādhakas? (24 min)',
            'youtubeLink': 'https://www.youtube.com/live/qLMa8Wg7y2s?si=JxLz8J3oCRlUPG--&t=4943',
        },
        {
            'subTopicName': 'What is ahaṅgrāhopāsanā? (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/qLMa8Wg7y2s?si=QLohHCzlU1OZeiY1&t=5500',
        },
        {
            'subTopicName': 'Is ahaṅgrāhopāsanā the same as māyāvāda? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/qLMa8Wg7y2s?si=BVO1k56Zxz3kwZm0&t=6480',
        },
        {
            'subTopicName': 'Who decides a person’s adhikāra for karma, jñāna and bhakti? (6 min)',
            'youtubeLink': 'https://youtu.be/0W5mBmDmT2w?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=2845',
        },
        {
            'subTopicName': 'Jñāna‑yogīs and aṣṭāṅga‑yogīs should not be criticized. (11 min)',
            'youtubeLink': 'https://youtu.be/F_OCV4HdUY0?si=1MFzU9z8hURZ_-eL&t=3701',
        },
        {
            'subTopicName': 'The misguided yogī. (5 min)',
            'youtubeLink': 'https://youtu.be/F_OCV4HdUY0?si=iFkdUPryOwgFgrap&t=4684',
        },
        {
            'subTopicName': 'How do the yogīs perceive the deity form of the Lord? (6 min)',
            'youtubeLink': 'https://youtu.be/g2YjiFKKKfs?si=sGIGGvqUtRcEMiFC&t=4719',
        },
        {
            'subTopicName': 'A yogī’s perception of bhakti. (3 min)',
            'youtubeLink': 'https://youtu.be/2uDMb-wElLE?si=rE_U76DdLlmKrBKS&t=1178',
        },
        {
            'subTopicName': 'Do the yogīs need blessings like bhaktas? (2 min)',
            'youtubeLink': 'https://youtu.be/czjhmtRFnjo?si=chJQvBK97d5urGLz&t=4122',
        },
        {
            'subTopicName': 'Is a yogī in samādhi oblivious to his body? (5 min)',
            'youtubeLink': 'https://youtu.be/czjhmtRFnjo?si=ZLAabCKF44zDwmms&t=4423',
        },
        {
            'subTopicName': 'Understanding Ananyā Bhakti practiced by Jñānīs at the stage of Jñāna Sannyāsa and how is it different from Śuddha Bhakti. (28 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=UYrJNA0H2Ks&t=2330s',
        },
        {
            'subTopicName': 'Transactional relationship of a Jñāna Yogī and an Aṣṭāṅga Yogī with Paramātmā. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OrEbBFsqADg&t=4245s',
        },
        {
            'subTopicName': 'Symptoms of yogārūḍha stage. (30 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-y_GswkNDVA&t=3210s',
        },
        {
            'subTopicName': 'A true sannyāsī is one who is detached from enjoying the fruits of his actions. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-y_GswkNDVA&t=1470s',
        },
        {
            'subTopicName': 'Comparing Jñāna Yoga and Aṣṭāṅga Yoga. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dPshBy0Z94A&t=3298s',
        },
        {
            'subTopicName': 'Understanding paramātmā realisation. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Aiwh5_InFhM&t=4530s',
        },
        {
            'subTopicName': 'Symptoms of Brahma Bhūta stage. (30 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Aiwh5_InFhM&t=2724s',
        },
        {
            'subTopicName': 'Equal vision of a yogī. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Aiwh5_InFhM&t=2724s',
        },
        {
            'subTopicName': 'Essential prerequisites for liberation through the path of Jñāna. (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6p3PKPOXAFc&t=4632s',
        },
        {
            'subTopicName': 'How Karma Yoga can progress to various shades of jñāna and Bhakti? (22 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=enPoIGsy4Pw&t=1920s',
        },
        {
            'subTopicName': 'Flowchart describing various sādhanas and how they transform into other sādhanas. (31 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0zJytSMFObI&t=1320s',
        },
        {
            'subTopicName': 'What comes first? Knowledge or purification of heart? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=FkJpzAur308&t=2459s',
        },
        {
            'subTopicName': 'A true Sannyāsī can continue to perform Niṣkāma Karma Yoga despite possessing a pure heart. (60 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=YLy7RJjP32o&t=1851s',
        },
        {
            'subTopicName': 'Who is a nitya sannyāsī? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nMHX1U_Yey4&t=1071s',
        },
        {
            'subTopicName': 'Summary of the Gradual path to liberation (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6p3PKPOXAFc&t=240s',
        },
        {
            'subTopicName': 'Paramātmā realisation. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OrEbBFsqADg&t=3316s',
        },
        {
            'subTopicName': 'Secondary means for those who cannot take up pure devotional service. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Rcws510LWh8&t=3820s',
        },
        {
            'subTopicName': 'Qualifications for taking the Vedic Sannyāsa. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OwTewOcAxQ4&t=2976s',
        },
        {
            'subTopicName': 'Qualifications for taking Sannyāsa. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OwTewOcAxQ4&t=2839s',
        },
        {
            'subTopicName': 'Symptoms of a person who performs Karma on the platform of Jñāna, and has transcended the false ego. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9EvcG3HS9ZQ&t=3780s',
        },
        {
            'subTopicName': 'A gṛhastha performing varṇāśrama duties and one who has taken Karma Sannyāsa after purification both achieve the same goal - liberation (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9EvcG3HS9ZQ&t=1538s',
        },
        {
            'subTopicName': 'Three ways to attain liberation (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Aiwh5_InFhM&t=4627s',
        },
        {
            'subTopicName': 'Summary of Gradual path leading to liberation. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nMHX1U_Yey4&t=186s',
        },
        {
            'subTopicName': 'Who are Jīvan Muktas? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OrEbBFsqADg&t=4560s',
        },
        {
            'subTopicName': 'All about Yoga ladder. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=aa446809Zgo&t=4281s',
        },
        {
            'subTopicName': 'One should give up performing Varṇāśrama duties in the later stages of Aṣṭāṅga Yoga. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-y_GswkNDVA&t=2380s',
        },
        {
            'subTopicName': 'Summary of the Gradual path as decribed by Śrīla Baladeva Vidyābhūṣaṇa and Śrīla Viśvanāth Cakravarti Ṭhākura. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6p3PKPOXAFc&t=5604s',
        },
        {
            'subTopicName': 'Jñāna sannyāsa is necessary for the jñāna yogī to transcend the guṇas and achieve liberation. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6p3PKPOXAFc&t=5215s',
        },
        {
            'subTopicName': 'In the perfected stage of yoga there are no material vāsanās. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=q0FTkYQBz1E&t=1988s',
        },
        {
            'subTopicName': 'Symptoms of yogārūḍha stage of Aṣṭāṅga yoga. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=q0FTkYQBz1E&t=2135s',
        },
        {
            'subTopicName': 'Difficulty of practicing Aṣṭāṅga yoga in today\'s age. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Gbg2F-YEDS8&t=3101s',
        },
        {
            'subTopicName': 'Mentality of a Jñāna yogī. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EledLeVo5J4&t=3455s',
        },
        {
            'subTopicName': 'Symptoms of a person with jñāna adhikāra. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EledLeVo5J4&t=3291s',
        },
        {
            'subTopicName': 'What is the qualification for Jñāna Yoga? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0fAPjgx62_8&t=1643s',
        },
        {
            'subTopicName': 'Fate of the unsuccessful yogī-1. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=w3TyHuJD0cw&t=2496s',
        },
        {
            'subTopicName': 'Who is an unsuccessful yogī? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=w3TyHuJD0cw&t=1683s',
        },
        {
            'subTopicName': 'Fate of the unsuccessful yogī-2 (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=w3TyHuJD0cw&t=4772s',
        },
        {
            'subTopicName': 'Destination of Aṣṭāṅga yogīs who fall down after practicing yoga for a long time. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=w3TyHuJD0cw&t=2984s',
        },
        {
            'subTopicName': 'Destination of Aṣṭāṅga yogīs who fall down after practicing yoga for a short time. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=w3TyHuJD0cw&t=2742s',
        },
        {
            'subTopicName': 'Summary of types of Bhakti and results of various yogic practices. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=R91CJZltUcs&t=2075s',
        },
        {
            'subTopicName': 'Is frustration from material life the only qualification for Jñāna? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0utgOK2TwGU&t=4000s',
        },
        {
            'subTopicName': 'Who are the foolish Sannyāsīs? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0utgOK2TwGU&t=2355s',
        },
        {
            'subTopicName': 'What is the destination of Kṣatriyas and Vaiśyas in the gradual path of Varṇāśrama as they cannot take to Sannyāsa? (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glVWOuUj9OA&t=3050s',
        },
        {
            'subTopicName': 'Types of indirect, impure worship of the Lord and types of jñāna‑yajñas. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QwKi7-MyaTg&t=5222s',
        },
    ],
    ['Parallels Between Bhakti and Other Paths']: [
        {
            'subTopicName': 'Is Gopa Kumāra’s journey an example of krama-mukti? (7 min)',
            'youtubeLink': 'https://youtu.be/ubOIdKVoXew?si=Ye0dNHSLNeJ2byTF&t=1440',
        },
        {
            'subTopicName': 'How to identify if an activity is a varṇāśrama activity or a devotional activity or a material activity? (13 min)',
            'youtubeLink': 'https://youtu.be/sbdWireHqZU?si=OpNHdTfmGvyVmpIp&t=1142',
        },
        {
            'subTopicName': 'In the jñāna path there is anartha‑nivṛtti but no artha‑pravṛtti. But on the path of bhakti, anartha‑nivṛtti and artha‑pravṛtti occur simultaneously. (3 min)',
            'youtubeLink': 'https://youtu.be/sbdWireHqZU?si=4sG54bjbO9HpNz4U&t=4740',
        },
        {
            'subTopicName': 'Comparing the vairāgya of a bhakti‑yogī and a jñāna‑yogī. (7 min)',
            'youtubeLink': 'https://youtu.be/gepFnz2QEtw?si=wRfAsxdvwgncr64J&t=1982',
        },
        {
            'subTopicName': 'Is ātma‑jñāna universal for all practitioners or are there different levels of understanding? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/vdTtp0mKMjM?si=0sRC_PzvV0qL1dRp&t=1582',
        },
        {
            'subTopicName': 'Karma‑saṁskāras and bhakti‑saṁskāras. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/TNeLuClc1oI?si=ugrvjdhOdkA6GFv5&t=2110',
        },
        {
            'subTopicName': 'Essence of Qur’ān brought out by Lord Caitanya. (19 min)',
            'youtubeLink': 'https://youtu.be/s7gxOBZxXTY?si=-3J6awUmNWhsW9D1&t=5998',
        },
        {
            'subTopicName': 'When we hear Nārada Muni and Uddhava performing austerities, is it yoga/austerities or Kṛṣṇa‑bhajana? (8 min)',
            'youtubeLink': 'https://youtu.be/rnA74aDvpRE?si=eydp2f2Sh026VuTT&t=1536',
        },
        {
            'subTopicName': 'How are Bhaktas, Yogīs, and Karmīs compared to tasting sugarcane juice, sugarcane stalks and thorns respectively? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ngCFwTEm7Zo&t=3378s',
        },
        {
            'subTopicName': 'Purification through the gradual path VS Purification through the path of Bhakti. (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9EvcG3HS9ZQ&t=3782s',
        },
        {
            'subTopicName': 'What\'s the difference between a Jñānī\'s vision of equality AND a devotee\'s vision of equality? (22 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2aJZVXd88aA&t=431s',
        },
        {
            'subTopicName': 'Getting out of the clutches of māyā - through Karma, Jñāna, Yoga and Bhakti. (41 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0JhMipOSX34&t=1055s',
        },
        {
            'subTopicName': 'Sannyāsa in bhakti is different from Vedic Sannyāsa. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OwTewOcAxQ4&t=3203s',
        },
        {
            'subTopicName': 'Parallels between path of Bhakti and path of Liberation. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OwTewOcAxQ4&t=1062s',
        },
        {
            'subTopicName': 'Various levels of spiritual aspirants. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OwTewOcAxQ4&t=907s',
        },
        {
            'subTopicName': 'Entering spiritual life through Gradual Process and Direct Process. (25 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=fVWoj98Jd-A&t=3920s',
        },
        {
            'subTopicName': 'Difference between the nature of meditation of a Yogī and Bhakta. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GhMA8-sKdI0&t=454s',
        },
        {
            'subTopicName': 'Jñāna yogīs are mokṣa parāyaṇāḥ, devotees are Nārāyaṇa parāyaṇāḥ. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=xqsdZWrV2FM&t=411s',
        },
        {
            'subTopicName': 'Differences in the bhakti element in an Aṣṭāṅga yogī and a Bhakti yogī. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JbcMdCyV4do&t=2250s',
        },
        {
            'subTopicName': 'Why don’t Vaiṣṇavas seem to follow dharma śāṣṭras? (48 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vt0EOh18BwQ&t=3525s',
        },
        {
            'subTopicName': 'Outcome and destination of various yogic practices. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2JHFguvmCfE&t=4572s',
        },
        {
            'subTopicName': 'Fate of an unsuccessful devotee (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=w3TyHuJD0cw&t=3158s',
        },
        {
            'subTopicName': 'Fate of an unsuccessful devotee-2. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=w3TyHuJD0cw&t=4328s',
        },
        {
            'subTopicName': 'Why don’t Vaiṣṇavas seem to follow dharma śāṣṭras? - Part1 (38 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=DC3ERl-63e0&t=4644s',
        },
        {
            'subTopicName': 'Why don’t Vaiṣṇavas seem to follow dharma śāṣṭras? - Part 2 (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vt0EOh18BwQ&t=1985s',
        },
        {
            'subTopicName': 'The three definitions of Mokṣa according to various philosophies. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=MFd3A2euW3o&t=4870s',
        },
        {
            'subTopicName': 'Materials Saṁskāras and Devotional Saṁskāras. (52 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=AR8_MT5v7j0&t=3730s',
        },
        {
            'subTopicName': 'What\'s the difference between Jñāna destroying the subtle body and Bhakti destroying the subtle body? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=3282s',
        },
        {
            'subTopicName': 'Is Bhakti easy / tedious? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=4149s',
        },
        {
            'subTopicName': 'Material Vision VS Impersonal Vision VS Vision of the Lord. (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n6q79aHYYKw&t=3300s',
        },
        {
            'subTopicName': 'What defines whether an activity is dhārmic, material or devotional? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sbdWireHqZU&t=1422s',
        },
    ],
    ['Practical Devotional Service']: [
        {
            'subTopicName': 'Caring with detachment. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/HLs1k6FVRTk?si=_athIa3sKYmpCmwo&t=2423',
        },
        {
            'subTopicName': 'Samskāras and Bhakti. (37 min)',
            'youtubeLink': 'https://youtu.be/_hEdInbzrv8?si=AAQcLtRICEqhRm6L&t=3769',
        },
        {
            'subTopicName': 'Astrology and Devotional service. (60 min)',
            'youtubeLink': 'https://www.youtube.com/live/QR152IH7NIs?si=VejYdRsWW5ktrs7k&t=3691',
        },
        {
            'subTopicName': 'Saṁskāras and Bhakti. (37 min)',
            'youtubeLink': 'https://youtu.be/_hEdInbzrv8?si=AAQcLtRICEqhRm6L&t=3769',
        },
        {
            'subTopicName': 'Arjuna had Kṛṣṇa as a guide. Whom should we approach for practical guidance? (3 min)',
            'youtubeLink': 'https://youtu.be/2c0puoy0NMw?si=MQM7T-UsYBcUAj9G&t=2179',
        },
        {
            'subTopicName': 'Is affection towards family members a sign of weakness of heart? (4 min)',
            'youtubeLink': 'https://youtu.be/2c0puoy0NMw?si=YTizJcpsjaDM_lUF&t=2488',
        },
        {
            'subTopicName': 'How do I understand that I am progressing in Bhakti when I am not experiencing Kṛṣṇa day after day? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/8YeJ_YbqCd4?si=lEffkhh6_8EerPH8&t=2643',
        },
        {
            'subTopicName': 'Is a study of Dharma śāstras a prerequisite to practice Bhakti? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/kqfiviAf3HA?si=kJXKX3KtqarwN9f_&t=656',
        },
        {
            'subTopicName': 'Does a devotee become irresponsible by taking up to bhakti? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/kqfiviAf3HA?si=xkkiTj1uJ-VBH6lz&t=3852',
        },
        {
            'subTopicName': 'How to convert material vāsanās into spiritual vāsanās. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/JqBTQylRg10?si=e1dqq8jY20qzVIlW&t=1743',
        },
        {
            'subTopicName': 'Is Prāyaścitta recommended for devotees? (5 min)',
            'youtubeLink': 'https://youtu.be/vwZjoD4Kh1s?si=1LTzauju8mqaBbZZ&t=1081',
        },
        {
            'subTopicName': 'How to dispose nirmālya? (8 min)',
            'youtubeLink': 'https://youtu.be/EiMIeLVmY3g?si=cx73DmQFgXLUOJCk&t=2295',
        },
        {
            'subTopicName': 'What is being sentimental in devotion? (11 min)',
            'youtubeLink': 'https://youtu.be/RXTbDKTzTtk?si=tyN2XKjQXPl1awzd&t=2966',
        },
        {
            'subTopicName': 'Lord Caitanya took principles from all bona fide sampradāyas. Does it mean that we can also do the same? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/NrJgtAPgGEw?si=4RKupKjpN8a70y4d&t=1478',
        },
        {
            'subTopicName': 'Institutional commitments vs. individual inspirations. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/NrJgtAPgGEw?si=wulhKRzSyz4W-7JK&t=2967',
        },
        {
            'subTopicName': 'Are devotees ungrateful to their forefathers due to their non-performance of śrāddha ceremony? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/EGFy5wmARC8?si=BhwGyDMJXl9wP5md&t=2959',
        },
        {
            'subTopicName': 'Is it necessary for devotees to perform the śrāddha rituals for the departed relatives? (23 min)',
            'youtubeLink': 'https://www.youtube.com/live/EGFy5wmARC8?si=S64Ls8ZcQgAXPcH_&t=5014',
        },
        {
            'subTopicName': 'Is it always mandatory to seek permission before partaking mahā-prasāda of a devotee? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/rpTraKYLpxk?si=QjOatuc427Rz8iZk&t=3354',
        },
        {
            'subTopicName': 'Is it okay to think "I am not a pure devotee; therefore I should do karma rituals"? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/oS0p9mqBkos?si=PJEXcAyAwyLfOU7J&t=781',
        },
        {
            'subTopicName': 'If bhakti is the solution for all sufferings, should devotees still go to a doctor? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/QR152IH7NIs?si=4givf8WmVrJaWmBn&t=939',
        },
        {
            'subTopicName': 'Relevance of fire sacrifices in our movement – Part 1. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=8SThoAuGMbVr299h&t=424',
        },
        {
            'subTopicName': 'Relevance of fire sacrifices in our movement – Part 2. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=QdM9iUaZcN_QmdKZ&t=927',
        },
        {
            'subTopicName': 'Relevance of fire sacrifices in our movement – Part 3. (19 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=-VYDtqgHv83WRsqM&t=1221',
        },
        {
            'subTopicName': 'What if a practicing devotee leaves his body and his last rites are not done? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=DwewZP4oJbgIFH86&t=6185',
        },
        {
            'subTopicName': 'Should devotees worship Lord Dhanvantari to overcome diseases? (11 min)',
            'youtubeLink': 'https://youtu.be/c5Lvt-y12Mg?si=ub0iwBFwNMOq2AhI&t=628',
        },
        {
            'subTopicName': 'Is retiring from preaching a symptom of advancement? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/6iHGvdhIQT0?si=zOJWs5NSxKU4UPBJ&t=3018',
        },
        {
            'subTopicName': 'Is chanting more rounds a symptom of advancement? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/6iHGvdhIQT0?si=JlzxKjTD1mXdv6ex&t=3233',
        },
        {
            'subTopicName': 'Under what circumstances is mental offering bona fide? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/Yat6Iasojzw?si=jeafwJYQnoNu-zps&t=1257',
        },
        {
            'subTopicName': 'Overcoming distractions through Kṛṣṇa conscious engagement. (30 min)',
            'youtubeLink': 'https://youtu.be/6RuUs5AEXrQ?si=b7mHkex6tPwsv3Vs&t=1724',
        },
        {
            'subTopicName': 'Can the problems created due to immature preaching of Bhakti be solved by taking shelter of Dharma-śāstras? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/9wpou6exh9Q?si=uZMsnxd9IBjBRH9U&t=3702',
        },
        {
            'subTopicName': 'What is wrong with this argument: If, as a sādhaka, you are watching a movie, then why cannot you perform varṇāśrama activities like sandhyā-vandana? (33 min)',
            'youtubeLink': 'https://www.youtube.com/live/RTepF-Dr4NI?si=FQ3Rg_mumtO_dWxX&t=2545',
        },
        {
            'subTopicName': 'Why does a sādhaka find tolerance a difficult aspect to practice? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/RTepF-Dr4NI?si=hGXBeNOzh9JRPz-6&t=4484',
        },
        {
            'subTopicName': 'Can one remain with family and continue bhakti? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/VFhaouqZfSI?si=s14bTVA_zok12mTE&t=3740',
        },
        {
            'subTopicName': 'How to keep Kṛṣṇa in the centre in our services? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/gD-lySniPH0?si=IF2yZ6L5ucjrgjEj&t=3394',
        },
        {
            'subTopicName': 'Does black magic affect devotees? (21 min)',
            'youtubeLink': 'https://www.youtube.com/live/J16RhR-e_CA?si=JE9t2CMHIffQmnqJ&t=937',
        },
        {
            'subTopicName': 'Should we lament at the death of the Vaiṣṇavas? (4 min)',
            'youtubeLink': 'https://youtu.be/ekEVgxupvng?si=DPIyawbDRRYGb5nx&t=2866',
        },
        {
            'subTopicName': 'Vyāsāsana etiquettes. (4 min)',
            'youtubeLink': 'https://youtu.be/1G09tBj3x1M?si=_Lzfj8XakJrXycUR&t=789',
        },
        {
            'subTopicName': 'Yoga helps me to concentrate on my sādhana. Does it mean that I am practicing mixed devotional service? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rnLOb76ko0A&t=3206s',
        },
        {
            'subTopicName': 'How to plan less and execute more on the path of bhakti? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ojNX7c_Kk30&t=2774s',
        },
        {
            'subTopicName': 'How to understand that my faith is progressing? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ojNX7c_Kk30&t=3715s',
        },
        {
            'subTopicName': 'The world view of a karma-yogī vs the world view of a devotee. (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=K5BB56w1M38&t=3270s',
        },
        {
            'subTopicName': 'Practical tips for sense control. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1T1tquP4yzU&t=3240s',
        },
        {
            'subTopicName': 'Do I have qualifications (adhikāra) for practicing bhakti? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=b6wJQpJQurw&t=2731s',
        },
        {
            'subTopicName': 'Can devotees perform rituals for doṣa in their horoscope? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/h0AL964D8mU?si=ZQTiMaTBXxO8hF0B&t=3853',
        },
        {
            'subTopicName': 'How to understand devotees’ performance of śrāddha ceremony? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/FcWTqdy5Kgk?si=S9FC26l-EBf-gc5o&t=3712',
        },
        {
            'subTopicName': 'What a devotee should do when he gets a selfish desire? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/bLGy3Huo9ok?si=kUQmDijWHDizVdXM&t=3680',
        },
        {
            'subTopicName': 'How to deal with fear and impatience while practicing bhakti? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/bLGy3Huo9ok?si=06fCfZvwP3cg8Qgt&t=3909',
        },
        {
            'subTopicName': 'What is the secret of transforming humility into impetus for bhakti without getting dejected? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/RniTCjHns4Y?si=EA4BjLeu-Dzmm4RX&t=3979',
        },
        {
            'subTopicName': 'Can a devotee perform karma-kāṇḍīya atonements to overcome material problems? (30 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=htYc_PFGI2EGWRtf&t=1787',
        },
        {
            'subTopicName': 'Should one follow the instructions or actions of the perfected devotees? (21 min)',
            'youtubeLink': 'https://www.youtube.com/live/5DPnaY774qg?si=OFDQ5dbI_yLmlIbW&t=1387',
        },
        {
            'subTopicName': 'How should one cultivate a positive attitude while in the phase of anartha-nivṛtti? (14 min)',
            'youtubeLink': 'https://youtu.be/Z5V4VGTOMc0?t=558',
        },
        {
            'subTopicName': 'Is patriotism towards India spirituality? (6 min)',
            'youtubeLink': 'https://youtu.be/-D3wC31dFY4?si=WU0ytk2eOf60O3hX&t=2637',
        },
        {
            'subTopicName': 'Devotional service can be performed only with love and trust. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/M9B1VyMoIaQ?si=QoPJN4JkqaXX2M5V&t=302',
        },
        {
            'subTopicName': 'Is a devotee child guaranteed for devotee parents and are devotee parents guaranteed to a soul who was a past practitioner of Bhakti? (68 min)',
            'youtubeLink': 'https://youtu.be/K-vN6pztYHs?si=5EVXAmHlh0MRyXd_&t=1029',
        },
        {
            'subTopicName': 'Does Garbhādhāna-saṃskāra guarantee a devotee child? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/TNeLuClc1oI?si=5UOKWAgMIgFcdf9R&t=1875',
        },
        {
            'subTopicName': '“Fake it till you make it” – should devotees follow this statement with respect to their developing Vaiṣṇava qualities? (15 min)',
            'youtubeLink': 'https://youtu.be/zmbxeCag-RI?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=636',
        },
        {
            'subTopicName': 'Irony of this world – those who wish to be praised are bereft of good qualities while those who have good qualities do not wish to be praised. (12 min)',
            'youtubeLink': 'https://youtu.be/RgPqaepshpY?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=537',
        },
        {
            'subTopicName': 'A servant understands unspoken words or emotions behind apparently contrary words. (9 min)',
            'youtubeLink': 'https://youtu.be/RgPqaepshpY?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=1411',
        },
        {
            'subTopicName': 'Our suffering is often due to perception of a sense of injustice. (2 min)',
            'youtubeLink': 'https://youtu.be/FlxPXeE306k?si=jihk41vdLl-d4AFU&t=1421',
        },
        {
            'subTopicName': 'What is true, healthy freedom? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/eWKL3Jw1FKI?si=Gn-IQjcg-_grLGsU&t=1860',
        },
        {
            'subTopicName': 'Should a devotee always tolerate difficult situations seeing them to be orchestrated by Kṛṣṇa? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/eWKL3Jw1FKI?si=cK3rVSTiLUeAO19u&t=2020',
        },
        {
            'subTopicName': 'The most important criteria to accept someone as authority. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/eWKL3Jw1FKI?si=0d1IIvHmeLTmuVhe&t=5004',
        },
        {
            'subTopicName': 'Understanding self‑love and selfishness in bhakti. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/gDZqD_Yz5Ns?si=ghYufFimQQvXSYQZ&t=2188',
        },
        {
            'subTopicName': 'Are institutional authorities by default uttama‑adhikārīs? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/gDZqD_Yz5Ns?si=t04NPNqvpGhukxJJ&t=3011',
        },
        {
            'subTopicName': 'Why do we lose enthusiasm in a particular setup? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/gDZqD_Yz5Ns?si=TOaJIl0cfhIju4UK&t=3480',
        },
        {
            'subTopicName': 'What should be a devotee’s approach towards vairāgya in the devotional path? (23 min)',
            'youtubeLink': 'https://youtu.be/zkeBvyL8JZY?si=c7Ccbe4zwdczdU-m&t=2285',
        },
        {
            'subTopicName': 'To what extent is material advancement helpful in Vaiṣṇavism and should Vaiṣṇavas themselves endeavour in that direction? (10 min)',
            'youtubeLink': 'https://youtu.be/zkeBvyL8JZY?si=UgTraWOcy4iw1ksB&t=1636',
        },
        {
            'subTopicName': 'Different ways to deal with reversals with sound philosophical basis. (9 min)',
            'youtubeLink': 'https://youtu.be/kTrXcDsUOyU?si=dVOqs_ub--11kUht&t=667',
        },
        {
            'subTopicName': 'Are devotees expected to tolerate every suffering coming from Kṛṣṇa? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/454cpAnNtMU?si=pldRaNvkzplG94ue&t=3470',
        },
        {
            'subTopicName': 'Should devotees hear Ekādaśī kathā or what should be the correct mood of observing Ekādaśī? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/O3OHLAEqa64?si=y6sbW3ws5P_IuGaD&t=5851',
        },
        {
            'subTopicName': 'Raising a child – when to pamper and when to scold. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/5THj2496iq4?si=IRsf-JsE8uuPxCwD&t=2085',
        },
        {
            'subTopicName': 'Sometimes, it is not possible to be straightforward, especially with seniors. How should we deal with such situations? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/5THj2496iq4?si=lYluhiyia7RAncSf&t=3755',
        },
        {
            'subTopicName': 'Is it appropriate to say something but mean something to get something from a devotee? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/da3Mhwh6Kec?si=eed8Lu1eeiKJ35kr&t=3789',
        },
        {
            'subTopicName': 'Are devotees supposed to eat tila (sesame) on śat‑tila Ekādaśī? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/da3Mhwh6Kec?si=c8saM6gTkLzUs5-B&t=4300',
        },
        {
            'subTopicName': 'Can we hear devotional songs sung by Indian Classical singers? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h18rDjUNHRM&t=3848s',
        },
        {
            'subTopicName': 'Should we offer only the previous Ācāryas\' / pure devotees\' prayers (like Queen Kuntī\'s) to the Lord as we are very fallen OR can we offer ours too? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jOAW3XNnk5M&t=4483s',
        },
        {
            'subTopicName': 'Self‑Love or Self Care. (35 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=AMDxJYuf6xM&t=3065s',
        },
        {
            'subTopicName': 'Should we refrain from showing respect to other Sādhakas if we fear they will get proud? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XSAGwNMoF08&t=3865s',
        },
        {
            'subTopicName': 'Should we make a show of Vaiṣṇava qualities like being respectful, though we don\'t posess them? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XSAGwNMoF08&t=3420s',
        },
        {
            'subTopicName': 'Is asking many questions necessarily a sign of advancement in Kṛṣṇa Consciousness? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GTd6KcvXc84&t=3895s',
        },
        {
            'subTopicName': 'How should we show self‑respect? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XSAGwNMoF08&t=4690s',
        },
        {
            'subTopicName': 'Pañca Saṁskāras in the Gauḍīya Vaiṣṇava Sampradāya. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ojOUXLH0qMs&t=3840s',
        },
        {
            'subTopicName': 'Is Pāṇḍava Nirjala Ekādaśī really special OR should it be treated like every other Ekādaśī? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rvVgw0pUnkg&t=5760s',
        },
        {
            'subTopicName': 'Are initiated devotees necessarily more sincere than non‑initiated devotees? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rvVgw0pUnkg&t=1732s',
        },
        {
            'subTopicName': 'Is it fine that ISKCON temples conduct different Yajñas to attract outsiders to our movement? Or is it a compromise? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dXwsyg80F5c&t=4480s',
        },
        {
            'subTopicName': 'Self‑Love or Self Care. (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=AMDxJYuf6xM&t=3065s',
        },
        {
            'subTopicName': 'How do we understand devotees\' children being strong at one point in time and completely giving up devotional service later? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ngCFwTEm7Zo&t=4540s',
        },
        {
            'subTopicName': 'How to deal with the perceived injustices in spiritual life and in Kṛṣṇa‑Līlā? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gVdLB-yEzwk&t=1425s',
        },
        {
            'subTopicName': 'How to distinguish General Instructions for all the Sādhakas from character specific ones, as in the case of Nalakūvera and Maṇigrīva, even if both come from the same source? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=DdJqYP2ubYg&t=2980s',
        },
        {
            'subTopicName': 'Conflict Resolution at different levels - lessons from Brahmā\'s stopping Pṛthu from performing his 100th Aśvamedha Yajña (47 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RAGls-9gZVU&t=2442s',
        },
        {
            'subTopicName': 'How do we understand and apply Pṛthu Mahārāja\'s giving up his 100th sacrifice in this competitive age of Kali Yuga? (74 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nTCjVAghH-8&t=4113s',
        },
        {
            'subTopicName': 'Dealing with Superiors - understanding the generic principle AND being mature enough to adjust negotiable details. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=76tSxvBUtZE&t=3620s',
        },
        {
            'subTopicName': 'Should or should not devotees give up their traditional family practices? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2aJZVXd88aA&t=2182s',
        },
        {
            'subTopicName': 'Identification and addressing the problem of saṁśayātmās (the cynical insider). (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=aa446809Zgo&t=3335s',
        },
        {
            'subTopicName': 'In the beginning stages engage in likable devotional activities to kill boredom. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ob7T9smsFvY&t=1260s',
        },
        {
            'subTopicName': 'How to invite a devotee soul as a child? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=TNeLuClc1oI&t=3069s',
        },
        {
            'subTopicName': 'Will the children who are inclined to devotion at their young age necessarily become devotees when they grow? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=TNeLuClc1oI&t=2347s',
        },
        {
            'subTopicName': 'Is it ok for a devotee couple to adopt a child? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=TNeLuClc1oI&t=3423s',
        },
        {
            'subTopicName': 'Should we feel sorry for other\'s sufferings even after knowing the siddhānta? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=X6mgE1oQFto&t=1832s',
        },
        {
            'subTopicName': 'Do only the practitioners of Sādhana Bhakti endeavor to change their Svabhāva OR others also do? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GfCGcN9jJdg&t=3741s',
        },
        {
            'subTopicName': 'A self‑realised person can accept his intelligence as his Guru. But, what about Sādhakas? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pLtOvwHMfmQ&t=3290s',
        },
        {
            'subTopicName': 'If a particular person doesn\'t have logical understanding OR analytical skill inherently as part of his/her Svabhāva, what is the scope for him/her to practise Bhakti effectively? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pLtOvwHMfmQ&t=3816s',
        },
        {
            'subTopicName': 'When we try to internalise the teachings of scriptures, is there a possibility of the mind using the intelligence merely for an intellectual exercise and derive pleasure from it RATHER THAN actually putting the teachings into practice? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pLtOvwHMfmQ&t=3978s',
        },
        {
            'subTopicName': 'Kṛṣṇa consciousness parenting - Will a devotee\'s son necessarily be a devotee? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=g4E16NTPNHg&t=960s',
        },
        {
            'subTopicName': 'Secondary rules to keep the body healthy. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Rcws510LWh8&t=4330s',
        },
        {
            'subTopicName': 'Secondary rules for Social Stability. (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Rcws510LWh8&t=4840s',
        },
        {
            'subTopicName': 'Secondary rules of devotional service. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ps8gaL79Lqw&t=1185s',
        },
        {
            'subTopicName': 'Application of the Secondary Rules depends on individual situations. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1ooqlgc2DZo&t=1320s',
        },
        {
            'subTopicName': 'Understanding the relevance of Saṁskāras in Bhakti. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ps8gaL79Lqw&t=3025s',
        },
        {
            'subTopicName': 'Intricacies of Charity in Kṛṣṇa Bhakti. (38 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LW6HP1FOCts&t=758s',
        },
        {
            'subTopicName': 'A devotee\'s debt to his fore fathers and demigods. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6FPH1bGupDk&t=1740s',
        },
        {
            'subTopicName': 'Sannyāsa in Gauḍīya Vaiṣṇava sampradāya is mainly for preaching and differs from traditional Vedic sannyāsa. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9EvcG3HS9ZQ&t=2332s',
        },
        {
            'subTopicName': 'Is it necessary a devotee perform saṁskāras? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9EvcG3HS9ZQ&t=5022s',
        },
        {
            'subTopicName': 'How householder devotees can perform Bhakti? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EledLeVo5J4&t=2342s',
        },
        {
            'subTopicName': 'Importance of devotees to build for themselves a forum where they can be mutually challenged. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8vsfp1JqwyE&t=2292s',
        },
        {
            'subTopicName': 'What are the dangers / disadvantages of NOT having a forum where one is NOT questioned / challenged? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8vsfp1JqwyE&t=2940s',
        },
        {
            'subTopicName': 'How can one rely on his reflections / realisations OR a senior devotee\'s confirmations of one\'s realisations when neither of them is an Ācārya? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8vsfp1JqwyE&t=3675s',
        },
        {
            'subTopicName': 'What is the meaning of Realization? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8vsfp1JqwyE&t=3855s',
        },
        {
            'subTopicName': 'Is it alright for Sādhakas to depend on Pratyakṣa Pramāṇa for developing faith in Śabda Pramāṇa? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8vsfp1JqwyE&t=4120s',
        },
        {
            'subTopicName': 'How much emphasis should be given to the external Vaiṣṇava dress, etc? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BNZEyBCkLWM&t=5660s',
        },
        {
            'subTopicName': 'What is the difference between "being affected by the conditioned nature" and "taking the conditioned nature seriously"? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=DC3ERl-63e0&t=5360s',
        },
        {
            'subTopicName': 'Why does even a senior Vaiṣṇava serving as a Guru for decades still fall victim to māyā? How should a disciple deal with this? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pHtStax8QBU&t=2500s',
        },
        {
            'subTopicName': 'Should one try to cultivate the 6 limbs of surrender or will it develop automatically with growth in Bhakti? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pHtStax8QBU&t=3180s',
        },
        {
            'subTopicName': 'How do we show compassion to a mūḍha, when he is not even interested in the subject matter we are speaking? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=1548s',
        },
        {
            'subTopicName': 'A Fish rots from its head and an Institution from its Leader. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hRVaoeIJ8BQ&t=3653s',
        },
        {
            'subTopicName': 'What kind of Saṁskāras do devotees perform? (52 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=AR8_MT5v7j0&t=3730s',
        },
        {
            'subTopicName': 'How does one know if he is qualified for bhakti? (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=b6wJQpJQurw&t=2754s',
        },
        {
            'subTopicName': 'Seeking senior devotees\' advice is non‑negotiable. Without that, we may end up compromising a principle which shouldn\'t be, and over‑emphasizing another which is negotiable. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RwaILVgzrF8&t=682s',
        },
        {
            'subTopicName': 'What we can practically learn from Pṛthu Mahārāj not following in the footsteps of his own father? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ft5OYPZnBho&t=1677s',
        },
        {
            'subTopicName': 'I oppose the demigod worship of my family members. Would the demigods create obstacles in my Bhakti? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=y7FRfYpPTxo&t=2771s',
        },
        {
            'subTopicName': 'What\'s the solution that Śrīla Bhaktisiddhānta Sarasvatī Ṭhākura and Śrīla Prabhupāda instituted for Gurus\' falldown / Gurus NOT being an Uttama‑adhikārī? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ft5OYPZnBho&t=3398s',
        },
        {
            'subTopicName': 'Can we say that majority of the ISKCON devotees today are Karma‑miśra‑bhaktas? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=d36Obvd-_68&t=3108s',
        },
        {
            'subTopicName': 'How should we see devotees sometimes introduced as belonging to Brāhmaṇa families? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tXLaiH5XLzA&t=3405s',
        },
        {
            'subTopicName': 'Are demigods disrespected in ISKCON? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tXLaiH5XLzA&t=3925s',
        },
        {
            'subTopicName': 'Genuine love is indicated by the expression of love for the tadīya. (28 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EBAqOcl0Gts&t=5425s',
        },
        {
            'subTopicName': 'How to balance practicing Bhakti properly while simultaneously be sensitive to people around us? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7YQcN7hlx9w&t=3065s',
        },
        {
            'subTopicName': 'On what basis should a Sādhaka prioritize one limb of Bhakti over the other? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7YQcN7hlx9w&t=5640s',
        },
        {
            'subTopicName': 'Is there any way to know whether my impressions of pre Kṛṣṇa conscious life are decreasing or increasing? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=4161s',
        },
        {
            'subTopicName': 'How should a Sādhaka distinguish between honouring Prasādam and eating something like Jain food, in his consciousness? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jDi9z66krt0&t=4532s',
        },
        {
            'subTopicName': 'In other prominent vaiṣṇava sampradāyas, the current generation considers consumption of onion/garlic acceptable. Could this happen to ISKCON as well? How to maintain our standards? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OSP02lDJzkw&t=3460s',
        },
        {
            'subTopicName': 'How should we deal with situations where one has to hear something that\'s NOT according to the Paramparā, but still can\'t avoid it on account of a variety of reasons? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=2408s',
        },
        {
            'subTopicName': 'Should devotee parents discourage their children in material education? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=3543s',
        },
        {
            'subTopicName': 'How to deal with well intentioned people preaching their own philosophy to us? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5zk7IbCiQJY&t=1664s',
        },
        {
            'subTopicName': 'Should we act on the platform of Mahābhārata or Śrīmad‑Bhāgavatam? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=4759s',
        },
        {
            'subTopicName': 'Discouraging children to carry on with their material studies will only increase their irresponsibilty later in bhakti also. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=1710s',
        },
        {
            'subTopicName': '​Is it possible to be a politician and still put into practice the principles of pure devotional service? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=3614s',
        },
        {
            'subTopicName': 'Is my faith in Bhakti compromised when I think "I have no other choice but to practice Bhakti since I am not qualified for Karma / Jñāna?" (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=3775s',
        },
        {
            'subTopicName': 'How to avoid introducing Karma‑kāṇḍīya mentality in Bhakti? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=2736s',
        },
        {
            'subTopicName': 'Attachment to Kṛṣṇa‑kathā doesn\'t come necessarily by demeaning material education. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=1430s',
        },
        {
            'subTopicName': 'Is there a need for more Counsellors to mitigate problems in our Society? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0utgOK2TwGU&t=4368s',
        },
        {
            'subTopicName': 'If Śrī Caitanya Mahāprabhu Himself borrowed 2 principles each from every Vaiṣṇava Sampradāya, why should we NOT not borrow? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gjIKMojudEU&t=1355s',
        },
        {
            'subTopicName': 'If Kṛṣṇa has put us in a particular situation, does he want us to accept it as it is? (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=a9vYWReNDwA&t=5160s',
        },
    ],
    ['Preaching']: [
        {
            'subTopicName': 'A preacher should know the faith level of his audience. (8 min)',
            'youtubeLink': 'https://youtu.be/gEB779mzLW0?si=QDH5bbfv0QPsUCFb&t=4022',
        },
        {
            'subTopicName': 'Thoughtful hearing and thoughtful inquiring. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/bfdbewI_XgE?si=83oPkqzFQrLHQPdP&t=1868',
        },
        {
            'subTopicName': 'Responsibility of a preacher is not just to give the message but to ensure that the message is received favourably. (3 min)',
            'youtubeLink': 'https://youtu.be/UCD1itvjZIA?si=8UzULgY2YzlbBhw8&t=2643',
        },
        {
            'subTopicName': 'How to gain trust before preaching? (10 min)',
            'youtubeLink': 'https://youtu.be/SYVykIjOH_g?si=sxy-jzrmsoK5HzL6&t=1802',
        },
        {
            'subTopicName': 'Importance of having a common pramāṇa to have an intelligent discussion. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/wq0Rk7XBQ8A?si=GnWMk_lxC1JTrYEU&t=1344',
        },
        {
            'subTopicName': 'As practitioners of pure devotional service, can we encourage beginners to practice bhakti to attain their material goals? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/K64Ma9q8HiI?si=_H2tWCzsazzebSbh&t=5564',
        },
        {
            'subTopicName': 'It is important to understand the interests of the recipients before giving instructions. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=jX1pZ-YtLlMqTpnk&t=761',
        },
        {
            'subTopicName': 'A Guru can give the same content in different packages. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=4QxrWxqQvhd6QYAO&t=2349',
        },
        {
            'subTopicName': 'People will understand the instructions only according to their adhikāra. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/Yat6Iasojzw?si=CBo8a0F4wcBx92Iw&t=1718',
        },
        {
            'subTopicName': 'The internal struggle of a preacher whose philosophical understanding changes after many years of preaching. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/9wpou6exh9Q?si=YnrRDb4WkxwBv38q&t=4196',
        },
        {
            'subTopicName': 'A strong foundation for good preaching to subordinates is laid through churning the subject matter in the association of equal devotees. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/Qv8myvTruxY?si=3dnhAYfZn4-Souja&t=3243',
        },
        {
            'subTopicName': 'Statements like "3 names of Lord Rāma is equivalent to 1 name of Lord Kṛṣṇa" are meant to inspire whom? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/T8_KihNeqEk?si=NHUERZciKgMHplvZ&t=4194',
        },
        {
            'subTopicName': 'Before guiding anyone we should find out if they are agreeing to a common Pramāṇa. (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/wA-GpgZ-J4c?si=hjvklAahdxwR2lW2&t=2101',
        },
        {
            'subTopicName': 'If 1 name of Lord Kṛṣṇa is equivalent to 3 names of Lord Rāma and 3000 names of Lord Nārāyaṇa, should all the devotees of Lord Rāma and Nārāyaṇa become worshippers of Lord Kṛṣṇa? (50 min)',
            'youtubeLink': 'https://www.youtube.com/live/T8_KihNeqEk?si=uHlZoSjxuOwHa0dw&t=1885',
        },
        {
            'subTopicName': 'Can we present the scriptural proofs of Śrīla Rūpa Gosvāmī and convince the followers of the other sampradāyas to take up to worshipping Kṛṣṇa? (40 min)',
            'youtubeLink': 'https://youtu.be/5hC01vRCDj8?si=V-2zlXBtujjroRdm&t=719',
        },
        {
            'subTopicName': 'How should a jñāna-yogī and a bhakti-yogī deal with a person with karma-adhikāra? (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4HjKSGFbgAY&t=4131s',
        },
        {
            'subTopicName': 'Importance of understanding the heart of an inquirer before answering his questions. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/Zh6Z16dGsBA?si=9vM8ODFlpmxH6cca&t=3068',
        },
        {
            'subTopicName': 'Should the purpose of loka-saṅgraha / the perception of the common mass matter so much to the Lord or to His pure devotees? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/Q9si4U-CjFE?si=dUeuLQRlhC8J_esX&t=2353',
        },
        {
            'subTopicName': 'Example of peer pressure in preaching. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/6cUjH7NqSw8?si=aVO-wuZzC8D1aMRY&t=2652',
        },
        {
            'subTopicName': 'Being forceful vs. inspiring in preaching. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/M9B1VyMoIaQ?si=ZV6mtUdZwcWs-ID4&t=2471',
        },
        {
            'subTopicName': 'Role of trust and freedom in bhakti. (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/M9B1VyMoIaQ?si=XJpAz486-aKrzck2&t=4501',
        },
        {
            'subTopicName': 'Ideal mood of a sādhaka preacher and the ideal mood of a hearer hearing from a sādhaka preacher. (21 min)',
            'youtubeLink': 'https://youtu.be/6LEHjUWzmFU?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=321',
        },
        {
            'subTopicName': 'What should the ideal mood of a preacher of Kṛṣṇa Consciousness and that of a recipient of Kṛṣṇa Consciousness be? (3 min)',
            'youtubeLink': 'https://youtu.be/FD68k2rO4QM?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=4038',
        },
        {
            'subTopicName': '“The Counsellor System is meant to facilitate inspiration, and not to institutionalise inspiration.” (7 min)',
            'youtubeLink': 'https://youtu.be/FD68k2rO4QM?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=4202',
        },
        {
            'subTopicName': 'Pure intentions alone are not sufficient for preaching. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/eWKL3Jw1FKI?si=_asWN6G-iJmzyp5_&t=3684',
        },
        {
            'subTopicName': 'How to understand if we are being forceful in our preaching? (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/eWKL3Jw1FKI?si=kyi_BmpLpqXblBtF&t=3913',
        },
        {
            'subTopicName': 'Mood behind engaging devotees in services. (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/gDZqD_Yz5Ns?si=t3alzTojb6si8exy&t=1676',
        },
        {
            'subTopicName': 'How to correct a devotee? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/gDZqD_Yz5Ns?si=yp1mXT59YE96oJHG&t=2491',
        },
        {
            'subTopicName': 'Right way to engage devotees in temple services. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/gDZqD_Yz5Ns?si=jwacOG0AyzJmz4qt&t=2763',
        },
        {
            'subTopicName': 'Is it alright to push devotees to fulfil the Spiritual Master’s instructions? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/gDZqD_Yz5Ns?si=ZEWtrv4TAGQ8Aru5&t=3311',
        },
        {
            'subTopicName': 'Can one authority be the all‑in‑all for giving guidance? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/gDZqD_Yz5Ns?si=9DPpu6KDN4Fdgz25&t=3682',
        },
        {
            'subTopicName': 'How to deal with non‑believers who do not surrender due to lack of faith in the śāstras? (25 min)',
            'youtubeLink': 'https://youtu.be/bdoGT9uFotM?si=y1r1iRu5-K50kAri&t=2922',
        },
        {
            'subTopicName': 'To experience the Lord the most important aspect is one’s heart rather than the eyes. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4Kj9WE3zldA&t=4370s',
        },
        {
            'subTopicName': 'Who does the verse \'na buddhi‑bhedam janayet\' (BG 3.26) i.e. \'do not disturb the faith of ordinary people in Karma\' refer to? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XSAGwNMoF08&t=2848s',
        },
        {
            'subTopicName': 'Is Kṛṣṇa Consciousness supposed to be spoken at all times and in all places? Or are there restrictions? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mxPutDQ2Lcs&t=4488s',
        },
        {
            'subTopicName': 'A teacher purposefully keeps some questions unanswered, so that the inquisitive student can pick them up, ask AND in the process, register the answer better. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mxlUn_ubXWs&t=405s',
        },
        {
            'subTopicName': 'Making new devotees vs refining older devotees (boiling the milk). What takes precedence? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nTCjVAghH-8&t=4453s',
        },
        {
            'subTopicName': 'Should all preachers use their own arguments and logic while giving the message of Bhagavad Gītā to others OR should they put themselves in the audience\'s shoes and use logic based on their level of understanding? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GfCGcN9jJdg&t=3089s',
        },
        {
            'subTopicName': 'Is it acceptable to preach Kṛṣṇa Consciousness as a means to get quick relief from material suffering to attract new comers? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JJprkcVJTpY&t=3770s',
        },
        {
            'subTopicName': 'One should not have Rajo Guṇī inspiration for preaching. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mxPutDQ2Lcs&t=362s',
        },
        {
            'subTopicName': 'Do the Śāstras criticize the atheists? And what should be our mentality towards them? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=284s',
        },
        {
            'subTopicName': 'There is no one universal logic through which you can convince everyone. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=827s',
        },
        {
            'subTopicName': 'How do we show compassion to a mūḍha, when he is not even interested in the subject matter we are speaking? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=1548s',
        },
        {
            'subTopicName': 'Way of receiving Vedic Knowledge. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Mul8EsJXjR8&t=3812s',
        },
        {
            'subTopicName': 'Should devotee parents discourage their children in material education? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=3543s',
        },
        {
            'subTopicName': 'How to deal with well intentioned people preaching their own philosophy to us? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5zk7IbCiQJY&t=1664s',
        },
        {
            'subTopicName': 'Why did Pṛthu Mahārāj patiently hear Jñāna‑miśra‑bhakti from the Kumāras? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5zk7IbCiQJY&t=1664s',
        },
        {
            'subTopicName': 'Discouraging children to carry on with their material studies will only increase their irresponsibilty later in bhakti also. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=1710s',
        },
        {
            'subTopicName': 'Why did pure devotees like Pṛthu Mahārāja engage in their Varṇāśrama duties perfectly? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=2942s',
        },
        {
            'subTopicName': 'Why did Pṛthu Mahārāja have to indulge in such severe austerities in the Vānaprastha‑āśrama at the end of his life? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=2607s',
        },
        {
            'subTopicName': 'Attachment to Kṛṣṇa‑kathā doesn\'t come necessarily by demeaning material education. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=1430s',
        },
        {
            'subTopicName': 'Why did pure devotees like Pṛthu Mahārāja have to engage in Jñāna‑yoga processes at the end of their lives? (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glVWOuUj9OA&t=2268s',
        },
    ],
    ['Rasa Tattva']: [
        {
            'subTopicName': 'Understanding the components of Rasa. (10 min)',
            'youtubeLink': 'https://youtu.be/KxlGUpdv0sM?si=mkxLotlnZjv5mkwq&t=3473',
        },
        {
            'subTopicName': 'Understanding the components of Rasa. (13 min)',
            'youtubeLink': 'https://youtu.be/KxlGUpdv0sM?si=gc4gDwVhxJEc4Y8F&t=3462',
        },
        {
            'subTopicName': 'Understanding the components of Rasa. (50 min)',
            'youtubeLink': 'https://www.youtube.com/live/eKPc6Oogc6M?si=ly1ttRLzoI4RN_9p&t=774',
        },
        {
            'subTopicName': 'Rādhā and Kṛṣṇa - Śrīmad-Bhāgavatam\'s most confidential subject matter (58 min)',
            'youtubeLink': 'https://www.youtube.com/live/JYld7aQ6KF8?si=7M9G7gsNDaCzHv3k&t=419',
        },
        {
            'subTopicName': 'Difference between material rasa and spiritual rasa. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/Xj9jrl12VB4?si=I0zL41o2NkVDytUL&t=2661',
        },
        {
            'subTopicName': 'Does Sakhya rasa exist in Vaikuṇṭha? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/1wFC-Z4xXpU?si=sUwiawj9EifyFYRk&t=2057',
        },
        {
            'subTopicName': 'Brief overview of rasa. (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/eKPc6Oogc6M?si=fdHdatqHJ6EhrC6R&t=789',
        },
        {
            'subTopicName': 'Does our ability to express or experience material emotions have an impact on our spiritual life? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/eKPc6Oogc6M?si=cPZ3G2xQ-Mt8bAjw&t=3476',
        },
        {
            'subTopicName': 'Are Arjuna’s emotions during the starting of Bhagavad-gītā material or spiritual? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/BoAwysqKaaM?si=SCmr2dCxPiPGmNgo&t=1100',
        },
        {
            'subTopicName': 'How will learning about sāttvika-bhāva help one at sādhaka stage? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/BoAwysqKaaM?si=lYBYc5g3gWRmpsV-&t=3703',
        },
        {
            'subTopicName': 'Sāttvika bhāva - Aśru or Tears. (25 min)',
            'youtubeLink': 'https://www.youtube.com/live/7vDnBNf5CuQ?si=plo9qHfpBFEmDPco&t=1177',
        },
        {
            'subTopicName': 'Sāttvika bhāva - Pralaya or Fainting. (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/7vDnBNf5CuQ?si=LLRRUtwwfeq63U5i&t=2682',
        },
        {
            'subTopicName': 'How to distinguish Rūkṣa from digdha sāttvika bhāva? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/7vDnBNf5CuQ?si=OhcHUd4MYUuiHUJb&t=3392',
        },
        {
            'subTopicName': 'What is the difference between anubhāvas and sāttvika bhāvas? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/7vDnBNf5CuQ?si=_hSxzzmLr6j1LFDM&t=3810',
        },
        {
            'subTopicName': 'How is intelligence involved in anubhāvas and absent in sāttvika bhāvas? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/7vDnBNf5CuQ?si=uNh5G2_clI0RkOwr&t=4225',
        },
        {
            'subTopicName': 'Variations in the degrees of sāttvika bhāvas. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/7vDnBNf5CuQ?si=hrpiNXFdLgoVGs0Z&t=4561',
        },
        {
            'subTopicName': 'Four categories of sāttvika bhāvas. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/7vDnBNf5CuQ?si=sxUQH-zWdxS8gVKC&t=5529',
        },
        {
            'subTopicName': 'Why and how did Śrīla Prabhupāda hide his sāttvika bhāvas and anubhāvas? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/7vDnBNf5CuQ?si=j3ZjtqtTulHhEeYG&t=5860',
        },
        {
            'subTopicName': 'Parameters for categorization of sāttvika bhāvas. (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/7vDnBNf5CuQ?si=3W_s_Nx2zb3jCKwx&t=6262',
        },
        {
            'subTopicName': 'Sāttvika bhāva - Svara bheda. (41 min)',
            'youtubeLink': 'https://www.youtube.com/live/GDaR3Wpoqas?si=4um89tW4Exeb3UD4&t=1987',
        },
        {
            'subTopicName': 'Sāttvika bhāva - Vepathu. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/BoAwysqKaaM?si=Mx_lZQ8wgezFNquS&t=970',
        },
        {
            'subTopicName': 'Sāttvika bhāva - Vaivarṇya. (35 min)',
            'youtubeLink': 'https://www.youtube.com/live/BoAwysqKaaM?si=L3o5U8q7mLS2gJ09&t=3297',
        },
        {
            'subTopicName': 'What is svacchā-rati? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/T8_KihNeqEk?si=PijenCHRk0nS3mpo&t=4374',
        },
        {
            'subTopicName': 'Daṇḍakāraṇya Ṛṣis had attraction only for Kṛṣṇa. (5 min)',
            'youtubeLink': 'https://youtu.be/q6muG4fsTLs?si=3X_J-zIdyyB7MU_n&t=1879',
        },
        {
            'subTopicName': 'Speciality of tears (aśru) and choking of voice (gadgada). (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XYnIMULuuo0&t=1550s',
        },
        {
            'subTopicName': 'Dhūmāyita sāttvika-bhāva. (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XYnIMULuuo0&t=2293s',
        },
        {
            'subTopicName': 'How can one hide sāttvika-bhāva? Doesn’t it make it anubhāva? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XYnIMULuuo0&t=2611s',
        },
        {
            'subTopicName': 'Jvalita sāttvika-bhāva. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XYnIMULuuo0&t=3177s',
        },
        {
            'subTopicName': 'Dīpta sāttvika-bhāva. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XYnIMULuuo0&t=3914s',
        },
        {
            'subTopicName': 'Uddīpta and śuddhīpta sāttvika-bhāva. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XYnIMULuuo0&t=4680s',
        },
        {
            'subTopicName': 'Śuddhīpta sāttvika-bhāva. (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XYnIMULuuo0&t=4913s',
        },
        {
            'subTopicName': 'Four levels of sāttvika-bhāva. (51 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XYnIMULuuo0&t=1854s',
        },
        {
            'subTopicName': 'Four types of sāttvika-ābhāsas. (37 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XYnIMULuuo0&t=4998s',
        },
        {
            'subTopicName': 'What is the difference between śānta-rasa and śānta-rati? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/kkNawrmCVaQ?si=9Ynjxz71_hazTleb&t=4161',
        },
        {
            'subTopicName': 'What is uddīpana? (4 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=Zo8pea3jtrUP0C7R&t=4252',
        },
        {
            'subTopicName': 'Description of primary rasas? (2 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=01TnSNiRlQCY4j4L&t=4510',
        },
        {
            'subTopicName': 'Do the animals of Vraja possess śānta-rasa towards Kṛṣṇa? (2 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=yhQgyaIc0y7FlE35&t=5090',
        },
        {
            'subTopicName': 'Understanding Vyābhicārī‑bhāva through a material analogy. Mother Devakī’s fear of Kaṁsa to protect Kṛṣṇa. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/pOqEe9h4uBM?si=sQrFlbeTehdU4nBJ&t=3735',
        },
        {
            'subTopicName': 'How to understand that a male can develop mādhurya‑rasa towards Kṛṣṇa? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/soPT-4X5lso?si=VEspuYGDIigfDhOZ&t=803',
        },
        {
            'subTopicName': 'Introduction to vyabhicārī‑bhāvas. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/_ILASOk4ah4?si=6SwNOGvr0QyLi5DC&t=240',
        },
        {
            'subTopicName': 'Is vyabhicārī aspect of sāttvika‑bhāva and vyabhicārī‑bhāva the same? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/_ILASOk4ah4?si=Nc0bwA5jtQXZ0B7q&t=2275',
        },
        {
            'subTopicName': 'How does vyabhicārī‑bhāva flow opposite to sthāyī‑bhāva? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/_ILASOk4ah4?si=87cM0cxQrEsebID3&t=2488',
        },
        {
            'subTopicName': 'First type of vyabhicārī‑bhāva – nirvedaḥ or self‑disgust. (43 min)',
            'youtubeLink': 'https://www.youtube.com/live/_ILASOk4ah4?si=nKSTO25yzCufg0V5&t=2815',
        },
        {
            'subTopicName': 'Complete overview of sāttvika‑bhāvas. (119 min)',
            'youtubeLink': 'https://www.youtube.com/live/zq5_gTZsmqU?si=dW-3oXIygIOUw-vP',
        },
        {
            'subTopicName': 'Is vyabhicārī‑bhāva the root of sāttvika‑bhāva and anubhāva? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/y0sK0SycI0o?si=jM20D9iSxoaLW88_&t=1132',
        },
        {
            'subTopicName': 'Second type of vyabhicārī‑bhāva – remorse or viṣāda. (29 min)',
            'youtubeLink': 'https://www.youtube.com/live/y0sK0SycI0o?si=uex6Bx8SjW4TiHSy&t=3840',
        },
        {
            'subTopicName': 'Third type of vyabhicārī‑bhāva – dainyaṁ or thinking low of oneself. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/y0sK0SycI0o?si=VR1uaUe4u9_NBnK8&t=5608',
        },
        {
            'subTopicName': 'Four types of sāttvika‑ābhāsa. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/G9YQFheuJUo?si=HGxdSOab3ecxXQ6K&t=3857',
        },
        {
            'subTopicName': 'Do cows of Vṛndāvana have śānta rasa? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/CHgBjEYlklI?si=hTVao2PbAgyCPNHr&t=5022',
        },
        {
            'subTopicName': 'Duties of the nurses in Goloka where Kṛṣṇa is always in kaiśora āvasthā. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/O3OHLAEqa64?si=yZYORoBDrNOofNal&t=1498',
        },
        {
            'subTopicName': 'Kṛṣṇa as akhila‑rasāmṛta‑mūrtiḥ. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/5THj2496iq4?si=3NEnzPHhFwC6x91T&t=1350',
        },
        {
            'subTopicName': 'Why Śānta rasa is not mentioned for Goloka? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GN2Gd1kjAxM&t=2043s',
        },
        {
            'subTopicName': '7th Vyabhicārī bhāva - Garva or haughtiness. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=_IyrnTWVWI4&t=3890s',
        },
        {
            'subTopicName': 'How does vyabhicārī bhāva lead to sāttvika bhāvas and other vyabhicārī bhāvas? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=_IyrnTWVWI4&t=1140s',
        },
        {
            'subTopicName': 'How does Akrūra know about Kṛṣṇa’s confidential pastimes, as he mentions them in his prayers? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pwP7CHw4IIo&t=3400s',
        },
        {
            'subTopicName': 'Akrūra’s appreciation of Kṛṣṇa’s mādhurya pastimes is not rasa ābhāsa. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pwP7CHw4IIo&t=1911s',
        },
        {
            'subTopicName': 'How do sāttvika bhāvas and anubhāvas manifest sequentially in a pure devotee like Pṛthu Mahārāja? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h18rDjUNHRM&t=1080s',
        },
        {
            'subTopicName': '4 types of Sāttvika Ābhāsa. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=G9YQFheuJUo&t=3860s',
        },
        {
            'subTopicName': '6th type of vyabhicārī bhāva - madaḥ or intoxicated state. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Jbpv6lx0-Zg&t=4850s',
        },
        {
            'subTopicName': '5th type of vyabhicārī bhāva - śrama or fatigue. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Jbpv6lx0-Zg&t=4100s',
        },
        {
            'subTopicName': '4th type of vyabhicārī bhāva - mlāni or weakened state from lack of strength and nourishment. (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Jbpv6lx0-Zg&t=3090s',
        },
        {
            'subTopicName': '3rd type of vyabhicārī bhāva - Dainya or thinking oneself a low creature. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Jbpv6lx0-Zg&t=2046s',
        },
        {
            'subTopicName': 'Does the nomenclature of each sāttvika bhāvas comes from the anubhāva aspect of sāttvika bhāvas? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Jbpv6lx0-Zg&t=6020s',
        },
        {
            'subTopicName': 'What is rasa between the cows, rivers etc and Kṛṣṇa? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oh6fTI7lz18&t=2888s',
        },
        {
            'subTopicName': 'If the devotee is satisfied in his Sthāyī Bhāva like Sakhyā, then what is the relevance of Lord Caitanya coming to give Mādhurya Bhakti? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=R2VmZix87yA&t=1715s',
        },
        {
            'subTopicName': 'The 5 Primary Rasas. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=zWJCSbQubLQ&t=1300s',
        },
        {
            'subTopicName': 'How do devotees in other rasas perceive Kṛṣṇa’s mādhuryā‑līlās? (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HJcD57yDGE8&t=4205s',
        },
        {
            'subTopicName': 'Analysis of the sāmagrī bhāvas in Akrūra’s experience of witnessing Lord’s lotus footprints. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HJcD57yDGE8&t=5740s',
        },
        {
            'subTopicName': '8th Vyabhicāri‑bhāva ‑ Śaṅkā or apprehension. (26 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LfPiRbq2bsU&t=2505s',
        },
        {
            'subTopicName': '9th Vyabhicāri‑bhāva ‑ Trāsa or disturbance ‑ part 1 (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LfPiRbq2bsU&t=4085s',
        },
        {
            'subTopicName': 'Is the list of Vyabhicāri bhāvas and anubhāvas fixed? (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LfPiRbq2bsU&t=4477s',
        },
        {
            'subTopicName': '9th Vyabhicāri‑bhāva ‑ Trāsa or disturbance ‑ part 2 (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LfPiRbq2bsU&t=5470s',
        },
        {
            'subTopicName': 'Is there a clear demarcation as to when one crosses from Vaidhī to Rāgānugā? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=CV6J5WDhduQ&t=4619s',
        },
        {
            'subTopicName': 'Identification of Sañcārī and Sāttvika‑bhāvas in Akrūra’s ecstasy during meeting with Kṛṣṇa and Balarāma. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7YQcN7hlx9w&t=4390s',
        },
        {
            'subTopicName': 'Analysis of the Sāmagrī bhāvas in the expressions of gopīs’ lamentation. (35 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=94rr4vmqmGM&t=2980s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize the Creator. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=2081s',
        },
        {
            'subTopicName': 'Gopīs get frightened at the prospect of separation from Kṛṣṇa. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=1315s',
        },
        {
            'subTopicName': 'Why is gopīs’ criticism of Akrūra not a vaiṣṇava‑aparādha? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=6070s',
        },
        {
            'subTopicName': 'How is gopīs’ criticism of the Lord different from Gāndhārī’s criticism of Kṛṣṇa? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=2810s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize Providence for cruelly taking their eyesight away. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=3370s',
        },
        {
            'subTopicName': 'Why did Pṛthu Mahārāja have to indulge in such severe austerities in the Vānaprastha‑āśrama at the end of his life? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=2607s',
        },
        {
            'subTopicName': 'Perfection of all rasas is in Kṛṣṇa. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=5190s',
        },
        {
            'subTopicName': '5 Primary Ratis. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=5040s',
        },
        {
            'subTopicName': 'Understanding Pūrvarāga and Utkaṇṭhitā. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=2100s',
        },
        {
            'subTopicName': 'Should the Gopīs’ criticisms in viraha‑gītā be taken at face value? (27 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=l9JSxaKiTi8&t=1230s',
        },
        {
            'subTopicName': 'Gopīs’ attachment to Kṛṣṇa in not letting him go to Mathurā is not due to material possessiveness. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=4390s',
        },
        {
            'subTopicName': '10th Vyabhicāri‑bhāva ‑ Āvega or confusion of mind. (57 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=I2rQUE0eyBU&t=1760s',
        },
        {
            'subTopicName': 'Exercise on identifying symptoms of vyabhicāri bhāvas and classifying them as words, actions or sattvas (48 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=I2rQUE0eyBU&t=2330s',
        },
        {
            'subTopicName': 'Lamentation of gopīs for Kṛṣṇa\'s departure from Vṛndāvana and Lord’s messages of reassurance (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BNepBkhv7aA&t=3465s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs express envy towards women of Mathurā (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=4950s',
        },
        {
            'subTopicName': 'It is difficult to understand a person in Prema‑bhakti. (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=SH0ionOFw-o&t=3560s',
        },
        {
            'subTopicName': 'Actions of a person at the stage of Bhāva. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=VFnjKiJO_rc&t=2320s',
        },
    ],
    ['Refuting Apa-Siddhānta']: [
        {
            'subTopicName': 'Refuting non Vaiṣṇava arguments for existence of soul. (9 min)',
            'youtubeLink': 'https://youtu.be/a3DqrSqPnp0?si=tg6BMm4KlOvdS7Ut&t=1564',
        },
        {
            'subTopicName': 'How to refute the arguments regarding Krishna being an ordinary conditioned soul? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/uSxVKrr7Ab8?si=jW541xSLgSLXKIJd&t=2098',
        },
        {
            'subTopicName': 'Refuting Māyāvādi Arguments- Vivarta Vāda. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/cFgOw0dHG0Q?si=InjZxsKjte2X3a5x&t=1375',
        },
        {
            'subTopicName': 'Does the Supreme Lord has temporary form made of matter? (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/jtZXoCAbrt0?si=fw0DXJrIzbNgVhfj&t=1262',
        },
        {
            'subTopicName': 'Is Kṛṣṇa\'s form seen in the material world temporary and material? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/qwr6qQ50sZc?si=1VulUuf7RwALXG-8&t=2607',
        },
        {
            'subTopicName': 'Refutation to the argument that there is only one universe and one Brahmā. (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/7lfELjXi5wQ?si=1UDkipTVrGramNfN&t=2400',
        },
        {
            'subTopicName': 'Refutation to the argument: If Kṛṣṇa is visible to material eyes then definitely that form is made of material guṇas? (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/27pSPzF12rQ?si=GpAsWBueEcFSmcwL&t=3838',
        },
        {
            'subTopicName': 'Defeating the argument that Kṛṣṇa is the vilāsa form of Nārāyaṇa. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/nb7gHrc5kUQ?si=53chlBI9LCTBKpRB&t=955',
        },
        {
            'subTopicName': 'Defeating the argument that Kṛṣṇa and Balarāma appeared from black and white hair of Kṣīrodakaśāyī Viṣṇu. (30 min)',
            'youtubeLink': 'https://youtu.be/-AcdZYA0xAo?si=94oIPB5NyVkGU2sz&t=1626',
        },
        {
            'subTopicName': 'Defeating the argument that Kṛṣṇa is an amśa of Kṣīrodakaśāyī Viṣṇu. (20 min)',
            'youtubeLink': 'https://youtu.be/R40e2EnGLi8?si=Q_k_Tcbb3i80rOsV&t=2077',
        },
        {
            'subTopicName': 'Defeating the argument that Kṛṣṇa is an amśa of Kṣīrodakaśāyī Viṣṇu. (31 min)',
            'youtubeLink': 'https://youtu.be/2E1IuKBbNIw?si=c4XbrrwKIcHPUNr-&t=1838',
        },
        {
            'subTopicName': 'Defeating the argument that Kṛṣṇa is expansion of Nārāyaṇa. (32 min)',
            'youtubeLink': 'https://youtu.be/2E1IuKBbNIw?si=u_SbfSnwrT8SQ04P&t=1555',
        },
        {
            'subTopicName': 'Defeating the argument that Kṛṣṇa is an amśa of Caturvyūha Vasudeva. (30 min)',
            'youtubeLink': 'https://youtu.be/Xtk3BYvvTgE?si=_Bex0WKG5uTj1uC4&t=1432',
        },
        {
            'subTopicName': 'Defeating the argument that Kṛṣṇa has material form and qualities. (40 min)',
            'youtubeLink': 'https://youtu.be/qHh74Y-8y3o?si=7QEQfQV3MWc5xvIz&t=1115',
        },
        {
            'subTopicName': 'Refuting the argument that Nārāyaṇa is the source of Kṛṣṇa. (33 min)',
            'youtubeLink': 'https://youtu.be/nyokZP-J5J8?si=mcFgcW5Z68ajXJBY&t=1588',
        },
        {
            'subTopicName': 'If the dīkṣā-guru in current life is acting as a representative of one’s bona fide guru from previous life, does that make it equivalent to a ṛtvik system? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QAV4P_DseEg&t=4576s',
        },
        {
            'subTopicName': 'Refutation of the argument: Kṛṣṇa’s form is material or illusory as it can be seen by the material eyes. ()',
            'youtubeLink': 'https://www.youtube.com/live/TtWtstSXjLc?si=QmJqePhodSLcY_gR&t=1822',
        },
        {
            'subTopicName': 'Refutation to the argument: Activities or pastimes correspond only to those who have a limited form and not to the Lord who is like the sky — unlimited or all-pervasive. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/9Ev8dpwI7jQ?si=iNvtUkqVLNSygNMN&t=2644',
        },
        {
            'subTopicName': 'Refutation to the argument that earthly Gokula cannot be superior to Goloka because it is situated on earth. (16 min)',
            'youtubeLink': 'https://www.youtube.com/live/M5LIRVZVMVA?si=ZPUAFmVhoD2KuXt_&t=3600',
        },
        {
            'subTopicName': 'Refutation of the argument: Because Nārāyaṇa has four hands and Kṛṣṇa has only two, Nārāyaṇa is the original Personality of Godhead. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/QS1HpvX2VN4?si=bC7n6d8KnVXm9hlJ&t=3612',
        },
        {
            'subTopicName': 'How the pūrva‑pakṣa interpretation of the verse ete cāṁśa‑kalāḥ puṁsaḥ is refuted? (45 min)',
            'youtubeLink': 'https://www.youtube.com/live/G-BHO1GVjXI?si=NfhtZ4LqlWEjNVjn&t=2726',
        },
        {
            'subTopicName': 'Vivartavāda and pariṇāmavāda. (30 min)',
            'youtubeLink': 'https://youtu.be/pIVrffAk210?si=Qjjm0Kycz5BwL_IJ&t=2495',
        },
        {
            'subTopicName': 'Is this material world actually unreal, an illusion? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9gMR2e8eaZ4&t=5380s',
        },
        {
            'subTopicName': 'For a devotee who could not attain perfection in this life, Kṛṣṇa guarantees protection of his bhakti but does not guarantee birth in a devotee family. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=eiRsN915n6A&t=1064s',
        },
        {
            'subTopicName': 'Māyāvāda/Vivartavāda vs Śakti Pariṇāmavāda. (75 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ar1okrtZNZQ&t=2430s',
        },
        {
            'subTopicName': 'Ritvik system of Initiation : greatest insult to the previous Ācāryas. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=76tSxvBUtZE&t=4137s',
        },
        {
            'subTopicName': 'Māyāvādī interpretation of the aphorism "ekaṁ brahma dvitīya nāsti". (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Q1tmJZhIgIc&t=1748s',
        },
        {
            'subTopicName': 'Māyāvādī understanding of Kṛṣṇa\'s form. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ZnQH4cbm3zc&t=2594s',
        },
        {
            'subTopicName': '2 Incorrect conclusions from the episode of Avadhūta brāhmaṇa and the 24 Gurus. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ft5OYPZnBho&t=694s',
        },
        {
            'subTopicName': 'Material Vision VS Impersonal Vision VS Vision of the Lord. (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n6q79aHYYKw&t=3300s',
        },
    ],
    ['Rāgānuga Bhakti']: [
        {
            'subTopicName': 'What is the secret meaning hidden in the prayers of personified Vedas ? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/Xj9jrl12VB4?si=rg4VIRC1vE0y9OA4&t=2974',
        },
        {
            'subTopicName': 'Gradual transition of a steady devotee from Vaidhī to Rāgānugā. (29 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cdYT3svsbSM&t=4940s',
        },
        {
            'subTopicName': '2 types of Rāgānugā Sādhana. (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6FPH1bGupDk&t=6180s',
        },
        {
            'subTopicName': 'How does one become a Rāgānugā Bhakta? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ob7T9smsFvY&t=5408s',
        },
        {
            'subTopicName': 'How Rāgānugā Bhakti develops? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ob7T9smsFvY&t=2500s',
        },
        {
            'subTopicName': 'In the Gauḍīya Vaiṣṇava Sampradāya Vaidhī sādhana is actually Rāgānugā in mood. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=G7F4Rp7mGL4&t=2475s',
        },
        {
            'subTopicName': 'Characteristics of Rāgānugā Sādhaka. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=G7F4Rp7mGL4&t=1320s',
        },
        {
            'subTopicName': 'Understanding the difference between the Vaidhī Mārga and Rāgānugā Mārga. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oh6fTI7lz18&t=3436s',
        },
        {
            'subTopicName': 'Did Śrīla Prabhupāda give us only Vaidhī Bhakti as he recommended his followers to worship the Lordships only in the mood of awe and reverence? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oh6fTI7lz18&t=2500s',
        },
        {
            'subTopicName': 'Did Śrīla Prabhupāda and Śrīla Bhakti Siddhānta Saraswatī Ṭhākura give us Rāgānugā bhakti or Vaidhī Bhakti? - Part‑2 (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oh6fTI7lz18&t=4124s',
        },
        {
            'subTopicName': 'Were there Rāgānugā Bhaktas before the coming of Śrī Caitanya Mahāprabhu? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0zJytSMFObI&t=4405s',
        },
        {
            'subTopicName': 'Did Śrīla Prabhupāda and Śrīla Bhakti Siddhānta Saraswatī Ṭhākura give us Rāgānugā bhakti or Vaidhī Bhakti? - Part‑1 (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Pwp-nD5Wtlc&t=3915s',
        },
        {
            'subTopicName': 'Symptoms of greed. (21 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cdYT3svsbSM&t=2598s',
        },
        {
            'subTopicName': 'Reliable symptoms of greed. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ob7T9smsFvY&t=6390s',
        },
        {
            'subTopicName': 'What is the impetus to increase the greed for Rāgānugā Bhakti? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oh6fTI7lz18&t=3999s',
        },
        {
            'subTopicName': 'Does Rāgānugā Bhakti start only after the stage of Annartha nivṛtti? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oh6fTI7lz18&t=2697s',
        },
        {
            'subTopicName': 'Is greed for Rāgānugā nurtured or is it spontaneous? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oh6fTI7lz18&t=1806s',
        },
        {
            'subTopicName': 'Is the intensity of attraction of the Rāgānugā Sādhakas towards their object of love always greater than that of the Vaidhī Sādhakas? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oh6fTI7lz18&t=2172s',
        },
        {
            'subTopicName': 'Do Rāgānugā Sādhakas follow the scriptures? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Pwp-nD5Wtlc&t=3780s',
        },
        {
            'subTopicName': 'Should Rāgānugā Sādhakas completely follow Vrajavāsīs in all aspects? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GfCGcN9jJdg&t=640s',
        },
        {
            'subTopicName': 'Practice of Rāgānugā Sādhana. (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=G7F4Rp7mGL4&t=4205s',
        },
        {
            'subTopicName': 'Vaidhi Bhakti may not transform to Raga Bhakti if the seed is of Aisvarya Bhakti. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=G7F4Rp7mGL4&t=2040s',
        },
        {
            'subTopicName': '4 primary elements of Rāgānugā sādhana. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=3140s',
        },
        {
            'subTopicName': 'How does greed for Rāgānugā Bhakti develop? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cdYT3svsbSM&t=4063s',
        },
        {
            'subTopicName': 'Understanding Rāgānugā Bhakti. (33 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6FPH1bGupDk&t=4170s',
        },
        {
            'subTopicName': 'Pitfalls on the practice of Rāgānugā Bhakti. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=s87B8SzYE70&t=3600s',
        },
        {
            'subTopicName': 'Rāgānugā sādhaka\'s relationship with the guru. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=bTOcBnPLlGM&t=3460s',
        },
        {
            'subTopicName': 'Internal and external paths of Rāgānugā bhakti. (25 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=bTOcBnPLlGM&t=4800s',
        },
        {
            'subTopicName': 'Descent of Mahāprabhu and history of Rāgānugā sādhana in Gauḍīya Vaiṣṇava Sampradāya. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=bTOcBnPLlGM&t=4148s',
        },
        {
            'subTopicName': 'Historical nuisance of external path of Rāgānugā Bhakti and it\'s resolution. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5TMgZekcaL0&t=1627s',
        },
        {
            'subTopicName': 'How does greed for Rāgānugā Bhakti develop? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cdYT3svsbSM&t=4060s',
        },
        {
            'subTopicName': 'Detailed descriptions of Vṛndāvana in Śrīmad‑Bhāgavatam nourishes Rāgānugā-bhakti. (23 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=N90t516qYew&t=320s',
        },
        {
            'subTopicName': 'Elements of practice of Kāmānugā-bhakti. (21 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mPV5ksADt7o&t=5625s',
        },
        {
            'subTopicName': 'Is the term Rāgānugā applicable to Vaikuṇṭha Bhakti? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=1725s',
        },
        {
            'subTopicName': 'Understanding Rāgānugā-sādhanā. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=93s',
        },
        {
            'subTopicName': 'Historical misuse of the external path of Rāgānugā-bhakti ‑ Part‑1. (92 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5TMgZekcaL0&t=1630s',
        },
        {
            'subTopicName': 'Historical misuse of the external path of Rāgānugā-bhakti ‑ Part‑2 (23 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cOjeSXHw1N0&t=500s',
        },
        {
            'subTopicName': 'History of Rāgānugā-sādhanā in the Gauḍīya Vaiṣṇava Sampradāya ‑ Part‑1 (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=bTOcBnPLlGM&t=4148s',
        },
        {
            'subTopicName': 'Internal and external paths of Rāgānugā-bhakti. (34 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=bTOcBnPLlGM&t=4800s',
        },
        {
            'subTopicName': 'Rāgānugā-sādhaka\'s relationship with guru. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=bTOcBnPLlGM&t=3460s',
        },
        {
            'subTopicName': 'Practice of Rāgānugā-bhakti ‑ Part‑1 (66 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=bTOcBnPLlGM&t=3140s',
        },
        {
            'subTopicName': 'Practice of Rāgānugā-bhakti ‑ Part‑2 (55 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=s87B8SzYE70&t=3600s',
        },
        {
            'subTopicName': 'How does greed for Rāgānugā-bhakti develop? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cdYT3svsbSM&t=4060s',
        },
        {
            'subTopicName': 'Practice of Rāgānugā-sādhanā. (66 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=3120s',
        },
        {
            'subTopicName': '4 Essential Elements of Rāgānugā-sādhanā. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=3120s',
        },
        {
            'subTopicName': 'The right kind of meditation for a Rāgānugā-sādhaka. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=3750s',
        },
        {
            'subTopicName': 'How will I know which Vrajavāsī to follow? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=3900s',
        },
        {
            'subTopicName': 'Pre‑requisite for remembering Kṛṣṇa and the Vrajavāsīs. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=4470s',
        },
        {
            'subTopicName': 'Genuine Rāgānugā-bhakti cannot be imitated. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=6100s',
        },
        {
            'subTopicName': 'Internal and External practices of Rāgānugā-sādhanā. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=6345s',
        },
        {
            'subTopicName': 'Elements of practice of sambandhānugā-bhakti (30 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=lC3mZpoQvH4&t=537s',
        },
        {
            'subTopicName': 'From practice to success in rāgānugā-bhakti. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=lC3mZpoQvH4&t=2340s',
        },
        {
            'subTopicName': 'How Vaidhī sādhanā transforms into Rāgānugā sādhanā? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=lC3mZpoQvH4&t=3997s',
        },
        {
            'subTopicName': 'Attaining Vastu‑siddhi through Rāgānugā sādhanā. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NGb3avTZOLw&t=5540s',
        },
        {
            'subTopicName': 'Role of Śrī Caitanya Mahāprabhu in the development of Rāgānugā-bhakti. (30 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=lC3mZpoQvH4&t=5082s',
        },
    ],
    ['Siddhānta-Vicāra']: [
        {
            'subTopicName': 'Connection between faith and intelligence. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/qFWjzQepoLI?si=lQ2Y0VW8bWoeNOku&t=4661',
        },
        {
            'subTopicName': 'Can someone really fall down from Brahma-jyoti? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/NqB3cD-nCHc?si=odBNNE8mTZK0JKcu&t=1242',
        },
        {
            'subTopicName': 'Even in the gradual path for liberation—bhakti is eternal. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/NqB3cD-nCHc?si=tHllqN-wgpDS8U1C&t=2111',
        },
        {
            'subTopicName': 'Two categories of materialists who do not follow the scriptural conclusions. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/NqB3cD-nCHc?si=7_NzgTw75UqkNasr&t=3325',
        },
        {
            'subTopicName': 'Is varṇa exclusively dependent on guṇa and karma and not birth? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/rpTraKYLpxk?si=Ya0NR5I0TTnW9nDH&t=6112',
        },
        {
            'subTopicName': 'Understanding aprārabdha-karma. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/oS0p9mqBkos?si=FRexEOdFTDkdma-M&t=5690',
        },
        {
            'subTopicName': 'Only bhakti is beyond three modes. Even the act of offering the fruits of karma to the Lord is in sattva-guṇa only. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=88YXmGfVQOueJOpC&t=5119',
        },
        {
            'subTopicName': 'How the three modes affect one\'s faith and conditioning? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=wpYFZsspyCIsR7p3&t=6487',
        },
        {
            'subTopicName': 'Those aspiring for liberation worship only Viṣṇu. (10 min)',
            'youtubeLink': 'https://youtu.be/_dliWlv7I9E?si=U-Np0ezjMg7zEa6_&t=1516',
        },
        {
            'subTopicName': 'Why māyā is compared to a witch? (7 min)',
            'youtubeLink': 'https://youtu.be/3ztcrGVEAoM?si=ozpg2qXJZNe0mFNX&t=1729',
        },
        {
            'subTopicName': 'Do Jaya and Vijaya fall down every day of Brahmā? (20 min)',
            'youtubeLink': 'https://youtu.be/VUYNDynSZw0?si=aY7ObSmscxxyefOW&t=1295',
        },
        {
            'subTopicName': 'Why Hiraṇyakaśipu and Rāvaṇa did not attain sāyujya-mukti. (13 min)',
            'youtubeLink': 'https://youtu.be/VUYNDynSZw0?si=Pw7eNfiU5TVHJKF2&t=2392',
        },
        {
            'subTopicName': 'How did Śiśupāla attain liberation? (4 min)',
            'youtubeLink': 'https://youtu.be/VUYNDynSZw0?si=wh6SeYLsVZaDCM7A&t=3179',
        },
        {
            'subTopicName': 'Why didn\'t Dhruva just ask for the lap of his father? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=dT3VQz9jKVxu65Jd&t=1141',
        },
        {
            'subTopicName': 'Is Oṁ mantra allowed for persons without the Upanayana-saṁskāra? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=6VrJxMxVjeRnpoUr&t=3283',
        },
        {
            'subTopicName': 'Is Dhruva a mixed devotee or a pure devotee? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=Q9hcrOOgSRe9JZNV&t=3817',
        },
        {
            'subTopicName': 'Who was the real cause of Dhruva\'s suffering? His mind or Mother Suruci\'s actions? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=8-QmBpGMEehRgtsU&t=4297',
        },
        {
            'subTopicName': 'Would Dhruva Mahārāja have achieved the same success if he had accepted the abuse just like Avanti Brāhmaṇa did and stayed back home? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=qMkZHSHbS9yVTUxW&t=4854',
        },
        {
            'subTopicName': 'Is sukṛti needed to practice karma and jñāna also? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=JNZopWuQoKuzkgTG&t=5202',
        },
        {
            'subTopicName': 'Different definitions of niyamāgraha. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/6iHGvdhIQT0?si=rlialyNHMcQajh2w&t=146',
        },
        {
            'subTopicName': 'The śāstras say that one name of Lord Rāma is equivalent to 1,000 names of Lord Viṣṇu, and one name of Lord Kṛṣṇa is equivalent to three names of Lord Rāma. Can we use such statements to convert the worshippers of Lord Nārāyaṇa and Lord Rāma into worshippers of Lord Kṛṣṇa? (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/T8_KihNeqEk?si=oITtmDKw2P9_-OzK&t=2184',
        },
        {
            'subTopicName': 'Understanding who is in false ego. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/NMWhuFTL4Yc?si=wFffrLg45h6cqdJW&t=910',
        },
        {
            'subTopicName': 'Karma is not reconciled by revenge - Part 1. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/FvsXHHtEyvw?si=e-2Y4HvPkCHfyy57&t=192',
        },
        {
            'subTopicName': 'Karma is not reconciled by revenge - Part 2. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/FvsXHHtEyvw?si=GXBLCqkF4ZXmuzY9&t=3289',
        },
        {
            'subTopicName': 'Karma is not reconciled by revenge - Part 3. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/FvsXHHtEyvw?si=zvF3R3iNjnZrgOfi&t=3785',
        },
        {
            'subTopicName': 'Karma is not reconciled by revenge - Part 4. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/FvsXHHtEyvw?si=cbJZMZWz6zQt1Xw7&t=4166',
        },
        {
            'subTopicName': 'Mercy vs. Justice - Part 1. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/6B1MpBJTU64?si=UQuVIssadxTsN1GQ&t=3297',
        },
        {
            'subTopicName': 'Mercy vs. Justice - Part 2. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/6B1MpBJTU64?si=yco1CAjF4BG1yVKJ&t=4214',
        },
        {
            'subTopicName': 'Mercy vs. Justice - Part 3. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/6B1MpBJTU64?si=YNx0_gYTTLntsxkX&t=4852',
        },
        {
            'subTopicName': 'What is the source of avidyā or illusion? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/oBSNCs_mTDw?si=7octO22dPYzGEqc8&t=690',
        },
        {
            'subTopicName': 'Bad or good depends on perception. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/oBSNCs_mTDw?si=GVtuyOFhDC2bBvNB&t=808',
        },
        {
            'subTopicName': 'How does conscious material energy, Durgā, not know about herself? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/oBSNCs_mTDw?si=fJqyWXKvxB5AAyZk&t=906',
        },
        {
            'subTopicName': 'By what potency does the insignificant jīva get empowered to control the pradhāna aspect of prakṛti? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/qwr6qQ50sZc?si=AE7A6g0GW8VV6YbP&t=671',
        },
        {
            'subTopicName': 'Can the Supreme Lord be understood by material logic? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/qwr6qQ50sZc?si=j7EhxGeGRs_CvFn-&t=740',
        },
        {
            'subTopicName': 'Stages of succumbing to sense gratification. (26 min)',
            'youtubeLink': 'https://youtu.be/6RuUs5AEXrQ?si=G12DZV6WUJ9e8QGn&t=3517',
        },
        {
            'subTopicName': 'Scriptural instructions are according to the qualifications of the recipient. (15 min)',
            'youtubeLink': 'https://youtu.be/OwTewOcAxQ4?si=p99npkNirqIzdzji&t=616',
        },
        {
            'subTopicName': 'Who is a true karma-sannyāsī? (12 min)',
            'youtubeLink': 'https://youtu.be/OwTewOcAxQ4?si=4xypFdaJJJBgmV_8&t=1533',
        },
        {
            'subTopicName': 'Sannyāsa in Kṛṣṇa consciousness. (8 min)',
            'youtubeLink': 'https://youtu.be/OwTewOcAxQ4?si=rWS7GjDTEKufekOX&t=3184',
        },
        {
            'subTopicName': 'Dangers of premature karma-sannyāsa. (9 min)',
            'youtubeLink': 'https://youtu.be/OwTewOcAxQ4?si=6niPz1vChWTmpLio&t=3907',
        },
        {
            'subTopicName': 'All about sannyāsa. (90 min)',
            'youtubeLink': 'https://youtu.be/OwTewOcAxQ4?si=LDFC7Ebw5Ao26lPr',
        },
        {
            'subTopicName': 'Are Bhakti-śāstras only for leaving, and do we need other śāstras for living? (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/9wpou6exh9Q?si=UfrkLnLmWhQOzwwJ&t=2456',
        },
        {
            'subTopicName': 'Contrasting the perfected stage of the jñānīs with that of the devotees. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/RTepF-Dr4NI?si=rRIzp57Hk7Xo2VA8&t=6282',
        },
        {
            'subTopicName': 'Contrasting deha-dharma with jaiva-dharma? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/EqXFFJ8I7h8?si=jsqxGQUN8ve1sICj&t=1881',
        },
        {
            'subTopicName': 'If bhakti is for Bhagavān only, then how to understand the descriptions of Brahman and Paramātmā features? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/0yNfiUCQnVg?si=5kzgqi1YkjR0_iql&t=4179',
        },
        {
            'subTopicName': 'What are yuga-sandhyās? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/AfxpAnkX-t4?si=hd4EaQ7ilGHYGudn&t=1330',
        },
        {
            'subTopicName': 'Should we fear mahā-māyā or our own svabhāva? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/kHDK6F33peg?si=rJmJFklv8yhObU3V&t=5161',
        },
        {
            'subTopicName': 'What is the connection between karma, svabhāva and vāsanās? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/kHDK6F33peg?si=gocCgZ-ZYylBn-wP&t=5830',
        },
        {
            'subTopicName': 'Why should ISKCON be restricted only to those who are aspiring for pure devotion? (4 min)',
            'youtubeLink': 'https://youtu.be/XYTw8SXHw_4?si=U-MA5zhvxnfuAppS&t=4034',
        },
        {
            'subTopicName': 'How will the degraded people of Kali-yuga be suddenly qualified to take birth in the next Satya-yuga? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/LBVwqJ_X7Eo?si=4jf7QHCUlrijvBOs&t=3486',
        },
        {
            'subTopicName': 'Are all jīvas śūdras in the age of Kali? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/PB7OSn9s3hE?si=ZY1PQu5n8R1RMIMg&t=3911',
        },
        {
            'subTopicName': 'How one identifies with body or mind? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/PB7OSn9s3hE?si=pmLBtFMD2wpnKIhi&t=4119',
        },
        {
            'subTopicName': 'The soul suffers due to false identification with the mind. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/kLsjHJ_fMeI?si=ky3bS9wJoQNiE7We&t=1202',
        },
        {
            'subTopicName': 'What is faith? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/hCBc7QObMig?si=asJCxGtDBKbnWzEz&t=4104',
        },
        {
            'subTopicName': 'Three levels of consciousness. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/hCBc7QObMig?si=Wden4WOs_C1rjPRy&t=6736',
        },
        {
            'subTopicName': 'How can we make our senses alive? (8 min)',
            'youtubeLink': 'https://youtu.be/0XI0basB3aI?si=lnGAfp3fAmtJChrP&t=1208',
        },
        {
            'subTopicName': 'What are the factors that contribute to the learning process? (11 min)',
            'youtubeLink': 'https://youtu.be/0XI0basB3aI?si=ILxJAirjjZOkN2fQ&t=3703',
        },
        {
            'subTopicName': 'Are the many universes the same size or different sizes? Are all the universes created and destroyed at the same time or different times? (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/7lfELjXi5wQ?si=0g33OEKBe1R70-67&t=3259',
        },
        {
            'subTopicName': 'Material emotions are temporary. (6 min)',
            'youtubeLink': 'https://youtu.be/PLuBQKhg2G0?si=G8W5Wrn_JRj6RiqD&t=879',
        },
        {
            'subTopicName': 'Body-soul relationship is an illusion created by the avidyā potency of Māyā. (4 min)',
            'youtubeLink': 'https://youtu.be/a3DqrSqPnp0?si=fxaX9tjU4PCiW65c&t=710',
        },
        {
            'subTopicName': 'Is Kṛṣṇa\'s form like human form or is human form like Kṛṣṇa\'s? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/nb7gHrc5kUQ?si=DzDN6CLvYFLzH6Xq&t=2918',
        },
        {
            'subTopicName': 'How to understand how much of our attachment to Kṛṣṇa is based on our conditioning and how much of it is substantial in nature? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/wA-GpgZ-J4c?si=ybllOEzbJzXLepcV&t=3887',
        },
        {
            'subTopicName': 'Isn\'t it a paradox that the deity form is composed of matter yet it is spiritual? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/27pSPzF12rQ?si=B3u70U_gYL2rMYrL&t=4951',
        },
        {
            'subTopicName': 'Are Brahmā, Viṣṇu, Śiva non-different? (6 min)',
            'youtubeLink': 'https://youtu.be/nF_ap_I_3j8?si=wxjrEu-4YX45ph5d&t=932',
        },
        {
            'subTopicName': 'Rights and responsibilities of Speaker and Hearer. (3 min)',
            'youtubeLink': 'https://youtu.be/Y6RgX079_h0?si=USEmR_6935U4QPCr&t=2224',
        },
        {
            'subTopicName': 'What is higher: śānta-rati or Sālōkya? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/yGOBaKMgyn0?si=nVQLzMH3fVhRrE5B&t=3540',
        },
        {
            'subTopicName': 'Two types of Brahma-jñāna with example. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/yGOBaKMgyn0?si=x8W_oLmnuLsx8P-y&t=3647',
        },
        {
            'subTopicName': 'Can Śabda (Scriptures) be rejected if it\'s contrary to Pratyakṣa Pramāṇa (Experience)? (24 min)',
            'youtubeLink': 'https://www.youtube.com/live/CVxfCTV6O2g?si=41EGNzRYhhfOFWCW&t=723',
        },
        {
            'subTopicName': 'Roles of Yogamāyā and Mahāmāyā. (25 min)',
            'youtubeLink': 'https://www.youtube.com/live/kHDK6F33peg?si=nCxnimUQliw8eJhn&t=409',
        },
        {
            'subTopicName': 'Difference between aṅgas and pārṣadas. (2 min)',
            'youtubeLink': 'https://youtu.be/Fx52lBy6RO4?si=zvIOfH9Ug5I2d160&t=988',
        },
        {
            'subTopicName': '8 pramāṇas condensed into 3. (30 min)',
            'youtubeLink': 'https://youtu.be/Fx52lBy6RO4?si=93N_ns4fdZGfd1ZD&t=1484',
        },
        {
            'subTopicName': 'Śabda is the most trustworthy Pramāṇa. (14 min)',
            'youtubeLink': 'https://youtu.be/btMcUFp30_w?si=faVErqchRm2OqjeB&t=1899',
        },
        {
            'subTopicName': 'Śakti pariṇāmavāda explained. (6 min)',
            'youtubeLink': 'https://youtu.be/2cggtuiu7Jk?si=pKZzEULyLEegl5Ln&t=2433',
        },
        {
            'subTopicName': 'Superiority of Śabda-pramāṇa over anumāna. (20 min)',
            'youtubeLink': 'https://youtu.be/btMcUFp30_w?si=60pZKZB6tnzXlRXI&t=981',
        },
        {
            'subTopicName': 'Nārāyaṇa and Kṛṣṇa are Supreme from 2 different perspectives. (50 min)',
            'youtubeLink': 'https://youtu.be/wT5NU2fci7M?si=M2olh-4SIA-g2ptC&t=240',
        },
        {
            'subTopicName': 'Understanding Sambandha, Abhideya, Prayojana jñāna. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/WgQ0Dd29wJ4?si=bS6ER7K-edIgc_-E&t=4418',
        },
        {
            'subTopicName': 'Sometimes even after reading scriptures, people do not accept pure devotional service. Are they exercising their free will or acting under modes of material nature? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=yfuzWHHVRoU&t=1664s',
        },
        {
            'subTopicName': 'Difference and similarity between sādhana-sādhya and abhidheya-prayojana. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rnLOb76ko0A&t=1200s',
        },
        {
            'subTopicName': 'Kṛṣṇa and perfected devotees have spiritual bodies. (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=c-sRV5wM-7c&t=2658s',
        },
        {
            'subTopicName': 'Does one always take birth after death? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=c-sRV5wM-7c&t=3705s',
        },
        {
            'subTopicName': 'Various definitions of Vaiṣṇavas from śāstras. (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2Y7OJqc-9Eo&t=2100s',
        },
        {
            'subTopicName': 'Is second initiation essential for every sādhaka? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/WvuXneSOLmU?si=mvyX3OH9JwWEKnzv&t=2910',
        },
        {
            'subTopicName': 'Why is śikṣā given more emphasis than dīkṣā in our sampradāya? (16 min)',
            'youtubeLink': 'https://www.youtube.com/live/WvuXneSOLmU?si=J1N0_V7N4x9xYVsN&t=3220',
        },
        {
            'subTopicName': 'Why is there so much emphasis on vaidhi-bhakti in our sampradāya when our goal is rāgānugā-bhakti? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/WvuXneSOLmU?si=RRW-bxYKgtIq70L1&t=4160',
        },
        {
            'subTopicName': 'Understanding falldown from brahma-jyoti. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/-4fWZa3IqS8?si=2Sv0CnzcCSR-3Msy&t=2947',
        },
        {
            'subTopicName': 'How to understand an initiated devotee not chanting but engaged in Kṛṣṇa-kathā? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/h0AL964D8mU?si=XUE08-cv5A6BaD2A&t=3512',
        },
        {
            'subTopicName': 'Is everything predestined in one\'s life? (26 min)',
            'youtubeLink': 'https://www.youtube.com/live/9VzQoyr1xZQ?si=u3AvKhkD77RoVQ64&t=982',
        },
        {
            'subTopicName': 'Why do we study scriptures when serving a guru is sufficient? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/KWzzpMq-mNI?si=xcw1oqU1HepkPIar&t=3638',
        },
        {
            'subTopicName': 'Five symptoms of intelligence. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/5enwGJglbhg?si=mRlY8BVYjLz6ZRqW&t=474',
        },
        {
            'subTopicName': 'What is it that truly pacifies the ātmā? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/jv3_D9sAtgQ?si=e2LwePcBucQ_lCex&t=1733',
        },
        {
            'subTopicName': 'The thankless job of Mahā-māyā. (21 min)',
            'youtubeLink': 'https://www.youtube.com/live/b9-RAq6Fhug?si=N9kJbvFbBRa62m_N&t=1669',
        },
        {
            'subTopicName': 'What is laukikī-śraddhā (sentimental faith)? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/Wl3Begp2hTg?si=qIGNilznPLX5oZvx&t=2371',
        },
        {
            'subTopicName': 'Understanding the nature of things leads to pacification of the mind. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/qSEYXVoQvp0?si=57HFVAq4zufSzEhE&t=1564',
        },
        {
            'subTopicName': 'Who will decide the conclusions about the Absolute Truth when different people have different opinions? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/dDFWGaCRpFk?si=w5_6fdRLaaLv-bZR&t=705',
        },
        {
            'subTopicName': 'Two understandings about Pṛśni and Sutapā. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/dDFWGaCRpFk?si=ZM79e7ZimZ-RB2qa&t=3859',
        },
        {
            'subTopicName': 'What’s the cause of the Pāṇḍavas’ suffering all the time? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/dDFWGaCRpFk?si=3NvIrYj2cB74rxRj&t=3925',
        },
        {
            'subTopicName': 'What is the cause of suffering? Is it due to the influence of time or mind? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/0QR_Myj46uI?si=yvzA0LoKmcv3_nBm&t=3628',
        },
        {
            'subTopicName': 'Three qualities of karmic suffering. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/YFxqYGzfQIk?si=rtv8bcho-IgF4VrV&t=2308',
        },
        {
            'subTopicName': 'Real vairāgya doesn’t bring regret, but joy. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/8ZbccLoQKNk?si=UmTnJfZsfLKXplmg&t=4139',
        },
        {
            'subTopicName': 'Regret vs. dejection — are they both the same? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/EH2m21SEr2A?si=Dld0Lxs0Ztkivy_Z&t=1346',
        },
        {
            'subTopicName': 'Kṛṣṇa reciprocates with your voice and not with the voice of your conditioning. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/EH2m21SEr2A?si=IDw2uJMtwmn6lo5N&t=3900',
        },
        {
            'subTopicName': 'Are all kinds of prasādam the same? (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/EH2m21SEr2A?si=wyOv35dOjh5DqQxZ&t=5245',
        },
        {
            'subTopicName': 'Can demigods cause trouble to a devotee independent of Kṛṣṇa’s desire? (8 min)',
            'youtubeLink': 'https://youtu.be/N-4rcvYqYjU?t=483',
        },
        {
            'subTopicName': 'What’s the destination of the decision-makers and the soldiers fighting a war? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/kUSzNWc62Lw?si=wQuLHJylcd5Big26&t=3665',
        },
        {
            'subTopicName': 'What’s the difference between the Lord using a pure devotee vs. a sādhaka vs. a materialist as a karmic instrument? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/kUSzNWc62Lw?si=-hWWiWCVuQNMJIU5&t=4862',
        },
        {
            'subTopicName': 'How does a recipient of karma and an executor of action see the \'law of karma\'? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/Zh6Z16dGsBA?si=izg2o_9XgeA-khwB&t=1618',
        },
        {
            'subTopicName': 'Do we serve people in this life because of debts we owed them in previous lives? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/jb_TeDKfY1c?si=nay4uSn6PHw6QsaC&t=3334',
        },
        {
            'subTopicName': 'Mind’s surrender to the senses in 4 stages and the intelligence’s surrender to the mind in 3 stages — how does it happen? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/Q9si4U-CjFE?si=8ONn6f1gXIvW1k4Q&t=1078',
        },
        {
            'subTopicName': 'Thinking, feeling and willing are the actions of the mind — what is the pramāṇa for this? (24 min)',
            'youtubeLink': 'https://www.youtube.com/live/Q9si4U-CjFE?si=R-uleIGkf-7r_t0x&t=3269',
        },
        {
            'subTopicName': 'Absorption in hearing kicks out all logic. (13 min)',
            'youtubeLink': 'https://youtu.be/NA7UEU7qFyM?si=OICPui5TJzPY7Ga7&t=3181',
        },
        {
            'subTopicName': 'Is there fear of uncertainty in Svarga? (3 min)',
            'youtubeLink': 'https://youtu.be/-D3wC31dFY4?si=dFRTfbjUiXZJIUXA&t=2968',
        },
        {
            'subTopicName': 'Why are the residents of Svarga called amara? (3 min)',
            'youtubeLink': 'https://youtu.be/-D3wC31dFY4?si=ToDrwCC48jZnI54D&t=2468',
        },
        {
            'subTopicName': 'Why does Indra, in spite of serving the Lord personally, commit offenses? (3 min)',
            'youtubeLink': 'https://youtu.be/nQ0mLXBs-qQ?si=607UQNr2HZrfRuxb&t=1802',
        },
        {
            'subTopicName': 'Can bhakti be performed only in Bhūloka? (5 min)',
            'youtubeLink': 'https://youtu.be/48HdPQhxDeU?si=BDBqRFHxL24QAmuT&t=4533',
        },
        {
            'subTopicName': 'Is arcirādi-mārga for pure bhakti sādhakas also? (10 min)',
            'youtubeLink': 'https://youtu.be/48HdPQhxDeU?si=i2BCKXJ2NtHblZYm&t=4802',
        },
        {
            'subTopicName': 'Where do the residents of Tapoloka go after mahā-pralaya? (3 min)',
            'youtubeLink': 'https://youtu.be/rxhJRuANck4?si=wv2bAN5cWzVKvo--&t=2977',
        },
        {
            'subTopicName': 'Different natures of faith inspire different spiritual desires. (10 min)',
            'youtubeLink': 'https://youtu.be/rxhJRuANck4?si=IgHns8WVRqfo350g&t=3249',
        },
        {
            'subTopicName': 'Why did Śaṅkarācārya propagate Māyāvāda if his purpose was to establish the authority of the Vedas? (10 min)',
            'youtubeLink': 'https://youtu.be/iK1f7f656gw?si=ufylmq-XxN8REBBG&t=621',
        },
        {
            'subTopicName': 'Is service a bliss or a burden? Who is responsible for one’s experience during service? (5 min)',
            'youtubeLink': 'https://youtu.be/pHt86Ovi0KU?si=OFD-Yet8rVFrWgfx&t=2875',
        },
        {
            'subTopicName': 'Three kinds of debts for a conditioned soul. (3 min)',
            'youtubeLink': 'https://youtu.be/EyXn8RUP27E?si=tJzImbjeW_qhKDTz&t=1551',
        },
        {
            'subTopicName': 'Role of Mahāmāyā and Yogamāyā for practicing devotees, non-devotees, and perfected devotees. (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/kHDK6F33peg?si=KvuNuxcKOLQhfLAk&t=3594',
        },
        {
            'subTopicName': 'Three meanings of karma: action, reaction, and karma-vāsanās (stimuli). (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/kHDK6F33peg?si=qMtllPHdmsP5V8En&t=5828',
        },
        {
            'subTopicName': 'Connection between knowledge and faith. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/I3hqjQ5Poo0?si=wMz4bXJ3GU9syAE_&t=1652',
        },
        {
            'subTopicName': 'To constantly see good and bad is itself a bad quality. The best quality is to transcend material good and evil. (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/V7a_GUrftQs?si=xhPyhqQzdpH8S6pO&t=970',
        },
        {
            'subTopicName': 'Is the verse yasyāsti bhaktir correct? Why then do I see bad qualities in devotees and good qualities in non-devotees? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/o1RMd5y0H30?si=xc1-Zfl7U8Bg6z4P&t=1395',
        },
        {
            'subTopicName': 'How does the soul get affected by the sufferings of the subtle and gross body? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/kLsjHJ_fMeI?si=kqSe0V4DosPNKkUl&t=1611',
        },
        {
            'subTopicName': 'If the Absolute Truth is multi‑faceted, are the Māyāvādīs also right in their understanding of the Absolute Truth? (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/pOqEe9h4uBM?si=Bj9gTP0brwpDN3YX&t=2234',
        },
        {
            'subTopicName': 'There is no guarantee that a devotee will take birth in a devotee family. (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/TNeLuClc1oI?si=aF3oOZwLNM4cruTa&t=1400',
        },
        {
            'subTopicName': 'Vyāsadeva sometimes presents incomplete realizations of other sages. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/Oojw4x1Jx6c?si=MRWNKXT3xi6bwj0h&t=2400',
        },
        {
            'subTopicName': 'Similarity between matter and spirit. (28 min)',
            'youtubeLink': 'https://youtu.be/EYaZ2XSLwts?si=afNzIrybW2wZZHzo&t=1525',
        },
        {
            'subTopicName': 'Nārada‑Muni’s journey to find out the condensed essence of Kṛṣṇa’s mercy. (8 min)',
            'youtubeLink': 'https://youtu.be/JrMQzTlp4iE?si=S5fWqsvF5sqFKOHe&t=964',
        },
        {
            'subTopicName': 'Why is the term “brāhmaṇa initiation” a misnomer? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/M_xhQVZancA?si=NC0RtCQyU53qP-iY&t=1376',
        },
        {
            'subTopicName': 'Is the second initiation for women not according to śāstras? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/M_xhQVZancA?si=qv0gvgJQwDAT-Vq_&t=1765',
        },
        {
            'subTopicName': 'Is second initiation only given for the purpose of deity service in temples? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/M_xhQVZancA?si=2lV3ZWRmLst9Ydou&t=2337',
        },
        {
            'subTopicName': 'Methods to approach the Lord. (24 min)',
            'youtubeLink': 'https://www.youtube.com/live/qLMa8Wg7y2s?si=kFc0KLr8Bxe3roLf&t=3495',
        },
        {
            'subTopicName': 'What is the purpose behind Śrīpāda Śaṅkarācārya preaching māyāvāda? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/BNZEyBCkLWM?si=mqfAupM6wnXwTwQY&t=3000',
        },
        {
            'subTopicName': 'How can other countries/religions know nitya‑dharma of jīva without knowing the Supreme Lord? (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/BNZEyBCkLWM?si=GRh2QuVqITgYn9o5&t=4432',
        },
        {
            'subTopicName': 'Can one use logic in explaining spiritual topics? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/jouVi4pU3Xk?si=cLBR8s5VLDFrkdYg&t=5016',
        },
        {
            'subTopicName': 'Differences in explanations of BG 9.27 yad karoṣi verse by Śrīla Viśvanātha Cakravartī Ṭhākura and Śrīla Jīva Gosvāmī. (21 min)',
            'youtubeLink': 'https://www.youtube.com/live/OzAAIvrhzgs?si=iLdG2BeqWg4JOn4f&t=1770',
        },
        {
            'subTopicName': 'Sight of genuine repentance in the wrong‑doer minimizes the idea of punishment in the receiver. (5 min)',
            'youtubeLink': 'https://youtu.be/6LEHjUWzmFU?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=2480',
        },
        {
            'subTopicName': 'Does knowledge of the ‘Law of Karma’ make us hard‑hearted? (5 min)',
            'youtubeLink': 'https://youtu.be/6LEHjUWzmFU?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=4023',
        },
        {
            'subTopicName': 'Does the ‘Law of Karma’ apply only to human beings in Bhārata‑varṣa? (2 min)',
            'youtubeLink': 'https://youtu.be/6LEHjUWzmFU?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=4478',
        },
        {
            'subTopicName': 'Does avoiding the sixth offence to the Holy Name (śruti‑śāstra‑ninda­naṁ) mean that everybody should follow all the Śāstras? How should leaders deal with this principle? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=d612rQHHUeM&list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&index=64&t=1230s',
        },
        {
            'subTopicName': 'Is one’s birth random or do guṇa/karma have a role to play in one’s birth too? (15 min)',
            'youtubeLink': 'https://youtu.be/P8PHNxanbxU?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=1701',
        },
        {
            'subTopicName': 'Under what conditions will a karma‑kāṇḍīya yājña be unsuccessful? (6 min)',
            'youtubeLink': 'https://youtu.be/P8PHNxanbxU?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=2992',
        },
        {
            'subTopicName': 'How do we understand Pṛthu Mahārāja coming out of the churning of the right hand of Vena? (6 min)',
            'youtubeLink': 'https://youtu.be/YacS18Q0dDI?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=3758',
        },
        {
            'subTopicName': 'Does the phrase ‘kalau śūdra‑sambhavāḥ’ mean that everybody in Kali‑yuga is actually born a śūdra? (9 min)',
            'youtubeLink': 'https://youtu.be/YacS18Q0dDI?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=4190',
        },
        {
            'subTopicName': 'How can we understand the Supreme Lord appearing in Aṅga’s sacrifice and yet Aṅga getting a wretched Vena as his son? (5 min)',
            'youtubeLink': 'https://youtu.be/zDVpPn3Gt_I?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=3230',
        },
        {
            'subTopicName': 'Do preachers of Kṛṣṇa Consciousness enter the karmic bubble of the people they preach to and get influenced? (4 min)',
            'youtubeLink': 'https://youtu.be/zmbxeCag-RI?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=5020',
        },
        {
            'subTopicName': 'Suppressing kāma without sufficient purification results in hard‑heartedness. (4 min)',
            'youtubeLink': 'https://youtu.be/gepFnz2QEtw?si=kQC2eRb9kAQwgKL7&t=1705',
        },
        {
            'subTopicName': 'Effect of fasting on the karmendriyas and the jñānendriyas. (3 min)',
            'youtubeLink': 'https://youtu.be/gepFnz2QEtw?si=o-mRyd6yLG-JiuCQ&t=3475',
        },
        {
            'subTopicName': 'Engaging the senses with sense objects does not cause agitation when the mind is controlled by the intelligence and not by the senses. (3 min)',
            'youtubeLink': 'https://youtu.be/6RuUs5AEXrQ?si=jQt0DGe5rZ8d2hJZ&t=4873',
        },
        {
            'subTopicName': 'The intelligence is stolen by the mind when the mind is controlled by the senses. (6 min)',
            'youtubeLink': 'https://youtu.be/6RuUs5AEXrQ?si=kZThYk6CqigM47_l&t=4007',
        },
        {
            'subTopicName': 'Seeing the Lord within and without. (6 min)',
            'youtubeLink': 'https://youtu.be/F_OCV4HdUY0?si=hLdfw_xPLWS5Tu7r&t=1137',
        },
        {
            'subTopicName': 'Are Maharloka residents more elevated than residents of Tapoloka? (12 min)',
            'youtubeLink': 'https://youtu.be/F_OCV4HdUY0?si=bEIHV_O1P4_hQeTP&t=2477',
        },
        {
            'subTopicName': 'Do we perceive objects with our gross senses, subtle senses or mind? (15 min)',
            'youtubeLink': 'https://youtu.be/g2YjiFKKKfs?si=S4LDDvEjL7YEiT6L&t=2010',
        },
        {
            'subTopicName': 'How is the mind’s functioning different from jñānendriyas and karmendriyas? (4 min)',
            'youtubeLink': 'https://youtu.be/g2YjiFKKKfs?si=blBSoz0ftfRDekFn&t=2894',
        },
        {
            'subTopicName': 'What does it mean to see the Lord with purified senses? (4 min)',
            'youtubeLink': 'https://youtu.be/g2YjiFKKKfs?si=_CHXbruFa1m8jfty&t=3151',
        },
        {
            'subTopicName': 'What devotees and demons experience seeing the form of the Lord? (4 min)',
            'youtubeLink': 'https://youtu.be/2uDMb-wElLE?si=HMDGG_bsWh2ulqBK&t=912',
        },
        {
            'subTopicName': 'Understanding the lokasaṅgraha‑dharma. (12 min)',
            'youtubeLink': 'https://youtu.be/VtforV3hH34?si=UDSfkzkDKiwoP0es&t=4545',
        },
        {
            'subTopicName': 'How can the śāstras indicate that, at one time, various events of different times occurred? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/M5LIRVZVMVA?si=oj7tTNC6ERCRxV1U&t=4695',
        },
        {
            'subTopicName': 'Spirit has gradations just like matter has. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/K_sLYVaKqnQ?si=dp8ThXuJ1DXVfrYb&t=2486',
        },
        {
            'subTopicName': 'How śabda‑pramāṇa depends on pratyakṣa‑pramāṇa? (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/G9YQFheuJUo?si=8rWYgvzEw0H8qU4n&t=2627',
        },
        {
            'subTopicName': 'Is Vaiṣṇavism monotheistic or polytheistic? (16 min)',
            'youtubeLink': 'https://youtu.be/AItRTbL-XwU?si=SE71Cd9CvD1cTey5&t=985',
        },
        {
            'subTopicName': 'The way you live is the way you leave! (7 min)',
            'youtubeLink': 'https://youtu.be/lApvtNPj6to?si=0HpRpsyogajumgxT&t=784',
        },
        {
            'subTopicName': 'Backbone of both spiritual and mundane knowledge: faith. (44 min)',
            'youtubeLink': 'https://youtu.be/lMWmy5UvqCE?si=jRvkMpanSuEWJQR_&t=571',
        },
        {
            'subTopicName': 'What are the characteristics of this universe (yad rūpam)? (2 min)',
            'youtubeLink': 'https://youtu.be/bdoGT9uFotM?si=_9wJ17rMj6Pc09a8&t=845',
        },
        {
            'subTopicName': 'What is the shelter of this universe (yad adhiṣṭhānaṁ)? (2 min)',
            'youtubeLink': 'https://youtu.be/bdoGT9uFotM?si=AvORZkZOj7O41r1J&t=1083',
        },
        {
            'subTopicName': 'How does this material creation manifest (yataḥ sṛṣṭam)? (5 min)',
            'youtubeLink': 'https://youtu.be/bdoGT9uFotM?si=OlBtGVuoDreKbWSY&t=1219',
        },
        {
            'subTopicName': 'Into whom does this material creation merge at the time of dissolution (yat saṁsthāṁ)? (2 min)',
            'youtubeLink': 'https://youtu.be/bdoGT9uFotM?si=Chzc-nuvE1ZO7oDB&t=1510',
        },
        {
            'subTopicName': 'Who is the ultimate controller of this universe (yat paraṁ)? (2 min)',
            'youtubeLink': 'https://youtu.be/bdoGT9uFotM?si=hcw3jpipCvy5N0yF&t=1595',
        },
        {
            'subTopicName': 'What is this universe constitutionally composed of (yat ca)? (10 min)',
            'youtubeLink': 'https://youtu.be/bdoGT9uFotM?si=B511rrDM16LpCMvr&t=1671',
        },
        {
            'subTopicName': 'What actually is the distinction between divine and demoniac personalities? (7 min)',
            'youtubeLink': 'https://youtu.be/bdoGT9uFotM?si=AoDNlHZaJlFmLuBo&t=2590',
        },
        {
            'subTopicName': 'What are material vibhūtis and the importance of understanding the vibhūtis of the Lord. (22 min)',
            'youtubeLink': 'https://youtu.be/gZzy9wAssuA?si=67RQjzELIETriR9l&t=2469',
        },
        {
            'subTopicName': 'Difference between knowing, understanding, and realizing. (10 min)',
            'youtubeLink': 'https://youtu.be/kTrXcDsUOyU?si=bznK729JpFDzF4Ds&t=4652',
        },
        {
            'subTopicName': 'How do we correctly understand the divine and the demoniac qualities in a practicing devotee and a person like Kaṁsa. (10 min)',
            'youtubeLink': 'https://youtu.be/kTrXcDsUOyU?si=2KiT2tiprN-C0bMA&t=6061',
        },
        {
            'subTopicName': 'Real cause of suffering: destiny or mind? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/zZWqKGRgMGw?si=VQ6bGUqZEorx5rU_&t=6004',
        },
        {
            'subTopicName': 'The two types of demons. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/lxUigu7wOeQ?si=YIAZRtVwl8guc5lL&t=1865',
        },
        {
            'subTopicName': 'Understanding ‑loka‑saṅgraha‑karma according to the teachings of the ācāryas. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/V7kbwG5dWJI?si=Ev6I1BssDtvS7Wqk&t=1626',
        },
        {
            'subTopicName': 'Will the chanting of Hare Kṛṣṇa mahā‑mantra nourish our bhakti to other forms of Lord Kṛṣṇa like Lord Rāma or Lord Nṛsiṁha? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/Fj7DzcIWN64?si=vcy0pcY-i3J3VM4N&t=4087',
        },
        {
            'subTopicName': 'Bhārata‑varṣa is not India. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/T7MOMdCA690?si=Z8DJu-NEcFxKZwoY&t=1557',
        },
        {
            'subTopicName': 'God‑realization according to ripened consciousness. (12 min)',
            'youtubeLink': 'https://youtu.be/8vGPaD7TCHU?si=v0LjkMJpVa903nx-&t=3200',
        },
        {
            'subTopicName': 'True and faulty knowledge. (30 min)',
            'youtubeLink': 'https://youtu.be/8vGPaD7TCHU?si=2XD6VdzPcBT_nP8P&t=3941',
        },
        {
            'subTopicName': 'Primary and secondary dharma. (30 min)',
            'youtubeLink': 'https://youtu.be/_wrlUjnpmmI?si=PManmQqbeV-GCiBM&t=1993',
        },
        {
            'subTopicName': 'What is sambandha‑jñāna? (17 min)',
            'youtubeLink': 'https://youtu.be/E-F-FbtvVaQ?si=xCGVG2RGhJ3et-qx&t=4634',
        },
        {
            'subTopicName': 'Object of worship depends on level of sukr̥ti. (11 min)',
            'youtubeLink': 'https://youtu.be/mEKJVfw9Sg8?si=Wn4BSETHmZT278fe&t=2940',
        },
        {
            'subTopicName': 'Understanding Kṛṣṇa requires sukr̥ti. (14 min)',
            'youtubeLink': 'https://youtu.be/mEKJVfw9Sg8?si=GAfOMIzMDkSIxf0j&t=3485',
        },
        {
            'subTopicName': 'Is māyā our enemy? (9 min)',
            'youtubeLink': 'https://youtu.be/_sCeZ37rIi0?si=8wruvPYMNyv_w8B7&t=3981',
        },
        {
            'subTopicName': 'Role of Śaṅkarācārya and progression of philosophies. (98 min)',
            'youtubeLink': 'https://youtu.be/XIRnYePxAH8?si=AFU1CTbKdgGGRU8-&t=2995',
        },
        {
            'subTopicName': 'Purpose of Phala Śrutis. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tMSGrkzkS-4&t=300s',
        },
        {
            'subTopicName': 'Will one stay in the Brahmajyoti till he gets the association of pure devotees OR even after he does so? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jOAW3XNnk5M&t=4286s',
        },
        {
            'subTopicName': 'Is there a connection between one\'s freewill (svecchā) and one\'s conditioned nature (svabhāva)? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ngo3AF4gytQ&t=4544s',
        },
        {
            'subTopicName': 'What does it mean when the Śrīmad Bhāgavatam says ‑ \'people bound by the Lord\'s words OR the Vedas\' words?\' (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ngo3AF4gytQ&t=4364s',
        },
        {
            'subTopicName': 'Freewill has to be surrendered by the Jīva out of his own freewill. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ngo3AF4gytQ&t=2419s',
        },
        {
            'subTopicName': 'Difference between attaining Brahman and realizing Paramātmā. (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dShVtpY4wzY&t=1429s',
        },
        {
            'subTopicName': 'Realization of Ātmā and Paramātmā. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dShVtpY4wzY&t=1251s',
        },
        {
            'subTopicName': 'Who does the verse \'na buddhi‑bhedam janayet\' (BG 3.26) i.e. \'do not disturb the faith of ordinary people in Karma\' refer to? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XSAGwNMoF08&t=2848s',
        },
        {
            'subTopicName': '2 Types of Demons: Demons by Curse and Demons by Nature. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=qy0gJXtzapw&t=4425s',
        },
        {
            'subTopicName': 'Is wealth actually more Intoxicating than Aristocracy, Education and Beauty as we understand from the episode of Nalakūvera and Maṇigrīva? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=irXwcVTNbbQ&t=6523s',
        },
        {
            'subTopicName': 'Is Advaitavāda the same as Māyāvāda? (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=YLy7RJjP32o&t=2683s',
        },
        {
            'subTopicName': 'Sādhana VS Abhidheya. (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0JhMipOSX34&t=3420s',
        },
        {
            'subTopicName': 'Did the people of previous Yugas have access to the same Literatures? Are Scriptures also Eternal? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-v9S56pnTuI&t=6670s',
        },
        {
            'subTopicName': 'Are the teachings of the Bhagavad Gītā for Arjuna or for others? - Light on the verse \'sarvopaniṣado gāvaḥ\' of Śrī Ādi Śaṅkara. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cheqqa0IiFw&t=667s',
        },
        {
            'subTopicName': 'Isn\'t performing an Aśvamedha Yajña Kṣatriya Dharma? Why then did Brahmā stop Pṛthu from performing his 100th? (65 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nTCjVAghH-8&t=3828s',
        },
        {
            'subTopicName': 'Mother Earth held back resources from the citizens in the Satya Yuga (Pṛthu Mahārāja\'s episode). How then are we getting resources in the Kali Yuga when the administration is far worse? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5_iCZQ-iff8&t=3434s',
        },
        {
            'subTopicName': 'What\'s the difference between attaining the jīvan‑mukta platform AND being situated on the Mode of Goodness? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2aJZVXd88aA&t=3392s',
        },
        {
            'subTopicName': 'Who is a true sannyāsī? (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=YLy7RJjP32o&t=1868s',
        },
        {
            'subTopicName': 'Understanding the bifurcation of Yugas (Sandhyā and Sandhyāṁśa). (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0zJytSMFObI&t=5232s',
        },
        {
            'subTopicName': 'In Brahmajyoti the living entity remains inactive. (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=FwZywLwu6Wk&t=3150s',
        },
        {
            'subTopicName': 'Why does Kṛṣṇa call some people as \'Mūḍhas\' if he actually sympathises with them in the verse \'yā niśā sarva‑bhūtānāṁ\' (BG 2.69)? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GfCGcN9jJdg&t=2541s',
        },
        {
            'subTopicName': 'Each and everything within this world is completely logical, and yet there\'s no universal logic in this world. How? (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GfCGcN9jJdg&t=1017s',
        },
        {
            'subTopicName': 'Purpose of Phala Śrutis. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tMSGrkzkS-4&t=368s',
        },
        {
            'subTopicName': 'Root cause of Mamakāra is Ahaṅkāra. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=qNg82CwyIdE&t=371s',
        },
        {
            'subTopicName': 'Are the 24 Gurus of the Avadhūta Brāhmaṇa in the 11th Canto his Śikṣā Gurus OR his Dīkṣā Gurus? (46 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pLtOvwHMfmQ&t=562s',
        },
        {
            'subTopicName': 'What is the true dharma of mankind? If there is only one true dharma, then why are there many paths? (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0iZFaRcw_4U&t=4440s',
        },
        {
            'subTopicName': 'Is Life air a part of Gross or Subtle body? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gOW6r-Kb0vU&t=3502s',
        },
        {
            'subTopicName': 'Material Religion vs Spiritual Religion. (49 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=fVWoj98Jd-A&t=1010s',
        },
        {
            'subTopicName': 'Understanding the aphorism "ekaṁ brahma dvitīya nāsti". (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Q1tmJZhIgIc&t=1490s',
        },
        {
            'subTopicName': 'Activities of Prāṇas, Karmendriyas and Jñānendriyas. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9EvcG3HS9ZQ&t=3435s',
        },
        {
            'subTopicName': 'Who are Jāti smāra? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=FwZywLwu6Wk&t=517s',
        },
        {
            'subTopicName': 'Difference between inquisitiveness and cynicism. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=aa446809Zgo&t=3040s',
        },
        {
            'subTopicName': 'Tolerance to austerity indicates purification of heart. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=__YuiNf5o1g&t=704s',
        },
        {
            'subTopicName': 'Can material analogy be used to explain spiritual subject matter? (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5kZYfDW2Wsg&t=2220s',
        },
        {
            'subTopicName': 'Should we take a firm stance on \'jīva\'s fall down from spiritual world\' subject matter? (33 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=dhxXSOxcaME&t=1320s',
        },
        {
            'subTopicName': 'Are Christianity and Islam temporary dharma only? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BNZEyBCkLWM&t=3470s',
        },
        {
            'subTopicName': 'What are true ego and false ego? How does the Jīva get them? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=E1Huq3O0vsg&t=2585s',
        },
        {
            'subTopicName': 'What are nitya, naimittika and anitya religions? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=E1Huq3O0vsg&t=3701s',
        },
        {
            'subTopicName': 'Are dovetailed naimittika duties still naimittika dharma only? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BNZEyBCkLWM&t=4225s',
        },
        {
            'subTopicName': 'What factors decide our adhikāra as a Karma Yogī or Bhakti Yogī? Is it our conditioning? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vt0EOh18BwQ&t=2580s',
        },
        {
            'subTopicName': 'Illusion, as understood by Māyāvādīs and Vaiṣṇava ācāryas. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Q1tmJZhIgIc&t=2613s',
        },
        {
            'subTopicName': 'Rajju Sarpa Nyāya. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Q1tmJZhIgIc&t=2892s',
        },
        {
            'subTopicName': 'Faith cannot be judged externally. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=X5x74WCbg3g&t=1960s',
        },
        {
            'subTopicName': 'Māyā\'s energies and how she bewilders the jīva. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Iea5UCJbc6o&t=2847s',
        },
        {
            'subTopicName': 'If the desire for Mukti is bad, then why did the Lord sanction it in the Bhagavad Gītā? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6J69C9122A0&t=4953s',
        },
        {
            'subTopicName': 'If Brahmājī received such close association with Lord (as described in Bṛhad Bhāgavatamṛta), how can he come back to this material world? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5gBZRGZdwRI&t=1782s',
        },
        {
            'subTopicName': 'What are the symptoms of false ego and true ego? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=DC3ERl-63e0&t=1350s',
        },
        {
            'subTopicName': 'Taste and appreciation is according to one\'s Adhikāra. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Mul8EsJXjR8&t=928s',
        },
        {
            'subTopicName': 'Bondage and Liberation is an illusion. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=MFd3A2euW3o&t=1981s',
        },
        {
            'subTopicName': 'How Bhakti Śāstras accomodate those who desire Mukti. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=MFd3A2euW3o&t=3034s',
        },
        {
            'subTopicName': 'Why there is no consciousness in the inanimate objects when the Supersoul is there in them also? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=xqsdZWrV2FM&t=5284s',
        },
        {
            'subTopicName': 'Do the Śāstras criticize the atheists? And what should be our mentality towards them? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=284s',
        },
        {
            'subTopicName': 'There is no logic which is universally appealing to all. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=827s',
        },
        {
            'subTopicName': 'It is said that one who doesn\'t believe in Caitanya Mahāprabhu goes to hell. How to understand such statements? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=1243s',
        },
        {
            'subTopicName': 'Multiple layers of understanding the difference between divine and demoniac. (21 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=2430s',
        },
        {
            'subTopicName': 'Why do demons not accept God? Is it because they are attached to their position? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=3705s',
        },
        {
            'subTopicName': 'Is māyā evil? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2JHFguvmCfE&t=1867s',
        },
        {
            'subTopicName': 'Why people do not surrender to Kṛṣṇa? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2JHFguvmCfE&t=3024s',
        },
        {
            'subTopicName': 'Who surrenders to Kṛṣṇa? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2JHFguvmCfE&t=3929s',
        },
        {
            'subTopicName': 'Do the Śāstras recommend Demigod worship? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0jaeK5dlL8E&t=2527s',
        },
        {
            'subTopicName': 'The 2 kinds of mercy that the Demigods bestow upon their worshippers. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0jaeK5dlL8E&t=3247s',
        },
        {
            'subTopicName': 'Results of improper and indirect Demigod Worship. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0jaeK5dlL8E&t=4890s',
        },
        {
            'subTopicName': 'Supreme Lord is Nirguṇa as Brahman and Saguṇa as Bhagavān. (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2D3b3u4tiQ0&t=4542s',
        },
        {
            'subTopicName': 'Different levels of Self Realisation. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=YUQ_hACNqp8&t=3330s',
        },
        {
            'subTopicName': 'Role of intelligence in a Sādhaka\'s life and a Self Realized person\'s life. (53 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=uXosOLmwCTg&t=525s',
        },
        {
            'subTopicName': 'Seeing paramātmā in matter. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Q1tmJZhIgIc&t=1926s',
        },
        {
            'subTopicName': 'All deviant philosophies have always existed. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ZnQH4cbm3zc&t=2594s',
        },
        {
            'subTopicName': 'Categorization of bonafide Vedic Practitioners. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hsOWsv1PRdo&t=1631s',
        },
        {
            'subTopicName': 'Is mind material or spiritual?? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Iea5UCJbc6o&t=3739s',
        },
        {
            'subTopicName': 'Understanding the role of Māma‑māyā. (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Iea5UCJbc6o&t=2298s',
        },
        {
            'subTopicName': 'Are the instructions of the Lord different for those having different faith (for ex: for those having Karma Adhikāra vs those having Bhakti Adhikāra)? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RwaILVgzrF8&t=1878s',
        },
        {
            'subTopicName': 'How do we understand that the Lord is NOT affected by the Karma of any individual though He plays the role of the Approver of all Karma, as per BG 18.14? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RwaILVgzrF8&t=3810s',
        },
        {
            'subTopicName': '2 Incorrect conclusions from the episode of Avadhūta brāhmaṇa and the 24 Gurus. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ft5OYPZnBho&t=694s',
        },
        {
            'subTopicName': 'What controls the birth of Sādhakas, Materialists and Perfected devotees in this world? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ft5OYPZnBho&t=2780s',
        },
        {
            'subTopicName': 'What do the scriptures mean when they say sometimes that the Lord enters the Brāhmaṇas / Kṣatriyas? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=y7FRfYpPTxo&t=2275s',
        },
        {
            'subTopicName': 'Purification of Intelligence vs Purification of Mind. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=d36Obvd-_68&t=3295s',
        },
        {
            'subTopicName': 'If all the sacrifices are supposed to be offered in Agni, who is considered the mouth of sacrifices, how can we understand statements in Śāstras that say that Fire is unconscious and hence offering food to the Brāhmaṇas\' mouth is much better? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1fMRJBYYcuE&t=4361s',
        },
        {
            'subTopicName': 'Does Paramātmā accompany the jīva to the Spiritual world/Brahmajyoti? (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0IPPwGpKaKc&t=2805s',
        },
        {
            'subTopicName': 'Māyādevī, Vaiṣṇavas, Śāstras and Kṛṣṇa have a common mission of sending the jīva back to the spiritual world. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=R91CJZltUcs&t=890s',
        },
        {
            'subTopicName': 'Understanding Svabhāva‑jaṁ Śraddhā (Faith born out of one\'s conditioned nature). (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=R91CJZltUcs&t=5211s',
        },
        {
            'subTopicName': 'Nature of the curtain of Mahāmāyā. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-dkJ3oTj9Kc&t=2144s',
        },
        {
            'subTopicName': 'When did the bewilderment of the Jīva by Māyā begin? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-dkJ3oTj9Kc&t=2820s',
        },
        {
            'subTopicName': 'What does it mean to accept a pramāṇa? Didn\'t Hiraṇyakaśipu also consider the Śāstras as a Pramāṇa? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=4400s',
        },
        {
            'subTopicName': 'How uncontrolled senses steal away the mind and intelligence? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=2049s',
        },
        {
            'subTopicName': 'What\'s the difference between Jñāna destroying the subtle body and Bhakti destroying the subtle body? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=3282s',
        },
        {
            'subTopicName': 'What does it mean when the subtle body gets destroyed? Is it figurative? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=4480s',
        },
        {
            'subTopicName': 'What is the difference a spiritual body and a spiritualised material body? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KAxPVgCwOSw&t=4870s',
        },
        {
            'subTopicName': 'Understanding Pre‑Meditated and Non Pre‑Meditated Sense Gratification. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jDi9z66krt0&t=3236s',
        },
        {
            'subTopicName': 'Where are the impressions of sense objects stored? In the mind or in the intelligence? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jDi9z66krt0&t=3786s',
        },
        {
            'subTopicName': 'Functions of Citta, Manas, Buddhi and Ahaṅkāra? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jDi9z66krt0&t=3862s',
        },
        {
            'subTopicName': 'If all souls have the same characteristics and moreover, it the mind, intelligence and ego are all matter, how is it that people have different likes and dislikes? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jDi9z66krt0&t=4262s',
        },
        {
            'subTopicName': 'How can one understand ignorance to be beginning‑less and eternal, when practical experience says that anything that has a beginning has to have an end? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0qKHOs7NFqM&t=3035s',
        },
        {
            'subTopicName': 'What is the Pramāṇa for the statement \'the ignorance of the Jīva is beginning‑less\'? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0qKHOs7NFqM&t=3219s',
        },
        {
            'subTopicName': 'What is the difference between a Jīvan‑mukta maintaining his body and an ordinary conditioned soul maintaining his? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0qKHOs7NFqM&t=3935s',
        },
        {
            'subTopicName': 'Understanding the difference between Scriptural and Sentimental Faith. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=770s',
        },
        {
            'subTopicName': 'How to understand if one has Śāstric Faith or Laukikī (Sentimental ) Faith? (22 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=1450s',
        },
        {
            'subTopicName': 'Can Viṣṇu Worshippers become Demigod Worshippers and vice versa? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=3580s',
        },
        {
            'subTopicName': 'Is Varṇa not dependent on birth? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OSP02lDJzkw&t=3250s',
        },
        {
            'subTopicName': 'Is frustration from material life the only qualification for Jñāna? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0utgOK2TwGU&t=4000s',
        },
        {
            'subTopicName': 'Is Vānaprastha‑āśrama mandatory for all Gṛhastha devotees? (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=650s',
        },
        {
            'subTopicName': 'Who are the foolish Sannyāsīs? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0utgOK2TwGU&t=2355s',
        },
        {
            'subTopicName': 'Is the process of merging one element into another while devotees leave their bodies as described in Śrīmad‑Bhāgavatam figurative OR real? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=5079s',
        },
        {
            'subTopicName': 'How did Jñāna‑miśra‑bhaktas like the 4 Kumāras glorify Śuddha‑bhakti? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5zk7IbCiQJY&t=261s',
        },
        {
            'subTopicName': 'What are the Common recommendations, the Highest recommendations, and allowances prescribed in the Mahābhārata, Bhagavad‑gītā, Bhāgavatam and Caitanya‑caritāmṛta? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=5298s',
        },
        {
            'subTopicName': 'What is the destination of Kṣatriyas and Vaiśyas in the gradual path of Varṇāśrama as they cannot take to Sannyāsa? (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glVWOuUj9OA&t=3050s',
        },
        {
            'subTopicName': 'Different categories of Sārūpya‑mukti. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mPV5ksADt7o&t=1130s',
        },
        {
            'subTopicName': 'Does the Lordships give Faith to Jīva? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pRT_2QL6fMc&t=3082s',
        },
        {
            'subTopicName': 'What destinations do Karma‑miśra‑bhakti, Jñāna‑miśra‑bhakti, and Śuddha‑bhakti fetch? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=o7YgN8pXjBs&t=1647s',
        },
        {
            'subTopicName': 'Is the Lord beautified by His ornaments OR are His ornaments beautified by Him? Or are both true? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gjIKMojudEU&t=3325s',
        },
        {
            'subTopicName': 'Who are the Presiding Deities and Worshippable Deities of the different aspects of Antaḥkaraṇa viz. citta, manaḥ, buddhi, and ahaṅkāra? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=o7YgN8pXjBs&t=2625s',
        },
        {
            'subTopicName': 'Material Vision VS Impersonal Vision VS Vision of the Lord. (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n6q79aHYYKw&t=3300s',
        },
        {
            'subTopicName': 'Purpose behind manifestation of the material world. (25 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=a9vYWReNDwA&t=1270s',
        },
        {
            'subTopicName': 'Direct Knowledge, Indirect Knowledge and Perverted Knowledge from the Saṁvit Potency. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=2615s',
        },
        {
            'subTopicName': 'What defines whether an activity is dhārmic, material or devotional? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sbdWireHqZU&t=1422s',
        },
        {
            'subTopicName': 'What is the meaning of "detachment from the fruits of one\'s work"? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=WpdSAdGLTEA&t=3792s',
        },
        {
            'subTopicName': 'What is free will? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JaBwvcMkjtY&t=1001s',
        },
        {
            'subTopicName': 'What if a devotee remembers a dog at the time of death? Will he get a dog birth? (21 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EkGPE4oRvgo&t=160s',
        },
        {
            'subTopicName': 'Types of indirect, impure worship of the Lord and types of jñāna‑yajñas. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QwKi7-MyaTg&t=5222s',
        },
    ],
    ['Speciality of the Gauḍīya Vaiṣṇava Paramparā/Kṛṣṇa Bhakti']: [
        {
            'subTopicName': 'Worshippers of Kṛṣṇa are the best amongst the Prema Bhaktas. (9 min)',
            'youtubeLink': 'https://youtu.be/SfFVMSoXu0I?si=WmRF5hHKxLyQnTLN&t=2932',
        },
        {
            'subTopicName': 'Rādhā-dāsyam – The rarest jewel. (5 min)',
            'youtubeLink': 'https://youtu.be/P3ZnLJs5ICc?si=43i26H2vDaasEm7J&t=3381',
        },
        {
            'subTopicName': 'How is Lord Narasiṁha worshipped in the Gauḍīya Vaiṣṇava sampradāya? (4 min)',
            'youtubeLink': 'https://youtu.be/N-4rcvYqYjU?t=3295',
        },
        {
            'subTopicName': 'Is Vraja‑bhakti for everyone? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=948s',
        },
    ],
    ['Spiritual World']: [
        {
            'subTopicName': 'Is there Duality in the Spiritual World? (8 min)',
            'youtubeLink': 'https://youtu.be/P3ZnLJs5ICc?si=EN2bPRgJFZXMPvSX&t=1098',
        },
        {
            'subTopicName': 'Gradation in the degree of bliss in Vaikuṇṭha. (25 min)',
            'youtubeLink': 'https://youtu.be/P3ZnLJs5ICc?si=fFDYqmJqrtLHMrxs&t=1799',
        },
        {
            'subTopicName': 'Can yogīs in Brahma-jyoti go back to Vaikuṇṭha by worshipping the Lord? (4 min)',
            'youtubeLink': 'https://youtu.be/0IPPwGpKaKc?si=INXfLkRMu3eq7lnB&t=2085',
        },
        {
            'subTopicName': 'Abodes of Kṣīrodakaśāyī Viṣṇu. (12 min)',
            'youtubeLink': 'https://youtu.be/Nr9FKFhTneM?si=G-VGK5YiJzUD6NDM&t=1346',
        },
        {
            'subTopicName': 'Abodes of avatāras. (6 min)',
            'youtubeLink': 'https://youtu.be/HmalZt6xdvA?si=TI8JPUdY64AAKXo0&t=3291',
        },
        {
            'subTopicName': 'Abodes of avatāras in the material world. (7 min)',
            'youtubeLink': 'https://youtu.be/XEVoigWeogA?si=seGrjiuacUv6U6ws&t=1530',
        },
        {
            'subTopicName': 'Abodes of tad-ekātma and avesa forms. (3 min)',
            'youtubeLink': 'https://youtu.be/2h4aegotCuE?si=HopyYcRHwxq9qehL&t=3750',
        },
        {
            'subTopicName': 'Description of Vaikuṇṭha - Part-1. (26 min)',
            'youtubeLink': 'https://youtu.be/kNP-eZaCudw?si=QC4GbVOdiJMt6r8y&t=1083',
        },
        {
            'subTopicName': 'Description of Vaikuṇṭha - Part-2. (26 min)',
            'youtubeLink': 'https://youtu.be/Wc_X4mLEEHc?si=NcZgHMV7mr3skoV0&t=838',
        },
        {
            'subTopicName': 'Description of Vaikuṇṭha - Part-3. (8 min)',
            'youtubeLink': 'https://youtu.be/ivYnnr3WCrA?si=e_Xf5-lKnGuS604o&t=2793',
        },
        {
            'subTopicName': 'Description of Aiśvarya‑Goloka. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/P8Lh5gkC0qo?si=hV1y2ZgE7aQ0vP9h&t=4560',
        },
        {
            'subTopicName': 'Are there Vaikuṇṭha planets in the material universe also? (2 min)',
            'youtubeLink': 'https://youtu.be/rnA74aDvpRE?si=aqNzU-YSGhhmPRqk&t=2136',
        },
        {
            'subTopicName': 'Why is Vaikuṇṭha very difficult to attain even for the liberated souls? (7 min)',
            'youtubeLink': 'https://youtu.be/MlObwlmgFLw?si=vwyvlIRJ-IajbBQZ&t=747',
        },
        {
            'subTopicName': 'Categories of residents of Vaikuṇṭha. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0zJytSMFObI&t=730s',
        },
        {
            'subTopicName': 'Does duality exist in Vaikuṇṭha? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=P3ZnLJs5ICc&t=1100s',
        },
    ],
    ['Stages of Bhakti']: [
        {
            'subTopicName': 'Symptoms of the stage of Niṣṭhā. (4 min)',
            'youtubeLink': 'https://youtu.be/KycrMfpSxYY?si=fCZwuuWCFzNerYWT&t=2907',
        },
        {
            'subTopicName': 'Stages of anartha nivṛtti. (5 min)',
            'youtubeLink': 'https://youtu.be/NSbLUll9y1c?si=nOXGDBFpYFvJJbzH&t=4600',
        },
        {
            'subTopicName': 'Similarities and differences of Bhāva Bhakti with Prema Bhakti and Sādhana Bhakti. (5 min)',
            'youtubeLink': 'https://youtu.be/_Jrl6bhAHMw?si=FvlSMcqDemP78A6t&t=1792',
        },
        {
            'subTopicName': 'When will a glimpse of our relationship with Kṛṣṇa be revealed? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/1wFC-Z4xXpU?si=NBnTsyImhTqssDkW&t=1834',
        },
        {
            'subTopicName': 'At what stage of bhakti do the sinful impressions get destroyed? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=v0O1aKXlIi3bt727&t=1100',
        },
        {
            'subTopicName': 'Symptoms of the stages of devotion. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/6iHGvdhIQT0?si=k751-bhjOCd6ObRz&t=784',
        },
        {
            'subTopicName': 'Gradual evolution of the various stages of bhakti. (34 min)',
            'youtubeLink': 'https://www.youtube.com/live/VuzxMXez__I?si=UMcIeBsrVbFz3F2o&t=1399',
        },
        {
            'subTopicName': 'Stages of devotional service. (43 min)',
            'youtubeLink': 'https://www.youtube.com/live/4N2x3a4P1wM?si=HWt3ZeK2HpzNlm9B&t=714',
        },
        {
            'subTopicName': 'Symptoms of niṣṭhā stage of bhakti. (4 min)',
            'youtubeLink': 'https://youtu.be/PLuBQKhg2G0?si=8xDBUVprNi4kdHom&t=4488',
        },
        {
            'subTopicName': 'From spontaneous sense gratification to spontaneous devotional service. (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=x96ilsBtFsI&t=2690s',
        },
        {
            'subTopicName': 'Constant knowledge is known as realization. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=c-sRV5wM-7c&t=830s',
        },
        {
            'subTopicName': 'Stages of devotional service explained. (19 min)',
            'youtubeLink': 'https://www.youtube.com/live/uvqUcmzKVhQ?si=1RVoQLB-ueFZGLpD&t=2424',
        },
        {
            'subTopicName': 'Symptoms of unsteady practice of bhakti. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/uvqUcmzKVhQ?si=QYKmC39Pa3f47UB3&t=3681',
        },
        {
            'subTopicName': 'Seeking shelter of Kṛṣṇa depends on sukṛti. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/FFwkcvT7muc?si=xwP1Kk4NvOeM0Adt&t=3389',
        },
        {
            'subTopicName': 'At what stage does the devotee develop eka-niṣṭhā to a particular form of the Lord? (2 min)',
            'youtubeLink': 'https://youtu.be/QT5ZlC5rURY?si=egtXgndQwpnnRXD8&t=1121',
        },
        {
            'subTopicName': 'Five symptoms of the stage of niṣṭhā. (3 min)',
            'youtubeLink': 'https://youtu.be/MTE2J19gZcA?si=5ZKvkCOTkO6_lxDa&t=1393',
        },
        {
            'subTopicName': 'Six stages of unsteady devotional service. (11 min)',
            'youtubeLink': 'https://youtu.be/z9bGcrczhi0?si=S4KiAYbeMEYw5kre&t=1813',
        },
        {
            'subTopicName': 'Attaining Vastu‑siddhi through Rāgānugā sādhanā. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NGb3avTZOLw&t=5540s',
        },
        {
            'subTopicName': 'How Vaidhī sādhanā transforms into Rāgānugā sādhanā? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=lC3mZpoQvH4&t=3997s',
        },
        {
            'subTopicName': 'Progressing in chanting from śraddhā to prema (76 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sCv630ZH52E&t=2745s',
        },
        {
            'subTopicName': 'Śikṣāṣṭakam and Progressive steps in Chanting. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-PziVSpmu9c&t=4390s',
        },
        {
            'subTopicName': 'Progressing from śraddhā to prema. (23 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=S_jL9Vulh-8&t=230s',
        },
        {
            'subTopicName': 'Stages leading to prema ‑ Part‑2. (36 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=SH0ionOFw-o&t=4860s',
        },
        {
            'subTopicName': 'Stages leading to prema ‑ Part‑1. (56 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=SH0ionOFw-o&t=215s',
        },
        {
            'subTopicName': 'Reliable symptoms of Bhāva‑bhakti. (64 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glw_mxNyMJQ&t=3355s',
        },
        {
            'subTopicName': 'Ways in which Bhāva‑bhakti appears ‑ Part‑1 (36 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sdG9Ak72tDk&t=4920s',
        },
        {
            'subTopicName': 'Ways in which Bhāva‑bhakti appears ‑ Part‑2. (44 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glw_mxNyMJQ&t=720s',
        },
        {
            'subTopicName': 'Understanding Bhāva‑bhakti. (36 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=4830s',
        },
        {
            'subTopicName': 'Proof for definition of Bhāva‑bhakti. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sdG9Ak72tDk&t=1305s',
        },
        {
            'subTopicName': 'Is Bhāva‑bhakti eternal in the Jīva? (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=2160s',
        },
        {
            'subTopicName': 'Definition of Vaidhī Sādhanā-bhakti. (25 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=_7jxSZ7LflE&t=1141s',
        },
        {
            'subTopicName': 'How do we say devotees are beyond the 3 modes while they are still acting under the influence of the 3 modes? (57 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vqtB83kCAKk&t=979s',
        },
    ],
    ['Studying Śāstras']: [
        {
            'subTopicName': 'Importance of Bhakti-rasāmṛta-sindhu. (10 min)',
            'youtubeLink': 'https://youtu.be/KxlGUpdv0sM?si=iFPO3X37X6zVZvbU&t=1303',
        },
        {
            'subTopicName': 'Comparing Nectar of Devotion and Bhakti-rasāmṛta-sindhu. (6 min)',
            'youtubeLink': 'https://youtu.be/KxlGUpdv0sM?si=TREsDyd9HxL_7GM8&t=1584',
        },
        {
            'subTopicName': 'How to verify if the explanations other than what is given in the purport of Śrīla Prabhupāda are bonafide? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/uSxVKrr7Ab8?si=AaXwbmuOj3rzs7YP&t=3608',
        },
        {
            'subTopicName': 'Mood to approach the Ācārya\'s commentaries. (42 min)',
            'youtubeLink': 'https://youtu.be/uEW_UcRi27A?si=c39ZjmsaGel_dAU4&t=1550',
        },
        {
            'subTopicName': 'What is an "As it is" commentary? (1 min)',
            'youtubeLink': 'https://www.youtube.com/live/-k-KLLTzxrg?si=ynCs9kYwq9ZpjWzq&t=327',
        },
        {
            'subTopicName': 'Comparitive study of different śāstras. (42 min)',
            'youtubeLink': 'https://www.youtube.com/live/eKPc6Oogc6M?si=t_gbCXa24YdtL8B_',
        },
        {
            'subTopicName': 'Every Ācārya\'s commentary is AS IT IS. (25 min)',
            'youtubeLink': 'https://youtu.be/JalSyN0N_Ls?si=0eeNj6YPEPBg3NQv&t=3103',
        },
        {
            'subTopicName': 'History of Upadeśāmṛta. (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/Z076in9W9-w?si=2eA3_ZLLvSY-AS_t&t=2097',
        },
        {
            'subTopicName': 'Summary of Upadeśāmṛta. (1 min)',
            'youtubeLink': 'https://www.youtube.com/live/96Gj-cfvCf8?si=BKMz7pjWYXKtKpn-&t=1048',
        },
        {
            'subTopicName': 'Hermeneutics to reconcile differences in Ācārya\'s writings. (43 min)',
            'youtubeLink': 'https://youtu.be/s6VlcK01erw?si=egIbJ40RfAqd-KGA&t=1622',
        },
        {
            'subTopicName': 'Polemics in our Ācārya\'s writings. (53 min)',
            'youtubeLink': 'https://youtu.be/-Rlv-uheoto?si=Kggwm6PAGIqoVzma&t=71',
        },
        {
            'subTopicName': 'What is an As it is commentary? (8 min)',
            'youtubeLink': 'https://youtu.be/uEW_UcRi27A?si=rHgFuZED7T6Mk3S3&t=3864',
        },
        {
            'subTopicName': 'How should we approach other Ācāryas commentaries? (7 min)',
            'youtubeLink': 'https://youtu.be/uEW_UcRi27A?si=0Gf3-arAAkrjsIaz&t=4468',
        },
        {
            'subTopicName': 'Hierarchy of various Śāstras. (13 min)',
            'youtubeLink': 'https://youtu.be/CrxOqEDHtI0?si=iJ0dCH2P8sO4fsEa&t=723',
        },
        {
            'subTopicName': 'Comparison of Mahābhārata and Śrīmad-Bhāgavatam. (12 min)',
            'youtubeLink': 'https://youtu.be/CrxOqEDHtI0?si=9i3Pa1Se2n06Bd8C&t=1576',
        },
        {
            'subTopicName': 'Pitfalls in referring to Ācāryas commentaries. (2 min)',
            'youtubeLink': 'https://youtu.be/CrxOqEDHtI0?si=aPe0K5wlHNtd1ZiJ&t=2613',
        },
        {
            'subTopicName': 'Are all verses of Gītā applicable for me to follow? (5 min)',
            'youtubeLink': 'https://youtu.be/KycrMfpSxYY?si=kwP5QkLf9KrKy2S_&t=1238',
        },
        {
            'subTopicName': 'Which instructions of the Gītā are truly meant for Arjuna? (2 min)',
            'youtubeLink': 'https://youtu.be/NSbLUll9y1c?si=-Q14TMau0vgrSFRd&t=1380',
        },
        {
            'subTopicName': 'Arjuna is just an instrument to establish the dharma for various types of practitioners. (4 min)',
            'youtubeLink': 'https://youtu.be/yGDWZZirSt0?si=mgcZDJpu4LOl4PXR&t=1238',
        },
        {
            'subTopicName': 'Why we do not see elaborate refutations of Māyāvāda in Srila Visvanath Cakravarti Thakura\'s commentaries? (4 min)',
            'youtubeLink': 'https://youtu.be/Wi68_XAAlcY?si=GQlJtU5fNz50PVMm&t=981',
        },
        {
            'subTopicName': 'Do Ācāryas interpret the Śāstras? (5 min)',
            'youtubeLink': 'https://youtu.be/gEB779mzLW0?si=4asEegSmWsiaptBo&t=1977',
        },
        {
            'subTopicName': 'Unique flavours of different Ācāryas. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/bfdbewI_XgE?si=ONuS3jBdrVxw7lDE&t=975',
        },
        {
            'subTopicName': 'Methodology of Ācāryas translation. (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/bfdbewI_XgE?si=LK_p70n3Um_0Lw1v&t=2210',
        },
        {
            'subTopicName': 'Qualification for studying Śāstras. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=BKJVeWZxF1O9QTqU&t=2693',
        },
        {
            'subTopicName': 'Even in a bona fide scripture, the authenticity of the speaker should be established. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/wq0Rk7XBQ8A?si=MjALLd30bBOLJQ7_&t=1960',
        },
        {
            'subTopicName': 'Should we study all the scriptures quoted by our ācāryas? (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/NrJgtAPgGEw?si=21pDzyXimF6FaNng&t=705',
        },
        {
            'subTopicName': 'How to understand the statements in the śāstras which indicate that one can attain bhakti by pious activities? (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/NrJgtAPgGEw?si=P5sY6316bj87_JgR&t=1945',
        },
        {
            'subTopicName': 'When to take the direct and indirect meaning of words in śāstras? (14 min)',
            'youtubeLink': 'https://youtu.be/Q-zIqhtgz3k?si=FWC-yZ-JN_LJvATy&t=2532',
        },
        {
            'subTopicName': 'How to understand contradictions in ācāryas\' revelations. (10 min)',
            'youtubeLink': 'https://youtu.be/UtolvDukp8w?si=26me46eT2X5Si7I2&t=1517',
        },
        {
            'subTopicName': 'Speciality of Bhaktivedanta purports. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/IPdCUszooy0?si=RdPUtT3SYfEaA5Gn&t=2557',
        },
        {
            'subTopicName': 'Is it not a redundant exercise on the part of different ācāryas to write books on the same topic or write commentaries to the same book? (12 min)',
            'youtubeLink': 'https://youtu.be/zsvIjoXPCPQ?si=FYpYXMZ0wV_fiExG&t=1433',
        },
        {
            'subTopicName': 'Why the other ācāryas give commentaries on the other yoga paths? (8 min)',
            'youtubeLink': 'https://youtu.be/iJx6h4gLfBw?si=eYq30fIv8NBXaawy&t=3491',
        },
        {
            'subTopicName': 'Why only incidental reading of Kṛṣṇa’s pastimes is recommended by Śrīla Prabhupāda and not a more focused reading? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/6iHGvdhIQT0?si=7YkvCwb4eYJR98d8&t=4325',
        },
        {
            'subTopicName': 'Are the different explanations of scriptures by the ācāryas word jugglery? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/oBSNCs_mTDw?si=MMcnNkLpAlVzdKYy&t=3326',
        },
        {
            'subTopicName': 'Devotee\'s perspective of the pastimes presented in Mahābhārata. (24 min)',
            'youtubeLink': 'https://youtu.be/vKIx7B4JIyk?si=WHqDYYpbYp1pmmJx&t=1582',
        },
        {
            'subTopicName': 'Why do our ācāryas quote from Bhāgavatam itself to prove statements of Bhāgavatam? Shouldn\'t they be quoting verses from other literatures? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/VFhaouqZfSI?si=VAhwH5u43CzJFzW_&t=4105',
        },
        {
            'subTopicName': 'Are the Vedas primarily for those who are qualified for karma? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/LBVwqJ_X7Eo?si=RAJOu0PtnQlTQmf2&t=4273',
        },
        {
            'subTopicName': 'How to know if we are qualified to read a particular scripture? (5 min)',
            'youtubeLink': 'https://youtu.be/JeybpTYH6Y4?si=YVatfroguLpXSRdd&t=3539',
        },
        {
            'subTopicName': 'The subject matter of Laghu Bhagavatāmṛta. (8 min)',
            'youtubeLink': 'https://youtu.be/btMcUFp30_w?si=Wab1Fqy65-qPuoB1&t=2863',
        },
        {
            'subTopicName': 'Śāstras reveal different shades of meanings to different schools of faith. (36 min)',
            'youtubeLink': 'https://youtu.be/rXEpkJlusHo?si=upx420rsfqyU4lTb&t=3144',
        },
        {
            'subTopicName': 'Reconciling apparent contradictions in the śāstras. (19 min)',
            'youtubeLink': 'https://youtu.be/HBLbm1PVlNQ?si=5Pq9kSp_1HUi_rq-&t=277',
        },
        {
            'subTopicName': 'Śāstras cannot be understood without guidance of ācāryas. (7 min)',
            'youtubeLink': 'https://youtu.be/HBLbm1PVlNQ?si=i81ppJqZlkRZILaE&t=1721',
        },
        {
            'subTopicName': 'Studying śāstras should be as per one’s qualification. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-9dp2mzOlKM&t=945s',
        },
        {
            'subTopicName': 'Vedas are universal but particular Vedic instructions are for people with particular qualifications. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=b6wJQpJQurw&t=2156s',
        },
        {
            'subTopicName': 'Importance of relying on the explanations of our ācāryas to save ourselves from misquoting verses. (22 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QAV4P_DseEg&t=870s',
        },
        {
            'subTopicName': 'Hearing with ruci vs vicāra. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QAV4P_DseEg&t=6026s',
        },
        {
            'subTopicName': 'Faith produced by hearing with vicāra. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QAV4P_DseEg&t=6235s',
        },
        {
            'subTopicName': 'Faith developed through hearing with ruci. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/WvuXneSOLmU?si=7mp7AbjcONCOd_a3&t=1434',
        },
        {
            'subTopicName': 'Pūrvapakṣa arguments and their refutations given in Laghu-Bhāgavatāmṛta are meant for whom? (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/CO9MBb75S_0?si=bwXJZK1-tWkIN5VG&t=2937',
        },
        {
            'subTopicName': 'Śāstras speak according to the adhikāra of the audience. (13 min)',
            'youtubeLink': 'https://youtu.be/SVFXJmtieUs?si=tfQ0psvQcDP8Adrs&t=1210',
        },
        {
            'subTopicName': 'Different people understand different scriptures depending on the amount of sukṛti they have. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/EHznydtUlts?si=vyW9SVRADcf4FiV8&t=4621',
        },
        {
            'subTopicName': 'Contents of Caitanya‑Śikṣāmṛta. (13 min)',
            'youtubeLink': 'https://youtu.be/EYaZ2XSLwts?si=dLGeHk-thf-4RPW8&t=315',
        },
        {
            'subTopicName': 'Why the śāstras describe other paths when Bhakti‑yoga is considered to be the greatest path? (10 min)',
            'youtubeLink': 'https://youtu.be/iJx6h4gLfBw?si=qG0qqlzxu8OqMnbt&t=3482',
        },
        {
            'subTopicName': 'Is it okay to justify one’s preference of a particular ācārya’s writings for reasons such as compatibility in terms of time, place, and circumstances? (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/qLMa8Wg7y2s?si=YY5mE4f_OZIccDhr&t=1180',
        },
        {
            'subTopicName': 'Why/how should a specific teaching of a Śāstra/of an ācārya be reconciled with the greater teachings of the same Śāstra/ācārya? (26 min)',
            'youtubeLink': 'https://youtu.be/Qjh9YAOxfzw?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=458',
        },
        {
            'subTopicName': 'Comparison of Mahābhārata, Bhagavad Gītā, Śrīmad Bhāgavatam and Śrī Caitanya Caritāmṛta. (8 min)',
            'youtubeLink': 'https://youtu.be/0W5mBmDmT2w?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=181',
        },
        {
            'subTopicName': 'How do we resolve apparent contradictions between ācāryas’ commentaries? (8 min)',
            'youtubeLink': 'https://youtu.be/0W5mBmDmT2w?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=3490',
        },
        {
            'subTopicName': 'How do we pick commentaries on Śāstras apart from Śrīla Prabhupāda’s commentary? (8 min)',
            'youtubeLink': 'https://youtu.be/0W5mBmDmT2w?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=4238',
        },
        {
            'subTopicName': 'Activities of the Pāṇḍavas in the Mahābhārata are for those who have karma‑niṣṭhā. (5 min)',
            'youtubeLink': 'https://youtu.be/vKIx7B4JIyk?si=YVKY6tfFj5J_S3hl&t=1836',
        },
        {
            'subTopicName': 'The same pastime can be narrated differently for audiences of different qualifications. (3 min)',
            'youtubeLink': 'https://youtu.be/vKIx7B4JIyk?si=2WYMnIxqdKFJzuCO&t=2755',
        },
        {
            'subTopicName': 'Kṛṣṇa’s instructions vary depending on the qualification of the spiritual practitioner. (3 min)',
            'youtubeLink': 'https://youtu.be/vKIx7B4JIyk?si=ZILNP6Ma1a4Uvqgn&t=4379',
        },
        {
            'subTopicName': '“‘How to know when Gītā and Bhāgavatam can be understood figuratively and when it can be understood in a literary sense?’” (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/kN12HLUcrU4?si=4Az_GrmOfF8yUnQy&t=3746',
        },
        {
            'subTopicName': 'Words of the śāstras should be understood through the insights of the ācāryas. (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/v6pulzCsUDQ?si=0lBT7lDIeW-4vN5H&t=1993',
        },
        {
            'subTopicName': 'Ācāryas explain the śāstric statements; they don\'t deny them. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/UHNyuwoANWk?si=JI7wZizO6mu3H0ZE&t=4134',
        },
        {
            'subTopicName': 'Are the four defects in humans also in the words of the authoritative sages? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/G-BHO1GVjXI?si=EWRuxFvxQVtOg05Y&t=3478',
        },
        {
            'subTopicName': 'Is Śaṅkarācārya more qualified than Vyāsadeva as he refutes some of his writings? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/K_sLYVaKqnQ?si=HbZp76QyHC4jieB4&t=1925',
        },
        {
            'subTopicName': 'Understanding the need of adhikāra in our approach to different scriptures. (9 min)',
            'youtubeLink': 'https://youtu.be/AItRTbL-XwU?si=gxP7GZMehB1INm6V&t=3502',
        },
        {
            'subTopicName': 'Different recommendations in different Vedic literatures. (6 min)',
            'youtubeLink': 'https://youtu.be/CCffX8V2sM4?si=j_D55F7SKjnh5zcH&t=2790',
        },
        {
            'subTopicName': 'Absolute truth is multifaceted: particular facets are revealed to particular ācāryas. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/M9Ep5BpOoBk?si=txxgoFLXrggNc51O&t=1778',
        },
        {
            'subTopicName': 'Can the philosophical statements spoken by demons like Kaṁsa etc. be taken as it is, even though they are from Śrīmad‑Bhāgavatam? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/454cpAnNtMU?si=x86iBcVhW9Z99zkS&t=2344',
        },
        {
            'subTopicName': 'How can the ācāryas reveal so many deep realizations in the commentary which are not directly given in the verses? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/T7MOMdCA690?si=liDrFZj0x0g2ESHJ&t=3114',
        },
        {
            'subTopicName': 'Hierarchy of scriptures. (7 min)',
            'youtubeLink': 'https://youtu.be/mEKJVfw9Sg8?si=50u-UZdC0J7NLHig&t=2500',
        },
        {
            'subTopicName': 'Right mood to approach the technical sections of Śrīmad‑Bhāgavatam. (15 min)',
            'youtubeLink': 'https://youtu.be/PWmLgLCTuzY?si=9P0CiWK-G-J1A2te&t=1894',
        },
        {
            'subTopicName': 'Position of śruti and smṛti. (15 min)',
            'youtubeLink': 'https://youtu.be/XIRnYePxAH8?si=z8wZN6PEpR02rM7W&t=1660',
        },
        {
            'subTopicName': 'A spiritual aspirant understands scriptural verses according to his qualification and adhikāra. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=eiRsN915n6A&t=1442s',
        },
        {
            'subTopicName': 'The genius of Rūpa Goswāmī in explaining first the Bhakti Siddhānta in Bhakti Rasāmṛta Sindhu and then the Rasa Siddhānta in the same work. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GTd6KcvXc84&t=3430s',
        },
        {
            'subTopicName': 'Example of utilizing śāstra yukti to churn, analyze and understand scriptures from multiple viewpoints. (63 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=VrG6-Yff7pw&t=2620s',
        },
        {
            'subTopicName': 'Should we study the books of the previous Ācāryas? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=G9YQFheuJUo&t=4791s',
        },
        {
            'subTopicName': 'It is impossible for an ordinary Sādhaka to understand the scriptures without the illuminations of the Ācāryas. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=UrPgbp3G1IU&t=1425s',
        },
        {
            'subTopicName': 'Overview of chapters in Jaiva Dharma (29 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vt-nAaamMZM&t=2957s',
        },
        {
            'subTopicName': 'Are the instructions of the Lord different for those having different faith (for ex: for those having Karma Adhikāra vs those having Bhakti Adhikāra)? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RwaILVgzrF8&t=1878s',
        },
        {
            'subTopicName': 'Parīkṣit Mahārāj didn\'t ask any question to Śukadeva Gosvāmī about Goloka Vṛndāvana in Śrīmad‑Bhāgavatam. Then, how is it that he is answering about Goloka Vṛndāvana to Mother Uttarā in Śrī Bṛhad‑bhāgavatāmṛta? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0IPPwGpKaKc&t=2260s',
        },
        {
            'subTopicName': 'Is Nārāyaṇīyam a Bonafide Scripture? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=2875s',
        },
        {
            'subTopicName': 'What are the Common recommendations, the Highest recommendations, and allowances prescribed in the Mahābhārata, Bhagavad‑gītā, Bhāgavatam and Caitanya‑caritāmṛta? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=5298s',
        },
        {
            'subTopicName': 'Most important hermeneutic principle for a sādhaka in understanding śāstras. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=1001s',
        },
    ],
    ['Sādhanā Bhakti']: [
        {
            'subTopicName': 'Definition of Vaidhi Sādhanā Bhakti. (9 min)',
            'youtubeLink': 'https://youtu.be/fQRmE-27pOM?si=ZVA-lnsV1dnM5fEg&t=1361',
        },
        {
            'subTopicName': 'Qualification to understand Bhakti. (16 min)',
            'youtubeLink': 'https://youtu.be/_Jrl6bhAHMw?si=vj2p-zFUI0iDO5aP&t=486',
        },
        {
            'subTopicName': 'It is not possible to understand Bhakti by Logic. (8 min)',
            'youtubeLink': 'https://youtu.be/_Jrl6bhAHMw?si=Tta4_ZT9H02HiKpg&t=970',
        },
        {
            'subTopicName': 'Qualification for taking upto Vaidhi Sādhanā bhakti. (6 min)',
            'youtubeLink': 'https://youtu.be/_Jrl6bhAHMw?si=sRjbU754Eowpd3Pm&t=4021',
        },
        {
            'subTopicName': 'All about Sādhanā Bhakti. (52 min)',
            'youtubeLink': 'https://youtu.be/_Jrl6bhAHMw?si=L37xwqasedGVUwp6&t=2081',
        },
        {
            'subTopicName': 'Categories of Vaidhi Sādhanā Bhaktas. (18 min)',
            'youtubeLink': 'https://youtu.be/_Jrl6bhAHMw?si=4OMjaFcH0waXIhlC&t=4942',
        },
        {
            'subTopicName': 'Definition of Sādhana Bhakti. (16 min)',
            'youtubeLink': 'https://youtu.be/_Jrl6bhAHMw?si=2BtwW2rLXnimleop&t=2081',
        },
        {
            'subTopicName': 'Results of Vaidhi Sādhana Bhakti. (5 min)',
            'youtubeLink': 'https://youtu.be/_Jrl6bhAHMw?si=hBo-xF2Xg_iVyBq-&t=3701',
        },
        {
            'subTopicName': 'Duties expeted of a Vaidhi Sādhaka. (7 min)',
            'youtubeLink': 'https://youtu.be/W3bCamTcsKM?si=BgXUJ15mKTqUH3e3&t=1916',
        },
        {
            'subTopicName': 'What does it mean to "neglect the haters" for a madhyama-adhikārī? (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/qFWjzQepoLI?si=aeZYzQZ1Kcw2OX8S&t=102',
        },
        {
            'subTopicName': 'Understanding the classic tug of war between the actions driven by one\'s devotional faith and actions driven by one\'s conditioning. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/oS0p9mqBkos?si=74aCptSKzjlbn5Ut&t=3789',
        },
        {
            'subTopicName': 'Why do we follow pāñcarātrika-vidhi for worshipping the deities? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/dgMDENNC67Y?si=-MEhZe0_WwVNSt6R&t=2426',
        },
        {
            'subTopicName': 'Why is hearing Kṛṣṇa’s naimittika-līlā more beneficial for sādhakas than hearing His nitya-līlā? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/6iHGvdhIQT0?si=JXCF__pXqKM4dQFz&t=2809',
        },
        {
            'subTopicName': 'What are the duties expected of a qualified practitioner of sādhana-bhakti? (15 min)',
            'youtubeLink': 'https://youtu.be/W3bCamTcsKM?si=Wwjr1vHT2vUBhNrw&t=1905',
        },
        {
            'subTopicName': 'How to keep the fire of devotional service burning brightly? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/pwByE7bADGc?si=8vO3IsLzb5LichEn&t=4403',
        },
        {
            'subTopicName': 'Appreciation or deep faith in any limb of bhakti is the door to success on the path of bhakti. (4 min)',
            'youtubeLink': 'https://youtu.be/9gCHD1z_nVU?si=kMNzsL9mhp6GJINI&t=2474',
        },
        {
            'subTopicName': 'What is the practice to realize the Absolute Truth? (21 min)',
            'youtubeLink': 'https://www.youtube.com/live/tKtflACfyY0?si=d6EGEPmWrQ4SMepV&t=723',
        },
        {
            'subTopicName': 'Duties expected of a Vaidhī sādhaka. (37 min)',
            'youtubeLink': 'https://youtu.be/XYTw8SXHw_4?si=CjwY2ySowFD26rvv&t=966',
        },
        {
            'subTopicName': 'The 20 aṅgas of bhakti which serve as a door to devotional service. (50 min)',
            'youtubeLink': 'https://youtu.be/DITSI_804SY?si=ZTEszHPdGPE-McdB&t=76',
        },
        {
            'subTopicName': 'Through what means does a sādhaka get protection in his journey towards the goal? (9 min)',
            'youtubeLink': 'https://youtu.be/mtmJpauKcE8?si=qtXIClURfZddVY4R&t=2373',
        },
        {
            'subTopicName': 'Japa is a form of seva. (18 min)',
            'youtubeLink': 'https://youtu.be/tLeqlQn1YkA?si=6WF5175oouqdeZxX&t=2695',
        },
        {
            'subTopicName': 'Proof for anarthas and abhilāṣas coexisting in a sādhaka. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vqtB83kCAKk&t=3019s',
        },
        {
            'subTopicName': 'I have a desire to please Kṛṣṇa through pure bhakti, but I am simultaneously troubled by sinful desires. What is my situation? (3 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=5gg5Qo1v-7u3G1KP&t=5180',
        },
        {
            'subTopicName': 'Karma is not a limb of bhakti. Nitya and naimittika-karma should be given up once pure devotional faith arises. (63 min)',
            'youtubeLink': 'https://www.youtube.com/live/_7Um2tT-z8o?si=IsaqHsJtMh0GVJ9C&t=2466',
        },
        {
            'subTopicName': 'Classic definition of vaidī‑sādhana‑bhakti. (15 min)',
            'youtubeLink': 'https://youtu.be/_7jxSZ7LflE?si=6Qs2TuvmeJonBrzl&t=1107',
        },
        {
            'subTopicName': 'Various ways in which the term “purity” is used in the scriptures. (6 min)',
            'youtubeLink': 'https://youtu.be/vRFiLPh7CDI?si=hHjaUGVHao-7UvO3&t=4615',
        },
        {
            'subTopicName': 'Bhakti‑sādhana. (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/6OI7sdLI8Vo?si=cJE_DSCazTbi5lT7&t=1205',
        },
        {
            'subTopicName': 'Definition of yukta‑vairāgya. (1.09)',
            'youtubeLink': 'https://youtu.be/gepFnz2QEtw?si=NS7PI4qPrzhoSbRj&t=2815',
        },
        {
            'subTopicName': 'The four stages a sādhaka goes through while practising pure devotional service. (5 min)',
            'youtubeLink': 'https://youtu.be/pFkS4zyyVe8?si=HZBV0jVPwppJyrX4&t=1664',
        },
        {
            'subTopicName': 'Ways to achieve Kṛṣṇa smaraṇam and obstacles to achieve Kṛṣṇa smaraṇam. (64 min)',
            'youtubeLink': 'https://youtu.be/MTE2J19gZcA?si=6GHKWTxyD5-5HVzS&t=789',
        },
        {
            'subTopicName': 'Four levels of practising devotional service. (10 min)',
            'youtubeLink': 'https://youtu.be/zkeBvyL8JZY?si=4D4bDcvoV0xppuR6&t=3037',
        },
        {
            'subTopicName': 'How the proper functioning of anus and genitals is important in the practice of devotional service? (2 min)',
            'youtubeLink': 'https://youtu.be/z9bGcrczhi0?si=bW6mJPSKiuahMAE3&t=2721',
        },
        {
            'subTopicName': 'Primary and secondary rules of bhakti. (18 min)',
            'youtubeLink': 'https://youtu.be/R7j9POpY4bU?si=jrZ1zTrw-vb6IQFZ&t=6141',
        },
        {
            'subTopicName': 'Śaraṇāgati in Vaidhī bhakti. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9IZAlA8UENA&t=4765s',
        },
        {
            'subTopicName': 'Types of Pure bhakti - Vaidhī. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9IZAlA8UENA&t=4090s',
        },
        {
            'subTopicName': 'Vaidhī and Rāgānugā Bhakti. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cdYT3svsbSM&t=1550s',
        },
        {
            'subTopicName': 'Rules for cultivating bhakti using body, mind and soul. (46 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OxEHivCX6z0&t=4358s',
        },
        {
            'subTopicName': 'Rules for cultivating bhakti using matter and society. (67 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=uSY2GgRj8UE&t=1403s',
        },
        {
            'subTopicName': 'Definition of Sādhana, Vaidhī and Rāgānugā bhakti. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ob7T9smsFvY&t=2200s',
        },
        {
            'subTopicName': 'Instructions for a Vaidhī Sādhaka to progress to Bhāva/Prema. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2UlP8whEbdI&t=4900s',
        },
        {
            'subTopicName': 'The first 20 limbs of Sādhana Bhakti - The Door to Bhakti. (75 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=whh7hZGhhnc&t=990s',
        },
        {
            'subTopicName': 'Limbs of Bhakti - 21 to 40 (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=whh7hZGhhnc&t=6050s',
        },
        {
            'subTopicName': 'Limbs of Bhakti - 41 to 59 (109 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=zuUVVdQwlVo&t=590s',
        },
        {
            'subTopicName': 'Characteristics of Sādhana Bhakti. (47 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0JhMipOSX34&t=4470s',
        },
        {
            'subTopicName': 'Yukta Vairāgya - The way to Prema. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=zWJCSbQubLQ&t=2160s',
        },
        {
            'subTopicName': 'Secondary rules for self, society and after life. (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ps8gaL79Lqw&t=2307s',
        },
        {
            'subTopicName': 'Practicing Yukta Vairāgya - Practical Tips. (67 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=zWJCSbQubLQ&t=3320s',
        },
        {
            'subTopicName': 'Understanding Sādhana Bhakti (21 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0JhMipOSX34&t=4648s',
        },
        {
            'subTopicName': 'Actions of a Sādhaka are the vector sum of his faith and svabhāva. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Aia0KJjqInw&t=4660s',
        },
        {
            'subTopicName': 'What is the Perfection of Vaidhī Sādhana Bhakti? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=q0FTkYQBz1E&t=4285s',
        },
        {
            'subTopicName': 'Who should practice Vaidhī Sādhana and who should practice Rāgānugā Sādhana Bhakti? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=I6BdqNwsPuY&t=360s',
        },
        {
            'subTopicName': 'Is there a clear demarcation as to when one crosses from Vaidhī to Rāgānugā? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=CV6J5WDhduQ&t=4619s',
        },
        {
            'subTopicName': 'Sādhanā-bhakti stage is characterized by simultaneous presence of Sense gratification and regret. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=3345s',
        },
        {
            'subTopicName': 'Symptoms of true ego in a sādhaka. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=2700s',
        },
        {
            'subTopicName': 'Anuśīlanam ìn the life of a sādhaka. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=1380s',
        },
        {
            'subTopicName': 'How Vaidhī sādhanā transforms into Rāgānugā sādhanā? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=lC3mZpoQvH4&t=3997s',
        },
        {
            'subTopicName': 'System for cultivating the name. (45 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pD0QG8prkIw&t=3570s',
        },
        {
            'subTopicName': 'Chanting the name with aspiration to attain prema ‑ Part‑2. (55 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n6q79aHYYKw&t=30s',
        },
        {
            'subTopicName': 'Chanting the name while aspiring to attain prema ‑ Part‑1. (81 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=S_jL9Vulh-8&t=1620s',
        },
        {
            'subTopicName': 'Progressing from śraddhā to prema. (23 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=S_jL9Vulh-8&t=230s',
        },
        {
            'subTopicName': 'If the Hlādinī‑śakti comes in touch with the Jīva only at the stage of Bhāva‑bhakti, then how does the Sādhaka receive nourishment? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mFOWu4YRy_g&t=4861s',
        },
        {
            'subTopicName': 'Definition of Vaidhī Sādhanā-bhakti. (25 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=_7jxSZ7LflE&t=1141s',
        },
        {
            'subTopicName': 'What are the various ways in which the 3 modes affect a Sādhaka? (57 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vqtB83kCAKk&t=979s',
        },
    ],
    ['Three Modes']: [
        {
            'subTopicName': 'Modes of passion and ignorance can’t be dovetailed in Devotional service. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/99oYGOaS-YQ?si=SVK58sFq4KUddKzP&t=1006',
        },
        {
            'subTopicName': 'Are Lord Brahma and Lord Śiva affected by the 3 modes? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/1wFC-Z4xXpU?si=5LJ38clVODeusmSn&t=4746',
        },
        {
            'subTopicName': 'Do the 3 modes control the desires or the desires determine which mode one is in? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/4N2x3a4P1wM?si=pSDHvP01DLpHk0GT&t=3810',
        },
        {
            'subTopicName': 'How the three modes influence the faith and conditioning of the various types of practitioners? (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/JPJswT-pS9Q?si=URC4kYLT5Lau15bO&t=1325',
        },
        {
            'subTopicName': 'Understanding the influence of the 3 modes and how śuddha-sattva is beyond the 3 modes. (45 min)',
            'youtubeLink': 'https://www.youtube.com/live/2PRIb9fu5iM?si=u78RaO0GQTCM2w7c&t=1038',
        },
        {
            'subTopicName': 'How do we know if my sattva-guṇī conditioning is conducive for my progress in bhakti or not? (8 min)',
            'youtubeLink': 'https://youtu.be/4F6z9cJm02w?si=J7NwM-HpucIDrxvc&t=2780',
        },
        {
            'subTopicName': 'Activities take up the guṇas by the "mentality of the agent" rather than the "object." (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/q21rUjORUJI?si=7wMMtjqP5zP1blJj&t=6289',
        },
        {
            'subTopicName': 'Examples of pure faith affected by modes. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LQZJYlTGtls&t=3505s',
        },
        {
            'subTopicName': 'How to understand that prakṛti is the actual doer? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EledLeVo5J4&t=2580s',
        },
        {
            'subTopicName': 'Hierarchy of sense objects, senses, mind, intelligence, ego and soul. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=x96ilsBtFsI&t=4765s',
        },
        {
            'subTopicName': 'The guṇas can contaminate our faith and our svabhāva. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ewylq64UBGs&t=4972s',
        },
        {
            'subTopicName': 'The guṇas can influence one’s faith. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vqtB83kCAKk&t=1320s',
        },
        {
            'subTopicName': 'The guṇas can influence one’s svabhāva (conditioning). (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vqtB83kCAKk&t=1619s',
        },
        {
            'subTopicName': 'How do the 3 modes of material nature affect one\'s Śraddhā (faith) and one\'s Svabhāva (conditioned nature) differently? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ngo3AF4gytQ&t=1635s',
        },
        {
            'subTopicName': 'Nature of Rajo‑Guṇa - craving for relative happiness than desire for absolute happiness. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nTCjVAghH-8&t=1004s',
        },
        {
            'subTopicName': 'Pure devotional faith and how the modes influence pure scriptural faith. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Aia0KJjqInw&t=3350s',
        },
        {
            'subTopicName': 'How the modes of nature influence the svabhāva of a sādhaka? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Iea5UCJbc6o&t=1263s',
        },
        {
            'subTopicName': 'How do we say devotees are beyond the 3 modes while they are still acting under the influence of the 3 modes? (57 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vqtB83kCAKk&t=979s',
        },
        {
            'subTopicName': 'What are the various ways in which the 3 modes affect a Sādhaka? (57 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vqtB83kCAKk&t=979s',
        },
        {
            'subTopicName': 'Only sattva‑guṇa can be dovetailed in Kṛṣṇa\'s service, rajo‑guṇa and tamo‑guṇa must be given up. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LtduJkS8hZU&t=815s',
        },
    ],
    ['Understanding Śrīla Prabhupāda\'s statements']: [
        {
            'subTopicName': 'Is understanding the 6 systems of philosophy a pre-requisite ot speak on. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=SP3w4IdZBP9x1Sik&t=2759',
        },
        {
            'subTopicName': 'Why did Śrīla Prabhupāda deglamorise the Brahma Jyoti? (30 min)',
            'youtubeLink': 'https://youtu.be/iJx6h4gLfBw?si=h606aJXegUTCxmr4&t=1419',
        },
        {
            'subTopicName': 'Did Śrīla Prabhupāda give a very compromised standard because he preached to the western audience? (12 min)',
            'youtubeLink': 'https://youtu.be/K634Vxup5dM?si=GlPgWgZdEUMaYY81&t=2938',
        },
        {
            'subTopicName': 'What is the true purpose behind Śrīla Prabhupāda\'s stress on establishment of varṇāśrama-dharma? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5kZYfDW2Wsg&t=6188s',
        },
        {
            'subTopicName': 'Understanding Prabhupāda\'s emphasis on falling from Brahmajyoti? (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/EHznydtUlts?si=i1GUH1p_5Wf387Wq&t=3400',
        },
        {
            'subTopicName': 'Understanding Śrīla Prabhupāda’s statements about falling down from Brahma-jyoti. (52 min)',
            'youtubeLink': 'https://www.youtube.com/live/EHznydtUlts?si=6cMd4a9SXzQrK2bP&t=1426',
        },
        {
            'subTopicName': 'Understanding Śrīla Prabhupāda’s statement about Brahman being a temporary place. (20 min)',
            'youtubeLink': 'https://youtu.be/mMx_JB0izg0?si=LTlTyGCggkF2tFs0&t=3494',
        },
        {
            'subTopicName': 'Reason behind Śrīla Prabhupāda naming the 6th Chapter of Canto 2 as ‘Puruṣa‑sūkta Confirmed’. (14 min)',
            'youtubeLink': 'https://youtu.be/gZzy9wAssuA?si=9qS4WXU4QwnhesfB&t=1086',
        },
        {
            'subTopicName': 'Why did Śrīla Prabhupāda have to say that one falls down from Brahmajyoti, when most of the Śāstras and the previous Ācāryas never say so? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jOAW3XNnk5M&t=2415s',
        },
        {
            'subTopicName': 'Importance of understanding Śrīla Prabhupāda\'s teachings in reference to the teachings of the greater Paramparā. (65 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=qNg82CwyIdE&t=3260s',
        },
        {
            'subTopicName': 'Why did Śrīla Prabhupāda emphasise on Bhakti even in the Jñāna yoga and Karma yoga chapters? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=K5BB56w1M38&t=79s',
        },
        {
            'subTopicName': 'It is important to understand the words of an Ācārya in reference to the context, his own greater teachings, and the teachings of the greater Paramparā. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tXLaiH5XLzA&t=2554s',
        },
        {
            'subTopicName': 'Why is contextualisation of Śāstric statements indispensable? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1fMRJBYYcuE&t=1912s',
        },
        {
            'subTopicName': 'How do we ensure that, in the name of contextualizing Śrīla Prabhupāda\'s words, we do not stray away from the core teachings of Śrī Caitanya Mahāprabhu? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1fMRJBYYcuE&t=3433s',
        },
        {
            'subTopicName': 'Were Śrīla Prabhupāda and Jesus Śaktyāveśa‑avatāras? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=3769s',
        },
        {
            'subTopicName': 'How can we take \'Bhagavad‑gītā As It Is\' book as ‘as it is’, if only Bhakti aspect is prioritized? Is it not biased? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=2811s',
        },
        {
            'subTopicName': 'How to understand the words of Prabhupāda stating that one should perform their prescribed duties? Does Prabhupāda refer to Varṇāśrama prescribed duties as being non negotiable for sādhakas? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=1908s',
        },
        {
            'subTopicName': 'What does it mean when Śrīla Prabhupāda says: Kṛṣṇa consciousness begins on the platform of pure goodness( viśuddha‑sattva). (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=1805s',
        },
    ],
    ['Vaiṣṇava Hermeneutics']: [
        {
            'subTopicName': 'Why are the Brāhmaṇas glorified sometimes in the Śrīmad‑Bhāgavatam to be more exalted than even the Supreme Lord? (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tXLaiH5XLzA&t=1041s',
        },
        {
            'subTopicName': 'Though spoken by exalted devotees, the words of Śrīmad‑Bhāgavatam need NOT be always philosophically correct. (26 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tXLaiH5XLzA&t=1862s',
        },
        {
            'subTopicName': 'It is important to understand the words of an Ācārya in reference to the context, his own greater teachings, and the teachings of the greater Paramparā. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=tXLaiH5XLzA&t=2554s',
        },
        {
            'subTopicName': 'Why is contextualisation of Śāstric statements indispensable? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1fMRJBYYcuE&t=1912s',
        },
        {
            'subTopicName': 'How do we ensure that, in the name of contextualizing Śrīla Prabhupāda\'s words, we do not stray away from the core teachings of Śrī Caitanya Mahāprabhu? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1fMRJBYYcuE&t=3433s',
        },
        {
            'subTopicName': 'If all the sacrifices are supposed to be offered in Agni, who is considered the mouth of sacrifices, how can we understand statements in Śāstras that say that Fire is unconscious and hence offering food to the Brāhmaṇas\' mouth is much better? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1fMRJBYYcuE&t=4361s',
        },
        {
            'subTopicName': 'Parīkṣit Mahārāj didn\'t ask any question to Śukadeva Gosvāmī about Goloka Vṛndāvana in Śrīmad‑Bhāgavatam. Then, how is it that he is answering about Goloka Vṛndāvana to Mother Uttarā in Śrī Bṛhad‑bhāgavatāmṛta? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0IPPwGpKaKc&t=2260s',
        },
        {
            'subTopicName': 'How do we understand the 4 Kumāras to be mixed devotees when they actually lead the Kumāra‑sampradāya? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0qKHOs7NFqM&t=4676s',
        },
        {
            'subTopicName': 'Were Śrīla Prabhupāda and Jesus Śaktyāveśa‑avatāras? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=3769s',
        },
        {
            'subTopicName': 'Will a Gauḍīya Vaiṣṇava devotee go to Vaikuṇṭha if a particular section of the Bhāgavatam that he reads has a Phala‑śruti associated with Vaikuṇṭha? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=2440s',
        },
        {
            'subTopicName': 'What are the Common recommendations, the Highest recommendations, and allowances prescribed in the Mahābhārata, Bhagavad‑gītā, Bhāgavatam and Caitanya‑caritāmṛta? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=5298s',
        },
        {
            'subTopicName': 'What is the purpose of our ācāryas elaborately describing to the sādhaka devotees these elevated topics about gopīs’s feelings of separation? How should one assess one’s qualification to hear these topics? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=6820s',
        },
        {
            'subTopicName': 'When śāstras say that Only a killer of animals will not hear the glories of the Lord, does it mean that animal killers cannot take up to devotion? (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nVfSEaO-qWc&t=3883s',
        },
        {
            'subTopicName': 'Discussion on the terminology \'pure devotee\'. (29 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=phYwzJ8IFGc&t=3885s',
        },
        {
            'subTopicName': 'How can we take \'Bhagavad‑gītā As It Is\' book as ‘as it is’, if only Bhakti aspect is prioritized? Is it not biased? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=2811s',
        },
        {
            'subTopicName': 'How to understand the words of Prabhupāda stating that one should perform their prescribed duties? Does Prabhupāda refer to Varṇāśrama prescribed duties as being non negotiable for sādhakas? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=1908s',
        },
        {
            'subTopicName': 'Most important hermeneutic principle for a sādhaka in understanding śāstras. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=1001s',
        },
    ],
    ['Vaiṣṇava sampradāyas']: [
        {
            'subTopicName': 'Can other sampradāya devotees come to bhāva/prema stage? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/Z076in9W9-w?si=3QlykspzkamT3THf&t=3663',
        },
        {
            'subTopicName': 'Can a great ācārya like Rāmānujācārya present a philosophy or a conclusion which is improper or incomplete? (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/ZwW__cOftwg?si=KqNaOVkoVoLNwgWP&t=990',
        },
        {
            'subTopicName': 'How can the bona fide ācāryas of the other sampradāyas not be aware of the supremacy of Kṛṣṇa? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/ZwW__cOftwg?si=pQEUXY1lDM7n3axt&t=2411',
        },
        {
            'subTopicName': 'How the other sampradāyas react to the exclusive Gauḍīya Vaiṣṇava explanations? (10 min)',
            'youtubeLink': 'https://youtu.be/yIDZBJMd_QE?si=REFRs5ZAfx7YX0nJ&t=3693',
        },
        {
            'subTopicName': 'How different sampradāyas coexist, each believing the supremacy of their own path, while accepting the same Vedic scriptures? (32 min)',
            'youtubeLink': 'https://youtu.be/5hC01vRCDj8?si=sHTfO-WZKQQoXPSF&t=959',
        },
        {
            'subTopicName': 'Process of maturation of faith in vicāra vs rasa path. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2Y7OJqc-9Eo&t=2995s',
        },
        {
            'subTopicName': 'Differences between vicāra and rasa devotional paths. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2Y7OJqc-9Eo&t=6468s',
        },
        {
            'subTopicName': 'Is krama-mukti taught in other sampradāyas? If yes, then how is it a pure devotional sampradāya? (19 min)',
            'youtubeLink': 'https://youtu.be/ubOIdKVoXew?si=Vqx9VliJd7t_fWAH&t=2641',
        },
        {
            'subTopicName': 'What do we do if contradictory explanations are given by the ācāryas of other sampradāyas? (16 min)',
            'youtubeLink': 'https://www.youtube.com/live/g_MA-tQ48M0?si=rs5fBk4qlU7JjPLZ&t=2013',
        },
        {
            'subTopicName': 'How to understand in which sampradāya to place our faith when there is a reasonable explanation for all the verses in the different sampradāyas? (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/g_MA-tQ48M0?si=d06CEOfvZTnWKpu8&t=5142',
        },
        {
            'subTopicName': 'Do the other Vaiṣṇava sampradāyas accept Śrīdhara Swami’s commentary as the topmost authority? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/K_sLYVaKqnQ?si=-0iZDhwrZFNn4I-M&t=1847',
        },
        {
            'subTopicName': 'Dāsa‑abhimāna in the Gauḍīya‑sampradāya Vs other Sampradāyas. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=La-E5bGUD4w&t=1606s',
        },
        {
            'subTopicName': 'If Śrī Caitanya Mahāprabhu Himself borrowed 2 principles each from every Vaiṣṇava Sampradāya, why should we NOT not borrow? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gjIKMojudEU&t=1355s',
        },
        {
            'subTopicName': 'Similarities in conclusions and differences in details amongst the various Vaiṣṇava Sampradāyas. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gjIKMojudEU&t=382s',
        },
        {
            'subTopicName': 'Is Vraja‑bhakti for everyone? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=948s',
        },
    ],
    ['Varṇāśrama']: [
        {
            'subTopicName': 'Can birth be an indicator of one\'s Varṇa. (6 min)',
            'youtubeLink': 'https://youtu.be/d8hiSn1MoDo?si=gOJWE8XptcTiWYdJ&t=4979',
        },
        {
            'subTopicName': 'Dharma changes according to one\'s adhikāra. (6 min)',
            'youtubeLink': 'https://youtu.be/yGDWZZirSt0?si=RXl2q8hrJW6A0zdq&t=3991',
        },
        {
            'subTopicName': 'Understanding Śrīla Prabhupāda\'s take on Varṇāśrama. (17 min)',
            'youtubeLink': 'https://youtu.be/yGDWZZirSt0?si=0MYTfC5PwLk4mu7G&t=4324',
        },
        {
            'subTopicName': 'Does birth determine one\'s varṇa? (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=iOP59vUAD6F2D7wN&t=3051',
        },
        {
            'subTopicName': 'What does the statement that "Devotees do not perform Varṇāśrama" mean? (9 min)',
            'youtubeLink': 'https://youtu.be/W3bCamTcsKM?si=nYhKF22WDCgyy_xQ&t=2820',
        },
        {
            'subTopicName': 'Is performance of varṇāśrama duties favorable or an obstacle to Bhakti? (32 min)',
            'youtubeLink': 'https://www.youtube.com/live/RTepF-Dr4NI?si=o_Cjn_vrDaMSqmXX&t=1667',
        },
        {
            'subTopicName': 'Why varṇāśrama-dharma is not considered as "paro-dharma"? (33 min)',
            'youtubeLink': 'https://www.youtube.com/live/VFhaouqZfSI?si=GKbBaO0-bD1k1SjM&t=1856',
        },
        {
            'subTopicName': 'Are varṇāśrama and cow protection outside the scope of bhakti? (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/VFhaouqZfSI?si=lHlf1HfjrPYFMCXY&t=4333',
        },
        {
            'subTopicName': 'Who all are expected to perform varṇāśrama duties? (7 min)',
            'youtubeLink': 'https://youtu.be/PdH_1kgQXJs?si=RYT0jWZMwb4628ZS&t=1922',
        },
        {
            'subTopicName': 'What is accomplished by the performance of varṇāśrama-prescribed duties? (7 min)',
            'youtubeLink': 'https://youtu.be/PdH_1kgQXJs?si=ib9P5YETVbcSCc7P&t=2338',
        },
        {
            'subTopicName': 'Does birth play a role in ascertaining one\'s varṇa? (19 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=Z-nkBjFw6qf95a9K&t=3050',
        },
        {
            'subTopicName': 'How would a bhakti-yogī\'s heart be purified if he neglects his varṇāśrama-dharma? (20 min)',
            'youtubeLink': 'https://youtu.be/PdH_1kgQXJs?si=CRTUOMQHD-zohOL2&t=2744',
        },
        {
            'subTopicName': 'How would a bhakti-yogī\'s heart be purified if neglects his varṇāśrama-dharma? (20 min)',
            'youtubeLink': 'https://youtu.be/PdH_1kgQXJs?si=z_GY6KVZp3eieZ5C&t=2744',
        },
        {
            'subTopicName': 'How do we understand Śrīla Prabhupāda\'s 50% incomplete work - the varṇāśrama system? (22 min)',
            'youtubeLink': 'https://youtu.be/XYTw8SXHw_4?si=Vvl_H_5vEUi2l2yD&t=3220',
        },
        {
            'subTopicName': 'Devotees and varṇāśrama prescribed duties. (8 min)',
            'youtubeLink': 'https://youtu.be/pDOOsYw50J8?si=cRLHMbWHoQPNo_9y&t=5380',
        },
        {
            'subTopicName': 'Who is qualified to give up varṇāśrama-prescribed duties? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4HjKSGFbgAY&t=1281s',
        },
        {
            'subTopicName': 'Even Kṛṣṇa performs varṇāśrama duties to set the right example. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4HjKSGFbgAY&t=3467s',
        },
        {
            'subTopicName': 'Dharma should be according to varṇa. (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1T1tquP4yzU&t=4128s',
        },
        {
            'subTopicName': 'Understanding vānaprastha-āśrama on the gradual path. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=__YuiNf5o1g&t=770s',
        },
        {
            'subTopicName': 'Varṇāśrama duties are not limbs of bhakti. (36 min)',
            'youtubeLink': 'https://youtu.be/kVLqAUzRayw?si=QyOu9FB1tKFiZXLc&t=120',
        },
        {
            'subTopicName': 'Was varṇāśrama‑system corrupted even in those days? Even though Vidura had good qualities, why then was he judged based on his birth? (1 min)',
            'youtubeLink': 'https://www.youtube.com/live/Fj7DzcIWN64?si=nclEr2R0gMzsy4wG&t=3331',
        },
        {
            'subTopicName': 'Detailed analysis about saṁskāras. (30 min)',
            'youtubeLink': 'https://youtu.be/_hEdInbzrv8?si=Bonzv5NwzHvY9G6e&t=2621',
        },
        {
            'subTopicName': 'If varṇāśrama is not a limb of bhakti, then how do we understand some verses which seem to indicate the contrary? (7 min)',
            'youtubeLink': 'https://youtu.be/0W5mBmDmT2w?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=2362',
        },
        {
            'subTopicName': 'Why should we not force devotees into varṇāśrama till the time we have a robust system to support it economically? (14 min)',
            'youtubeLink': 'https://youtu.be/YacS18Q0dDI?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=4924',
        },
        {
            'subTopicName': 'By performing varṇāśrama duties with detachment one gets ready for liberation. (2 min)',
            'youtubeLink': 'https://youtu.be/sbdWireHqZU?si=eaTaBkS3SbTTY9lh&t=1903',
        },
        {
            'subTopicName': 'What is role of varṇāśrama in the practice of bhakti and how do we reconcile the apparent contradictions between the statements of different ācāryas? (47 min)',
            'youtubeLink': 'https://youtu.be/gaqtgYl08Mc?si=mXOQd6tm5LHolHfH&t=749',
        },
        {
            'subTopicName': 'Traditional varṇāśrama vs daivi varṇāśrama. (20 min)',
            'youtubeLink': 'https://youtu.be/gaqtgYl08Mc?si=AXGmuTbGF0OiOkuv&t=2152',
        },
        {
            'subTopicName': 'Why varṇāśrama system? (15 min)',
            'youtubeLink': 'https://youtu.be/_wrlUjnpmmI?si=pz-IzFCagcLT0z9M&t=1090',
        },
        {
            'subTopicName': 'Are Varṇāśrama colleges diluting principles of Pure Devotional Service? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=rvVgw0pUnkg&t=4484s',
        },
        {
            'subTopicName': 'Is varṇāśrama an obstacle to Vaidhī bhakti? (22 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=enPoIGsy4Pw&t=3240s',
        },
        {
            'subTopicName': 'Varṇāśrama as an obstacle to bhakti. (46 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=enPoIGsy4Pw&t=3240s',
        },
        {
            'subTopicName': 'Deterioration of the Varṇāśrama system in India. (28 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=uvtPbeUA1zY&t=3420s',
        },
        {
            'subTopicName': 'Why is Varṇāśrama rejected in our Sampradāya? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Pwp-nD5Wtlc&t=4726s',
        },
        {
            'subTopicName': 'Varṇāśrama leads to purification and mukti. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=aM97nlDGpJg&t=2430s',
        },
        {
            'subTopicName': 'Are Varṇāśrama positions designations of the soul? (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=TNeLuClc1oI&t=3263s',
        },
        {
            'subTopicName': 'Birth also has a role in deciding Varṇa. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ps8gaL79Lqw&t=3730s',
        },
        {
            'subTopicName': 'Giving up Saṁskāras results in difficulty in ascertaiting the Varṇa. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ps8gaL79Lqw&t=3960s',
        },
        {
            'subTopicName': 'Duties of various varṇas and āśramas. (44 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=aM97nlDGpJg&t=3240s',
        },
        {
            'subTopicName': 'A king must externally follow the dharma śāstras though he may be qualified for jñāna. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4HjKSGFbgAY&t=3149s',
        },
        {
            'subTopicName': 'Performing Varṇāśrama duties with detachment results in purification of the heart on the Gradual Path. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0fAPjgx62_8&t=463s',
        },
        {
            'subTopicName': 'Purpose of performing Varṇāśrama duties. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4HjKSGFbgAY&t=1488s',
        },
        {
            'subTopicName': 'Significance of Varṇāśrama duties for various categories of spiritual aspirants. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4HjKSGFbgAY&t=1975s',
        },
        {
            'subTopicName': 'When can one give up Varṇāśrama duties? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4HjKSGFbgAY&t=4658s',
        },
        {
            'subTopicName': 'Why does Śrīmad‑Bhāgavatam contain glorification of Brāhmaṇas if it rejects Varṇāśrama? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=y7FRfYpPTxo&t=3416s',
        },
        {
            'subTopicName': 'Varṇa designations are not appropriate for a Vaiṣṇava. (49 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=2500s',
        },
        {
            'subTopicName': 'Mixed Devotional Service and Varṇāśrama designations. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=5455s',
        },
        {
            'subTopicName': 'Is Varṇa not dependent on birth? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OSP02lDJzkw&t=3250s',
        },
        {
            'subTopicName': 'Is Vānaprastha‑āśrama mandatory for all Gṛhastha devotees? (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=650s',
        },
        {
            'subTopicName': 'Why did pure devotees like Pṛthu Mahārāja engage in their Varṇāśrama duties perfectly? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=2942s',
        },
        {
            'subTopicName': 'What is the destination of Kṣatriyas and Vaiśyas in the gradual path of Varṇāśrama as they cannot take to Sannyāsa? (1 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=glVWOuUj9OA&t=3050s',
        },
        {
            'subTopicName': 'How to understand the words of Prabhupāda stating that one should perform their prescribed duties? Does Prabhupāda refer to Varṇāśrama prescribed duties as being non negotiable for sādhakas? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=1908s',
        },
    ],
    ['Vraja Prema']: [
        {
            'subTopicName': 'Right wing vs Left wing gopīs\' flavor of service to Krishna. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/zikcWKy_ugw?si=td0aD_io3qLp-Jm_&t=3948',
        },
        {
            'subTopicName': 'Kṛṣṇa establishes exalted position of the Gopī\'s love. (90 min)',
            'youtubeLink': 'https://www.youtube.com/live/otTjvHH4z2g?si=p10_tfSTG92lu0Kh&t=2310',
        },
        {
            'subTopicName': 'Transcendental nature of the love between the Gopīs and Kṛṣṇa. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/LgCt_b8JFJ8?si=C9V71Gvc7dWD80xG&t=937',
        },
        {
            'subTopicName': 'The Left wing Gopīs control Kṛṣṇa. (27 min)',
            'youtubeLink': 'https://www.youtube.com/live/YrZvu95et_M?si=2UiAtbP58wlyfx30&t=1332',
        },
        {
            'subTopicName': 'What is the mood of devotees who worship Jagannātha? (2 min)',
            'youtubeLink': 'https://youtu.be/sJhDmHinfOI?si=KP7KEKR51KtYi5bu&t=2839',
        },
        {
            'subTopicName': 'Why did Śrīla Prabhupāda encourage the worship of Jagannātha deities? (2 min)',
            'youtubeLink': 'https://youtu.be/sJhDmHinfOI?si=gzk0WN1gc3cWH-x6&t=5542',
        },
        {
            'subTopicName': 'The love of the Vrajavāsīs is not dependent on knowledge of Kṛṣṇa. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/dDFWGaCRpFk?si=vsopaKBEyNETD9jV&t=3705',
        },
        {
            'subTopicName': 'Intense mood of separation is felt only by the Vrajavāsīs? (9 min)',
            'youtubeLink': 'https://youtu.be/48HdPQhxDeU?si=GHHSdSTHOp9Xwtqa&t=3383',
        },
        {
            'subTopicName': 'Giving up of karma is essential to develop the mood of Vraja-bhakti. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/7FxSflL0bG8?si=aA-I0uFmGg3rf0QZ&t=150',
        },
        {
            'subTopicName': 'Vīraha‑bhāva of the Vrajavāsīs explained by Kṛṣṇa Himself. (65 min)',
            'youtubeLink': 'https://youtu.be/JrMQzTlp4iE?si=8DVFUw0rRyT02wQG&t=886',
        },
        {
            'subTopicName': 'The twin moods of prema: the heat of separation and coolness of union. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/ez76v_qh4zA?si=pGJ8POmxyqtpp_Rr&t=605',
        },
        {
            'subTopicName': 'The feeling of separation from Kṛṣṇa stirs even inanimate things. (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/ez76v_qh4zA?si=4b7s2miJtAsiLC3b&t=1471',
        },
        {
            'subTopicName': 'Supremacy of Mother Yaśodā, who, among all the devotees, brought Kṛṣṇa under her control. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Kbi_NC_cDbU&t=3750s',
        },
        {
            'subTopicName': 'Why do Lord Śiva and Lord Brahmā not follow in the footsteps of the Vrajavāsīs even though they are Devotees? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=irXwcVTNbbQ&t=5180s',
        },
        {
            'subTopicName': 'How did Vrajavāsīs love Kṛṣṇa more than their own Children? (30 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=AMDxJYuf6xM&t=1260s',
        },
        {
            'subTopicName': 'The unique good fortune of the Vrajavāsīs as compared with others. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JRqNYNleALQ&t=4370s',
        },
        {
            'subTopicName': 'Glories of Mother Yaśodā\'s sweet Vātsalya Prema. (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cCMI4GYa-g4&t=3270s',
        },
        {
            'subTopicName': 'Understanding Rāgātmikā Bhakti. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ob7T9smsFvY&t=3660s',
        },
        {
            'subTopicName': 'Understanding Vrajavāsī\'s greater love for Kṛṣṇa than their own children. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=AMDxJYuf6xM&t=95s',
        },
        {
            'subTopicName': 'Why Uttara feels that Goloka cannot be a part of Vaikuṇṭha? (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=P3ZnLJs5ICc&t=1690s',
        },
        {
            'subTopicName': 'Veṇu‑gītā ‑ Part 1 (94 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=72_gLEYpXNg&t=1010s',
        },
        {
            'subTopicName': 'Veṇu‑gītā ‑ Part 2 (34 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JsxlorE3-fc&t=2115s',
        },
        {
            'subTopicName': 'Veṇu‑gītā ‑ Part 3 (32 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=qW_I1-vb5fs&t=1778s',
        },
        {
            'subTopicName': 'Veṇu‑gītā ‑ Part 4 (48 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ZUnbRbGaojk&t=3285s',
        },
        {
            'subTopicName': 'The 3 chief Hari‑dāsas (Servants of Lord Hari) ‑ Yudhiṣṭhira, Uddhava and Govardhana Hill. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=DYVNES6xu2Q&t=1920s',
        },
        {
            'subTopicName': 'Veṇu‑gītā ‑ Part 5 (34 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=DYVNES6xu2Q&t=1500s',
        },
        {
            'subTopicName': 'Kṛṣṇa steals the Garments of unmarried Gopīs ‑‑ Part 2 (71 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=M4uzc8AOsHw&t=2705s',
        },
        {
            'subTopicName': 'Why did the Vraja Gopīs worship Kātyāyanī Devī? (37 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2xR9wTPsUG8&t=45s',
        },
        {
            'subTopicName': 'Kṛṣṇa steals the Garments of unmarried Gopīs ‑ Part 1 (85 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=FTNrcgmJFck&t=1630s',
        },
        {
            'subTopicName': 'Kṛṣṇa steals the Garments of unmarried Gopīs ‑ Part 3 (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=_MHWgq-IcYU&t=2460s',
        },
        {
            'subTopicName': 'The 8 Principal Gopa friends of Śrī Kṛṣṇa and the 8 Principal Gopī friends of Śrīmatī Rādhārāṇī. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=_MHWgq-IcYU&t=5600s',
        },
        {
            'subTopicName': 'Is it true that the airplanes come only to go to Vaikuṇṭha, but for going to Goloka one has to only change his consciousness? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0IPPwGpKaKc&t=1391s',
        },
        {
            'subTopicName': 'What is the reason why Advaita Ācārya did not distribute Vraja‑prema? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=La-E5bGUD4w&t=635s',
        },
        {
            'subTopicName': 'Lamentation of the gopīs hearing Akrūra’s intention to take Kṛṣṇa and Balarāma out of Vṛndāvana. (39 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=94rr4vmqmGM&t=2820s',
        },
        {
            'subTopicName': 'Analysis of the Sāmagrī bhāvas in the expressions of gopīs’ lamentation. (35 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=94rr4vmqmGM&t=2980s',
        },
        {
            'subTopicName': 'Did all the Ṛṣi‑cārī‑gopīs take part in Rāsa‑līlā? (47 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=F17c52Fz5E0&t=90s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize the Creator. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=2081s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize Kṛṣṇa for being indifferent towards them and deciding to leave to Mathurā. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=3876s',
        },
        {
            'subTopicName': 'Kāma‑rūpā rāgātmikā-bhakti of gopīs. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mPV5ksADt7o&t=1945s',
        },
        {
            'subTopicName': 'Kāma‑rūpā rāgātmikā-bhakti. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=6180s',
        },
        {
            'subTopicName': 'Understanding Pūrvarāga and Utkaṇṭhitā. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=2100s',
        },
        {
            'subTopicName': 'Kāma‑rūpā and Sambandha‑rūpā Rāgātmikā-bhakti. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=1110s',
        },
        {
            'subTopicName': 'Understanding Rāgātmikā-bhakti. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=n_xIIBMzcG8&t=650s',
        },
        {
            'subTopicName': '2 types of Rāgātmikā-bhakti. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cOjeSXHw1N0&t=6800s',
        },
        {
            'subTopicName': 'Understanding Rāgātmikā-bhakti. (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cOjeSXHw1N0&t=2985s',
        },
        {
            'subTopicName': 'What is the purpose of our ācāryas elaborately describing to the sādhaka devotees these elevated topics about gopīs’s feelings of separation? How should one assess one’s qualification to hear these topics? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=6820s',
        },
        {
            'subTopicName': 'Gopīs cry out loudly to prevent Kṛṣṇa from leaving Vṛndāvana. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=l9JSxaKiTi8&t=4447s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs’ inability to exist without Kṛṣṇa (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=l9JSxaKiTi8&t=4050s',
        },
        {
            'subTopicName': 'Gopīs’ attachment to Kṛṣṇa in not letting him go to Mathurā is not due to material possessiveness. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=4390s',
        },
        {
            'subTopicName': 'Lamentation of gopīs for Kṛṣṇa\'s departure from Vṛndāvana and Lord’s messages of reassurance (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BNepBkhv7aA&t=3465s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs decide to abandon all dharma and directly try to stop Kṛṣṇa from leaving Vṛndāvana. (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ix-cxhDpdCg&t=4170s',
        },
        {
            'subTopicName': 'Are the gopīs really envious on the women of mathura that they will now get to relish Kṛṣṇa? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ix-cxhDpdCg&t=2663s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize Akrūra as a krūra or cruel man (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=6070s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs express envy towards women of Mathurā (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=4950s',
        },
        {
            'subTopicName': 'Is Vraja‑bhakti for everyone? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HUaTcxskDKQ&t=948s',
        },
        {
            'subTopicName': 'How Lord Kṛṣṇa\'s consorts help him taste rasa and help him in his pastime? (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=4265s',
        },
        {
            'subTopicName': 'Gopī\'s imagination of festival in Mathurā & Kṛṣṇa\'s welcome. (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=5600s',
        },
    ],
    ['kṛṣṇas tu bhagavān svayam']: [
        {
            'subTopicName': 'Why Hiraṇyakaśipu and Rāvaṇa did not get liberated but Śiśupāla got liberated?. (34 min)',
            'youtubeLink': 'https://youtu.be/caXzDBid3j4?si=pJtg49F7sDtsuVXf&t=1348',
        },
        {
            'subTopicName': 'Tāratamya in parāvastha forms. (47 min)',
            'youtubeLink': 'https://youtu.be/BVsbtJr0hp8?si=b3x1qqXCh_2hYfaP&t=829',
        },
        {
            'subTopicName': 'Why the demons killed by Kṛṣṇa attain Liberation and not by the other forms? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/Xj9jrl12VB4?si=vKhsHQ0uJKp_NQpU&t=2086',
        },
        {
            'subTopicName': 'Sweetness of Kṛṣṇa\'s relation with His devotees attracts even Lord Viṣṇu. (16 min)',
            'youtubeLink': 'https://youtu.be/yIDZBJMd_QE?si=CtpYqIMX-l8GaLyk&t=2597',
        },
        {
            'subTopicName': 'Kṛṣṇa is not an aṁśa of Nārāyaṇa. (30 min)',
            'youtubeLink': 'https://youtu.be/ICXPGRidIZM?si=vUzoM_xfxQln4N5D&t=231',
        },
        {
            'subTopicName': 'Because Kṛṣṇa is svayam-bhagavān, He can attract demons and devotees alike. (12 min)',
            'youtubeLink': 'https://youtu.be/o88wd4wqTrY?si=iYiz37Ub_xXj_ynT&t=193',
        },
        {
            'subTopicName': 'Amongst the three paravastha forms, Kṛṣṇa\'s form is the best. (5 min)',
            'youtubeLink': 'https://youtu.be/Sw5xO5BaoI8?si=-hL77Fwq4ZBef5Xi&t=2647',
        },
        {
            'subTopicName': 'Explanation of the "ete cāṁśa-kalāḥ puṁsaḥ" verse. (22 min)',
            'youtubeLink': 'https://www.youtube.com/live/AfxpAnkX-t4?si=paU7JrX82o_5nzIT&t=2392',
        },
        {
            'subTopicName': 'Elaboration on the "ete cāṁśa-kalāḥ puṁsaḥ" verse. (60 min)',
            'youtubeLink': 'https://www.youtube.com/live/PMVSc2dJ8vY?si=vHq6XnVEM_67SmdF&t=98',
        },
        {
            'subTopicName': 'Various Brahmās are emanations from Puruṣa-avatāras and these Brahmās are bowing down to Kṛṣṇa. Hence Kṛṣṇa is supreme. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/7lfELjXi5wQ?si=KOb0rIAhAIvWIPyp&t=4452',
        },
        {
            'subTopicName': 'Only Kṛṣṇa\'s form is the most suitable form for human-like pastimes. (21 min)',
            'youtubeLink': 'https://www.youtube.com/live/nb7gHrc5kUQ?si=S8k_F95xtORykxtV&t=959',
        },
        {
            'subTopicName': 'The complete extent of Yogamāyā is displayed only in the pastimes of Kṛṣṇa. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/nb7gHrc5kUQ?si=Ftz_Dlzn9KNnBY_2&t=2154',
        },
        {
            'subTopicName': 'Superiority of Kṛṣṇa over Nārāyaṇa is shown by showing how Mother Lakṣmī has desire to attain Lord Kṛṣṇa\'s chest. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/nb7gHrc5kUQ?si=5GqT7GOefiukHEHC&t=4189',
        },
        {
            'subTopicName': 'Superiority of Kṛṣṇa\'s names over the names of Lord Nārāyaṇa. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/nb7gHrc5kUQ?si=YtmuiN9EswMHk3zC&t=4716',
        },
        {
            'subTopicName': 'Establishing Kṛṣṇa\'s form to be svayaṁ-rūpa through Brahma-saṁhitā. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/wA-GpgZ-J4c?si=poi831EuyjcjtE_V&t=1086',
        },
        {
            'subTopicName': 'If Kṛṣṇa appeared only at the end of Dvāpara-yuga, how can one say that Nārāyaṇa, who is without beginning, is his vilāsa expansion? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/wA-GpgZ-J4c?si=kVg0N_-2Ze6VgcC0&t=4449',
        },
        {
            'subTopicName': 'Proof that Kṛṣṇa descends with all his vilāsa and amśa forms. (16 min)',
            'youtubeLink': 'https://www.youtube.com/live/nOfNItlQ3Y4?si=cBa89WbcAGyUXFWO&t=1381',
        },
        {
            'subTopicName': 'Explanation of the "Īśvaraḥ paramah kṛṣṇaḥ" verse. (30 min)',
            'youtubeLink': 'https://youtu.be/5XncZKbSKHA?si=xUFXtRe7MaGZ6Sy_&t=1809',
        },
        {
            'subTopicName': 'Kṛṣṇa can attract demons and devotees alike. (12 min)',
            'youtubeLink': 'https://youtu.be/o88wd4wqTrY?si=LCjsWXGclxZeJtxP&t=173',
        },
        {
            'subTopicName': 'More complete happiness can come from a more complete display of qualities by Kṛṣṇa and not by a partial display of qualities by His amśas. (6 min)',
            'youtubeLink': 'https://youtu.be/hlGCNWin6B0?si=wwWenbfaAibQK3Ba&t=3047',
        },
        {
            'subTopicName': 'Vyūha-avatāras are expansions of Kṛṣṇa. (18 min)',
            'youtubeLink': 'https://youtu.be/tH-6gKdbtpM?si=oFslikOaN5kZFdec&t=2083',
        },
        {
            'subTopicName': 'Kṛṣṇa is the source of Karaṇodakaśāyī and Garbhodakaśāyī Viṣṇus. (56 min)',
            'youtubeLink': 'https://youtu.be/WktP5zXDiUk?si=0f7d-_7EUhBycpPb&t=248',
        },
        {
            'subTopicName': 'Kṛṣṇa is the source of the puruṣāvatāras. (25 min)',
            'youtubeLink': 'https://youtu.be/R40e2EnGLi8?si=OxzE0180CSoS_ACn&t=1860',
        },
        {
            'subTopicName': 'Kṛṣṇa\'s amśas cannot give liberation to the demons. (30 min)',
            'youtubeLink': 'https://youtu.be/hlGCNWin6B0?si=c5fgzjJnQ0dKZLb5&t=1223',
        },
        {
            'subTopicName': 'Kṛṣṇa superior to all puruṣāvatāras (24 min)',
            'youtubeLink': 'https://youtu.be/3xGfFG7YTis?si=z2VlE4CAwYMSzR6n&t=1614',
        },
        {
            'subTopicName': 'Proof that Kṣīrodakaśāyī Viṣṇu is an amśa of Kṛṣṇa. (44 min)',
            'youtubeLink': 'https://youtu.be/-AcdZYA0xAo?si=QfIaNLarHEIDH1NI&t=806',
        },
        {
            'subTopicName': 'Kṛṣṇa is superior to Vasudeva of the Caturvyūha. (30 min)',
            'youtubeLink': 'https://youtu.be/vGhxGZ8AHOo?si=cFHLUTcRAcHykffi&t=1573',
        },
        {
            'subTopicName': 'Kṛṣṇa is superior to Brahman. (48 min)',
            'youtubeLink': 'https://youtu.be/JEBABitOvb0?si=2O5f2vm9JTK9AJwd&t=714',
        },
        {
            'subTopicName': 'Kṛṣṇa is superior to Nārāyaṇa. (16 min)',
            'youtubeLink': 'https://youtu.be/rXEpkJlusHo?si=K5BVQO-53smNN9xe&t=2218',
        },
        {
            'subTopicName': 'Kṛṣṇa\'s superior qualities. (22 min)',
            'youtubeLink': 'https://youtu.be/8fJ5oYINzpQ?si=bbZFc0A_2csM6qpa&t=1113',
        },
        {
            'subTopicName': 'Superiority of Kṛṣṇa over Nārāyaṇa. (50 min)',
            'youtubeLink': 'https://youtu.be/IhuVM6RY_tE?si=xX9_TwlZLYS4SXTL&t=358',
        },
        {
            'subTopicName': 'Only Kṛṣṇa can deliver liberation to the demons He kills. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/e8Xim730Nz8?si=98zrVBvTBPJbBkXx&t=2190',
        },
        {
            'subTopicName': 'Kṛṣṇa’s form is Supreme. (27 min)',
            'youtubeLink': 'https://www.youtube.com/live/nFbtd7AIHZA?si=Y7JCnHo1r1_WQ_QF&t=1624',
        },
        {
            'subTopicName': 'Lakṣmī’s desire to attain Kṛṣṇa. (16 min)',
            'youtubeLink': 'https://youtu.be/Y-pt0okA-A0?si=tVTHl1UFOwvnO-eD&t=1517',
        },
        {
            'subTopicName': 'Superiority of Kṛṣṇa’s name. (17 min)',
            'youtubeLink': 'https://youtu.be/Y-pt0okA-A0?si=hs8heava9IKc-5sg&t=2462',
        },
        {
            'subTopicName': 'Kṛṣṇa manifests līlā‑avatars in Vṛndāvana. (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/Oojw4x1Jx6c?si=qSisesX4K9noOzdy&t=1288',
        },
        {
            'subTopicName': 'Lord Śrī Kṛṣṇa is superior to Lord Nārāyaṇa. (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/QS1HpvX2VN4?si=yhGQsU_MdBbs1PMQ&t=1760',
        },
        {
            'subTopicName': 'SB10.14:14(nārāyaṇas tvaṁ na hi sarva‑dehinām)‑‑Verse to prove that Kṛṣṇa is Svayam Bhagavān. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wiiBuDgtFJM&t=5200s',
        },
        {
            'subTopicName': 'Perfection of all rasas is in Kṛṣṇa. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=5190s',
        },
        {
            'subTopicName': 'Liberation of demons is due to the glorious position of Kṛṣṇa. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mPV5ksADt7o&t=4130s',
        },
        {
            'subTopicName': 'Kṛṣṇa the aṁśī can claim to have performed an action actually performed by one of His aṁśas. (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oFANPMdLS2k&t=1520s',
        },
    ],
    ['Ānukūlyasya saṅkalpaḥ prātikūlyasya varjanam']: [
        {
            'subTopicName': 'Submissiveness and surrender leads to spiritual realization. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/HLs1k6FVRTk?si=yGcOrX9qR-xryjmX&t=2005',
        },
        {
            'subTopicName': 'Atyahara. (1 min)',
            'youtubeLink': 'https://www.youtube.com/live/jO33AgEPYmI?si=fXsy5Ap0GLEFkOoZ&t=1917',
        },
        {
            'subTopicName': 'Two types of asat-saṅga and how they affect the devotees. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/qFWjzQepoLI?si=F1GKLqorZuxmv6Xh&t=3426',
        },
        {
            'subTopicName': 'If bhakti is voluntary, then what is the problem if I perform activities of karma voluntarily without allowing it to affect my faith? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/rpTraKYLpxk?si=kwo2TSM2zFIdsVBz&t=6592',
        },
        {
            'subTopicName': 'Astrology in Kṛṣṇa consciousness. (6 min)',
            'youtubeLink': 'https://youtu.be/c5Lvt-y12Mg?si=6Aqc9_WrDzlzeiDs&t=1273',
        },
        {
            'subTopicName': 'Giving up instant sense gratification to achieve a higher goal. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/Yat6Iasojzw?si=-P6axCpwftusZcdh&t=1492',
        },
        {
            'subTopicName': 'Imitation vs. Inspiration. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/6B1MpBJTU64?si=MtGi3eglCAFq_bKv&t=4631',
        },
        {
            'subTopicName': 'Spiritual poetry and emotions shall never be directed towards material people. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/eKPc6Oogc6M?si=0Bjyt50vu2T9LRZS&t=2249',
        },
        {
            'subTopicName': 'Importance of inquiring from a spiritual master in the right mood. (10 min)',
            'youtubeLink': 'https://youtu.be/9gCHD1z_nVU?si=rEOZHX0w9eEcXUNx&t=949',
        },
        {
            'subTopicName': 'Renouncing enjoyment for the pleasure of Kṛṣṇa. (6 min)',
            'youtubeLink': 'https://youtu.be/9gCHD1z_nVU?si=4zwc35pTfDbxcPwj&t=2152',
        },
        {
            'subTopicName': 'What is the meaning of simple living for a devotee? (14 min)',
            'youtubeLink': 'https://youtu.be/9gCHD1z_nVU?si=fo6UvmLPoauxwORE&t=3240',
        },
        {
            'subTopicName': 'How to think of Kṛṣṇa always? (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/hCBc7QObMig?si=nXIHPBc0VeLkQYzP&t=3419',
        },
        {
            'subTopicName': 'How to not offend when you hear apa-siddhānta being presented by speakers? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/Qv8myvTruxY?si=EvEjIrmkpebSOR3y&t=126',
        },
        {
            'subTopicName': 'How to be respectful to the speaker in spite of the difference of opinion? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/Qv8myvTruxY?si=6wovi-CXVFN6lsWY&t=1731',
        },
        {
            'subTopicName': 'How can sādhakas remain fixed in their final goal without deviation? (6 min)',
            'youtubeLink': 'https://youtu.be/mtmJpauKcE8?si=czRFPm6E1QnbwIC-&t=1557',
        },
        {
            'subTopicName': 'Avoid scriptures contrary to the conclusions of Bhāgavatam. (7 min)',
            'youtubeLink': 'https://youtu.be/kuFpSksNlVA?si=jzfsgcRyxdCQTtov&t=977',
        },
        {
            'subTopicName': 'Accepting reversals in a graceful way. (7 min)',
            'youtubeLink': 'https://youtu.be/kuFpSksNlVA?si=5Nxrz-1nYXCPnf4s&t=1640',
        },
        {
            'subTopicName': 'One should avoid extreme emotions as they hinder bhakti. (6 min)',
            'youtubeLink': 'https://youtu.be/kuFpSksNlVA?si=T4WtW8CefDrDuIG1&t=2029',
        },
        {
            'subTopicName': 'Why do pure devotees not aspire for other types of liberation? (2 min)',
            'youtubeLink': 'https://youtu.be/XnpWFlSi2xo?si=1CJyQCdLg3llAxjJ&t=4592',
        },
        {
            'subTopicName': 'Seeing reversals as Kṛṣṇa’s mercy. (7min)',
            'youtubeLink': 'https://www.youtube.com/live/8ZbccLoQKNk?si=ArxXuf1qM4hspDVo&t=1487',
        },
        {
            'subTopicName': 'One thing that’s really worth collecting: good wishes from everybody. (3 min)',
            'youtubeLink': 'https://youtu.be/Qjh9YAOxfzw?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=2435',
        },
        {
            'subTopicName': 'Name, fame and glory for others in the Vedic age vs name, fame and glory for oneself in the age of social media. (9 min)',
            'youtubeLink': 'https://youtu.be/YPeC4oKgPUU?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=2418',
        },
        {
            'subTopicName': 'Detachment from matter and attachment to Kṛṣṇa. (13 min)',
            'youtubeLink': 'https://youtu.be/gepFnz2QEtw?si=rhIhII0D2V-KIHqs&t=2373',
        },
        {
            'subTopicName': 'Attraction to Kṛṣṇa’s qualities is the antidote to worldly attachments. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/IRLmhxLey7o?si=P2FF-6NG2yG9vVUi&t=1974',
        },
        {
            'subTopicName': 'The swan and lotus analogy in devotional prayers of King Kulaśekhara Ālvār. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/ArTC9o-3vJg?si=_CR_m5v0TJCc_V54&t=724',
        },
        {
            'subTopicName': 'Vaiṣṇavas focus on the qualitative and the quantitative superiority of the Lord in comparison to the jīva, and not on the qualitative similarity. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/K_sLYVaKqnQ?si=q1tFkpQaWttW3vMg&t=3137',
        },
        {
            'subTopicName': 'Why is it important to avoid extreme emotions? (8 min)',
            'youtubeLink': 'https://youtu.be/kTrXcDsUOyU?si=2DKVCjwSjuOpSRnq&t=1311',
        },
        {
            'subTopicName': 'SB10.14.8(tat te \'nukampām su‑samīkṣamāṇo..)‑‑What should be a Devotee\'s mood in the face of reversals i.e. seeing Kṛṣṇa\'s benevolence in both happiness and distress. (40 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OeawW2Xt8Y0&t=3610s',
        },
        {
            'subTopicName': 'Attachment to the Lord includes attachment to everyone and everything (tadīya) connected to the Lord. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4Kj9WE3zldA&t=3540s',
        },
        {
            'subTopicName': 'Downside of entitlement feeling versus advantage of humility in devotional service (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pwP7CHw4IIo&t=1070s',
        },
        {
            'subTopicName': 'Appreciation of Kṛṣṇa\'s Aiśvarya in the beginning stages helps in properly appreciating his Sweetness. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=PGmncAg6Trs&t=935s',
        },
        {
            'subTopicName': 'What is the true meaning of the phrase \'dviṣatsu upekṣā\' according to two of our preeminent Ācāryas? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=XUgB4PWa1jA&t=2060s',
        },
        {
            'subTopicName': 'Disrespecting Devatās. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LW6HP1FOCts&t=4800s',
        },
        {
            'subTopicName': 'If we don\'t understand Kṛṣṇa\'s godhood properly, can that lead to Sahajiyāism? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Pwp-nD5Wtlc&t=528s',
        },
        {
            'subTopicName': 'Understanding Śaraṇāgati as a limb of Bhakti. (37 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JJprkcVJTpY&t=975s',
        },
        {
            'subTopicName': 'Why is the understanding that devotees are controlled by karma, harmful for spiritual development? How is such a mood expressed by a perfected devotee completely different? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JJprkcVJTpY&t=3170s',
        },
        {
            'subTopicName': 'Association with materialists. (57 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KKboXsS-Q40&t=1741s',
        },
        {
            'subTopicName': 'Unfavorable relationships. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KKboXsS-Q40&t=5480s',
        },
        {
            'subTopicName': 'A devotee is governed by the Bhakti Śāstras and not Dharma Śāstras. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=K5BB56w1M38&t=3429s',
        },
        {
            'subTopicName': 'Knowledge of Kṛṣṇa\'s powers is necessary to develop attachment to Him (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=xqsdZWrV2FM&t=2888s',
        },
        {
            'subTopicName': 'If Prāṇāyāma helps me focus on my chanting, is it Mixed devotional service? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JbcMdCyV4do&t=5013s',
        },
        {
            'subTopicName': 'Importance of determination in spiritual practice. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=q0FTkYQBz1E&t=3262s',
        },
        {
            'subTopicName': 'Seeking help is a powerful means to progress in Bhakti yoga. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Gbg2F-YEDS8&t=3822s',
        },
        {
            'subTopicName': 'Do devotees incur sin by accepting in charity from sinful people? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=bVJyBgjD79E&t=4571s',
        },
        {
            'subTopicName': 'Importance of engaging in likeable devotional activities to avoid succumbing to sense gratification. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=x96ilsBtFsI&t=3389s',
        },
        {
            'subTopicName': 'Is Inquiry the birth‑right of the audience AND answering questions satisfactorily the absolute duty of the Speaker? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8vsfp1JqwyE&t=4552s',
        },
        {
            'subTopicName': 'How should a Vaiṣṇava feel about different religions in different countries? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BNZEyBCkLWM&t=6030s',
        },
        {
            'subTopicName': 'Examples of Blind Following. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=WDsb54zH1qk&t=3948s',
        },
        {
            'subTopicName': 'Words devoid of Lord\'s Glories are ornaments of a dead body. (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4Kj9WE3zldA&t=2317s',
        },
        {
            'subTopicName': 'The problem of Blind Following. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hRVaoeIJ8BQ&t=238s',
        },
        {
            'subTopicName': 'Materials Saṁskāras and their Devotional Adaptations. (52 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=AR8_MT5v7j0&t=3730s',
        },
        {
            'subTopicName': 'Importance of seeking advice of senior Vaiṣṇavas. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RwaILVgzrF8&t=682s',
        },
        {
            'subTopicName': 'Importance of Vaiṣṇava blessings for the proper execution of one\'s services. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RwaILVgzrF8&t=2388s',
        },
        {
            'subTopicName': 'Is the blind following of our family traditions innocuous or scary? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ft5OYPZnBho&t=1218s',
        },
        {
            'subTopicName': 'Why is contextualisation of Śāstric statements indispensable? (15 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1fMRJBYYcuE&t=1912s',
        },
        {
            'subTopicName': 'Development in Bhakti depends solely on the attachment to our guru (20 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7FEVl_0dUvs&t=2090s',
        },
        {
            'subTopicName': 'How to balance practicing Bhakti properly while simultaneously be sensitive to people around us? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7YQcN7hlx9w&t=3065s',
        },
        {
            'subTopicName': 'Essential philosophical conclusions of the prayers of Akrūra. (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7YQcN7hlx9w&t=2570s',
        },
        {
            'subTopicName': 'Result of associating with Vaiṣṇavas is the giving up of false identification on the platform of false ego. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=1920s',
        },
        {
            'subTopicName': 'Varṇa designations are not appropriate for a Vaiṣṇava. (49 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=2500s',
        },
        {
            'subTopicName': 'Gotra in Gauḍīya Vaiṣṇava tradition. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wdwxkgEDAVM&t=2624s',
        },
        {
            'subTopicName': 'A Sādhaka\'s approach to honoring prasād changes according to the maturity of his consciousness. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jDi9z66krt0&t=4532s',
        },
        {
            'subTopicName': 'Can Viṣṇu Worshippers become Demigod Worshippers and vice versa? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=3580s',
        },
        {
            'subTopicName': 'In other prominent vaiṣṇava sampradāyas, the current generation considers consumption of onion/garlic acceptable. Could this happen to ISKCON as well? How to maintain our standards? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OSP02lDJzkw&t=3460s',
        },
        {
            'subTopicName': 'Glories and benefits of associating and serving great devotees. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OSP02lDJzkw&t=3920s',
        },
        {
            'subTopicName': 'Difference between gratitude and a sense of obligation. (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=1728s',
        },
        {
            'subTopicName': 'How should we deal with situations where one has to hear something that\'s NOT according to the Paramparā, but still can\'t avoid it on account of a variety of reasons? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=2408s',
        },
        {
            'subTopicName': 'Should devotee parents discourage their children in material education? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0_HulpykdeE&t=3543s',
        },
        {
            'subTopicName': 'How to deal with well intentioned people preaching their own philosophy to us? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5zk7IbCiQJY&t=1664s',
        },
        {
            'subTopicName': 'Why did Pṛthu Mahārāj patiently hear Jñāna‑miśra‑bhakti from the Kumāras? (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5zk7IbCiQJY&t=1664s',
        },
        {
            'subTopicName': 'We shouldn\'t have a utilitarian mindset in everything. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=5zk7IbCiQJY&t=1664s',
        },
        {
            'subTopicName': '​Is it possible to be a politician and still put into practice the principles of pure devotional service? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=3614s',
        },
        {
            'subTopicName': 'How to avoid introducing Karma‑kāṇḍīya mentality in Bhakti? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jKIqBbFngKw&t=2736s',
        },
        {
            'subTopicName': 'Attachment to Kṛṣṇa‑kathā doesn\'t come necessarily by demeaning material education. (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=1430s',
        },
        {
            'subTopicName': 'Loving association of devotees is non‑negotiable at any stage of our Kṛṣṇa Consciousness. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=8ERgx3aAPBY&t=545s',
        },
        {
            'subTopicName': 'What makes or breaks the lifeline of devotees\' association? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=nwHllIMh068&t=4062s',
        },
        {
            'subTopicName': 'one should overlook the faults of a Bhāva‑bhakta. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BMKjlLIWykw&t=4290s',
        },
        {
            'subTopicName': 'Why / how are prayers powerful? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mVProlZbvaY&t=934s',
        },
        {
            'subTopicName': 'Impact of hearing from great devotees even on simpler topics that one may not find intellectually stimulating. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=phYwzJ8IFGc&t=1828s',
        },
        {
            'subTopicName': 'Is it acceptable to skip puruṣāvatāra‑kathā and get into līlāvatāra‑kathā? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=4370s',
        },
        {
            'subTopicName': 'Pre‑requisite for remembering Kṛṣṇa and the Vrajavāsīs. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NMoLRwWeCgI&t=4470s',
        },
        {
            'subTopicName': 'Vaiṣṇava‑aparādha destroys Bhakti. (61 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Xoe0HwWTnBk&t=2700s',
        },
        {
            'subTopicName': 'If Kṛṣṇa has put us in a particular situation, does he want us to accept it as it is? (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=a9vYWReNDwA&t=5160s',
        },
        {
            'subTopicName': 'What defines whether an activity is dhārmic, material or devotional? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sbdWireHqZU&t=1422s',
        },
        {
            'subTopicName': 'Importance of worshipping the \'Tādīya\' of the Lord. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4Kj9WE3zldA&t=3714s',
        },
        {
            'subTopicName': 'Only sattva‑guṇa can be dovetailed in Kṛṣṇa\'s service, rajo‑guṇa and tamo‑guṇa must be given up. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LtduJkS8hZU&t=815s',
        },
    ],
    ['Īśvara tattva']: [
        {
            'subTopicName': 'Is Krishna bound by time or extrrnal circumstances to appear? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/cFgOw0dHG0Q?si=yeOw4IGC1np_dluV&t=603',
        },
        {
            'subTopicName': 'Is the "Janmādyasya yataḥ" verse describing about Kāraṇodakaśāyī Viṣṇu or Kṛṣṇa? (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/B98CWoYuYh4?si=R_RbTCn5C5iCUqFZ&t=3706',
        },
        {
            'subTopicName': 'Is the "Janmādyasya yataḥ" verse describing about Kāraṇodakaśāyī Viṣṇu or Kṛṣṇa? - Part-2. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/r2uDAt3-ESc?si=A8k6gfxD6iFEigq0&t=1789',
        },
        {
            'subTopicName': 'The Supreme Lord is the cause of the universe. (35 min)',
            'youtubeLink': 'https://www.youtube.com/live/B98CWoYuYh4?si=0K3WVuasgyjG2tF5&t=254',
        },
        {
            'subTopicName': 'The Supreme Lord is the cause of the universe. (22 min)',
            'youtubeLink': 'https://www.youtube.com/live/cFgOw0dHG0Q?si=AgSZq-rQ6q8xQcfL&t=2570',
        },
        {
            'subTopicName': 'What is the source of illusion or Avidya? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/oBSNCs_mTDw?si=nx5qY7g4s_eGnV2o&t=636',
        },
        {
            'subTopicName': 'What is the highest understanding of "Absolute Truth ". (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/ZbdsnNICR-Q?si=M1yylxLaUsHtIYCM&t=2572',
        },
        {
            'subTopicName': 'Two-handed form is supreme. (2 min)',
            'youtubeLink': 'https://youtu.be/2h4aegotCuE?si=uHDMFJswBlH-ylNT&t=3584',
        },
        {
            'subTopicName': 'Viṣṇu is completely beyond modes. (24 min)',
            'youtubeLink': 'https://youtu.be/Q-zIqhtgz3k?si=QrPhJb1sQU7E5nPv&t=1092',
        },
        {
            'subTopicName': 'Dāsa abhimāna even in the Viṣṇu-tattvas. (3 min)',
            'youtubeLink': 'https://youtu.be/yIDZBJMd_QE?si=yqL8PC36-pmn6byF&t=3246',
        },
        {
            'subTopicName': 'Various ways in which Kṛṣṇa reciprocates with the sādhaka\'s devotional service. (9 min)',
            'youtubeLink': 'https://www.youtube.com/live/pwByE7bADGc?si=q4LdlySijovDgXeg&t=4538',
        },
        {
            'subTopicName': 'Why the glories of Lord are said to be spotless? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/zJQzbf_XGtc?si=B_9nWlx-dMuRuUES&t=3982',
        },
        {
            'subTopicName': 'Worship of Bhagavān is superior. (38 min)',
            'youtubeLink': 'https://www.youtube.com/live/0yNfiUCQnVg?si=kzHntyauGqijJ1vY&t=1285',
        },
        {
            'subTopicName': 'How is it possible for the Lord to take birth and still be unborn? (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/nOfNItlQ3Y4?si=ctgObGWpVXKZS93q&t=3211',
        },
        {
            'subTopicName': 'If the Lord is full of bliss in Himself, then how does bhakti done by His devotees make Him happy? - Part-1. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/yGOBaKMgyn0?si=JJbw0r_64wLMoKus&t=5690',
        },
        {
            'subTopicName': 'If the Lord is full of bliss in Himself, then how does bhakti done by His devotees make Him happy? - Part-2. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/8MTQOdwb7Fg?si=yXvyXF9uUVYS3i84&t=304',
        },
        {
            'subTopicName': 'Lord can protect the world and at the same time be indifferent. (14 min)',
            'youtubeLink': 'https://youtu.be/oSZn8MwNqYw?si=jZY0ZeOj3cCa5QjM&t=2501',
        },
        {
            'subTopicName': 'Contradictions can coexist in Lord by His inconceivable powers. (10 min)',
            'youtubeLink': 'https://youtu.be/q6muG4fsTLs?si=rsi44vjcCogDbO2M&t=2093',
        },
        {
            'subTopicName': 'Definition of Bhagavān. (3 min)',
            'youtubeLink': 'https://youtu.be/1kM9zfQaOI4?si=wOWVE1yzrRIKX1zd&t=2008',
        },
        {
            'subTopicName': 'The Supreme Lord is beyond the material logic and logicians. (20 min)',
            'youtubeLink': 'https://youtu.be/CI3g8w5uwx8?si=gRl-c-Nv_yd-gz44&t=2516',
        },
        {
            'subTopicName': 'The Lord has no material birth. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/FhQaHCtXw4s?si=9fntrVPoTOPzyvd4&t=2543',
        },
        {
            'subTopicName': 'The Lord as Śaraṇāgata-vatsala. (15 min)',
            'youtubeLink': 'https://youtu.be/3ARTcK4W4w8?si=__JfpmpSEBNVdXZH&t=2585',
        },
        {
            'subTopicName': 'No one knows the plan or intentions of Kṛṣṇa. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/WGDxS2Zh950?si=Al4RNJKGLWenzo6h&t=2337',
        },
        {
            'subTopicName': 'No one understands the plans of Kṛṣṇa. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/0QR_Myj46uI?si=iNt_OIYzX3__l-MI&t=2966',
        },
        {
            'subTopicName': 'The Lord has an equal vision. (19 min)',
            'youtubeLink': 'https://www.youtube.com/live/LSVkGYWfWYY?si=CwdeAJ42xtcpDnwJ&t=1816',
        },
        {
            'subTopicName': 'The Lord knows what’s best for a devotee. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/w233O_wl1jA?si=qXCqjTMcnbXMVecM&t=2310',
        },
        {
            'subTopicName': 'The Lord’s mercy is not stereotyped. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/8ZbccLoQKNk?si=oU2CSbrQbDBv3NRG&t=645',
        },
        {
            'subTopicName': 'The disappearance and appearance of the Lord is compared to the setting and rising of the sun. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/pjgffDmoxhk?si=np-_rVt1OrDb62Ju&t=2089',
        },
        {
            'subTopicName': 'What is the role of Garbhodakaśāyī Viṣṇu in this material world? (6 min)',
            'youtubeLink': 'https://youtu.be/sVUOpD4LyQk?si=hp6T_yLdIo1LhrkU&t=4626',
        },
        {
            'subTopicName': 'Does Kṛṣṇa decide whether one gets a male child or a female child? (5 min)',
            'youtubeLink': 'https://youtu.be/FD68k2rO4QM?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=3591',
        },
        {
            'subTopicName': 'Why can’t Kṛṣṇa create the material world as an absolute place of enjoyment and no suffering at all, since the living entities are here to enjoy? (16 min)',
            'youtubeLink': 'https://youtu.be/zDVpPn3Gt_I?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=3508',
        },
        {
            'subTopicName': 'Why does the Lord love to hear His own glorification? (6 min)',
            'youtubeLink': 'https://youtu.be/YPeC4oKgPUU?list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&t=3361',
        },
        {
            'subTopicName': 'Kṛṣṇa’s response is according to one’s relationship with Him. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/47TiOFaCKPc?si=cS0csukmVf7NV0uu&t=2490',
        },
        {
            'subTopicName': 'How to understand Kṛṣṇa accepting women and Lord Rāma’s renunciation of Sītā? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/47TiOFaCKPc?si=_SK1KjiPPQmgMY0v&t=3502',
        },
        {
            'subTopicName': 'The apparent contradiction: Kṛṣṇa is ātmārāma yet pleased by devotion. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/ArTC9o-3vJg?si=ei-hESFJTzFOCS1R&t=1321',
        },
        {
            'subTopicName': 'Kṛṣṇa will strengthen our faith in anything, be it our ācāryas, demigods or even in atheism. How to understand this? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/v6pulzCsUDQ?si=oeO7uE3rZrm7SEA3&t=2998',
        },
        {
            'subTopicName': 'Śāstric proofs to establish Bhagavān is superior to Brahman and Paramātmā. (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/QS1HpvX2VN4?si=ayyDsRJBUmCMd1f7&t=585',
        },
        {
            'subTopicName': 'How can the Lord have innumerable forms when the Śruti says He is one without a second? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/YryHwqGZOt4?si=1RPpeZTKBh-mWgK-&t=1294',
        },
        {
            'subTopicName': 'Understanding the phrase – “When One Lord decided to become many.” (3 min)',
            'youtubeLink': 'https://youtu.be/bdoGT9uFotM?si=QakyfjmH-hKWCOX1&t=1238',
        },
        {
            'subTopicName': 'Understanding the ‘āśraya‑tattva’, the ultimate shelter. (8 min)',
            'youtubeLink': 'https://youtu.be/CCffX8V2sM4?si=mnY4_Jg1uNSL9uZc&t=1274',
        },
        {
            'subTopicName': 'Aiśvarya covers the sweetness of the Lord. (10 min)',
            'youtubeLink': 'https://youtu.be/R7j9POpY4bU?si=oe2uOOj7JBhGZ5tA&t=4989',
        },
        {
            'subTopicName': 'Bhagavān explained. (9 min)',
            'youtubeLink': 'https://youtu.be/mEKJVfw9Sg8?si=_F0_Cbypcm3kIgQ-&t=2013',
        },
        {
            'subTopicName': 'Kṛṣṇa can be understood by his Mercy alone. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=UYrJNA0H2Ks&t=1340s',
        },
        {
            'subTopicName': 'What is Prāṇa Pratiṣṭhā? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9gMR2e8eaZ4&t=4225s',
        },
        {
            'subTopicName': 'Why are Garbhodakaśāyī Viṣṇu and Kāraṇodakaśāyī Viṣṇu also called Nārāyaṇa? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=wiiBuDgtFJM&t=4895s',
        },
        {
            'subTopicName': 'Kṛṣṇa\'s Mercy follows endevour to please Kṛṣṇa. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gVdLB-yEzwk&t=2930s',
        },
        {
            'subTopicName': 'Does Kṛṣṇa purify the desire of His devotees or does He fulfill them? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ctk6M9Y0Cj4&t=3638s',
        },
        {
            'subTopicName': 'Why doesn\'t Kṛṣṇa directly influence a jīva to take up to Pure Devotion, instead of facilitating the gradual path with Karma, Yoga etc.? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vt0EOh18BwQ&t=3005s',
        },
        {
            'subTopicName': 'How do we understand that the Lord is NOT affected by the Karma of any individual though He plays the role of the Approver of all Karma, as per BG 18.14? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=RwaILVgzrF8&t=3810s',
        },
        {
            'subTopicName': 'How the Supereme Lord, who is Bhāva‑grāhī, deals with a Sādhaka troubled by desires for Sense Gratification? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=4258s',
        },
        {
            'subTopicName': 'Why the Lord becomes obliged to respond to mixed devotees who have material desires? (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=EBAqOcl0Gts&t=3490s',
        },
        {
            'subTopicName': 'Understanding Kṛṣṇa\'s inconceivable mystic potency. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QwKi7-MyaTg&t=302s',
        },
        {
            'subTopicName': 'Kṛṣṇa is both the material cause and the efficient cause of this universe. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=oFANPMdLS2k&t=2925s',
        },
        {
            'subTopicName': 'Śakti‑pariṇāmavāda ‑ creation of the material universe happens by transformation of Kṛṣṇa\'s external energy. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h-QxzjE5SLc&t=4974s',
        },
        {
            'subTopicName': 'By Kṛṣṇa\'s inconceivable potency He gives shelter, maintains and protects, yet remains changeless and completely detached. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h-QxzjE5SLc&t=4164s',
        },
        {
            'subTopicName': 'If Kṛṣṇa is ātmārāma, then why does He get attracted to bhakti? (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h-QxzjE5SLc&t=1401s',
        },
    ],
    ['Śakti Tattva']: [
        {
            'subTopicName': 'Kṛṣṇa and His Svarūpa-śakti. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/B98CWoYuYh4?si=JxOXVBJmenXPZe7n&t=2663',
        },
        {
            'subTopicName': 'How is the external energy working under the direction of the Lord if matter is unconscious? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/r2uDAt3-ESc?si=FP3FRsB9qL2d77mw&t=1383',
        },
        {
            'subTopicName': 'Are Sense Devatas manifestations of Svarūpa-śakti of the Lord? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/r2uDAt3-ESc?si=AO-XnhnCQpUNbx5e&t=3225',
        },
        {
            'subTopicName': 'How is the external energy working under the direction of the Lord if matter is unconscious? - Part-2. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/jtZXoCAbrt0?si=mN3rl6IDpVIdRNPd&t=745',
        },
        {
            'subTopicName': 'Is matter animated by Paramātmā or Māyādevi? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/jtZXoCAbrt0?si=pQv8jfDBeq86hwnp&t=3139',
        },
        {
            'subTopicName': 'Understanding mahāmāyā and yogamāyā. (15 min)',
            'youtubeLink': 'https://youtu.be/Wi68_XAAlcY?si=l4rvF2_Zw6-LSel5&t=1669',
        },
        {
            'subTopicName': 'Understanding the scope of yoga-māyā and mahā-māyā. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/kHDK6F33peg?si=PBWxmUjAo_C4UJgg&t=1032',
        },
        {
            'subTopicName': 'What is the role of mahā-māyā in the life of a conditioned soul and a practicing devotee? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/kHDK6F33peg?si=B0tO4LtI79eOof9n&t=2780',
        },
        {
            'subTopicName': 'Sandhinī-śakti. (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/hCBc7QObMig?si=b_22hfxY_4KdRmDk&t=3236',
        },
        {
            'subTopicName': 'Diverse aspects of māyā. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/KWzzpMq-mNI?si=VKlX4pji6Tiq5I7C&t=2523',
        },
        {
            'subTopicName': 'Why māyā is compared to piśācī? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/b9-RAq6Fhug?si=2edhT7fZLU8cVjGS&t=4117',
        },
        {
            'subTopicName': 'Understanding the role of yogamāyā and mahāmāyā. (29 min)',
            'youtubeLink': 'https://youtu.be/zDnmTqZHGuE?si=9Ap_Jh64ZBskGy6z&t=2354',
        },
        {
            'subTopicName': 'Kṛṣṇa’s energies and their interaction. (30 min)',
            'youtubeLink': 'https://youtu.be/mEKJVfw9Sg8?si=0LxlTazn-Ory7wjJ&t=4651',
        },
        {
            'subTopicName': 'Why is it necessary to know about Kṛṣṇa’s energies? (7 min)',
            'youtubeLink': 'https://youtu.be/PWmLgLCTuzY?si=vY3OE59ddZ5BMOR7&t=1454',
        },
        {
            'subTopicName': 'How do Kṛṣṇa\'s various energies (Śaktis) manifest and unmanifest at various times? (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ngCFwTEm7Zo&t=570s',
        },
        {
            'subTopicName': 'Role of Vidyā and Avidyā Potencies of Mahāmāyā on the jīva. (12 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6p3PKPOXAFc&t=3325s',
        },
        {
            'subTopicName': 'Is Bhūmidevī a part of Internal Energy OR External Energy of the Lord. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=vc95tzVZ3Qw&t=2798s',
        },
        {
            'subTopicName': 'Jīva is convinced of his spiritual nature by the vidyā potency of Mahāmāyā and not by Yogamāyā. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6p3PKPOXAFc&t=3537s',
        },
        {
            'subTopicName': 'Māyā is Kṛṣṇa\'s agent and facilitates the lives of rebellious jīvas who want to enjoy independent of Kṛṣṇa. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Iea5UCJbc6o&t=2372s',
        },
        {
            'subTopicName': 'Is māyā evil? (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2JHFguvmCfE&t=1867s',
        },
        {
            'subTopicName': 'Since when are jīvas bewildered by māyā? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ZnQH4cbm3zc&t=4900s',
        },
        {
            'subTopicName': 'Is Māyā Pro‑Kṛṣṇa or Anti‑Kṛṣṇa? Is Māyā Pro‑Jīva or Anti‑Jīva? (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Iea5UCJbc6o&t=2298s',
        },
        {
            'subTopicName': 'Māyādevī, Vaiṣṇavas, Śāstras and Kṛṣṇa have a common mission of sending the jīva back to the spiritual world. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=R91CJZltUcs&t=890s',
        },
        {
            'subTopicName': 'Nature of the curtain of Mahāmāyā. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-dkJ3oTj9Kc&t=2144s',
        },
        {
            'subTopicName': 'When did the bewilderment of the Jīva by Māyā begin? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-dkJ3oTj9Kc&t=2820s',
        },
        {
            'subTopicName': 'Role of Saṁvit and Hlādinī‑śakti in maifesting Bhāva. (31 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=sdG9Ak72tDk&t=2040s',
        },
        {
            'subTopicName': 'Understanding the role of the Hlādinī potency of the Lord. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=2888s',
        },
        {
            'subTopicName': 'Direct Knowledge, Indirect Knowledge and Perverted Knowledge from the Saṁvit Potency. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=2615s',
        },
        {
            'subTopicName': 'Understanding Saṁvit potency of the Lord. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=2477s',
        },
        {
            'subTopicName': 'Understanding the Sandhinī‑śakti. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=1745s',
        },
        {
            'subTopicName': 'If the Hlādinī‑śakti comes in touch with the Jīva only at the stage of Bhāva‑bhakti, then how does the Sādhaka receive nourishment? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=mFOWu4YRy_g&t=4861s',
        },
        {
            'subTopicName': 'Understanding Kṛṣṇa\'s inconceivable mystic potency. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QwKi7-MyaTg&t=302s',
        },
        {
            'subTopicName': 'Śakti‑pariṇāmavāda ‑ creation of the material universe happens by transformation of Kṛṣṇa\'s external energy. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h-QxzjE5SLc&t=4974s',
        },
        {
            'subTopicName': 'By Kṛṣṇa\'s inconceivable potency He gives shelter, maintains and protects, yet remains changeless and completely detached. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h-QxzjE5SLc&t=4164s',
        },
    ],
    ['Śambhu-Tattva']: [
        {
            'subTopicName': 'Expansions and forms of Rudra. (4 min)',
            'youtubeLink': 'https://youtu.be/CNnWmvveZg0?si=koFIh702hDkVHNPG&t=1325',
        },
        {
            'subTopicName': 'How is Lord Śiva not touched by guṇas? (10 min)',
            'youtubeLink': 'https://youtu.be/CNnWmvveZg0?si=SQfLf_3AKAFb4j6r&t=3007',
        },
        {
            'subTopicName': 'Sometimes jīvas can take the role of Lord Śiva. (13 min)',
            'youtubeLink': 'https://youtu.be/CNnWmvveZg0?si=pe85tnY06fsOUCys&t=1542',
        },
        {
            'subTopicName': 'How is Lord Śiva different and non-different from Lord Viṣṇu? (6 min)',
            'youtubeLink': 'https://youtu.be/EGzBFBDSmsA?si=8jI6m2CeVFBwHCuO&t=1106',
        },
        {
            'subTopicName': 'Appearance of Rudra in different kalpas. (4 min)',
            'youtubeLink': 'https://youtu.be/EGzBFBDSmsA?si=E9xYbg11GSA8xqIx&t=1458',
        },
        {
            'subTopicName': 'Multiple roles of Lord Śiva in the material world. (5 min)',
            'youtubeLink': 'https://youtu.be/EGzBFBDSmsA?si=5ccJs6agsub37npq&t=1676',
        },
        {
            'subTopicName': 'Who is Sadāśiva? (35 min)',
            'youtubeLink': 'https://youtu.be/EGzBFBDSmsA?si=llnlV-y0ERtyUCWo&t=1979',
        },
        {
            'subTopicName': 'Śiva tattva. (40 min)',
            'youtubeLink': 'https://youtu.be/EGzBFBDSmsA?si=O2m4PR0Br3wBJ3KC&t=668',
        },
        {
            'subTopicName': 'What’s the difference between Śaivites considering Lord Śiva to be equal to Lord Viṣṇu vs Vaiṣṇavas considering the same? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2Y7OJqc-9Eo&t=6062s',
        },
        {
            'subTopicName': 'Who is Sadā-Śiva? (35 min)',
            'youtubeLink': 'https://youtu.be/EGzBFBDSmsA?si=PbosGgHHDTOtqSp4&t=1910',
        },
    ],
    ['Śrī Caitanya-caritāmṛta']: [
        {
            'subTopicName': 'Caitanya-caritāmṛta – why it is called PhD level study. (16 min)',
            'youtubeLink': 'https://www.youtube.com/live/IPdCUszooy0?si=XudiOPk3TDt1euGe&t=1561',
        },
        {
            'subTopicName': 'How the maṅgalācaraṇa verses of the Ādi-līlā expand into multiple chapters. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/IPdCUszooy0?si=wgsQDmLKlvWebvn-&t=4544',
        },
        {
            'subTopicName': 'Importance of Maṅgalācharaṇa verses. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/WgQ0Dd29wJ4?si=uqyGRPVwSlLqZCue&t=5161',
        },
        {
            'subTopicName': 'Why Śrīla Prabhupāda describes the Caitanya‑caritāmṛta as the PhD study. (13 min)',
            'youtubeLink': 'https://youtu.be/qI9X0S0D7fs?si=oawRBJW4jcnqdih3&t=3000',
        },
        {
            'subTopicName': 'Understanding the role of the Hlādinī potency of the Lord. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=2888s',
        },
    ],
    ['Śrīmad Bhagavad-gītā']: [
        {
            'subTopicName': 'Duryodhana\'s diplomacy ). (5 min)',
            'youtubeLink': 'https://youtu.be/yIDZBJMd_QE?si=16RTN4fqi7cxnAdT&t=1077',
        },
        {
            'subTopicName': 'Meaning of Guḍākeśa. (5 min)',
            'youtubeLink': 'https://youtu.be/yIDZBJMd_QE?si=-0-Ld7GZwvWsFnK9&t=2596',
        },
        {
            'subTopicName': 'Duryodhana\'s diplomacy. (3 min)',
            'youtubeLink': 'https://youtu.be/yIDZBJMd_QE?si=Knj427Y2qgH_GQh1&t=1081',
        },
        {
            'subTopicName': 'Understanding Arjuna’s confusion. (15 min)',
            'youtubeLink': 'https://youtu.be/vKIx7B4JIyk?si=k_13SUoDG5rNI6Q1&t=3317',
        },
        {
            'subTopicName': 'Why in Bhagavad-gītā one whole chapter is dedicated to describing the "universal form"? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/Lj0h6N7IZL4?si=xrEsnUOGwhAwB_EU&t=1790',
        },
        {
            'subTopicName': 'Does BG Chapter 17 talk about faith affected by modes? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LQZJYlTGtls&t=3255s',
        },
        {
            'subTopicName': 'The teachings of Gītā are not for Arjuna. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=b6wJQpJQurw&t=1910s',
        },
        {
            'subTopicName': 'Why do we study Bhagavad-gītā where other paths are also described? Won’t we get deviated? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/jv3_D9sAtgQ?si=I9F2iC-OxfgH8mBr&t=3870',
        },
        {
            'subTopicName': 'Insights into the verse "janma karma ca me divyam...". (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/WGDxS2Zh950?si=6U2m6Y96d8Zsy3WA&t=3765',
        },
        {
            'subTopicName': 'In Bhagavad Gītā, Kṛṣṇa the prototype teacher instructs Arjuna the prototype student about all yoga practices. (3 min)',
            'youtubeLink': 'https://youtu.be/WpdSAdGLTEA?si=GFbqED-dNm9sPfU-&t=3142',
        },
        {
            'subTopicName': 'Is the Bhagavad Gītā meant for Arjuna? (2 min)',
            'youtubeLink': 'https://youtu.be/WpdSAdGLTEA?si=F1dhC0ivtEZSa7bW&t=3464',
        },
        {
            'subTopicName': 'Who is the real Arjuna, and are the instructions of Bhagavad Gītā really meant for Arjuna, or has Kṛṣṇa only used him as a prototype to instruct different practitioners as per qualification? (20 min)',
            'youtubeLink': 'https://youtu.be/hiA1oSf812A?si=J4mrz2snNBrhmHoo&t=690',
        },
        {
            'subTopicName': 'Bhagavad Gītā gives instructions to all types of spiritual aspirants and one should accept instructions as per his adhikāra. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Y5WG8UdumvY&t=3971s',
        },
        {
            'subTopicName': 'What is the meaning of Divyam in the verse "janma karma ca me divyam"? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=1phTLCyR2ms&t=3110s',
        },
        {
            'subTopicName': 'Arjuna is not the target audience for the Bhagavad Gītā. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OwTewOcAxQ4&t=690s',
        },
        {
            'subTopicName': 'Deeper Understanding of the "bhūmir āpo \'nalo vāyuḥ" verse. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=xqsdZWrV2FM&t=3564s',
        },
        {
            'subTopicName': 'Multiple layers of understanding the difference between divine and demoniac. (21 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3arzACKjIpA&t=2430s',
        },
        {
            'subTopicName': 'The four types of people who do not surrender to Kṛṣṇa. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2JHFguvmCfE&t=3024s',
        },
        {
            'subTopicName': 'Four types of people who surrender to Kṛṣṇa. (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2JHFguvmCfE&t=3929s',
        },
        {
            'subTopicName': 'Who is the best amongst the 4 kinds of people who surrender to Kṛṣṇa? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=0jaeK5dlL8E&t=1530s',
        },
        {
            'subTopicName': 'The six types of devotees who cross over Māyā according to the Bhagavad‑gītā. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=hsOWsv1PRdo&t=2500s',
        },
        {
            'subTopicName': 'How can we take \'Bhagavad‑gītā As It Is\' book as ‘as it is’, if only Bhakti aspect is prioritized? Is it not biased? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ROVXcckpgcU&t=2811s',
        },
        {
            'subTopicName': 'Types of indirect, impure worship of the Lord and types of jñāna‑yajñas. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QwKi7-MyaTg&t=5222s',
        },
        {
            'subTopicName': 'Meaning of "bhajanty ananya‑manaso" and "satataṁ kīrtayanto mām". (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=QwKi7-MyaTg&t=3284s',
        },
    ],
    ['Śrīmad-Bhāgavatam']: [
        {
            'subTopicName': 'Śrīmad-Bhāgavatam is the natural commentary of Vedānta-sūtra. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/cFgOw0dHG0Q?si=FPegNtkfc6LElekf&t=2742',
        },
        {
            'subTopicName': 'Śrīmad-Bhāgavatam is compared to sun and a desire tree. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/cFgOw0dHG0Q?si=_5Rg3lpvp__RK6d-&t=548',
        },
        {
            'subTopicName': 'How to best study Śrīmad-Bhāgavatam? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/bfdbewI_XgE?si=s6w97weCKVhQ64De&t=1397',
        },
        {
            'subTopicName': 'Who can develop attraction to Śrīmad-Bhāgavatam. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=Ap-TtuCXGw8S05AG&t=4401',
        },
        {
            'subTopicName': 'Can Śrīmad-Bhāgavatam even bewilder its own readers? (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/mjq6ixAvJTM?si=7APVRTQ86jyFmsRc&t=363',
        },
        {
            'subTopicName': 'Is Śrīmad-Bhāgavatam only for the non-envious? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/mjq6ixAvJTM?si=o-sPOXkpn_mlBgHc&t=980',
        },
        {
            'subTopicName': 'Śrīmad-Bhāgavatam\'s understanding of Kaitava Dharma. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/mjq6ixAvJTM?si=Z5qlrdpx0hqTjltT&t=1336',
        },
        {
            'subTopicName': 'Whom does Śrīmad-Bhāgavatam refer to as mahā-muni in the beginning of the book? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/8YeJ_YbqCd4?si=bVajC1CHJdVMUivG&t=958',
        },
        {
            'subTopicName': 'What does Śrīmad-Bhāgavatam refer to as vāstava-vastu in the beginning of the book? (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/8YeJ_YbqCd4?si=WEFDhhPeTyHu05Jb&t=1333',
        },
        {
            'subTopicName': 'What are the actions strongly recommended by Śrīmad-Bhāgavatam? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/8YeJ_YbqCd4?si=q7jI5OGaFabm7apI&t=1504',
        },
        {
            'subTopicName': 'What is the significance of the word ālayamin connection with Śrīmad-Bhāgavatam ? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/ZbdsnNICR-Q?si=srsPQbLhK3Cva4x-&t=1950',
        },
        {
            'subTopicName': 'What exactly is the rasa of Śrīmad-Bhāgavatam ? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/ZbdsnNICR-Q?si=KvNvbJ_OrEdgit_8&t=2914',
        },
        {
            'subTopicName': 'If the ripened fruit has fallen down from the desire tree of the Vedas, then does it no longer exist there? (4 min)',
            'youtubeLink': 'https://youtu.be/V4PsCuKR8nE?si=tJj81D0m433cPkMD&t=2430',
        },
        {
            'subTopicName': 'Why jñāna, karma, and yoga are described in Śrīmad-Bhāgavatam? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/zHyqzUP8kjc?si=zF5z19NhfDj_cfti&t=834',
        },
        {
            'subTopicName': 'How Śrīmad-Bhāgavatam becomes sweeter? (5 min)',
            'youtubeLink': 'https://youtu.be/zsvIjoXPCPQ?si=_963FwYzc9-f-dxq&t=4115',
        },
        {
            'subTopicName': 'Eagerness is the key to unearth the sweetness of Śrīmad-Bhāgavatam. (4 min)',
            'youtubeLink': 'https://youtu.be/zsvIjoXPCPQ?si=LAcGJSYNSrpZgyUd&t=4350',
        },
        {
            'subTopicName': 'Subject matter or vastu of Śrīmad Bhāgavatam is mādhurya-rasa. (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/oBSNCs_mTDw?si=kCqTkq4KZBa5dlw-&t=2116',
        },
        {
            'subTopicName': 'Kṛṣṇa is the vastu or subject matter of Śrīmad Bhāgavatam. (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/qwr6qQ50sZc?si=VwDKn4q_88b0SlyA&t=931',
        },
        {
            'subTopicName': 'Mādhurya-rasa is the subject matter of Śrīmad Bhāgavatam. (58 min)',
            'youtubeLink': 'https://www.youtube.com/live/eKPc6Oogc6M?si=yCQ0yHFjjSkhMNFt&t=330',
        },
        {
            'subTopicName': 'Is Bhāgavatam alone sufficient for the entire population? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/zJQzbf_XGtc?si=TVuVRMwIub5vIvjj&t=3504',
        },
        {
            'subTopicName': 'Why there are material phala-śrutis in Bhāgavatam? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/gD-lySniPH0?si=0nyUxAXkYZSnXJmL&t=3298',
        },
        {
            'subTopicName': 'Does Bhāgavatam try to scare people to take up to devotion? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/gD-lySniPH0?si=tU715gqTo9b6Cxpl&t=3598',
        },
        {
            'subTopicName': 'Should Śrīmad-Bhāgavatam also be considered as a place of pilgrimage for crows as it also contains discussions of karma, jñāna etc.? (32 min)',
            'youtubeLink': 'https://www.youtube.com/live/gD-lySniPH0?si=4PToPxyuznZCNMel&t=892',
        },
        {
            'subTopicName': 'Why are there not many detailed narrations of pastimes of an ordinary sādhaka in books like Śrīmad-Bhāgavatam? (9 min)',
            'youtubeLink': 'https://youtu.be/JeybpTYH6Y4?si=fR-FS6CxkKbgA7-5&t=2037',
        },
        {
            'subTopicName': 'Śrīmad-Bhāgavatam presents karma, jñāna etc. to create contrast with bhakti. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/7lfELjXi5wQ?si=tddLO4ic7ltStp3A&t=943',
        },
        {
            'subTopicName': 'Verdict of Śrīmad Bhāgavatam: One must perform exclusive ananya bhakti, even if one may have desire for dharma, artha, kāma, mokṣa. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/uRKVFlGq3p4?si=-N1LjZqE2SaXWOUK&t=1607',
        },
        {
            'subTopicName': 'Importance of reading Bhāgavatam in association of devotees. (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/fCnjnG9Ioz0?si=qDAH8qKyufpuKUQC&t=1203',
        },
        {
            'subTopicName': 'Understanding Rādhā and Kṛṣṇa as the subject matter of Śrīmad-Bhāgavatam. (50 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JYld7aQ6KF8&t=420s',
        },
        {
            'subTopicName': 'If Śukadeva Gosvāmī was an impersonalist before hearing Śrīmad-Bhāgavatam, then why is he referred here as Ādi-kavi? (6 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JYld7aQ6KF8&t=2721s',
        },
        {
            'subTopicName': 'Bhakti is the subject matter of Śrīmad-Bhāgavatam. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JYld7aQ6KF8&t=3502s',
        },
        {
            'subTopicName': 'Bhakti as the subject matter of Śrīmad-Bhāgavatam. (65 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LQZJYlTGtls&t=251s',
        },
        {
            'subTopicName': 'Śrīmad-Bhāgavatam is compared to a lamp, sun, ripened fruit and Mohinī-mūrti. (36 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=miIZ5wHAJs8&t=660s',
        },
        {
            'subTopicName': 'What is wrong if the non-devotees, who lack the right attitude, are served the right meaning? Why Śrīmad-Bhāgavatam has to intentionally bewilder them? (2 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=miIZ5wHAJs8&t=3578s',
        },
        {
            'subTopicName': 'How can we understand that Śrīmad-Bhāgavatam elevates one to the level of śuddha-sattva? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/h0AL964D8mU?si=8-sAibP4rpKUiP-U&t=3269',
        },
        {
            'subTopicName': 'Is Śrīmad-Bhāgavatam only meant for the paramahaṁsas? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/5enwGJglbhg?si=-ggOOAqZXa42Oztw&t=3049',
        },
        {
            'subTopicName': 'Why is Śrīmad-Bhāgavatam termed as Paramahaṁsa-saṁhitā when it is actually meant for ignorant jīvas? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/b9-RAq6Fhug?si=M7hB7HyROrGLwJN0&t=3692',
        },
        {
            'subTopicName': 'Can a grantha (Śrīmad-Bhāgavatam) deliver the nirgranthas (ātmārāmas)? (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/Wl3Begp2hTg?si=NUlB7PHgi4_U6mVa&t=1281',
        },
        {
            'subTopicName': 'Rūpa Gosvāmī’s glorification of Śrīmad-Bhāgavatam. (7 min)',
            'youtubeLink': 'https://youtu.be/k47R3GdsSxM?si=kaujUEd4iyqN9LfO&t=4340',
        },
        {
            'subTopicName': 'Is there no mention of Viṣṇu-sahasranāma in Śrīmad-Bhāgavatam? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/TB88pYlqksg?si=TA8wG5bR2bvrguGD&t=3968',
        },
        {
            'subTopicName': 'Śrīmad-Bhāgavatam doesn’t explicitly say that Yaśodā gave birth to a male child, whereas the Ādi Purāṇa does. So have our ācāryas rejected the authority of the Bhāgavatam and accepted the Ādi-Purāṇa? (23 min)',
            'youtubeLink': 'https://www.youtube.com/live/g_MA-tQ48M0?si=GKkQlYUmAJ3JSQI3&t=3115',
        },
        {
            'subTopicName': 'Importance of the interlude verses by the narrators of the pastimes like Śrī Sūta and Śukadeva Gosvāmīs. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/Fj7DzcIWN64?si=8NktLTAIc4m8J0rW&t=1840',
        },
        {
            'subTopicName': 'What is the purpose of Phala‑Śrutīs in SB? Do all the benefits of Phala‑Śrutīs apply to practising devotees too? (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=FD68k2rO4QM&list=PLOlsz8SWVWGGNUrSJfnLsac345RZ0NhQy&index=65',
        },
        {
            'subTopicName': 'How would Śukadeva Gosvāmī’s hiding the fact that Kṛṣṇa was born to both Yaśodā and Devakī stop Kaṁsa’s persecuting them? His narration to Parīkṣit Mahārāja happened much later. (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/v6pulzCsUDQ?si=AsVrnyrnPYzj5oR8&t=1648',
        },
        {
            'subTopicName': 'Why the position of our ācāryas is superior to Śukadeva Gosvāmī? (4 min)',
            'youtubeLink': 'https://www.youtube.com/live/v6pulzCsUDQ?si=9LWbwnp1JLJAGlSL&t=2281',
        },
        {
            'subTopicName': 'The uniqueness of Śrīmad Bhāgavatam when compared to the other Vedic literatures. (67 min)',
            'youtubeLink': 'https://youtu.be/7JzBbNfJBQY?si=6xYyllm8lHrUo-SZ&t=1219',
        },
        {
            'subTopicName': '“Are conditioned souls also qualified to approach Śrīmad Bhāgavatam or is it only for the paramahaṃsas?” (13 min)',
            'youtubeLink': 'https://youtu.be/7JzBbNfJBQY?si=DK4rm7BLOxeWVMSs&t=3318',
        },
        {
            'subTopicName': 'Is Bhāgavatam a book only for leaving or for living also? (15 min)',
            'youtubeLink': 'https://youtu.be/7JzBbNfJBQY?si=oVxZySPsKDEAyufO&t=4042',
        },
        {
            'subTopicName': 'Why there are descriptions of other processes in Śrīmad Bhāgavatam when it establishes bhakti as topmost? (4 min)',
            'youtubeLink': 'https://youtu.be/zkeBvyL8JZY?si=Fs6DdzgUJi8sFTDE&t=1115',
        },
        {
            'subTopicName': 'The ten topīs of Śrīmad‑Bhāgavatam. (17 min)',
            'youtubeLink': 'https://youtu.be/CCffX8V2sM4?si=M-U1mQmx8B1_M3e-&t=828',
        },
        {
            'subTopicName': 'Titling of Śrīmad‑Bhāgavatam by Śrīla Prabhupāda. (3 min)',
            'youtubeLink': 'https://youtu.be/CCffX8V2sM4?si=iWC14JAsf4blLjMT&t=1817',
        },
        {
            'subTopicName': 'The unique glories of Śrīmad‑Bhāgavatam. (26 min)',
            'youtubeLink': 'https://youtu.be/CCffX8V2sM4?si=rCogGe3L0Pk-AtCN&t=2116',
        },
        {
            'subTopicName': 'Is Śrīmatī Rādhā‑Rānī’s name hidden in Śrīmad‑Bhāgavatam? (15 min)',
            'youtubeLink': 'https://www.youtube.com/live/GLNyoijb_2w?si=pIa530gNfq92D8eU&t=1388',
        },
        {
            'subTopicName': 'Śrīmad‑Bhāgavatam is for paramahaṃsas as well as conditioned souls. (46 min)',
            'youtubeLink': 'https://youtu.be/PWmLgLCTuzY?si=f_kfdCQJcEeIL4qL&t=2815',
        },
        {
            'subTopicName': 'Who presented the first 3 verses of Śrīmad-Bhāgavatam? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/cFgOw0dHG0Q?si=qS8ibG4sjlb6iE4c&t=2572',
        },
        {
            'subTopicName': 'Śrīmad-Bhāgavatam is the natural commentary of Vedānta-sūtra - Part-2. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/jtZXoCAbrt0?si=jEkput7Tc88bKhXr&t=1144',
        },
        {
            'subTopicName': 'If the goal of Gauḍīya Vaiṣṇavas is to reach Goloka Vṛndāvana with the mood of cultivating the mood of the Gopīs, then how can we have Śrīmad Bhāgavatam as Pramāṇa, where we see most of the pure devotees reaching Vaikuṇṭha? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=jOAW3XNnk5M&t=4070s',
        },
        {
            'subTopicName': 'What is the ideal mood of a Speaker and a Hearer in approaching Śrīmad Bhāgavatam? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cheqqa0IiFw&t=1809s',
        },
        {
            'subTopicName': 'Anuccheda 260/261/262 ‑ In the process of hearing, hearing Bhāgavatam is the best. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=phYwzJ8IFGc&t=6570s',
        },
    ],
    ['Śrīmad-Bhāgavatam Pastimes']: [
        {
            'subTopicName': 'Kṛṣṇa’s indebtedness to His devotees. (60 min)',
            'youtubeLink': 'https://www.youtube.com/live/pwByE7bADGc?si=XNyN53x5ZEjVcr3t&t=539',
        },
        {
            'subTopicName': 'Details of questions by Parīkṣit. (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/3yzhm3qVIcY?si=OxsCWxqkNTZ3WdYR&t=5627',
        },
        {
            'subTopicName': 'Kṛṣṇa, the Supreme master of all artistic skills. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/Tv-7I6lsqZ0?si=V6gzqJTnTpMk5La5&t=1291',
        },
        {
            'subTopicName': 'Perfect orchestration of yoga-māyā during the rāsa-līlā. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/Tv-7I6lsqZ0?si=eeXh2il4bqVrShv8&t=1622',
        },
        {
            'subTopicName': 'Why unnecessary suffering was given to Vasudeva and Devakī during Kṛṣṇa\'s birth? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/kLsjHJ_fMeI?si=ovnZ3EjUnX5apufZ&t=949',
        },
        {
            'subTopicName': '9 reasons why Nārada spoke confidential words to Kaṁsa. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/qOHUGmgjlyc?si=vOQ8xiIlnd4huj0o&t=2202',
        },
        {
            'subTopicName': 'Why Nārada Muni addresses Kaṁsa as "Bhārata"? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/qOHUGmgjlyc?si=8pPDLQ877MHp7Mnj&t=2696',
        },
        {
            'subTopicName': 'How Kaṁsa giving back the child would have obstructed the appearance of Lord? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/qOHUGmgjlyc?si=na75SjMdWI1HPIve&t=2812',
        },
        {
            'subTopicName': 'Why Balarāma appeared in the womb of Devakī? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/qOHUGmgjlyc?si=opIEUXYqZ3hK50wu&t=5144',
        },
        {
            'subTopicName': 'How could 6 material children appear in the womb of Devakī who is a pure devotee? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/qOHUGmgjlyc?si=qzWruRjshM5Ih4sO&t=5408',
        },
        {
            'subTopicName': 'Kṛṣṇa was not conceived by Devakī in a material way. (13 min)',
            'youtubeLink': 'https://www.youtube.com/live/TakJANwT7d4?si=gJdvMRk6h0XfuPcb&t=4084',
        },
        {
            'subTopicName': 'Kaṁsa exemplifies the perfection of unfavorable absorption in Kṛṣṇa. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/TakJANwT7d4?si=eM-0kHk_7oqcbh2Y&t=6628',
        },
        {
            'subTopicName': 'Cause of Vyāsadeva\'s dissatisfaction. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/zJQzbf_XGtc?si=J0GULxnPnx7_xiQ8&t=1573',
        },
        {
            'subTopicName': 'Conversation between Gopīs and Kṛṣṇa prior to the Rāsa-līlā. (68 min)',
            'youtubeLink': 'https://www.youtube.com/live/pwByE7bADGc?si=Hwk0x_LyqHQOreKw',
        },
        {
            'subTopicName': 'The spotless glory of "Rasotsava". (29 min)',
            'youtubeLink': 'https://www.youtube.com/live/Tv-7I6lsqZ0?si=vgtXrFb1DUKP3taP&t=661',
        },
        {
            'subTopicName': 'Vyāsadeva expressing his dissatisfaction to Nārada. (46 min)',
            'youtubeLink': 'https://www.youtube.com/live/zJQzbf_XGtc?si=wmZE7qgFaV2ne6NK&t=594',
        },
        {
            'subTopicName': 'Dexterity of Kṛṣṇa\'s movements in the Rāsa dance. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/Tv-7I6lsqZ0?si=w-np_8neKGyYer2c&t=1211',
        },
        {
            'subTopicName': 'Gopīs\' transcendental singing. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/Tv-7I6lsqZ0?si=cK689XiOLdCAeUiJ&t=4481',
        },
        {
            'subTopicName': 'Draupadī\'s lamentation: a mother\'s devastation. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/ZO2DtVVIyB0?si=yyS62erWfQbs9PA5&t=1971',
        },
        {
            'subTopicName': 'Draupadī\'s supreme act of compassion. (11 min)',
            'youtubeLink': 'https://www.youtube.com/live/Qw0uvqBg1K8?si=xhbDxydxAiosITiM&t=2808',
        },
        {
            'subTopicName': 'In the episode of the Pāṇḍavas forgiving Aśvatthāmā, are Draupadī and Arjuna acting against their kṣatriya-dharma? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/Qw0uvqBg1K8?si=kGVwSLq-7a-Zu9fR&t=3538',
        },
        {
            'subTopicName': 'Kṛṣṇa protects Uttarā and Parīkṣit Mahārāja. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/pWdeQCFPTRo?si=44YOXowSzvfpNQQB&t=718',
        },
        {
            'subTopicName': 'Devotee’s chaste attachment to Kṛṣṇa. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/pWdeQCFPTRo?si=5J8IgF9w9oDVmMTF&t=1541',
        },
        {
            'subTopicName': 'Kṛṣṇa, the exclusive lover of Gopīs and not Lakṣmī. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/RuOG-Z-lAtg?si=bV9aCE26L6nP67gv&t=4819',
        },
        {
            'subTopicName': 'Description of the Rāsa-līlā. (75 min)',
            'youtubeLink': 'https://www.youtube.com/live/ix1qTqpWbx4?si=HoSwXzBm2mgPt3XU&t=281',
        },
        {
            'subTopicName': 'Parīkṣit Mahārāja\'s doubts about the Rāsa-līlā. (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/ix1qTqpWbx4?si=IGLei8SZzHNFXPp7&t=5201',
        },
        {
            'subTopicName': 'The deeper import of the word rasikaḥ. (30 min)',
            'youtubeLink': 'https://youtu.be/UFvqDmP0D44?si=lseI1MMVMLulW-T0&t=2519',
        },
        {
            'subTopicName': 'Overview of Kuntī-devī’s prayers. (60 min)',
            'youtubeLink': 'https://www.youtube.com/live/WGDxS2Zh950?si=l79S8JKp2xAlUEKd&t=80',
        },
        {
            'subTopicName': 'How Kṛṣṇa responded to Kuntī’s prayers? (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/ar-PURH43Kc?si=QeEYA2OrYi0vA_vK&t=3041',
        },
        {
            'subTopicName': 'Kuntī’s final prayer, which is the essence of Śrīmad-Bhāgavatam. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/ar-PURH43Kc?si=oGY32nSpdJwrJLm2&t=2855',
        },
        {
            'subTopicName': 'Bhīṣma-deva’s role as the Pāṇḍavas’ guide. (37 min)',
            'youtubeLink': 'https://www.youtube.com/live/0QR_Myj46uI?si=y3FVL1UHm23TUb0t&t=1436',
        },
        {
            'subTopicName': 'Nanda Mahārāja’s rescue and the deliverance of the serpent. (26 min)',
            'youtubeLink': 'https://www.youtube.com/live/u3teY1AAIWI?si=Qi35JW8qLpjaJqY-&t=3502',
        },
        {
            'subTopicName': 'Kṛṣṇa’s Rāsa-līlā — "The song that melts material lust into Kṛṣṇa-prema". (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/u3teY1AAIWI?si=CiDAP4GNiYqDU2KY&t=1841',
        },
        {
            'subTopicName': 'The fall of Śaṅkhacūḍa. (16 min)',
            'youtubeLink': 'https://www.youtube.com/live/u3teY1AAIWI?si=RkDf7NUVFPyW4GbY&t=5233',
        },
        {
            'subTopicName': 'Bhīṣma’s attraction to Kṛṣṇa in vīra-rasa. (47 min)',
            'youtubeLink': 'https://www.youtube.com/live/e8Xim730Nz8?si=k4JZuDo3uyZuhVjh&t=91',
        },
        {
            'subTopicName': 'Beauty of the broken vows: Kṛṣṇa as bhakta-vatsala. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/e8Xim730Nz8?si=Kop2juQfxoP3fw5B&t=919',
        },
        {
            'subTopicName': 'Bhīṣma contemplates on the exalted prema of the Gopīs. (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/e8Xim730Nz8?si=YoeKP0MOplhjnVD4&t=2910',
        },
        {
            'subTopicName': 'Nine reasons why Nārada revealed the real identity of the relatives and well-wishers of Kaṁsa. (10 min)',
            'youtubeLink': 'https://www.youtube.com/live/qOHUGmgjlyc?si=-AclzCnmSseXN314&t=2086',
        },
        {
            'subTopicName': 'How did Devakī, a nitya-siddha associate, give birth to six material children? (17 min)',
            'youtubeLink': 'https://www.youtube.com/live/qOHUGmgjlyc?si=Or9FQLJ82BW4wJ_f&t=5410',
        },
        {
            'subTopicName': 'Four reasons why Vasudeva was struck with wonder when Śrī Kṛṣṇa took birth. (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/QKpw10f8Uik?si=Evx8RCYIBmQrZGlV&t=4215',
        },
        {
            'subTopicName': 'What was the real opulence of Vidura’s house? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/Fj7DzcIWN64?si=AhZfU5ukC8pz1x2E&t=728',
        },
        {
            'subTopicName': 'Yugala‑gīta. (94 min)',
            'youtubeLink': 'https://www.youtube.com/live/ez76v_qh4zA?si=_ykrzdVwfkJ5svhd&t=409',
        },
        {
            'subTopicName': 'Kṛṣṇa’s flute sound alleviates the feelings of separation of trees and animals of Vṛndāvana forest. (8 min)',
            'youtubeLink': 'https://www.youtube.com/live/ez76v_qh4zA?si=iUJZJFC9zwuun3Ci&t=1469',
        },
        {
            'subTopicName': 'Kṛṣṇa’s flute sound bewilders even celestial wedded men and women. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/ez76v_qh4zA?si=IghoHEZo-NkjVZ1X&t=2535',
        },
        {
            'subTopicName': 'Kṛṣṇa’s flute sound bewilders the rivers of Vṛndāvana. (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/ez76v_qh4zA?si=acImDel2MQUlcX28&t=5415',
        },
        {
            'subTopicName': 'Enchantment of trees, creepers, bees, and lake-dwelling birds by the flute sound of Kṛṣṇa. (29 min)',
            'youtubeLink': 'https://www.youtube.com/live/soPT-4X5lso?si=p34K4eDU0x0cSKnK&t=3204',
        },
        {
            'subTopicName': 'Services rendered by the clouds to Kṛṣṇa while He plays the flute. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/soPT-4X5lso?si=CmTxUZJ7BSUHPRbM&t=5412',
        },
        {
            'subTopicName': 'Complete overview of Yugala‑gīta. (114 min)',
            'youtubeLink': 'https://www.youtube.com/live/kNiFskZAikc?si=nMwAIpaqhal5Jfp1',
        },
        {
            'subTopicName': 'Killing of Ariṣṭāsura. (33 min)',
            'youtubeLink': 'https://www.youtube.com/live/ZxMEsaYIDaY?si=SjVEPJ5-fu3R2fvc&t=246',
        },
        {
            'subTopicName': 'Appearance of Rādhā‑kuṇḍa. (14 min)',
            'youtubeLink': 'https://www.youtube.com/live/ZxMEsaYIDaY?si=G6YGoLvy5hXeOfwu&t=2400',
        },
        {
            'subTopicName': 'Nārada reveals the truth about Kṛṣṇa being Vasudeva and Devakī’s son to Kaṁsa and Kaṁsa formulates strategy to kill Kṛṣṇa. (44 min)',
            'youtubeLink': 'https://www.youtube.com/live/ZxMEsaYIDaY?si=ysoJ9-ZsMZwj3N-i&t=3210',
        },
        {
            'subTopicName': '“Kṛṣṇa’s role in establishing dharma and Yudhiṣṭhira’s enlightened rule.” (22 min)',
            'youtubeLink': 'https://www.youtube.com/live/IRLmhxLey7o?si=RqIp8bN3aBYGbYRC&t=638',
        },
        {
            'subTopicName': 'Kuru women: not learned yet spiritually exalted. (46 min)',
            'youtubeLink': 'https://www.youtube.com/live/gm-LWZ6qybc?si=s6QMGehFyJDNer1B&t=619',
        },
        {
            'subTopicName': 'The Vedic essence in the words of simple women of Hastināpura. (30 min)',
            'youtubeLink': 'https://www.youtube.com/live/gm-LWZ6qybc?si=-Tvi1VI9Dfqwqaxc&t=848',
        },
        {
            'subTopicName': '“The Yugala Gīta: the tapasya of love sung in separation.” (95 min)',
            'youtubeLink': 'https://www.youtube.com/live/ez76v_qh4zA?si=ppwDoil1aFpOTQ30&t=255',
        },
        {
            'subTopicName': '“Queens and Gopīs: a contrast in divine ecstasy.” (18 min)',
            'youtubeLink': 'https://www.youtube.com/live/47TiOFaCKPc?si=SqD0cNYp8PPqCbO0&t=1381',
        },
        {
            'subTopicName': 'The joy of surrender as expressed by the Dvārakāvasīs. (7 min)',
            'youtubeLink': 'https://www.youtube.com/live/7m-fkyqfHIE?si=tZP9JbpR2tMPl1_x&t=825',
        },
        {
            'subTopicName': 'The silent embrace of the queens of Dvārakā: a symbol of chaste devotion. (12 min)',
            'youtubeLink': 'https://www.youtube.com/live/G61l_G9Zuuk?si=C5LXUWFubJQyeGx3&t=651',
        },
        {
            'subTopicName': 'Important learnings from Bali Mahārāja’s episode with Vāmana‑devā. (26 min)',
            'youtubeLink': 'https://youtu.be/AItRTbL-XwU?si=zd1eD15sR_uWP5SY&t=1941',
        },
        {
            'subTopicName': 'Why did Parīkṣit Mahārāja only punish Kali and not kill him? (8 min)',
            'youtubeLink': 'https://youtu.be/lApvtNPj6to?si=hpbPcl04ksUPHlcf&t=1244',
        },
        {
            'subTopicName': 'What are the lessons for a sādhaka from the story of the Āvadhūta Brahmaṇa and his 24 gurus? (47 min)',
            'youtubeLink': 'https://youtu.be/TdqNxn3IfXk?si=Vcu8fQ2nG_hHzzko&t=746',
        },
        {
            'subTopicName': 'The six questions asked by Nārada and answered by Brahmā‑jī in verse SB 2.5.2. (25 min)',
            'youtubeLink': 'https://youtu.be/bdoGT9uFotM?si=xKyfMqueRhioU25L&t=751',
        },
        {
            'subTopicName': 'Purpose behind three different descriptions of the Universal Form in the 2nd Canto. (14 min)',
            'youtubeLink': 'https://youtu.be/gZzy9wAssuA?si=KGMJnrbxJ96gQTQI&t=1988',
        },
        {
            'subTopicName': 'Can Vasudeva be accused of being selfish in protecting his own child by sacrificing another? (6 min)',
            'youtubeLink': 'https://www.youtube.com/live/M9Ep5BpOoBk?si=ea7diXvxf98pMmLl&t=1190',
        },
        {
            'subTopicName': 'Five reasons why Kṛṣṇa closed His eyes seeing Puṭanā. (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/lxUigu7wOeQ?si=ACPin5qVV9EsD7rK&t=500',
        },
        {
            'subTopicName': 'Understanding the benevolence and causeless mercy of Kṛṣṇa from Puṭanā’s episode. (27 min)',
            'youtubeLink': 'https://www.youtube.com/live/lxUigu7wOeQ?si=3Uw7nxxoe-VYzf8_&t=4911',
        },
        {
            'subTopicName': 'What position did Puṭanā actually get after being killed by Lord Kṛṣṇa? (33 min)',
            'youtubeLink': 'https://www.youtube.com/live/CHgBjEYlklI?si=HxNIQibqEFLq7HM2&t=1447',
        },
        {
            'subTopicName': 'Vidura’s wise counsel to Dhṛtarāṣṭra. (20 min)',
            'youtubeLink': 'https://www.youtube.com/live/5THj2496iq4?si=CZSS5XdMVnbuMi5C&t=780',
        },
        {
            'subTopicName': 'How could Vidura leave the palace without any pain? (5 min)',
            'youtubeLink': 'https://www.youtube.com/live/5THj2496iq4?si=XqbjDLeQsu1eQ58L&t=2721',
        },
        {
            'subTopicName': 'Did Vidura have hope in Dhṛtarāṣṭra as he was giving advice to him, or was he just duty‑bound as a minister? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/5THj2496iq4?si=ePrWHBh1_GRsP9Tw&t=3404',
        },
        {
            'subTopicName': 'Was Vidura also known for his fighting skills, since we hear only about his brāhmaṇical aspect as an advisor? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/5THj2496iq4?si=GH-CFImqkoiwn7gE&t=3552',
        },
        {
            'subTopicName': 'Why did Vidura advise so outrightly in front of Duryodhana? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/5THj2496iq4?si=o4HeYMtRUiw7IExf&t=3697',
        },
        {
            'subTopicName': 'Was Karṇa’s suffering due to his offense towards Vidura? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/5THj2496iq4?si=gDjukzKP7LnxxG6N&t=4015',
        },
        {
            'subTopicName': 'Why did Vidura inquire about the welfare of Kṛṣṇa and Balarāma to Uddhava? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/T7MOMdCA690?si=vxlAZdH9FiUazGPO&t=2476',
        },
        {
            'subTopicName': 'Why did Vidura not ask about the welfare of Dhṛtarāṣṭra? (2 min)',
            'youtubeLink': 'https://www.youtube.com/live/da3Mhwh6Kec?si=zX25FNxH6-tFHHYA&t=2839',
        },
        {
            'subTopicName': 'Is it Vidura’s own desire that manifested as Duryodhana’s words that facilitated his exit from the palace? (3 min)',
            'youtubeLink': 'https://www.youtube.com/live/da3Mhwh6Kec?si=QuEd4Pg58q_OldFJ&t=4118',
        },
        {
            'subTopicName': 'Reasons behind Brahmā\'s bewilderment due to Yogamāyā in Brahmā Vimohan Līlā. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=lAOlO2AiPaU&t=3530s',
        },
        {
            'subTopicName': 'Akrūra’s prayerful consciousness on the way to Vṛndāvan, anticipating the meeting with Kṛṣṇa - Part2 (34 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4Kj9WE3zldA&t=2313s',
        },
        {
            'subTopicName': 'Akrūra’s prayerful consciousness on the way to Vṛndāvan, anticipating the meeting with Kṛṣṇa- Part 1. (69 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=pwP7CHw4IIo&t=545s',
        },
        {
            'subTopicName': 'If Pṛthu Mahārāja is supposed to represent the limb of Pūjā / worshipping the Supreme Lord, how do we see him praying exclusively for an opportunity to hear Kṛṣṇa Kathā from the Supreme Lord in his prayers of the 4th Canto? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=GTd6KcvXc84&t=3730s',
        },
        {
            'subTopicName': 'How are the Sense Devatās (Presiding Deities) able to relish the nectar of Kṛṣṇa\'s Lotus feet in Vraja? (35 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=e-OVjHGgkdQ&t=1945s',
        },
        {
            'subTopicName': 'Lord Brahmā\'s wish to receive the dust of the Lotus feet of the Vrajavāsīs on his head. (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=e-OVjHGgkdQ&t=4115s',
        },
        {
            'subTopicName': 'The Supreme Lord Śrī Kṛṣṇa is accessible only to his to Devotees as demonstrated in Dāmodar Līlā. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=irXwcVTNbbQ&t=3470s',
        },
        {
            'subTopicName': 'The Rationale behind Nārada\'s Emphasis on Poverty and Pain as an ointment to subdue pride and to develop detachment. (45 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=B859Nrb_aeE&t=1645s',
        },
        {
            'subTopicName': 'Reason behind Kṛṣṇa showing the Universal Form to Mother Yaśodā. (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=cCMI4GYa-g4&t=1770s',
        },
        {
            'subTopicName': 'Deliverance of the demon Vyomāsura. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NfsDcuEqmpw&t=5600s',
        },
        {
            'subTopicName': 'Why did Aghāsura get Sārūpya Mukti? (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=qy0gJXtzapw&t=3780s',
        },
        {
            'subTopicName': 'The killing of the Keśī demon. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=NfsDcuEqmpw&t=390s',
        },
        {
            'subTopicName': 'Understanding the increasing Vātsalya of Mother Yaśodā and the other elderly Gopīs before and after the Brahmā Vimohana Līlā. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=OoCKjii-29k&t=3220s',
        },
        {
            'subTopicName': 'Give up before you are given up - Vidura chastises Dhṛtarāṣṭra. (29 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=gOW6r-Kb0vU&t=1690s',
        },
        {
            'subTopicName': 'Akrūra’s prayerful consciousness on the way to Vṛndāvan, anticipating the meeting with Kṛṣṇa- Part 4 (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2ffu8hErtBs&t=3740s',
        },
        {
            'subTopicName': 'Akrūra’s meditation on the lotus hands and feet of the Lord, anticipating the meeting with Kṛṣṇa - part3 (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2ffu8hErtBs&t=1654s',
        },
        {
            'subTopicName': 'Gāndhārī\'s warrior like renunciation. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=j1HQ4RmnZz0&t=1431s',
        },
        {
            'subTopicName': 'Dhṛtarāṣṭra quits home. (36 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=qNqa-UHc-2Q&t=1440s',
        },
        {
            'subTopicName': 'Vidura\'s purpose of staying back. (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=fCnjnG9Ioz0&t=2572s',
        },
        {
            'subTopicName': 'History of Kāliya and Garuḍa. (34 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=kghkt4_jLzE&t=660s',
        },
        {
            'subTopicName': 'Beauty of Vṛndāvan in Summer and the killing of Pralambāsura by Lord Balarāma. (81 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Bmr7UxGkV1M&t=2065s',
        },
        {
            'subTopicName': 'Lord protects Parīkṣit in the womb. (56 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=WXYILB1v5Oo&t=690s',
        },
        {
            'subTopicName': 'How Kṛṣṇa and the Cowherd boys spent their Paugaṇḍa age in the forests of Vṛndāvana. (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=6PaGtAQKW7Q&t=3145s',
        },
        {
            'subTopicName': 'How Gopīs emotionally received Kṛṣṇa at Dusk after Kṛṣṇa returned from the jungle with the Cows. (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=h9u-x5Gx4XA&t=3945s',
        },
        {
            'subTopicName': 'Akrūra’s vision of Lord’s lotus footprints in Vṛndāvana. (16 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HJcD57yDGE8&t=5405s',
        },
        {
            'subTopicName': 'Pastime of Swallowing the 2nd Forest Fire. (52 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=9ShfeSenKsc&t=905s',
        },
        {
            'subTopicName': 'Kṛṣṇa shows mercy to the Brāhmaṇa\'s wives ‑‑ Part 1 (41 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=-mKZ7QuxKKo&t=1840s',
        },
        {
            'subTopicName': 'Kṛṣṇa steals the Garments of unmarried Gopīs ‑‑ Part 2 (71 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=M4uzc8AOsHw&t=2705s',
        },
        {
            'subTopicName': 'Kṛṣṇa shows mercy to the Brāhmaṇa\'s wives ‑‑ Part 2 (79 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Y1NkSBQgjAQ&t=1575s',
        },
        {
            'subTopicName': 'Kṛṣṇa shows mercy to the Brāhmaṇa\'s wives ‑‑ Part 3 (59 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HsLGfe6fEjA&t=3290s',
        },
        {
            'subTopicName': 'Kṛṣṇa shows mercy to the Brāhmaṇa\'s wives ‑‑ Part 4 (25 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=AR8_MT5v7j0&t=3120s',
        },
        {
            'subTopicName': 'Kṛṣṇa shows mercy to the Brāhmaṇa\'s wives ‑‑ Part 5 (47 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BGh0mCDt9XE&t=90s',
        },
        {
            'subTopicName': 'Rainy Season in Vṛndāvana‑Part 1 (95 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ciwV7SjB0uc&t=560s',
        },
        {
            'subTopicName': 'Rainy Season in Vṛndāvana‑Part 2 (38 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HJoDej88k54&t=1290s',
        },
        {
            'subTopicName': 'Śarad‑ṛtu (Autumn Season in Vṛndāvana) ‑ Part 1 (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=HJoDej88k54&t=3560s',
        },
        {
            'subTopicName': 'Śarad‑ṛtu (Autumn Season) in Vṛndāvana ‑ Part 2 (84 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=LUKUYdlh2nE&t=145s',
        },
        {
            'subTopicName': 'Veṇu‑gītā ‑ Part 1 (94 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=72_gLEYpXNg&t=1010s',
        },
        {
            'subTopicName': 'Veṇu‑gītā ‑ Part 2 (34 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=JsxlorE3-fc&t=2115s',
        },
        {
            'subTopicName': 'Veṇu‑gītā ‑ Part 3 (32 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=qW_I1-vb5fs&t=1778s',
        },
        {
            'subTopicName': 'Veṇu‑gītā ‑ Part 4 (48 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ZUnbRbGaojk&t=3285s',
        },
        {
            'subTopicName': 'Veṇu‑gītā ‑ Part 5 (34 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=DYVNES6xu2Q&t=1500s',
        },
        {
            'subTopicName': 'Why did the Vraja Gopīs worship Kātyāyanī Devī? (37 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2xR9wTPsUG8&t=45s',
        },
        {
            'subTopicName': 'Kṛṣṇa steals the Garments of unmarried Gopīs ‑ Part 1 (85 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=FTNrcgmJFck&t=1630s',
        },
        {
            'subTopicName': 'Kṛṣṇa steals the Garments of unmarried Gopīs ‑ Part 3 (42 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=_MHWgq-IcYU&t=2460s',
        },
        {
            'subTopicName': 'Akrūra meets Lord Kṛṣṇa and Balarāma in Vṛndāvana and gets welcomed. (27 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7YQcN7hlx9w&t=4050s',
        },
        {
            'subTopicName': 'Akrūra conveys the message of Kaṁsa to Kṛṣṇa and Balarāma. (28 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=94rr4vmqmGM&t=225s',
        },
        {
            'subTopicName': 'When Akrūra came to Vṛndāvana, did the Vrajavāsīs already know that Vasudeva was the biological father of Kṛṣṇa? (3 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=94rr4vmqmGM&t=2430s',
        },
        {
            'subTopicName': 'Lamentation of the gopīs hearing Akrūra’s intention to take Kṛṣṇa and Balarāma out of Vṛndāvana. (39 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=94rr4vmqmGM&t=2820s',
        },
        {
            'subTopicName': 'What is the purpose of Pṛthu Mahārāj justifying his actions to the 4 Kumāras? Don\'t they already understand the heart of Pṛthu, being exalted beings themselves? (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3qnSB9TmSAQ&t=3825s',
        },
        {
            'subTopicName': 'Govardhana‑līlā Part‑‑1 (29 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=T7Tth9X1Aoc&t=1800s',
        },
        {
            'subTopicName': 'Govardhana‑līlā Part‑‑2 (37 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=3840s',
        },
        {
            'subTopicName': 'Govardhana‑līlā Part‑‑3 (38 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=1610s',
        },
        {
            'subTopicName': 'Govardhana‑līlā Part‑‑4 (32 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Qmy_2ggEp9A&t=30s',
        },
        {
            'subTopicName': 'Govardhana‑līlā Part‑‑5 (85 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=r3lOK54HG2Q&t=500s',
        },
        {
            'subTopicName': 'Kṛṣṇa asserting the Karma‑mīmāṁsā Philosophy. (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=T7Tth9X1Aoc&t=2460s',
        },
        {
            'subTopicName': 'Did all the Ṛṣi‑cārī‑gopīs take part in Rāsa‑līlā? (47 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=F17c52Fz5E0&t=90s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize the Creator. (19 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=2081s',
        },
        {
            'subTopicName': 'Gopīs get frightened at the prospect of separation from Kṛṣṇa. (13 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=1315s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize Kṛṣṇa for being indifferent towards them and deciding to leave to Mathurā. (9 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=3876s',
        },
        {
            'subTopicName': 'Kṛṣṇa leaves to Mathurā (8 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=l9JSxaKiTi8&t=4996s',
        },
        {
            'subTopicName': 'When did the 4 Kumāras meet Pṛthu Mahārāja? After the Jaya‑Vijaya episode OR before? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=KXly-GhZbDM&t=3300s',
        },
        {
            'subTopicName': 'Gopīs cry out loudly to prevent Kṛṣṇa from leaving Vṛndāvana. (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=l9JSxaKiTi8&t=4447s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs’ inability to exist without Kṛṣṇa (7 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=l9JSxaKiTi8&t=4050s',
        },
        {
            'subTopicName': 'Govardhana‑līlā Part ‑ 6 (71 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=PD_l5sJXxQ8&t=120s',
        },
        {
            'subTopicName': 'Govardhana‑līlā Part ‑ 7 (58 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Y4q-TMO6W24&t=2730s',
        },
        {
            'subTopicName': 'Akrūra’s vision of Lord Nārāyaṇa. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BNepBkhv7aA&t=5431s',
        },
        {
            'subTopicName': 'Akrūra’s darśana of Lord Ananta Śeṣa. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BNepBkhv7aA&t=5178s',
        },
        {
            'subTopicName': 'Akrūra\'s divine vision of Vaikuṇṭha in the pool of Yamunā (24 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=BNepBkhv7aA&t=4760s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs decide to abandon all dharma and directly try to stop Kṛṣṇa from leaving Vṛndāvana. (17 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ix-cxhDpdCg&t=4170s',
        },
        {
            'subTopicName': 'Are the gopīs really envious on the women of mathura that they will now get to relish Kṛṣṇa? (14 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=Ix-cxhDpdCg&t=2663s',
        },
        {
            'subTopicName': 'Viraha‑gītā ‑ Gopīs criticize Akrūra as a krūra or cruel man (10 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=6070s',
        },
        {
            'subTopicName': 'Why didn\'t Lord Śiva get up when Dakṣa entered the assembly? (4 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=3xhUEH31HU4&t=4028s',
        },
        {
            'subTopicName': 'Akrūra\'s anticipation & eagerness to see Kṛṣṇa. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=4Kj9WE3zldA&t=3420s',
        },
        {
            'subTopicName': 'Gopī\'s imagination of festival in Mathurā & Kṛṣṇa\'s welcome. (18 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=ALqZELjDvpY&t=5600s',
        },
        {
            'subTopicName': 'Akrūra reveals the internal meaning of Kaṁsa\'s invitation to Kṛṣṇa. (27 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=94rr4vmqmGM&t=1228s',
        },
        {
            'subTopicName': 'Akrūra\'s display of giving up the instruments of false ego. (23 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=7YQcN7hlx9w&t=2702s',
        },
        {
            'subTopicName': 'Kṛṣṇa is Bhāva‑grāhī. (11 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2ffu8hErtBs&t=3748s',
        },
        {
            'subTopicName': 'Comparison of Kṛṣṇa and the desire tree. (5 min)',
            'youtubeLink': 'https://www.youtube.com/watch?v=2ffu8hErtBs&t=4714s',
        },
    ],
};
